(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[551],{

/***/ 50358:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _features_design_components_BlockHeadingComponent__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60746);
/* harmony import */ var _features_design_components_CommonBlockComponent_BlockCombined_AdvancedSettingWrapper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15879);
/* harmony import */ var _features_design_components_CommonBlockComponent_BlockCombined_BlockListsDisplay__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82454);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _app_hooks__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(65457);







var PreviewContent = function(param) {
    var advancedSettingData = param.advancedSettingData, enableBlocks = param.enableBlocks, blockSpace = param.blockSpace, blockTitle = param.blockTitle, blockDescription = param.blockDescription, isApplyGlobalSettings = param.isApplyGlobalSettings, blockType = param.blockType, blockUid = param.blockUid;
    var ref, ref1;
    var siteSettings = (0,_app_hooks__WEBPACK_IMPORTED_MODULE_6__/* .useAppSelector */ .CG)(function(state) {
        return state.siteSettings;
    });
    var outside_space = ((siteSettings === null || siteSettings === void 0 ? void 0 : (ref = siteSettings.display_setting) === null || ref === void 0 ? void 0 : (ref1 = ref.block_setting) === null || ref1 === void 0 ? void 0 : ref1.block_style) || {}).outside_space;
    var customStyle = !(advancedSettingData === null || advancedSettingData === void 0 ? void 0 : advancedSettingData.use_advanced_setting) ? {
        marginLeft: "var(--block-outside-space)",
        marginRight: "var(--block-outside-space)",
        padding: " 12px var(--block-inner-space)",
        backgroundColor: "var(--block-background-color)",
        backdropFilter: "blur(var(--block-background-blur))",
        boxShadow: "var(--block-box-shadow)",
        borderRadius: "var(--block-border-radius)",
        borderWidth: "var(--block-border-width)",
        borderStyle: "var(--block-border-style)",
        borderColor: "var(--block-border-color)"
    } : {};
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "block-combined-preview-fullscreen-content design-class py-3 background-image background-color",
        style: {
            pointerEvents: "none",
            backgroundPosition: "center center",
            objectFit: "cover",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: classnames__WEBPACK_IMPORTED_MODULE_5___default()("relative", "block-".concat(blockType)),
            style: customStyle,
            children: (advancedSettingData === null || advancedSettingData === void 0 ? void 0 : advancedSettingData.use_advanced_setting) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_features_design_components_CommonBlockComponent_BlockCombined_AdvancedSettingWrapper__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                advancedSetting: advancedSettingData,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_features_design_components_BlockHeadingComponent__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        title: blockTitle,
                        blockType: blockType,
                        subtitle: blockDescription,
                        blockUid: blockUid
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        style: {
                            marginLeft: isApplyGlobalSettings && outside_space ? "-12px" : "0px",
                            marginRight: isApplyGlobalSettings && outside_space ? "-12px" : "0px"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_features_design_components_CommonBlockComponent_BlockCombined_BlockListsDisplay__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            blocks: enableBlocks,
                            blockSpace: blockSpace,
                            isApplyGlobalSettings: isApplyGlobalSettings
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_features_design_components_BlockHeadingComponent__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        title: blockTitle,
                        blockType: blockType,
                        subtitle: blockDescription
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        style: {
                            marginLeft: isApplyGlobalSettings && outside_space ? "-12px" : "0px",
                            marginRight: isApplyGlobalSettings && outside_space ? "-12px" : "0px"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_features_design_components_CommonBlockComponent_BlockCombined_BlockListsDisplay__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            blocks: enableBlocks,
                            blockSpace: blockSpace,
                            isApplyGlobalSettings: isApplyGlobalSettings
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PreviewContent);


/***/ }),

/***/ 66581:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _PreviewContent__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50358);
/* harmony import */ var _share_components_full_screen_popup__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40015);
/* harmony import */ var _share_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64035);
/* harmony import */ var antd_mobile__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27175);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(31567);
/* harmony import */ var _PreviewStyleHOC__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(16841);








var PreviewFullscreen = function(param) {
    var isVisible = param.isVisible, onCancel = param.onCancel, blockTitle = param.blockTitle, blockDescription = param.blockDescription, blockSpace = param.blockSpace, enableBlocks = param.enableBlocks, advancedSettingData = param.advancedSettingData, isApplyGlobalSettings = param.isApplyGlobalSettings, blockType = param.blockType, blockUid = param.blockUid;
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_7__/* .useTranslation */ .$)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_share_components_full_screen_popup__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            visible: isVisible,
            onMaskClick: onCancel,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_5__/* .NavBar */ .l2, {
                    className: "bg-white sticky top-0 z-[5]",
                    backArrow: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_4__/* .BackAngelIcon */ .Nz, {}),
                    onBack: onCancel,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "flex flex-row gap-2 items-center justify-center",
                        children: t("ss_builder_preview")
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PreviewStyleHOC__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    elementId: "".concat(blockUid, "-preview-fullscreen"),
                    advancedSetting: advancedSettingData,
                    isAppliedBlockGlobalSettings: isApplyGlobalSettings,
                    blockUid: blockUid,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        id: "".concat(blockUid, "-preview-fullscreen"),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PreviewContent__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            enableBlocks: enableBlocks,
                            blockSpace: blockSpace,
                            blockTitle: blockTitle,
                            blockDescription: blockDescription,
                            advancedSettingData: advancedSettingData,
                            isApplyGlobalSettings: isApplyGlobalSettings,
                            blockType: blockType,
                            blockUid: blockUid
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PreviewFullscreen);


/***/ }),

/***/ 16841:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _app_hooks__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65457);
/* harmony import */ var _features_block_libs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22814);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);



var PreviewStyleHOC = function(param) {
    var elementId = param.elementId, advancedSetting = param.advancedSetting, isAppliedBlockGlobalSettings = param.isAppliedBlockGlobalSettings, children = param.children, blockUid = param.blockUid;
    var siteSettings = (0,_app_hooks__WEBPACK_IMPORTED_MODULE_0__/* .useAppSelector */ .CG)(function(state) {
        return state.siteSettings;
    });
    var ref4 = (siteSettings === null || siteSettings === void 0 ? void 0 : siteSettings.display_setting) || {}, _heading_color_generate = ref4.heading_color_generate, heading_color_generate = _heading_color_generate === void 0 ? {} : _heading_color_generate, _text_color_generate = ref4.text_color_generate, text_color_generate = _text_color_generate === void 0 ? {} : _text_color_generate;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var combinedElement = document.getElementById(elementId);
        var combinedHeadingElement = document.querySelectorAll("#".concat(blockUid, "-heading"));
        var titleColorArr = (0,_features_block_libs__WEBPACK_IMPORTED_MODULE_2__/* .generateColorFunc */ .KL)((advancedSetting === null || advancedSetting === void 0 ? void 0 : advancedSetting.color_title) || "");
        var paragraphColorArr = (0,_features_block_libs__WEBPACK_IMPORTED_MODULE_2__/* .generateColorFunc */ .KL)((advancedSetting === null || advancedSetting === void 0 ? void 0 : advancedSetting.color_paragraph) || "");
        if ((advancedSetting === null || advancedSetting === void 0 ? void 0 : advancedSetting.use_advanced_setting) && !isAppliedBlockGlobalSettings) {
            var _loop = function(i) {
                titleColorArr === null || titleColorArr === void 0 ? void 0 : titleColorArr.forEach(function(ele, index) {
                    var ref;
                    (ref = combinedHeadingElement[i]) === null || ref === void 0 ? void 0 : ref.style.setProperty("--heading-color-".concat(index + 1), ele);
                });
                paragraphColorArr === null || paragraphColorArr === void 0 ? void 0 : paragraphColorArr.forEach(function(ele, index) {
                    var ref;
                    (ref = combinedHeadingElement[i]) === null || ref === void 0 ? void 0 : ref.style.setProperty("--text-color-".concat(index + 1), ele);
                });
            };
            titleColorArr === null || titleColorArr === void 0 ? void 0 : titleColorArr.forEach(function(ele, index) {
                combinedElement === null || combinedElement === void 0 ? void 0 : combinedElement.style.setProperty("--heading-color-".concat(index + 1), ele);
            });
            paragraphColorArr === null || paragraphColorArr === void 0 ? void 0 : paragraphColorArr.forEach(function(ele, index) {
                combinedElement === null || combinedElement === void 0 ? void 0 : combinedElement.style.setProperty("--text-color-".concat(index + 1), ele);
            });
            for(var i = 0; i < combinedHeadingElement.length; i++)_loop(i);
        } else if ((advancedSetting === null || advancedSetting === void 0 ? void 0 : advancedSetting.use_advanced_setting) && isAppliedBlockGlobalSettings) {
            var _loop1 = function(i1) {
                titleColorArr === null || titleColorArr === void 0 ? void 0 : titleColorArr.forEach(function(ele, index) {
                    var ref;
                    (ref = combinedHeadingElement[i1]) === null || ref === void 0 ? void 0 : ref.style.setProperty("--heading-color-".concat(index + 1), ele);
                });
                paragraphColorArr === null || paragraphColorArr === void 0 ? void 0 : paragraphColorArr.forEach(function(ele, index) {
                    var ref;
                    (ref = combinedHeadingElement[i1]) === null || ref === void 0 ? void 0 : ref.style.setProperty("--text-color-".concat(index + 1), ele);
                });
            };
            var ref5, ref1;
            (ref5 = Object.values(heading_color_generate)) === null || ref5 === void 0 ? void 0 : ref5.forEach(function(ele, index) {
                combinedElement === null || combinedElement === void 0 ? void 0 : combinedElement.style.setProperty("--heading-color-".concat(index + 1), ele);
            });
            (ref1 = Object.values(text_color_generate)) === null || ref1 === void 0 ? void 0 : ref1.forEach(function(ele, index) {
                combinedElement === null || combinedElement === void 0 ? void 0 : combinedElement.style.setProperty("--text-color-".concat(index + 1), ele);
            });
            for(var i1 = 0; i1 < combinedHeadingElement.length; i1++)_loop1(i1);
        } else {
            var _loop2 = function(i2) {
                var ref7, ref6;
                (ref7 = Object.values(heading_color_generate)) === null || ref7 === void 0 ? void 0 : ref7.forEach(function(ele, index) {
                    var ref;
                    (ref = combinedHeadingElement[i2]) === null || ref === void 0 ? void 0 : ref.style.setProperty("--heading-color-".concat(index + 1), ele);
                });
                (ref6 = Object.values(text_color_generate)) === null || ref6 === void 0 ? void 0 : ref6.forEach(function(ele, index) {
                    var ref;
                    (ref = combinedHeadingElement[i2]) === null || ref === void 0 ? void 0 : ref.style.setProperty("--text-color-".concat(index + 1), ele);
                });
            };
            var ref2, ref3;
            (ref2 = Object.values(heading_color_generate)) === null || ref2 === void 0 ? void 0 : ref2.forEach(function(ele, index) {
                combinedElement === null || combinedElement === void 0 ? void 0 : combinedElement.style.setProperty("--heading-color-".concat(index + 1), ele);
            });
            (ref3 = Object.values(text_color_generate)) === null || ref3 === void 0 ? void 0 : ref3.forEach(function(ele, index) {
                combinedElement === null || combinedElement === void 0 ? void 0 : combinedElement.style.setProperty("--text-color-".concat(index + 1), ele);
            });
            for(var i2 = 0; i2 < combinedHeadingElement.length; i2++)_loop2(i2);
        }
    });
    return children;
};
/* harmony default export */ __webpack_exports__["Z"] = (PreviewStyleHOC);


/***/ }),

/***/ 96790:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BV": function() { return /* binding */ RADIUS_STYLE_SQUARE; },
/* harmony export */   "GE": function() { return /* binding */ COLOR_TYPE_GRADIENT; },
/* harmony export */   "Ro": function() { return /* binding */ RADIUS_STYLE_ROUNDED; },
/* harmony export */   "Tt": function() { return /* binding */ masks; },
/* harmony export */   "U1": function() { return /* binding */ RADIUS_STYLE_CUSTOM; },
/* harmony export */   "Ux": function() { return /* binding */ softShadowIcon; },
/* harmony export */   "XQ": function() { return /* binding */ COLOR_TYPE_SOLID; },
/* harmony export */   "n3": function() { return /* binding */ masksForBorderWidth; },
/* harmony export */   "nu": function() { return /* binding */ hardShadowIcon; },
/* harmony export */   "u9": function() { return /* binding */ directionButtonOptionsV2; },
/* harmony export */   "wy": function() { return /* binding */ noShadowIcon; },
/* harmony export */   "yE": function() { return /* binding */ directionButtonOptions; }
/* harmony export */ });
/* unused harmony exports marks, TITLE_COMBINED, DES_COMBINED */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _share_icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64035);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _share_configs_const__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55016);
/* harmony import */ var _features_setting_components_Icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76143);





var directionButtonOptions = [
    {
        label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_1__/* .ArrowUpLeft */ .$o, {
            className: "align-middle inline-block"
        }),
        value: "top left"
    },
    {
        label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_1__/* .ArrowUp */ .a2, {
            className: "align-middle inline-block"
        }),
        value: "top"
    },
    {
        label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_1__/* .ArrowUpRight */ .Gu, {
            className: "align-middle inline-block"
        }),
        value: "top right"
    },
    {
        label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_1__/* .ArrowLeft */ .Xd, {
            className: "align-middle inline-block"
        }),
        value: "left"
    },
    {
        label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_1__/* .ArrowCenter */ .GV, {
            className: "align-middle inline-block"
        }),
        value: "center"
    },
    {
        label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_1__/* .ArrowRight */ .ol, {
            className: "align-middle inline-block"
        }),
        value: "right"
    },
    {
        label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_1__/* .ArrowDownLeft */ .l2, {
            className: "align-middle inline-block"
        }),
        value: "bottom left"
    },
    {
        label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_1__/* .ArrowDown */ .K5, {
            className: "align-middle inline-block"
        }),
        value: "bottom"
    },
    {
        label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_1__/* .ArrowDownRight */ .NC, {
            className: "align-middle inline-block"
        }),
        value: "bottom right"
    }, 
];
var directionButtonOptionsV2 = [
    {
        label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_1__/* .ArrowUpLeft */ .$o, {
            className: "align-middle inline-block"
        }),
        value: "to top left"
    },
    {
        label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_1__/* .ArrowUp */ .a2, {
            className: "align-middle inline-block"
        }),
        value: "to top"
    },
    {
        label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_1__/* .ArrowUpRight */ .Gu, {
            className: "align-middle inline-block"
        }),
        value: "to top right"
    },
    {
        label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_1__/* .ArrowLeft */ .Xd, {
            className: "align-middle inline-block"
        }),
        value: "to left"
    },
    {
        label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: ""
        }),
        value: "center",
        disabled: true
    },
    {
        label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_1__/* .ArrowRight */ .ol, {
            className: "align-middle inline-block"
        }),
        value: "to right"
    },
    {
        label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_1__/* .ArrowDownLeft */ .l2, {
            className: "align-middle inline-block"
        }),
        value: "to bottom left"
    },
    {
        label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_1__/* .ArrowDown */ .K5, {
            className: "align-middle inline-block"
        }),
        value: "to bottom"
    },
    {
        label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_1__/* .ArrowDownRight */ .NC, {
            className: "align-middle inline-block"
        }),
        value: "to bottom right"
    }, 
];
var marks = {
    0: 0,
    100: 100
};
var COLOR_TYPE_SOLID = "solid";
var COLOR_TYPE_GRADIENT = "gradient";
var RADIUS_STYLE_SQUARE = "square";
var RADIUS_STYLE_ROUNDED = "rounded";
var RADIUS_STYLE_CUSTOM = "custom";
var masks = {
    0: 0,
    1: "",
    2: "",
    3: "",
    4: "",
    5: "",
    6: "",
    7: "",
    8: "",
    9: "",
    10: "",
    11: "",
    12: "",
    13: "",
    14: "",
    15: "",
    16: "",
    17: "",
    18: "",
    19: "",
    20: "",
    21: "",
    22: "",
    23: "",
    24: "",
    25: "",
    26: "",
    27: "",
    28: "",
    29: "",
    30: "",
    31: "",
    32: "",
    33: "",
    34: "",
    35: "",
    36: "",
    37: "",
    38: "",
    39: "",
    40: "",
    41: "",
    42: "",
    43: "",
    44: "",
    45: "",
    46: "",
    47: "",
    48: 48
};
var noShadowIcon = function(radius_type) {
    var iconElement = null;
    switch(radius_type){
        case _share_configs_const__WEBPACK_IMPORTED_MODULE_3__/* .BUTTON_SETTING_RADIUS_STYLE.SQUARE */ .OX.SQUARE:
            iconElement = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_features_setting_components_Icons__WEBPACK_IMPORTED_MODULE_4__/* .NoShadowSquareIcon */ .mB, {
                className: "m-auto"
            });
            break;
        case _share_configs_const__WEBPACK_IMPORTED_MODULE_3__/* .BUTTON_SETTING_RADIUS_STYLE.ROUNDED */ .OX.ROUNDED:
            iconElement = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_features_setting_components_Icons__WEBPACK_IMPORTED_MODULE_4__/* .NoShadowRoundedIcon */ .ak, {
                className: "m-auto"
            });
            break;
        case _share_configs_const__WEBPACK_IMPORTED_MODULE_3__/* .BUTTON_SETTING_RADIUS_STYLE.CUSTOM */ .OX.CUSTOM:
            iconElement = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_features_setting_components_Icons__WEBPACK_IMPORTED_MODULE_4__/* .NoShadowCustomIcon */ .H, {
                className: "m-auto"
            });
            break;
        default:
            iconElement = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_features_setting_components_Icons__WEBPACK_IMPORTED_MODULE_4__/* .NoShadowSquareIcon */ .mB, {
                className: "m-auto"
            });
    }
    return iconElement;
};
var softShadowIcon = function(radius_type) {
    var iconElement = null;
    switch(radius_type){
        case _share_configs_const__WEBPACK_IMPORTED_MODULE_3__/* .BUTTON_SETTING_RADIUS_STYLE.SQUARE */ .OX.SQUARE:
            iconElement = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_features_setting_components_Icons__WEBPACK_IMPORTED_MODULE_4__/* .SoftShadowSquareIcon */ .TV, {
                className: "m-auto"
            });
            break;
        case _share_configs_const__WEBPACK_IMPORTED_MODULE_3__/* .BUTTON_SETTING_RADIUS_STYLE.ROUNDED */ .OX.ROUNDED:
            iconElement = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_features_setting_components_Icons__WEBPACK_IMPORTED_MODULE_4__/* .SoftShadowRoundedIcon */ .qK, {
                className: "m-auto"
            });
            break;
        case _share_configs_const__WEBPACK_IMPORTED_MODULE_3__/* .BUTTON_SETTING_RADIUS_STYLE.CUSTOM */ .OX.CUSTOM:
            iconElement = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_features_setting_components_Icons__WEBPACK_IMPORTED_MODULE_4__/* .SoftShadowCustomIcon */ .T8, {
                className: "m-auto"
            });
            break;
        default:
            iconElement = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_features_setting_components_Icons__WEBPACK_IMPORTED_MODULE_4__/* .SoftShadowSquareIcon */ .TV, {
                className: "m-auto"
            });
    }
    return iconElement;
};
var hardShadowIcon = function(radius_type) {
    var iconElement = null;
    switch(radius_type){
        case _share_configs_const__WEBPACK_IMPORTED_MODULE_3__/* .BUTTON_SETTING_RADIUS_STYLE.SQUARE */ .OX.SQUARE:
            iconElement = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_features_setting_components_Icons__WEBPACK_IMPORTED_MODULE_4__/* .HardShadowSquareIcon */ .y1, {
                className: "m-auto"
            });
            break;
        case _share_configs_const__WEBPACK_IMPORTED_MODULE_3__/* .BUTTON_SETTING_RADIUS_STYLE.ROUNDED */ .OX.ROUNDED:
            iconElement = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_features_setting_components_Icons__WEBPACK_IMPORTED_MODULE_4__/* .HardShadowRoundedIcon */ .O$, {
                className: "m-auto"
            });
            break;
        case _share_configs_const__WEBPACK_IMPORTED_MODULE_3__/* .BUTTON_SETTING_RADIUS_STYLE.CUSTOM */ .OX.CUSTOM:
            iconElement = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_features_setting_components_Icons__WEBPACK_IMPORTED_MODULE_4__/* .HardShadowCustomIcon */ .KE, {
                className: "m-auto"
            });
            break;
        default:
            iconElement = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_features_setting_components_Icons__WEBPACK_IMPORTED_MODULE_4__/* .HardShadowSquareIcon */ .y1, {
                className: "m-auto"
            });
    }
    return iconElement;
};
var masksForBorderWidth = {
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9,
    10: 10,
    11: 11,
    12: 12
};
var TITLE_COMBINED = "Combined block";
var DES_COMBINED = "Maecenas faucibus tempor nulla, ac eleifend nulla commodo eu. Nam id risus nisi.";


/***/ }),

/***/ 75157:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _features_block_block_conf__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61086);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);



var Block = function(param) {
    var blockData = param.blockData, onUpdateData = param.onUpdateData, setButtonStatus = param.setButtonStatus, setEditStatus = param.setEditStatus, setButtonLoading = param.setButtonLoading, handleCancelBlock = param.handleCancelBlock, setShowFooterBlockEdit = param.setShowFooterBlockEdit, defaultBlockData = param.defaultBlockData;
    var Component = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        if (_features_block_block_conf__WEBPACK_IMPORTED_MODULE_1__/* .BLOCK_EDIT_COMPONENT_CONFIG */ .s_[blockData === null || blockData === void 0 ? void 0 : blockData.block_type]) {
            return _features_block_block_conf__WEBPACK_IMPORTED_MODULE_1__/* .BLOCK_EDIT_COMPONENT_CONFIG */ .s_[blockData === null || blockData === void 0 ? void 0 : blockData.block_type];
        }
        return function(props) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
        };
    }, [
        blockData === null || blockData === void 0 ? void 0 : blockData.block_type
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_2__.Suspense, {
        fallback: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, {
            block: blockData,
            onUpdateData: onUpdateData,
            setButtonStatus: setButtonStatus,
            setEditStatus: setEditStatus,
            setButtonLoading: setButtonLoading,
            handleCancelBlock: handleCancelBlock,
            setShowFooterBlockEdit: setShowFooterBlockEdit,
            defaultBlockData: defaultBlockData
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Block);


/***/ }),

/***/ 13641:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ BlockEdit; },
  "U": function() { return /* binding */ runMiddleware; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/app/hooks.ts
var hooks = __webpack_require__(65457);
// EXTERNAL MODULE: ./src/features/block/block.conf.ts + 92 modules
var block_conf = __webpack_require__(61086);
// EXTERNAL MODULE: ./src/features/block/store/edittingBlockSlice.ts
var edittingBlockSlice = __webpack_require__(18684);
// EXTERNAL MODULE: ./src/features/main/store/dynamicSlice.ts
var dynamicSlice = __webpack_require__(24865);
// EXTERNAL MODULE: ./src/features/main/store/interface.ts
var store_interface = __webpack_require__(30053);
// EXTERNAL MODULE: ./src/features/main/store/positionsSlice.ts + 2 modules
var positionsSlice = __webpack_require__(99265);
// EXTERNAL MODULE: ./src/features/share/components/full-screen-popup/index.tsx
var full_screen_popup = __webpack_require__(40015);
// EXTERNAL MODULE: ./src/features/share/configs/const.ts
var configs_const = __webpack_require__(55016);
// EXTERNAL MODULE: ./src/features/share/icons/index.tsx
var icons = __webpack_require__(64035);
// EXTERNAL MODULE: ./src/features/share/lib/index.ts + 1 modules
var lib = __webpack_require__(11116);
// EXTERNAL MODULE: ./src/features/share/lib/ga-events.ts
var ga_events = __webpack_require__(2991);
// EXTERNAL MODULE: ./node_modules/antd-mobile/es/index.js + 251 modules
var es = __webpack_require__(27175);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(31567);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 16 modules
var react_redux_es = __webpack_require__(92145);
// EXTERNAL MODULE: ./src/features/block/components/Block/index.tsx
var Block = __webpack_require__(75157);
// EXTERNAL MODULE: ./src/features/block/components/BlockEditorWrapper/index.tsx + 6 modules
var BlockEditorWrapper = __webpack_require__(23133);
// EXTERNAL MODULE: ./src/features/block/components/TemplateComponent/TemplateList.tsx
var TemplateList = __webpack_require__(1385);
// EXTERNAL MODULE: ./src/features/share/api/index.tsx
var api = __webpack_require__(85861);
// EXTERNAL MODULE: ./node_modules/lodash/cloneDeep.js
var cloneDeep = __webpack_require__(50361);
var cloneDeep_default = /*#__PURE__*/__webpack_require__.n(cloneDeep);
// EXTERNAL MODULE: ./src/features/block/components/TemplateComponent/TemplateSaving.tsx
var TemplateSaving = __webpack_require__(75363);
// EXTERNAL MODULE: ./src/features/share/hooks/toast.tsx
var toast = __webpack_require__(95880);
;// CONCATENATED MODULE: ./src/features/block/components/TemplateComponent/TemplateOverWriteComponent.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
















var TemplateOverWriteComponent = function(props) {
    var isOpenTemplate = props.isOpenTemplate, handleClose = props.handleClose, KEY = props.KEY, dataOverWrite = props.dataOverWrite, handleLogicShowModalChooseOptionTemplate = props.handleLogicShowModalChooseOptionTemplate;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var SuccessToast = (0,toast/* useToast */.p)().SuccessToast;
    var ref9 = (0,react.useState)(null), templateData = ref9[0], setTemplateData = ref9[1];
    var ref1 = (0,react.useState)(false), isAddNewTemplate = ref1[0], setIsAddNewTemplate = ref1[1];
    var ref2 = (0,react.useState)(null), templateSelected = ref2[0], setTemplateSelected = ref2[1];
    var ref3 = (0,react.useState)(false), isShowModalConfirm = ref3[0], setIsShowModalConfirm = ref3[1];
    var ref4 = (0,react.useState)([]), searchedTemplate1 = ref4[0], setSearchedTemplate = ref4[1];
    var ref5 = (0,react.useState)(false), isSearchMode = ref5[0], setIsSearchMode = ref5[1];
    var ref6 = (0,react.useState)(""), value1 = ref6[0], setValue = ref6[1];
    var ref7 = (0,react.useState)(true), isLoading = ref7[0], setIsLoading = ref7[1];
    var passioPageProfile = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.passioPageProfile;
    });
    var creator_role = passioPageProfile === null || passioPageProfile === void 0 ? void 0 : passioPageProfile.creator_role;
    var isAdminRole = (0,react.useMemo)(function() {
        return creator_role === store_interface/* CREATOR_ROLE_ENUM.ADMIN */.lp.ADMIN;
    }, [
        creator_role
    ]);
    (0,react.useEffect)(function() {
        var requestTemplateList = function() {
            var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
                var listTemplateResponse, dataRequest, listTemplateArr;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            listTemplateResponse = null;
                            dataRequest = {
                                per_page: 100,
                                keyword: "",
                                is_admin: isAdminRole,
                                block_type: block_conf/* BLOCK_TYPE.COMBINED */.bF.COMBINED
                            };
                            _ctx.prev = 2;
                            _ctx.next = 5;
                            return (0,api/* requestSearchTemplate */.ux)(dataRequest);
                        case 5:
                            listTemplateResponse = _ctx.sent;
                            _ctx.next = 11;
                            break;
                        case 8:
                            _ctx.prev = 8;
                            _ctx.t0 = _ctx["catch"](2);
                            console.log(_ctx.t0);
                        case 11:
                            listTemplateArr = listTemplateResponse === null || listTemplateResponse === void 0 ? void 0 : listTemplateResponse.data;
                            setIsLoading(false);
                            if (listTemplateArr) setTemplateData(listTemplateArr);
                        case 14:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        2,
                        8
                    ]
                ]);
            }));
            return function requestTemplateList() {
                return _ref.apply(this, arguments);
            };
        }();
        if (isOpenTemplate) requestTemplateList();
    }, [
        isAdminRole,
        isOpenTemplate
    ]);
    var handleDeleteTemplate = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(id) {
            var ref, response, templateArrClone, newTemplateArr;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        response = null;
                        _ctx.prev = 2;
                        _ctx.next = 5;
                        return (0,api/* requestDeleteTemplate */.fu)(id);
                    case 5:
                        response = _ctx.sent;
                        _ctx.next = 11;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](2);
                        console.log(_ctx.t0);
                    case 11:
                        if (/^20[0-9]$/.test(response === null || response === void 0 ? void 0 : response.status.toString()) && (response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.success)) {
                            templateArrClone = cloneDeep_default()(templateData);
                            newTemplateArr = templateArrClone === null || templateArrClone === void 0 ? void 0 : templateArrClone.filter(function(ele) {
                                return ele.id !== id;
                            });
                            setTemplateData(newTemplateArr);
                            SuccessToast(t("ss_builder_delete_template_successfully_label"));
                        }
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    8
                ]
            ]);
        }));
        return function handleDeleteTemplate(id) {
            return _ref.apply(this, arguments);
        };
    }();
    var DataTemplateOverWrite = (0,react.useMemo)(function() {
        return _objectSpread({}, templateSelected, {
            block_space: dataOverWrite === null || dataOverWrite === void 0 ? void 0 : dataOverWrite.block_space,
            block_data: dataOverWrite === null || dataOverWrite === void 0 ? void 0 : dataOverWrite.block_data,
            is_using_global_block_settings: dataOverWrite === null || dataOverWrite === void 0 ? void 0 : dataOverWrite.is_using_global_block_settings,
            advanced_settings: dataOverWrite === null || dataOverWrite === void 0 ? void 0 : dataOverWrite.advanced_settings
        });
    }, [
        dataOverWrite,
        templateSelected
    ]);
    var handleEditTemplate = function(data) {
        setTemplateSelected(data);
        setIsAddNewTemplate(true);
    };
    var handleSelectedTemplate = function(dataTemplateSelected) {
        setTemplateSelected(dataTemplateSelected);
    };
    var handleShowHide = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(data) {
            var ref, isShowTemplate, newData, response, templateArrClone, newTemplateArr;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        isShowTemplate = (data === null || data === void 0 ? void 0 : data.status) === configs_const/* STATUS.ENABLE */.Q_.ENABLE;
                        newData = _objectSpread({}, data, {
                            status: isShowTemplate ? configs_const/* STATUS.DISABLE */.Q_.DISABLE : configs_const/* STATUS.ENABLE */.Q_.ENABLE
                        });
                        response = null;
                        _ctx.prev = 4;
                        _ctx.next = 7;
                        return (0,api/* requestUpdateTemplate */.mW)(newData);
                    case 7:
                        response = _ctx.sent;
                        _ctx.next = 13;
                        break;
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](4);
                        console.log(_ctx.t0);
                    case 13:
                        if (/^20[0-9]$/.test(response === null || response === void 0 ? void 0 : response.status.toString()) && (response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.success)) {
                            templateArrClone = cloneDeep_default()(templateData);
                            newTemplateArr = templateArrClone === null || templateArrClone === void 0 ? void 0 : templateArrClone.map(function(ele) {
                                if (ele.id === newData.id) return _objectSpread({}, ele, {
                                    status: isShowTemplate ? configs_const/* STATUS.DISABLE */.Q_.DISABLE : configs_const/* STATUS.ENABLE */.Q_.ENABLE
                                });
                                return ele;
                            });
                            setTemplateData(newTemplateArr);
                            SuccessToast(isShowTemplate ? t("ss_builder_hide_template_successfully_label") : t("ss_builder_show_template_successfully_label"));
                        }
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    4,
                    10
                ]
            ]);
        }));
        return function handleShowHide(data) {
            return _ref.apply(this, arguments);
        };
    }();
    var triggerModalConfirm = function(value) {
        setIsShowModalConfirm(value);
    };
    var searchStringTransformed = function(str) {
        return str.toLowerCase().split(/[ ,]+/).filter(function(e) {
            return !!e;
        });
    };
    var getTagsAndTitleList = function(item) {
        var tags = _toConsumableArray(item.tags);
        var name = [
            item.title
        ];
        return _toConsumableArray(tags).concat(_toConsumableArray(name));
    };
    var isMatchSearchKey = function(template, searchKey) {
        var tagsAndTitleArr = getTagsAndTitleList(template);
        var isMatch = tagsAndTitleArr.some(function(tag) {
            var splitedTagsArr = searchStringTransformed(tag);
            var isTagIncludeAllKey = searchKey.every(function(key) {
                return splitedTagsArr.includes(key);
            });
            return isTagIncludeAllKey;
        });
        return isMatch;
    };
    var handleSearchTemplate = function(value) {
        var searchKeys = searchStringTransformed(value);
        var allTemplate = _toConsumableArray(templateData);
        if (searchKeys.length > 0) {
            var searchedTemplate = [];
            allTemplate.forEach(function(template) {
                if (isMatchSearchKey(template, searchKeys)) {
                    searchedTemplate.push(template);
                }
            });
            setSearchedTemplate(searchedTemplate);
            setIsSearchMode(true);
        } else {
            setSearchedTemplate(templateData);
            setIsSearchMode(false);
        }
    };
    var onUpdateListTemplate = function(newListTemplate) {
        setTemplateData(newListTemplate);
    };
    var ref8;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(full_screen_popup/* default */.Z, {
                visible: isOpenTemplate,
                onMaskClick: function() {
                    return handleClose();
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bg-white h-full",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* NavBar */.l2, {
                                backArrow: null,
                                // onBack={handleClose}
                                className: "w-full",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-row text-center items-center justify-center gap-[4px] text-[13px]",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* TemplateIcon */.bj, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-ellipsis whitespace-nowrap overflow-hidden max-w-[70vw] md:max-w-[20vw] text-titleFontSize",
                                            children: (ref8 = t("ss_builder_template_overwrite_title")) !== null && ref8 !== void 0 ? ref8 : "Template"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex w-full bg-white search-block h-[36px] px-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* SearchBar */.E1, {
                                        icon: function() {
                                            return null;
                                        },
                                        placeholder: t("ss_builder_template_search_bar_placeholder"),
                                        onSearch: handleSearchTemplate,
                                        onChange: function(val) {
                                            return setValue(val);
                                        },
                                        style: {
                                            width: "100%"
                                        },
                                        onClear: function() {
                                            return setIsSearchMode(false);
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "bg-[#EE3244] flex h-43 w-43 cursor-pointer",
                                        style: {
                                            width: "43px",
                                            height: "36px",
                                            borderRadius: "0 6px 6px 0"
                                        },
                                        onClick: function() {
                                            return handleSearchTemplate(value1);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* SearchIcon */.W1, {
                                            className: "m-auto"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {
                                style: {
                                    margin: "12px 0 0"
                                }
                            }),
                            isSearchMode && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "p-4 pb-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-lg leading-6 mb-1 font-normal",
                                    children: t("ss_builder_search_results_theme_store")
                                })
                            }),
                            isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute",
                                style: {
                                    left: "calc(50% - 16px)",
                                    top: "calc(50% - 16px)"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* SpinLoading */.wW, {
                                    color: "primary",
                                    style: {
                                        "--size": "32px"
                                    }
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(TemplateList/* default */.Z, {
                                onSelectTemplate: function(data) {
                                    return handleSelectedTemplate(data);
                                },
                                onEditTemplate: function(data) {
                                    return handleEditTemplate(data);
                                },
                                onDeleteTemplate: function(id) {
                                    return handleDeleteTemplate(id);
                                },
                                onShowHideTemplate: function(data) {
                                    return handleShowHide(data);
                                },
                                KEY: configs_const/* TEMPLATE_RENDER_LIST_KEY.TEMPLATE_OVERWRITE_SELECTION */.fS.TEMPLATE_OVERWRITE_SELECTION,
                                templateData: isSearchMode ? searchedTemplate1 : templateData
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "max-width-content-class fixed bottom-0 p-2 flex w-full justify-between gap-2 z-[1] bg-[#FFFFFF]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-1/2 text-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                                            className: "w-full",
                                            onClick: handleClose,
                                            children: t("ss_builder_editor_btn-cancel")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-1/2 text-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                                            className: "w-full",
                                            color: "primary",
                                            onClick: function() {
                                                return triggerModalConfirm(true);
                                            },
                                            disabled: !templateSelected,
                                            children: t("ss_builder_overwrite_theme_btn_label")
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    isShowModalConfirm && /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Modal */.u_, {
                        visible: isShowModalConfirm,
                        content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-center",
                            children: t("ss_builder_overwrite_description")
                        }),
                        closeOnAction: true,
                        onClose: function() {
                            triggerModalConfirm(false);
                        },
                        header: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationTriangleIcon */.Lm, {
                            className: "w-11 h-11",
                            fillColor: "#FF8F1F",
                            onClick: function() {}
                        }),
                        title: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: t("ss_builder_overwrite_title")
                        }),
                        actions: [
                            {
                                key: "confirm",
                                text: t("ss_builder_confirm_overwrite"),
                                className: "create-text-template",
                                primary: true,
                                onClick: function() {
                                    return setIsAddNewTemplate(true);
                                }
                            },
                            {
                                key: "cancel",
                                text: t("ss_builder_editor_btn-cancel"),
                                className: "cancel-text-template",
                                onClick: function() {
                                    return triggerModalConfirm(false);
                                }
                            }, 
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TemplateSaving/* default */.Z, {
                visible: isAddNewTemplate,
                onMaskClick: function() {
                    return setIsAddNewTemplate(false);
                },
                KEY: configs_const/* TEMPLATE_KEY.OVERWRITE */.ax.OVERWRITE,
                templateDataSaving: DataTemplateOverWrite,
                handleCancelTemplateSaving: function() {
                    return setIsAddNewTemplate(false);
                },
                handleLogicShowModalChooseOptionTemplate: handleLogicShowModalChooseOptionTemplate,
                onUpdateListTemplate: onUpdateListTemplate,
                handleCloseOverwriteList: handleClose
            })
        ]
    });
};
/* harmony default export */ var TemplateComponent_TemplateOverWriteComponent = (TemplateOverWriteComponent);

// EXTERNAL MODULE: ./src/features/block/context/context.ts
var context = __webpack_require__(52790);
// EXTERNAL MODULE: ./src/features/share/configs/rxjs.ts + 20 modules
var rxjs = __webpack_require__(18109);
// EXTERNAL MODULE: ./src/features/block/block-editor/DigitalProduct/api/index.tsx
var DigitalProduct_api = __webpack_require__(49961);
;// CONCATENATED MODULE: ./src/features/block/components/BlockEditV2/extraFunction/helper.ts
function helper_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function helper_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return helper_arrayLikeToArray(arr);
}
function helper_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function helper_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function helper_toConsumableArray(arr) {
    return helper_arrayWithoutHoles(arr) || helper_iterableToArray(arr) || helper_unsupportedIterableToArray(arr) || helper_nonIterableSpread();
}
function helper_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return helper_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return helper_arrayLikeToArray(o, minLen);
}

function getBlockListsOfPosition(position) {
    if (position.slug === store_interface/* POSITION_SLUG.BODY */.bW.BODY) {
        var ref, ref1;
        var blockListsArr = [];
        var tabLists = (ref = position === null || position === void 0 ? void 0 : position.block_list[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.content_attributes) === null || ref1 === void 0 ? void 0 : ref1.tabs;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = tabLists[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var tab = _step.value;
                var blockLists = tab === null || tab === void 0 ? void 0 : tab.block_list;
                blockListsArr = helper_toConsumableArray(blockListsArr).concat(helper_toConsumableArray(blockLists));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return blockListsArr;
    } else {
        return position === null || position === void 0 ? void 0 : position.block_list;
    }
}

;// CONCATENATED MODULE: ./src/features/block/components/BlockEditV2/extraFunction/constant.ts
var ACTION_TYPE = {
    CANCEL: "cancel",
    SAVE: "save"
};

;// CONCATENATED MODULE: ./src/features/block/components/BlockEditV2/extraFunction/block/digital-product.ts
function digital_product_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function digital_product_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                digital_product_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                digital_product_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function digital_product_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function digital_product_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            digital_product_defineProperty(target, key, source[key]);
        });
    }
    return target;
}






var fetchDataProductApi = function() {
    var _ref = digital_product_asyncToGenerator(runtime_default().mark(function _callee(listID) {
        var params, res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    params = listID ? {
                        ids: listID.join(",")
                    } : {
                        status: 1
                    };
                    _ctx.prev = 1;
                    _ctx.next = 4;
                    return DigitalProduct_api/* default.listProduct */.Z.listProduct(params);
                case 4:
                    res = _ctx.sent;
                    if (!(res === null || res === void 0 ? void 0 : res.success)) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 7:
                    _ctx.next = 12;
                    break;
                case 9:
                    _ctx.prev = 9;
                    _ctx.t0 = _ctx["catch"](1);
                    console.error(_ctx.t0);
                case 12:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                9
            ]
        ]);
    }));
    return function fetchDataProductApi(listID) {
        return _ref.apply(this, arguments);
    };
}();
function digitalProductExtraFunc(blockData, positions, dispatch, actionType) {
    return _digitalProductExtraFunc.apply(this, arguments);
};
function _digitalProductExtraFunc() {
    _digitalProductExtraFunc = digital_product_asyncToGenerator(runtime_default().mark(function _callee(blockData, positions, dispatch, actionType) {
        var productList, formatProductList, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _loop, _iterator, _step;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return fetchDataProductApi();
                case 2:
                    productList = _ctx.sent;
                    formatProductList = productList === null || productList === void 0 ? void 0 : productList.map(function(product) {
                        var ref, ref1;
                        return {
                            category: {
                                id: product === null || product === void 0 ? void 0 : (ref = product.category) === null || ref === void 0 ? void 0 : ref.id
                            },
                            currency: product === null || product === void 0 ? void 0 : product.currency,
                            id: product === null || product === void 0 ? void 0 : product.id,
                            name: product === null || product === void 0 ? void 0 : product.name,
                            ordinal_number_lucky_card: product === null || product === void 0 ? void 0 : product.ordinal_number_lucky_card,
                            original_price: product === null || product === void 0 ? void 0 : product.original_price,
                            price: product === null || product === void 0 ? void 0 : product.price,
                            product_type: product === null || product === void 0 ? void 0 : product.product_type,
                            thumbnail: (ref1 = product === null || product === void 0 ? void 0 : product.thumbnails[0]) === null || ref1 === void 0 ? void 0 : ref1.url_small,
                            cover_image: (product === null || product === void 0 ? void 0 : product.cover_image) ? product === null || product === void 0 ? void 0 : product.cover_image : null
                        };
                    });
                    if (!productList) {
                        _ctx.next = 23;
                        break;
                    }
                    _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    _ctx.prev = 6;
                    _loop = function(_iterator, _step) {
                        var position = _step.value;
                        var blockLists = getBlockListsOfPosition(position);
                        var digitalProductBlockList = blockLists === null || blockLists === void 0 ? void 0 : blockLists.filter(function(block) {
                            return actionType === ACTION_TYPE.CANCEL ? (block === null || block === void 0 ? void 0 : block.block_type) === block_conf/* BLOCK_TYPE.DIGITAL_PRODUCT */.bF.DIGITAL_PRODUCT : (block === null || block === void 0 ? void 0 : block.block_type) === block_conf/* BLOCK_TYPE.DIGITAL_PRODUCT */.bF.DIGITAL_PRODUCT && (block === null || block === void 0 ? void 0 : block.uid) !== (blockData === null || blockData === void 0 ? void 0 : blockData.uid);
                        });
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator1 = digitalProductBlockList[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                                var block1 = _step1.value;
                                var ref;
                                var dp_data = block1 === null || block1 === void 0 ? void 0 : (ref = block1.content_attributes) === null || ref === void 0 ? void 0 : ref.dp_data;
                                var newDpData = dp_data.map(function(dp) {
                                    var newProduct = formatProductList === null || formatProductList === void 0 ? void 0 : formatProductList.find(function(x) {
                                        return x.id === dp.id;
                                    });
                                    return newProduct || dp;
                                });
                                var newDpItems = newDpData.map(function(dp) {
                                    return dp.id;
                                });
                                var newBlockData = digital_product_objectSpread({}, block1, {
                                    content_attributes: digital_product_objectSpread({}, block1.content_attributes, {
                                        dp_data: newDpData,
                                        dp_items: newDpItems
                                    })
                                });
                                var tabUid = (block1 === null || block1 === void 0 ? void 0 : block1.tab_uid) && (block1 === null || block1 === void 0 ? void 0 : block1.tab_uid) !== "0" ? block1 === null || block1 === void 0 ? void 0 : block1.tab_uid : null;
                                dispatch((0,positionsSlice/* updateBlock */.Df)({
                                    tabUid: tabUid,
                                    positionSlug: position.slug,
                                    blockData: newBlockData
                                }));
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    };
                    for(_iterator = positions[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true)_loop(_iterator, _step);
                    _ctx.next = 15;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](6);
                    _didIteratorError1 = true;
                    _iteratorError1 = _ctx.t0;
                case 15:
                    _ctx.prev = 15;
                    _ctx.prev = 16;
                    if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                        _iterator.return();
                    }
                case 18:
                    _ctx.prev = 18;
                    if (!_didIteratorError1) {
                        _ctx.next = 21;
                        break;
                    }
                    throw _iteratorError1;
                case 21:
                    return _ctx.finish(18);
                case 22:
                    return _ctx.finish(15);
                case 23:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                6,
                11,
                15,
                23
            ],
            [
                16,
                ,
                18,
                22
            ]
        ]);
    }));
    return _digitalProductExtraFunc.apply(this, arguments);
}

;// CONCATENATED MODULE: ./src/features/block/components/BlockEditV2/extraFunction/index.ts
function extraFunction_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function extraFunction_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                extraFunction_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                extraFunction_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function extraFunction_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}



var BLOCK_EXTRA_FUNCTION = extraFunction_defineProperty({}, block_conf/* BLOCK_TYPE.DIGITAL_PRODUCT */.bF.DIGITAL_PRODUCT, digitalProductExtraFunc);
//Handling logics after saving or exiting the block editor screen
var runExtraFunction = function() {
    var _ref = extraFunction_asyncToGenerator(runtime_default().mark(function _callee(blockData, positions, dispatch, actionType) {
        var blockType, extraFunc;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    blockType = blockData === null || blockData === void 0 ? void 0 : blockData.block_type;
                    extraFunc = BLOCK_EXTRA_FUNCTION[blockType];
                    if (!extraFunc) {
                        _ctx.next = 6;
                        break;
                    }
                    _ctx.next = 5;
                    return extraFunc(blockData, positions, dispatch, actionType).catch(function(e) {
                        console.log(e);
                        throw e;
                    });
                case 5:
                    return _ctx.abrupt("return", _ctx.sent);
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function runExtraFunction(blockData, positions, dispatch, actionType) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/features/block/components/BlockEditV2/index.tsx
function BlockEditV2_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function BlockEditV2_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return BlockEditV2_arrayLikeToArray(arr);
}
function BlockEditV2_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function BlockEditV2_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                BlockEditV2_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                BlockEditV2_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function BlockEditV2_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function BlockEditV2_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function BlockEditV2_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function BlockEditV2_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            BlockEditV2_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function BlockEditV2_toConsumableArray(arr) {
    return BlockEditV2_arrayWithoutHoles(arr) || BlockEditV2_iterableToArray(arr) || BlockEditV2_unsupportedIterableToArray(arr) || BlockEditV2_nonIterableSpread();
}
function BlockEditV2_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return BlockEditV2_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return BlockEditV2_arrayLikeToArray(o, minLen);
}


























var runMiddleware = function() {
    var _ref = BlockEditV2_asyncToGenerator(runtime_default().mark(function _callee(blockType, data, extraData, extraFunction) {
        var middleware;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    console.log("blockType", blockType);
                    middleware = block_conf/* BLOCK_DATA_SAVE_MIDDLEWARE */.l5[blockType];
                    console.log("middleware", middleware);
                    if (!middleware) {
                        _ctx.next = 7;
                        break;
                    }
                    _ctx.next = 6;
                    return middleware(data, extraData, extraFunction).catch(function(e) {
                        console.log(e);
                        throw e;
                    });
                case 6:
                    return _ctx.abrupt("return", _ctx.sent);
                case 7:
                    return _ctx.abrupt("return", data);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function runMiddleware(blockType, data, extraData, extraFunction) {
        return _ref.apply(this, arguments);
    };
}();
function BlockEdit(props) {
    var ref12, ref1, ref2;
    var handleRedirectTabs = props.handleRedirectTabs, handleCloseFloatingAddBlock = props.handleCloseFloatingAddBlock, handleOpenFloatingAddBlock = props.handleOpenFloatingAddBlock;
    var scrollBottomRef = (0,react.useRef)(null);
    var visible = (0,react_redux_es/* useSelector */.v9)(function(state) {
        return state.edittingBlock.open;
    });
    var edittingBlock = (0,react_redux_es/* useSelector */.v9)(function(state) {
        return state.edittingBlock;
    });
    var dynamicConfig = (0,react_redux_es/* useSelector */.v9)(function(state) {
        return state.dynamicConfig;
    });
    var siteSettings = (0,react_redux_es/* useSelector */.v9)(function(state) {
        return state.siteSettings;
    });
    var ref3 = (0,react.useState)(true), showFooterBlockEdit = ref3[0], setShowFooterBlockEdit = ref3[1];
    var blockTabId = (0,hooks/* useAppSelector */.CG)(function(state) {
        if (!siteSettings.id) {
            return null;
        }
        return state.positions.find(function(position) {
            return position.slug == "body";
        }).block_list.find(function(block) {
            return block.block_type == block_conf/* BLOCK_TYPE.TAB */.bF.TAB;
        }).id;
    });
    var extraData = {
        // id: siteSettings.id,
        user_id: siteSettings.user_id
    };
    var positions1 = (0,react_redux_es/* useSelector */.v9)(function(state) {
        return state.positions;
    });
    var edittingBlockData = edittingBlock && edittingBlock.block_data;
    var tabUid = edittingBlock && edittingBlock.tab_uid;
    var positionSlug = edittingBlock && edittingBlock.position_uid;
    var positionId = edittingBlock && edittingBlock.position_id;
    var sortOrder = edittingBlock && edittingBlock.sort_order;
    var KEY = edittingBlock && edittingBlock.KEY;
    var listTabInBody = (ref1 = (ref12 = positions1 === null || positions1 === void 0 ? void 0 : positions1.find(function(x) {
        return (x === null || x === void 0 ? void 0 : x.slug) === "body";
    })) === null || ref12 === void 0 ? void 0 : ref12.block_list[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.content_attributes) === null || ref2 === void 0 ? void 0 : ref2.tabs;
    var dispatch1 = (0,react_redux_es/* useDispatch */.I0)();
    var ref4 = (0,react.useState)(null), blockDataState1 = ref4[0], setBlockDatatState = ref4[1];
    var ref5 = (0,react.useState)(true), isSaveButtonDisable = ref5[0], setIsSaveButtonDisable = ref5[1];
    var ref6 = (0,react.useState)(false), isSaveButtonLoading = ref6[0], setIsSaveButtonLoading = ref6[1];
    var ref7 = (0,react.useState)(false), isEditStatus = ref7[0], setIsEditStatus = ref7[1];
    var ref8 = (0,react.useState)(false), isOpenTemplate = ref8[0], setIsOpenTemplate = ref8[1];
    var ref9 = (0,react.useState)(false), isAddNewTemplate = ref9[0], setIsAddNewTemplate = ref9[1];
    var ref10 = (0,react.useState)(null), dataFromDesign = ref10[0], setDataFromDesign = ref10[1];
    var ref11 = (0,react.useState)(false), isShowModalHandleLogicTemplate = ref11[0], setIsShowModalHandleLogicTemplate = ref11[1];
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var passioPageProfile = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.passioPageProfile;
    });
    (0,react.useEffect)(function() {
        if (!visible) {
            setBlockDatatState(null);
            setIsSaveButtonDisable(true);
            setIsEditStatus(false);
            setIsSaveButtonLoading(false);
        }
    }, [
        visible
    ]);
    (0,react.useEffect)(function() {
        var subscription = rxjs/* dataService.getObservable */.c.getObservable().subscribe(function(data) {
            if (data && Object.keys(data).length > 0) {
                setDataFromDesign(function(state) {
                    return BlockEditV2_objectSpread({}, state, data);
                });
            }
        });
        return function() {
            return subscription.unsubscribe();
        };
    }, []);
    var handleUpdateTabsBody = function(data) {
        dispatch1((0,positionsSlice/* updateTabsBody */.g2)({
            data: data
        }));
    };
    var extraFunction = {
        handleUpdateTabsBody: handleUpdateTabsBody
    };
    var getEventGA = function() {
        var event = "";
        var indexTab = (listTabInBody === null || listTabInBody === void 0 ? void 0 : listTabInBody.findIndex(function(item) {
            return item.uid === tabUid;
        })) + 1;
        switch(positionSlug){
            case store_interface/* POSITION_SLUG.HEADER */.bW.HEADER:
                event = "Header_AddBlock";
                break;
            case store_interface/* POSITION_SLUG.FOOTER */.bW.FOOTER:
                event = "Footer_AddBlock";
                break;
            case store_interface/* POSITION_SLUG.BODY */.bW.BODY:
                event = "BodyTab".concat(indexTab, "_AddBlock");
                break;
            case store_interface/* POSITION_SLUG.EXPAND */.bW.EXPAND:
                event = "Extended_AddBlock";
                break;
            default:
        }
        return event;
    };
    var getLabelGA = function() {
        var label = "";
        var indexTab = (listTabInBody === null || listTabInBody === void 0 ? void 0 : listTabInBody.findIndex(function(item) {
            return item.uid === tabUid;
        })) + 1;
        var blockType = edittingBlockData === null || edittingBlockData === void 0 ? void 0 : edittingBlockData.block_type;
        switch(positionSlug){
            case store_interface/* POSITION_SLUG.HEADER */.bW.HEADER:
                label = "Header";
                break;
            case store_interface/* POSITION_SLUG.FOOTER */.bW.FOOTER:
                label = "Footer";
                break;
            case store_interface/* POSITION_SLUG.BODY */.bW.BODY:
                label = "Body - Tab ".concat(indexTab);
                break;
            case store_interface/* POSITION_SLUG.EXPAND */.bW.EXPAND:
                if (blockType === block_conf/* BLOCK_TYPE.IMAGE_POPUP */.bF.IMAGE_POPUP) {
                    label = "Extended - Popup";
                } else if (blockType === block_conf/* BLOCK_TYPE.BRAND_GIFT_FOOTER */.bF.BRAND_GIFT_FOOTER || blockType === block_conf/* BLOCK_TYPE.TRUTH_OR_DARE_FOOTER */.bF.TRUTH_OR_DARE_FOOTER || blockType === block_conf/* BLOCK_TYPE.GIFT_FOOTER */.bF.GIFT_FOOTER) {
                    label = "Extended - Floating Icons";
                }
                break;
            default:
        }
        return label;
    };
    function handleRunExtraFunction(blockDataState, dispatch, actionType) {
        return _handleRunExtraFunction.apply(this, arguments);
    }
    function _handleRunExtraFunction() {
        _handleRunExtraFunction = BlockEditV2_asyncToGenerator(runtime_default().mark(function _callee(blockDataState, dispatch, actionType) {
            var ref, responseSite, positions;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        if (!(blockDataState === null || blockDataState === void 0 ? void 0 : (ref = blockDataState.content_attributes) === null || ref === void 0 ? void 0 : ref.use_extra_function)) {
                            _ctx.next = 13;
                            break;
                        }
                        responseSite = null;
                        _ctx.prev = 3;
                        _ctx.next = 6;
                        return (0,api/* fetchSiteSetting */.Dx)(siteSettings.user_id);
                    case 6:
                        responseSite = _ctx.sent;
                        _ctx.next = 12;
                        break;
                    case 9:
                        _ctx.prev = 9;
                        _ctx.t0 = _ctx["catch"](3);
                        console.log(_ctx.t0);
                    case 12:
                        if (responseSite) {
                            positions = responseSite.positions;
                            runExtraFunction(blockDataState, positions, dispatch, actionType);
                        }
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    3,
                    9
                ]
            ]);
        }));
        return _handleRunExtraFunction.apply(this, arguments);
    }
    var handleSaveBlock = function() {
        var _ref = BlockEditV2_asyncToGenerator(runtime_default().mark(function _callee() {
            var ref19, data, blockType, newSortOrder, ref13, tabBlockList, _Math, positionBlockList, _Math1, blockData, uid, element, ref14, ref15, headerState, blockListHeader, tabBarBlock, tabMenuStyle, position_style, ghim_style, tabMenuHeight, tabMenuAlwaysGhimElement, ref16, tabBarHeaderElement, ref17, tabBarHeaderHeight, blockClass;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        setIsSaveButtonLoading(true);
                        console.log("1111111111111111");
                        _ctx.prev = 3;
                        _ctx.next = 6;
                        return runMiddleware(blockDataState1 === null || blockDataState1 === void 0 ? void 0 : blockDataState1.block_type, blockDataState1, extraData, extraFunction);
                    case 6:
                        data = _ctx.sent;
                        _ctx.next = 12;
                        break;
                    case 9:
                        _ctx.prev = 9;
                        _ctx.t0 = _ctx["catch"](3);
                        return _ctx.abrupt("return");
                    case 12:
                        blockType = ga_events/* BLOCK_TYPE_EVENT_CONFIG */.Aw[blockDataState1 === null || blockDataState1 === void 0 ? void 0 : (ref19 = blockDataState1.block_type) === null || ref19 === void 0 ? void 0 : ref19.toUpperCase()] || (0,lib/* handleCapitalizeFirstLetter */.Tz)(blockDataState1.block_type);
                        if (KEY === configs_const/* KEY_BLOCK.EDIT */.ne.EDIT) {
                            ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.BLOCK */.Bt.BLOCK, "Block_Edit_".concat(blockType), blockType, ga_events/* ACTION_CONFIG.EDIT */.AN.EDIT);
                            dispatch1((0,positionsSlice/* updateBlock */.Df)({
                                tabUid: tabUid,
                                positionSlug: positionSlug,
                                blockData: data
                            }));
                        } else {
                            newSortOrder = 1;
                            if (tabUid) {
                                ;
                                tabBlockList = (ref13 = listTabInBody.find(function(tab) {
                                    return tab.uid == tabUid;
                                })) === null || ref13 === void 0 ? void 0 : ref13.block_list;
                                if ((tabBlockList === null || tabBlockList === void 0 ? void 0 : tabBlockList.length) > 0) {
                                    ;
                                    newSortOrder = 1 + (_Math = Math).max.apply(_Math, BlockEditV2_toConsumableArray(tabBlockList.map(function(item) {
                                        return item.sort_order;
                                    })));
                                }
                            } else {
                                positionBlockList = positions1.find(function(item) {
                                    return item.slug == positionSlug;
                                }).block_list;
                                if ((positionBlockList === null || positionBlockList === void 0 ? void 0 : positionBlockList.length) > 0) {
                                    ;
                                    newSortOrder = 1 + (_Math1 = Math).max.apply(_Math1, BlockEditV2_toConsumableArray(positionBlockList.map(function(item) {
                                        return item.sort_order;
                                    })));
                                }
                            }
                            if (sortOrder) {
                                newSortOrder = sortOrder;
                            }
                            blockData = BlockEditV2_objectSpread({}, data, {
                                tab_uid: tabUid ? tabUid : "0",
                                position_id: tabUid ? "0" : positionId,
                                parent_id: tabUid ? blockTabId : "0",
                                sort_order: newSortOrder
                            });
                            ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.BLOCK_TYPE */.Bt.BLOCK_TYPE, "BlockType_Add_".concat(blockType), blockType, ga_events/* ACTION_CONFIG.ADD */.AN.ADD);
                            ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.POSITION */.Bt.POSITION, getEventGA(), getLabelGA(), ga_events/* ACTION_CONFIG.ADD_BLOCK */.AN.ADD_BLOCK);
                            dispatch1((0,positionsSlice/* addBlock */.U6)({
                                tabUid: tabUid,
                                positionSlug: positionSlug,
                                blockData: blockData,
                                positionId: positionId
                            }));
                        }
                        handleRunExtraFunction(blockDataState1, dispatch1, ACTION_TYPE.SAVE);
                        dispatch1((0,edittingBlockSlice/* closePopup */.j4)());
                        handleRedirectTabs && handleRedirectTabs();
                        handleCloseFloatingAddBlock && handleCloseFloatingAddBlock();
                        dispatch1((0,dynamicSlice/* setParamsTab */.qS)({
                            data: {
                                activeKeyTab: tabUid
                            }
                        }));
                        setIsSaveButtonLoading(false);
                        if (KEY !== configs_const/* KEY_BLOCK.EDIT */.ne.EDIT) {
                            uid = blockDataState1 === null || blockDataState1 === void 0 ? void 0 : blockDataState1.uid;
                            if (uid) {
                                element = document.getElementById(uid);
                                if (element) {
                                    ;
                                    headerState = positions1.find(function(x) {
                                        return x.slug === configs_const/* POSITION_MAIN_LAYOUT.HEADER */.Kw.HEADER;
                                    });
                                    blockListHeader = headerState && headerState.block_list;
                                    tabBarBlock = blockListHeader && blockListHeader.find(function(x) {
                                        return x.block_type === block_conf/* BLOCK_TYPE.TAB_BAR */.bF.TAB_BAR;
                                    });
                                    tabMenuStyle = tabBarBlock && tabBarBlock.style_attributes;
                                    position_style = tabMenuStyle && tabMenuStyle.position_style;
                                    ghim_style = tabMenuStyle && tabMenuStyle.ghim_style;
                                    tabMenuHeight = 0;
                                    if (ghim_style === configs_const/* TAB_GHIM_STYLE.ALWAYS_GHIM */.EK.ALWAYS_GHIM && position_style === "top") {
                                        tabMenuAlwaysGhimElement = document.querySelector(".tab-design-always-ghim");
                                        ;
                                        tabMenuHeight = (ref16 = tabMenuAlwaysGhimElement === null || tabMenuAlwaysGhimElement === void 0 ? void 0 : tabMenuAlwaysGhimElement.offsetHeight) !== null && ref16 !== void 0 ? ref16 : 0;
                                    }
                                    tabBarHeaderElement = document.querySelector(".tab-bar-design-header");
                                    ;
                                    tabBarHeaderHeight = (ref17 = tabBarHeaderElement === null || tabBarHeaderElement === void 0 ? void 0 : tabBarHeaderElement.offsetHeight) !== null && ref17 !== void 0 ? ref17 : 0;
                                    setTimeout(function() {
                                        // element?.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
                                        window.scrollTo({
                                            behavior: "smooth",
                                            top: (element === null || element === void 0 ? void 0 : element.getBoundingClientRect().top) - document.body.getBoundingClientRect().top - tabBarHeaderHeight - tabMenuHeight
                                        });
                                    }, 400);
                                    blockClass = document.getElementById(uid).getElementsByClassName("block-class");
                                    (ref14 = blockClass[0]) === null || ref14 === void 0 ? void 0 : ref14.style.setProperty("outline", "solid 2px #00B578");
                                    (ref15 = blockClass[0]) === null || ref15 === void 0 ? void 0 : ref15.style.setProperty("outline-offset", "-2px");
                                    setTimeout(function() {
                                        var ref, ref18;
                                        (ref = blockClass[0]) === null || ref === void 0 ? void 0 : ref.style.setProperty("outline", "unset");
                                        (ref18 = blockClass[0]) === null || ref18 === void 0 ? void 0 : ref18.style.setProperty("outline-offset", "unset");
                                    }, 2000);
                                }
                            }
                        }
                    case 21:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    3,
                    9
                ]
            ]);
        }));
        return function handleSaveBlock() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCancelBlock = function() {
        var _ref = BlockEditV2_asyncToGenerator(runtime_default().mark(function _callee() {
            var ref, blockType;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        setShowFooterBlockEdit(true);
                        blockType = ga_events/* BLOCK_TYPE_EVENT_CONFIG */.Aw[blockDataState1 && (blockDataState1 === null || blockDataState1 === void 0 ? void 0 : (ref = blockDataState1.block_type) === null || ref === void 0 ? void 0 : ref.toUpperCase())] || (0,lib/* handleCapitalizeFirstLetter */.Tz)(blockDataState1 === null || blockDataState1 === void 0 ? void 0 : blockDataState1.block_type);
                        if (isEditStatus) {
                            es/* Modal.confirm */.u_.confirm({
                                header: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationIcon */.Yk, {
                                    className: "w-11 h-11",
                                    fillColor: "#FF8F1F",
                                    onClick: function() {}
                                }),
                                title: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: t("ss_builder_cancel_edit_block_title")
                                }),
                                content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-[15px] font-normal leading-[140%] text-textColorDefault text-center",
                                    children: t("ss_builder_cancel_edit_block_content")
                                }),
                                confirmText: t("ss_builder_continue_edit_block_label"),
                                cancelText: t("ss_builder_cancel_block_btn_label"),
                                onConfirm: function() {
                                    return;
                                },
                                onCancel: function() {
                                    if (KEY === configs_const/* KEY_BLOCK.EDIT */.ne.EDIT) {
                                        ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.BLOCK */.Bt.BLOCK, "Block_Cancel_".concat(blockType), blockType, ga_events/* ACTION_CONFIG.CANCEL */.AN.CANCEL);
                                    } else {
                                        ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.BLOCK_TYPE */.Bt.BLOCK_TYPE, "BlockType_Cancel_".concat(blockType), blockType, ga_events/* ACTION_CONFIG.CANCEL */.AN.CANCEL);
                                    }
                                    dispatch1((0,edittingBlockSlice/* closePopup */.j4)());
                                }
                            });
                        } else {
                            if (KEY === configs_const/* KEY_BLOCK.EDIT */.ne.EDIT) {
                                ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.BLOCK */.Bt.BLOCK, "Block_Cancel_".concat(blockType), blockType, ga_events/* ACTION_CONFIG.CANCEL */.AN.CANCEL);
                            } else {
                                ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.BLOCK_TYPE */.Bt.BLOCK_TYPE, "BlockType_Cancel_".concat(blockType), blockType, ga_events/* ACTION_CONFIG.CANCEL */.AN.CANCEL);
                            }
                            dispatch1((0,edittingBlockSlice/* closePopup */.j4)());
                        }
                        handleRunExtraFunction(blockDataState1, dispatch1, ACTION_TYPE.CANCEL);
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleCancelBlock() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCloseTemplatePopup = function() {
        setIsOpenTemplate(false);
    };
    var handleOpenTemplatePopup = function() {
        setIsOpenTemplate(true);
    };
    var handleOpenAndHidePopupAddNewTemplate = function(value) {
        setIsAddNewTemplate(value);
    };
    var handleLogicShowModalChooseOptionTemplate = function(value) {
        setIsShowModalHandleLogicTemplate(value);
    };
    var dataTemplateSaving = (0,react.useMemo)(function() {
        var ref, ref20, ref21, ref22;
        return {
            block_type: block_conf/* BLOCK_TYPE.COMBINED */.bF.COMBINED,
            title: "",
            image: "",
            status: 1,
            tags: [],
            block_space: blockDataState1 === null || blockDataState1 === void 0 ? void 0 : (ref = blockDataState1.style_attributes) === null || ref === void 0 ? void 0 : ref.block_space,
            block_data: blockDataState1 === null || blockDataState1 === void 0 ? void 0 : (ref20 = blockDataState1.content_attributes) === null || ref20 === void 0 ? void 0 : ref20.blocks,
            is_using_global_block_settings: (blockDataState1 === null || blockDataState1 === void 0 ? void 0 : (ref21 = blockDataState1.style_attributes) === null || ref21 === void 0 ? void 0 : ref21.is_applied_block_global_settings) || false,
            advanced_settings: (blockDataState1 === null || blockDataState1 === void 0 ? void 0 : (ref22 = blockDataState1.style_attributes) === null || ref22 === void 0 ? void 0 : ref22.advanced_setting) || {}
        };
    }, [
        blockDataState1
    ]);
    var defaultBlockData = (0,react.useMemo)(function() {
        var blockData = edittingBlockData;
        var blockType = edittingBlockData === null || edittingBlockData === void 0 ? void 0 : edittingBlockData.block_type;
        switch(blockType){
            case block_conf/* BLOCK_TYPE.AFF_PRODUCT_GROUP */.bF.AFF_PRODUCT_GROUP:
                blockData = BlockEditV2_objectSpread({}, edittingBlockData, {
                    content_attributes: BlockEditV2_objectSpread({}, edittingBlockData.content_attributes, dataFromDesign)
                });
                break;
        }
        return blockData;
    }, [
        edittingBlockData,
        dataFromDesign
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(context/* BlockEditV2Context.Provider */.s.Provider, {
        value: {
            handleOpenTemplatePopup: handleOpenTemplatePopup,
            handleOpenAndHidePopupAddNewTemplate: handleOpenAndHidePopupAddNewTemplate,
            isShowModalHandleLogicTemplate: isShowModalHandleLogicTemplate,
            handleLogicShowModalChooseOptionTemplate: handleLogicShowModalChooseOptionTemplate
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(full_screen_popup/* default */.Z, {
                visible: visible,
                onMaskClick: function() {
                    dispatch1((0,edittingBlockSlice/* closePopup */.j4)());
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockEditorWrapper/* default */.Z, {
                    block: blockDataState1 !== null && blockDataState1 !== void 0 ? blockDataState1 : edittingBlock,
                    saveBtn: {
                        disabled: isSaveButtonDisable,
                        loading: isSaveButtonLoading
                    },
                    onUpdateBlockData: function(data) {
                        return setBlockDatatState(data);
                    },
                    onCancelEdit: handleCancelBlock,
                    onSave: handleSaveBlock,
                    footer: showFooterBlockEdit,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block/* default */.Z, {
                        blockData: blockDataState1 ? blockDataState1 : edittingBlockData,
                        setButtonStatus: function(status) {
                            return setIsSaveButtonDisable(status);
                        },
                        setButtonLoading: function(isLoading) {
                            return setIsSaveButtonLoading(isLoading);
                        },
                        setEditStatus: function(status) {
                            return setIsEditStatus(status);
                        },
                        onUpdateData: function(data) {
                            return setBlockDatatState(data);
                        },
                        handleCancelBlock: handleCancelBlock,
                        setShowFooterBlockEdit: setShowFooterBlockEdit,
                        defaultBlockData: defaultBlockData
                    })
                })
            }),
            isOpenTemplate && /*#__PURE__*/ (0,jsx_runtime.jsx)(TemplateComponent_TemplateOverWriteComponent, {
                handleClose: handleCloseTemplatePopup,
                isOpenTemplate: isOpenTemplate,
                KEY: configs_const/* TEMPLATE_KEY.OVERWRITE */.ax.OVERWRITE,
                dataOverWrite: dataTemplateSaving,
                handleLogicShowModalChooseOptionTemplate: handleLogicShowModalChooseOptionTemplate
            }),
            isAddNewTemplate && /*#__PURE__*/ (0,jsx_runtime.jsx)(TemplateSaving/* default */.Z, {
                visible: isAddNewTemplate,
                onMaskClick: function() {
                    return setIsAddNewTemplate(false);
                },
                KEY: configs_const/* TEMPLATE_KEY.SAVE_NEW */.ax.SAVE_NEW,
                templateDataSaving: dataTemplateSaving,
                handleCancelTemplateSaving: function() {
                    return setIsAddNewTemplate(false);
                },
                handleLogicShowModalChooseOptionTemplate: handleLogicShowModalChooseOptionTemplate
            })
        ]
    });
};


/***/ }),

/***/ 23133:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_BlockEditorWrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/app/hooks.ts
var hooks = __webpack_require__(65457);
// EXTERNAL MODULE: ./src/features/share/icons/index.tsx
var icons = __webpack_require__(64035);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/features/block/block-editor/Combined/components/AdvancedSetting/PreviewFullscreen/index.tsx
var PreviewFullscreen = __webpack_require__(66581);
;// CONCATENATED MODULE: ./src/features/block/block-editor/Combined/components/PreviewSetting.tsx




var PreviewSetting = function(param) {
    var blockData = param.blockData;
    var ref, ref1, ref2;
    var ref3 = (0,react.useState)(false), isOpenPreview = ref3[0], setIsOpenPreview = ref3[1];
    var ref4 = (blockData === null || blockData === void 0 ? void 0 : blockData.content_attributes) || {}, block_title = ref4.block_title, block_description = ref4.block_description, blocks = ref4.blocks;
    var blockSpace = (blockData === null || blockData === void 0 ? void 0 : (ref = blockData.style_attributes) === null || ref === void 0 ? void 0 : ref.block_space) || 12;
    var advancedSettingData = (blockData === null || blockData === void 0 ? void 0 : (ref1 = blockData.style_attributes) === null || ref1 === void 0 ? void 0 : ref1.advanced_setting) || {};
    var isApplyGlobalSettings = (blockData === null || blockData === void 0 ? void 0 : (ref2 = blockData.style_attributes) === null || ref2 === void 0 ? void 0 : ref2.is_applied_block_global_settings) || false;
    var enableBlocks = blocks === null || blocks === void 0 ? void 0 : blocks.filter(function(x) {
        return x.enable === 1;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                onClick: function() {
                    return setIsOpenPreview(true);
                },
                className: "w-8 h-8 flex justify-center items-center cursor-pointer",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* PreviewThemeIcon */.gc, {
                    className: "w-6 h-6"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PreviewFullscreen/* default */.Z, {
                isVisible: isOpenPreview,
                onCancel: function() {
                    return setIsOpenPreview(false);
                },
                blockTitle: block_title,
                blockDescription: block_description,
                blockSpace: blockSpace,
                enableBlocks: enableBlocks,
                advancedSettingData: advancedSettingData,
                isApplyGlobalSettings: isApplyGlobalSettings,
                blockType: blockData === null || blockData === void 0 ? void 0 : blockData.block_type,
                blockUid: blockData === null || blockData === void 0 ? void 0 : blockData.uid
            })
        ]
    });
};
/* harmony default export */ var components_PreviewSetting = (PreviewSetting);

// EXTERNAL MODULE: ./src/features/block/block.conf.ts + 92 modules
var block_conf = __webpack_require__(61086);
// EXTERNAL MODULE: ./node_modules/antd-mobile/es/index.js + 251 modules
var es = __webpack_require__(27175);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(31567);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/features/share/icons/product-tour-icon.tsx
var product_tour_icon = __webpack_require__(16525);
// EXTERNAL MODULE: ./src/features/block/block-editor/AffiliateProductGroup/AffiliateProductTourOpening/ProductSettingTour/setting-tour-config.ts
var setting_tour_config = __webpack_require__(7246);
// EXTERNAL MODULE: ./src/features/share/components/ProductTourComponent/index.tsx
var ProductTourComponent = __webpack_require__(17347);
// EXTERNAL MODULE: ./src/features/share/configs/const.ts
var configs_const = __webpack_require__(55016);
;// CONCATENATED MODULE: ./src/features/block/block-editor/AffiliateProductGroup/AffiliateProductTourOpening/ProductSettingTour/index.tsx
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}









var ProductSettingTour = function(props) {
    var handleHideSettingTour = props.handleHideSettingTour;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var productTourRef = (0,react.useRef)(null);
    var dynamicConfig = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.dynamicConfig;
    });
    var edittingBlock = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.edittingBlock;
    });
    var ref1 = edittingBlock || {}, keyBlock = ref1.KEY;
    var hiddenSteps = ((dynamicConfig === null || dynamicConfig === void 0 ? void 0 : dynamicConfig.affiliateSettingTour) || {}).hiddenSteps;
    var dispatch = (0,hooks/* useAppDispatch */.TL)();
    var setRef = function(ref) {
        productTourRef.current = ref;
        var fullscreenContentElement = document.getElementsByClassName("full-screen-popup-content");
        if (productTourRef.current) {
            productTourRef.current.introJs._targetElement = fullscreenContentElement[(fullscreenContentElement === null || fullscreenContentElement === void 0 ? void 0 : fullscreenContentElement.length) - 1];
        }
    };
    var isHideStep1 = (0,react.useMemo)(function() {
        return hiddenSteps === null || hiddenSteps === void 0 ? void 0 : hiddenSteps.includes(setting_tour_config/* STEP_INDEX.STEP_1 */.om.STEP_1);
    }, [
        hiddenSteps
    ]);
    var isHideStep7 = (0,react.useMemo)(function() {
        return hiddenSteps === null || hiddenSteps === void 0 ? void 0 : hiddenSteps.includes(setting_tour_config/* STEP_INDEX.STEP_7 */.om.STEP_7);
    }, [
        hiddenSteps
    ]);
    var stepsDefault = setting_tour_config/* steps.map */.S6.map(function(ele) {
        return {
            title: '<div class="wrapper-image">' + product_tour_icon/* placeHolderImageIcon */.GT + '\n        <img class="img-product-tour" src='.concat(ele.image_header, ' /> </div>\n        <div class="title">').concat(t(ele.title_key), "<div/>"),
            element: ele.using_selector ? document.querySelector(".".concat(ele.element_class)) : ".".concat(ele.element_class),
            intro: "<div> ".concat(t(ele.intro_key), "<div/>"),
            tooltipClass: "tooltip-product-tour ".concat(ele.tooltip_class),
            position: (ele === null || ele === void 0 ? void 0 : ele.position) || "auto"
        };
    });
    var onExit = function() {
        handleHideSettingTour();
    };
    var onBeforeExit = function(stepIndex) {
        var castWindow = window;
        if (stepIndex === setting_tour_config/* STEP_INDEX.STEP_1 */.om.STEP_1 && !isHideStep1) {
            castWindow.triggerVisiblePopoverMoreElement(false);
        }
        if (stepIndex === setting_tour_config/* STEP_INDEX.STEP_7 */.om.STEP_7 && !isHideStep7) {
            castWindow.triggerVisibleAffiliatePopoverProductDetail(false);
        }
    };
    var onChangeProductTour = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(nextStepIndex, nextElement) {
            var castWindow, fullScreenPopupContent, popupConentScrollHeight, tooltipElement, i, i1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        castWindow = window;
                        fullScreenPopupContent = document.querySelectorAll(".full-screen-popup-content");
                        popupConentScrollHeight = fullScreenPopupContent[(fullScreenPopupContent === null || fullScreenPopupContent === void 0 ? void 0 : fullScreenPopupContent.length) - 1].scrollTop;
                        tooltipElement = document.querySelectorAll(".introjs-fixedTooltip");
                        if (tooltipElement) {
                            if (keyBlock === configs_const/* KEY_BLOCK.EDIT */.ne.EDIT && nextStepIndex !== setting_tour_config/* STEP_INDEX.STEP_1 */.om.STEP_1 && nextStepIndex !== setting_tour_config/* STEP_INDEX.STEP_8 */.om.STEP_8 || keyBlock === configs_const/* KEY_BLOCK.ADD_NEW */.ne.ADD_NEW && nextStepIndex !== setting_tour_config/* STEP_INDEX.STEP_6 */.om.STEP_6) {
                                for(i = 0; i < (tooltipElement === null || tooltipElement === void 0 ? void 0 : tooltipElement.length); i++){
                                    tooltipElement[i].style.cssText = "top:".concat(nextElement.getBoundingClientRect().top + popupConentScrollHeight - 5, "px !important");
                                    tooltipElement[i].style.position = "absolute";
                                    tooltipElement[i].style.background = "#FFFFFF";
                                }
                            } else {
                                for(i1 = 0; i1 < (tooltipElement === null || tooltipElement === void 0 ? void 0 : tooltipElement.length); i1++){
                                    tooltipElement[i1].style.cssText = "";
                                    tooltipElement[i1].style.position = "";
                                    tooltipElement[i1].style.background = "";
                                }
                            }
                        }
                        if (!(nextStepIndex === setting_tour_config/* STEP_INDEX.STEP_1 */.om.STEP_1)) {
                            _ctx.next = 10;
                            break;
                        }
                        if (isHideStep1) {
                            _ctx.next = 10;
                            break;
                        }
                        castWindow.triggerVisiblePopoverMoreElement(true);
                        _ctx.next = 10;
                        return new Promise(function(resolve, reject) {
                            var ref;
                            (ref = productTourRef.current) === null || ref === void 0 ? void 0 : ref.updateStepElement(setting_tour_config/* STEP_INDEX.STEP_1 */.om.STEP_1);
                            setTimeout(function() {
                                return resolve({});
                            }, 100);
                        });
                    case 10:
                        if (!(nextStepIndex === setting_tour_config/* STEP_INDEX.STEP_7 */.om.STEP_7)) {
                            _ctx.next = 15;
                            break;
                        }
                        if (isHideStep7) {
                            _ctx.next = 15;
                            break;
                        }
                        castWindow.triggerVisibleAffiliatePopoverProductDetail(true);
                        _ctx.next = 15;
                        return new Promise(function(resolve, reject) {
                            var ref;
                            (ref = productTourRef.current) === null || ref === void 0 ? void 0 : ref.updateStepElement(setting_tour_config/* STEP_INDEX.STEP_7 */.om.STEP_7);
                            setTimeout(function() {
                                return resolve({});
                            }, 100);
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onChangeProductTour(nextStepIndex, nextElement) {
            return _ref.apply(this, arguments);
        };
    }();
    var onCompleteProductTour = function() {};
    var onBeforeChange = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(nextStepIndex, nextElement) {
            var castWindow;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        castWindow = window;
                        if (!(nextStepIndex === setting_tour_config/* STEP_INDEX.STEP_1 */.om.STEP_1)) {
                            _ctx.next = 9;
                            break;
                        }
                        if (isHideStep1) {
                            _ctx.next = 8;
                            break;
                        }
                        castWindow.triggerVisiblePopoverMoreElement(true);
                        _ctx.next = 6;
                        return new Promise(function(resolve, reject) {
                            var ref;
                            (ref = productTourRef.current) === null || ref === void 0 ? void 0 : ref.updateStepElement(setting_tour_config/* STEP_INDEX.STEP_1 */.om.STEP_1);
                            setTimeout(function() {
                                return resolve({});
                            }, 100);
                        });
                    case 6:
                        _ctx.next = 9;
                        break;
                    case 8:
                        {
                            nextElement.scrollIntoView();
                        }
                    case 9:
                        if (nextStepIndex === setting_tour_config/* STEP_INDEX.STEP_2 */.om.STEP_2) {
                            castWindow.triggerVisiblePopoverMoreElement(false);
                            nextElement.scrollIntoView();
                        }
                        if (nextStepIndex === setting_tour_config/* STEP_INDEX.STEP_3 */.om.STEP_3) {
                            nextElement.scrollIntoView();
                        }
                        if (nextStepIndex === setting_tour_config/* STEP_INDEX.STEP_4 */.om.STEP_4) {
                            nextElement.scrollIntoView();
                        }
                        if (nextStepIndex === setting_tour_config/* STEP_INDEX.STEP_5 */.om.STEP_5) {
                            nextElement.scrollIntoView();
                        }
                        if (nextStepIndex === setting_tour_config/* STEP_INDEX.STEP_6 */.om.STEP_6) {
                            nextElement.scrollIntoView();
                            if (!isHideStep7) {
                                castWindow.triggerVisibleAffiliatePopoverProductDetail(false);
                            }
                        }
                        if (!(nextStepIndex === setting_tour_config/* STEP_INDEX.STEP_7 */.om.STEP_7)) {
                            _ctx.next = 22;
                            break;
                        }
                        if (isHideStep7) {
                            _ctx.next = 21;
                            break;
                        }
                        castWindow.triggerVisibleAffiliatePopoverProductDetail(true);
                        _ctx.next = 19;
                        return new Promise(function(resolve, reject) {
                            productTourRef.current.updateStepElement(setting_tour_config/* STEP_INDEX.STEP_7 */.om.STEP_7);
                            setTimeout(function() {
                                return resolve({});
                            }, 100);
                        });
                    case 19:
                        _ctx.next = 22;
                        break;
                    case 21:
                        {
                            nextElement.scrollIntoView();
                        }
                    case 22:
                        if (nextStepIndex === setting_tour_config/* STEP_INDEX.STEP_8 */.om.STEP_8) {
                            if (!isHideStep7) {
                                castWindow.triggerVisibleAffiliatePopoverProductDetail(false);
                            }
                        }
                    case 23:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onBeforeChange(nextStepIndex, nextElement) {
            return _ref.apply(this, arguments);
        };
    }();
    var stepsFilter = (0,react.useMemo)(function() {
        return stepsDefault === null || stepsDefault === void 0 ? void 0 : stepsDefault.filter(function(ele, idx) {
            return !(hiddenSteps === null || hiddenSteps === void 0 ? void 0 : hiddenSteps.includes(idx));
        });
    }, [
        stepsDefault,
        hiddenSteps
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductTourComponent/* default */.Z, {
        steps: stepsFilter,
        onExit: onExit,
        onBeforeExit: onBeforeExit,
        onChange: onChangeProductTour,
        onComplete: onCompleteProductTour,
        onBeforeChange: onBeforeChange,
        setRef: setRef
    });
};
/* harmony default export */ var AffiliateProductTourOpening_ProductSettingTour = (ProductSettingTour);

// EXTERNAL MODULE: ./src/features/main/store/dynamicSlice.ts
var dynamicSlice = __webpack_require__(24865);
;// CONCATENATED MODULE: ./src/features/block/block-editor/AffiliateProductGroup/AffiliateProductTourOpening/index.tsx
function _throw(e) {
    throw e;
}









var AffiliateProductTourOpening = function(param) {
    var param = param !== null ? param : _throw(new TypeError("Cannot destructure undefined"));
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var dispatch = (0,hooks/* useAppDispatch */.TL)();
    var dynamicConfig = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.dynamicConfig;
    });
    var ref = (0,react.useState)(false), isOpenProductSettingTour = ref[0], setIsOpenProductSettingTour = ref[1];
    var popoverRef = (0,react.useRef)(null);
    var popoverManualRef = (0,react.useRef)(null);
    var handleHidePopoverManual = function() {
        popoverManualRef.current.hide();
    };
    (0,react.useEffect)(function() {
        dispatch((0,dynamicSlice/* setDynamicParams */.B9)({
            data: {
                isOpenAffiliateSettingTour: isOpenProductSettingTour
            }
        }));
        var timer = setTimeout(function() {
            var settingTourOverlay = document.getElementsByClassName("introjs-overlay")[0];
            var blockEditorWrapper = document.querySelector(".block-editor-wrapper");
            if (isOpenProductSettingTour) {
                settingTourOverlay.style.display = "none";
            } else {
                settingTourOverlay === null || settingTourOverlay === void 0 ? void 0 : settingTourOverlay.remove();
            }
            if (isOpenProductSettingTour) {
                if (blockEditorWrapper) blockEditorWrapper.style.cssText = "pointer-events: none;";
            } else {
                if (blockEditorWrapper) blockEditorWrapper.style.cssText = "";
            }
        }, 100);
        (function() {
            return clearTimeout(timer);
        });
    }, [
        isOpenProductSettingTour
    ]);
    var handleHideSettingTour = function() {
        setIsOpenProductSettingTour(false);
    };
    var contentPopoverManual = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "w-[270px] relative max-w-full",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-[32px] h-[32px] absolute p-1 right-2 top-2 cursor-pointer z-[3]",
                    onClick: function() {
                        return handleHidePopoverManual();
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ClosePopupIconV2 */.gz, {
                        fillColor: "#fff"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "https://image.passio.eco/page-builder/page-builder/affiliate-setting-tour/affiliate-setting-tour-opening.gif",
                        alt: ""
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "p-3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mb-2 text-lg leading-[25px] font-bold",
                            children: t("ss_builder_affiliate_setting_popover_manual_title")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-[15px] font-normal leading-[140%] text-textColorDefault mb-5",
                            children: t("ss_builder_affiliate_setting_popover_manual_content")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                            color: "primary",
                            size: "middle",
                            fill: "solid",
                            onClick: function() {
                                handleHidePopoverManual();
                                setIsOpenProductSettingTour(true);
                            },
                            block: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "flex items-center w-full justify-center gap-2 text-[17px]",
                                children: [
                                    t("ss_builder_popover_manual_button"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ArrowRightIcon */.LZ, {
                                        fillColor: "#fff"
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "user-manual",
                ref: popoverRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Popover */.J2, {
                    className: "popover-user-manual",
                    content: contentPopoverManual(),
                    placement: "bottom-end",
                    // visible={isOpenPopoverManual}
                    trigger: "click",
                    stopPropagation: [
                        "click"
                    ],
                    getContainer: function() {
                        return popoverRef.current;
                    },
                    ref: popoverManualRef,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: setting_tour_config/* AFFILIATE_SETTING_TOUR_CLASS_NAME.STEP_9 */.P9.STEP_9,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* QuestionIcon */.UO, {
                            width: 20,
                            height: 20,
                            className: "cursor-pointer"
                        })
                    })
                })
            }),
            isOpenProductSettingTour && /*#__PURE__*/ (0,jsx_runtime.jsx)(AffiliateProductTourOpening_ProductSettingTour, {
                handleHideSettingTour: handleHideSettingTour
            })
        ]
    });
};
/* harmony default export */ var AffiliateProductGroup_AffiliateProductTourOpening = (AffiliateProductTourOpening);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/features/share/thunk/index.tsx
var thunk = __webpack_require__(60580);
// EXTERNAL MODULE: ./src/features/main/store/positionsSlice.ts + 2 modules
var positionsSlice = __webpack_require__(99265);
// EXTERNAL MODULE: ./src/features/block/store/edittingBlockSlice.ts
var edittingBlockSlice = __webpack_require__(18684);
// EXTERNAL MODULE: ./src/features/share/lib/ga-events.ts
var ga_events = __webpack_require__(2991);
// EXTERNAL MODULE: ./src/features/share/lib/index.ts + 1 modules
var lib = __webpack_require__(11116);
// EXTERNAL MODULE: ./node_modules/usehooks-ts/dist/esm/index.js + 36 modules
var esm = __webpack_require__(5678);
// EXTERNAL MODULE: ./src/features/block/context/context.ts
var context = __webpack_require__(52790);
// EXTERNAL MODULE: ./src/features/main/store/interface.ts
var store_interface = __webpack_require__(30053);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/features/share/icons/line-icon.tsx
var line_icon = __webpack_require__(45297);
;// CONCATENATED MODULE: ./src/features/block/components/MoreElement/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}





















var MoreElement = function(props) {
    var ref;
    var isEnable = props.isEnable, positionSlug1 = props.positionSlug, blockUid1 = props.blockUid, tabUid = props.tabUid, sort_order1 = props.sort_order, handeSetEnableBlock = props.handeSetEnableBlock, type = props.type, blockType = props.blockType, visible = props.visible, dataBlock = props.dataBlock, KEY = props.KEY;
    var ref1 = (0,context/* useBlockEditV2Context */.o)(), handleOpenTemplatePopup = ref1.handleOpenTemplatePopup, handleOpenAndHidePopupAddNewTemplate = ref1.handleOpenAndHidePopupAddNewTemplate, isShowModalHandleLogicTemplate = ref1.isShowModalHandleLogicTemplate, handleLogicShowModalChooseOptionTemplate = ref1.handleLogicShowModalChooseOptionTemplate;
    var passioPageProfile = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.passioPageProfile;
    });
    var creator_role = passioPageProfile === null || passioPageProfile === void 0 ? void 0 : passioPageProfile.creator_role;
    var isAdminRole = (0,react.useMemo)(function() {
        return creator_role === store_interface/* CREATOR_ROLE_ENUM.ADMIN */.lp.ADMIN;
    }, [
        creator_role
    ]);
    var router = (0,next_router.useRouter)();
    var positions = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.positions;
    });
    var positionState = positions.find(function(x) {
        return x.slug === positionSlug1;
    });
    var listBlocks = positionState === null || positionState === void 0 ? void 0 : positionState.block_list;
    if (positionSlug1 === configs_const/* POSITION_MAIN_LAYOUT.BODY */.Kw.BODY) {
        var block_list = listBlocks[0].content_attributes.tabs.find(function(x) {
            return x.uid === tabUid;
        });
        listBlocks = block_list.block_list;
    }
    var CONFIRM_TEXT = "OK";
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var dispatch = (0,hooks/* useAppDispatch */.TL)();
    var popoverContainerRef = (0,react.useRef)(null);
    var popoverOptionRef = (0,react.useRef)(null);
    var ref2 = (0,react.useState)(false), isOpenConfirmEnterText = ref2[0], setIsOpenConfirmEnterText = ref2[1];
    var ref3 = (0,react.useState)(null), valueConfirmText = ref3[0], setValueConfirmText = ref3[1];
    var debouncedValueConfirmText = (0,esm/* useDebounce */.Nr)(valueConfirmText, 500);
    var handleCompareConfirmText = function(val) {
        setValueConfirmText(val);
    };
    var handleCloseModalConfirmText = function() {
        setIsOpenConfirmEnterText(false);
        setValueConfirmText(null);
    };
    var isEnableConfirm = (0,react.useMemo)(function() {
        return !(typeof debouncedValueConfirmText === "string" && debouncedValueConfirmText.toLowerCase() === CONFIRM_TEXT.toLowerCase());
    }, [
        debouncedValueConfirmText
    ]);
    var actions1 = [
        {
            key: configs_const/* ACTION_BLOCK.VISIBLE_BLOCK */.am.VISIBLE_BLOCK,
            icon: isEnable === configs_const/* ENABLE_BLOCK */.C5 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* EyeVisibleIcon */.m0, {
                className: "fill-white",
                width: 20,
                height: 20
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* EyeHiddenIcon */.Fl, {
                className: "fill-white",
                width: 20,
                height: 20
            }),
            text: isEnable === configs_const/* ENABLE_BLOCK */.C5 ? t("ss_builder_hide_block_label") : t("ss_builder_show_block_label")
        },
        {
            key: configs_const/* ACTION_BLOCK.DELETE_BLOCK */.am.DELETE_BLOCK,
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* DeleteIcon */.pJ, {
                className: "fill-white",
                width: 20,
                height: 20,
                fillColor: "#fff"
            }),
            text: t("ss_builder_delete_block_label")
        }, 
    ];
    var handleClickMoreIcon = function(event) {
        event.preventDefault();
    };
    var blockTypeEvent = ga_events/* BLOCK_TYPE_EVENT_CONFIG */.Aw[blockType === null || blockType === void 0 ? void 0 : blockType.toUpperCase()] || (0,lib/* handleCapitalizeFirstLetter */.Tz)(blockType);
    var handleEnableDisableBlock = function() {
        if (isEnable === configs_const/* ENABLE_BLOCK */.C5) {
            ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.BLOCK */.Bt.BLOCK, "Block_Hide_".concat(blockTypeEvent), blockTypeEvent, ga_events/* ACTION_CONFIG.HIDE */.AN.HIDE);
        } else {
            ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.BLOCK */.Bt.BLOCK, "Block_Show_".concat(blockTypeEvent), blockTypeEvent, ga_events/* ACTION_CONFIG.SHOW */.AN.SHOW);
        }
        var blockStatus = isEnable === configs_const/* ENABLE_BLOCK */.C5 ? configs_const/* DISABLE_BLOCK */.gK : configs_const/* ENABLE_BLOCK */.C5;
        onDisableEnableBlock(positionSlug1, blockUid1, blockStatus);
        es/* Toast.show */.FN.show({
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CheckCircleIcon */.rE, {
                className: "text-center inline-block w-[30px] h-[30px]",
                fillColor: "#00B578"
            }),
            content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-center",
                children: isEnable === configs_const/* ENABLE_BLOCK */.C5 ? t("ss_builder_disable_block_successfully_label") : t("ss_builder_enable_block_successfully_label")
            })
        });
    };
    var onRemoveItem = function(sort_order) {
        var deletedBlock = listBlocks.find(function(ele) {
            return ele.sort_order === sort_order;
        });
        dispatch((0,positionsSlice/* deleteBlock */.Gc)({
            deletedBlock: deletedBlock,
            positionSlug: positionSlug1,
            tabUid: tabUid
        }));
        dispatch((0,edittingBlockSlice/* closePopup */.j4)());
    };
    var confirmRemoveBlock = function() {
        var block1 = listBlocks === null || listBlocks === void 0 ? void 0 : listBlocks.find(function(block) {
            return block.uid === blockUid1;
        });
        var isAffProduct = block1.block_type === block_conf/* BLOCK_TYPE.AFF_PRODUCT_GROUP */.bF.AFF_PRODUCT_GROUP || block1.block_type === block_conf/* BLOCK_TYPE.AFF_PRODUCT_GROUP */.bF.AFF_PRODUCT_GROUP;
        es/* Modal.confirm */.u_.confirm({
            header: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationIcon */.Yk, {
                className: "w-11 h-11",
                fillColor: "var(--adm-color-primary)",
                onClick: function() {}
            }),
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: t("ss_builder_confirm-delete_block_title")
            }),
            content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-[15px] font-normal leading-[140%] text-textColorDefault text-center whitespace-normal",
                children: isAffProduct ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "break-words",
                    children: [
                        t("ss_builder_if_delete"),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: "text-[#ee3244ff]",
                            children: [
                                " ",
                                t("ss_builder_all_setting_and_product"),
                                " "
                            ]
                        }),
                        t("ss_builder_in_block_delete_forever_are_you_sure")
                    ]
                }) : t("ss_builder_confirm-delete_block_label")
            }),
            confirmText: t("ss_builder_confirm_delete_block_btn_label"),
            cancelText: t("ss_builder_cancel-delete_block_label"),
            onConfirm: function() {
                if (blockType === block_conf/* BLOCK_TYPE.AFF_PRODUCT */.bF.AFF_PRODUCT || blockType === block_conf/* BLOCK_TYPE.AFF_PRODUCT_GROUP */.bF.AFF_PRODUCT_GROUP) {
                    setIsOpenConfirmEnterText(true);
                } else {
                    onRemoveItem(sort_order1);
                    ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.BLOCK */.Bt.BLOCK, "Block_Delete_".concat(blockTypeEvent), blockTypeEvent, ga_events/* ACTION_CONFIG.DELETE */.AN.DELETE);
                    es/* Toast.show */.FN.show({
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CheckCircleIcon */.rE, {
                            className: "text-center inline-block w-[30px] h-[30px]",
                            fillColor: "#00B578"
                        }),
                        content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-center",
                            children: t("ss_builder_delete_block_successfully_label")
                        })
                    });
                }
            },
            onCancel: function() {
                return;
            }
        });
    };
    var handleTemplate = function() {
        handleLogicShowModalChooseOptionTemplate(true);
    // handleOpenTemplatePopup();
    };
    var handleRemoveItem = function() {
        onRemoveItem(sort_order1);
        ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.BLOCK */.Bt.BLOCK, "Block_Delete_".concat(blockTypeEvent), blockTypeEvent, ga_events/* ACTION_CONFIG.DELETE */.AN.DELETE);
        es/* Toast.show */.FN.show({
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CheckCircleIcon */.rE, {
                className: "text-center inline-block w-[30px] h-[30px]",
                fillColor: "#00B578"
            }),
            content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-center",
                children: t("ss_builder_delete_block_successfully_label")
            })
        });
    };
    var handleClickPopoverItem = function(item) {
        var key = item === null || item === void 0 ? void 0 : item.key;
        switch(key){
            case configs_const/* ACTION_BLOCK.VISIBLE_BLOCK */.am.VISIBLE_BLOCK:
                handleEnableDisableBlock();
                handeSetEnableBlock();
                break;
            case configs_const/* ACTION_BLOCK.DELETE_BLOCK */.am.DELETE_BLOCK:
                confirmRemoveBlock();
                break;
            case configs_const/* ACTION_BLOCK.UPLOAD_AFFILIATE_PRODUCT */.am.UPLOAD_AFFILIATE_PRODUCT:
                handleUploadProductFile();
                break;
            case configs_const/* ACTION_BLOCK.IMPORT_SITE_URL */.am.IMPORT_SITE_URL:
                handleImportSiteUrl();
                break;
            default:
        }
    };
    var handleClickPopoverItemV2 = function(item) {
        var key = item === null || item === void 0 ? void 0 : item.key;
        switch(key){
            case configs_const/* ACTION_BLOCK.VISIBLE_BLOCK */.am.VISIBLE_BLOCK:
                handleEnableDisableBlock();
                handeSetEnableBlock();
                break;
            case configs_const/* ACTION_BLOCK.DELETE_BLOCK */.am.DELETE_BLOCK:
                confirmRemoveBlock();
                break;
            case configs_const/* ACTION_BLOCK.HANDLE_TEMPLATE */.am.HANDLE_TEMPLATE:
                handleTemplate();
                break;
            default:
        }
    };
    var onDisableEnableBlock = function(positionSlug, blockUid, blockStatus) {
        dispatch((0,positionsSlice/* disableEnableBlock */.a8)({
            positionSlug: positionSlug,
            blockUid: blockUid,
            blockStatus: blockStatus,
            tabUid: tabUid
        }));
        var isAutoSave = true;
        dispatch((0,thunk/* saveSite */.qP)(isAutoSave));
        dispatch((0,dynamicSlice/* setDynamicParams */.B9)({
            data: {
                isSaving: true
            }
        }));
    };
    var actionMoreElement = actions1;
    if (blockType === block_conf/* BLOCK_TYPE.TAB */.bF.TAB || blockType === block_conf/* BLOCK_TYPE.TAB_BAR */.bF.TAB_BAR) {
        actionMoreElement = actions1.filter(function(actions) {
            return actions.key !== configs_const/* ACTION_BLOCK.DELETE_BLOCK */.am.DELETE_BLOCK;
        });
    }
    if (blockType === block_conf/* BLOCK_TYPE.COMBINED */.bF.COMBINED && isAdminRole) {
        var ref4, ref5;
        actionMoreElement = _toConsumableArray(KEY !== configs_const/* KEY_BLOCK.ADD_NEW */.ne.ADD_NEW ? actions1 : []).concat([
            {
                key: configs_const/* ACTION_BLOCK.HANDLE_TEMPLATE */.am.HANDLE_TEMPLATE,
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* AddIconTemplateV2 */.ox, {
                    className: "fill-white",
                    width: 20,
                    height: 20,
                    fillColor: "#fff"
                }),
                text: t("ss_builder_add_new_template_label"),
                disabled: !(dataBlock === null || dataBlock === void 0 ? void 0 : (ref4 = dataBlock.content_attributes) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.blocks) === null || ref5 === void 0 ? void 0 : ref5.length)
            }, 
        ]);
    }
    if (blockType === block_conf/* BLOCK_TYPE.AFF_PRODUCT_GROUP */.bF.AFF_PRODUCT_GROUP && Number(router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.import) === configs_const/* IS_DISPLAY_IMPORT_PRODUCT_FILE */.yz) {
        actionMoreElement = _toConsumableArray(KEY !== configs_const/* KEY_BLOCK.ADD_NEW */.ne.ADD_NEW ? actions1 : []).concat([
            {
                key: configs_const/* ACTION_BLOCK.UPLOAD_AFFILIATE_PRODUCT */.am.UPLOAD_AFFILIATE_PRODUCT,
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* UploadIcon */.e3, {
                    className: "w-[17px] h-[17px]",
                    fillColor: "white"
                }),
                text: t("ss_builder_affiliate_upload_product_label")
            },
            {
                key: configs_const/* ACTION_BLOCK.IMPORT_SITE_URL */.am.IMPORT_SITE_URL,
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(line_icon/* LinkAltIcon */.UH, {
                    className: "w-[17px] h-[17px]",
                    fillColor: "white"
                }),
                text: t("ss_builder_import_site_url_label")
            }, 
        ]);
    }
    var handleUploadProductFile = function() {
        dispatch((0,dynamicSlice/* setDynamicParams */.B9)({
            data: {
                isUploadProductFile: true
            }
        }));
    };
    var handleImportSiteUrl = function() {
        dispatch((0,dynamicSlice/* setDynamicParams */.B9)({
            data: {
                isUploadProductFromSiteUrl: true
            }
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex items-center justify-center w-[32px] h-[32px] cursor-pointer",
        style: {
            backgroundColor: "rgba(255, 255, 255, 0.6)",
            borderRadius: "4px"
        },
        onClick: handleClickMoreIcon,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative",
                ref: popoverContainerRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Popover.Menu */.J2.Menu, _objectSpread({
                    className: classnames_default()("popover-block", blockType === block_conf/* BLOCK_TYPE.AFF_PRODUCT_GROUP */.bF.AFF_PRODUCT_GROUP && setting_tour_config/* AFFILIATE_SETTING_TOUR_CLASS_NAME.STEP_1 */.P9.STEP_1),
                    mode: "dark",
                    actions: actionMoreElement,
                    placement: "bottom-end",
                    trigger: "click",
                    stopPropagation: [
                        "click"
                    ],
                    getContainer: function() {
                        return popoverContainerRef.current;
                    },
                    onAction: function(item) {
                        return blockType === block_conf/* BLOCK_TYPE.COMBINED */.bF.COMBINED && isAdminRole ? handleClickPopoverItemV2(item) : handleClickPopoverItem(item);
                    }
                }, visible ? {
                    visible: true
                } : {}, {
                    ref: popoverOptionRef,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* MoreIcon */.nX, {
                        className: "fill-black"
                    })
                }))
            }),
            isOpenConfirmEnterText && /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Modal */.u_, {
                visible: isOpenConfirmEnterText,
                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-[15px] font-normal leading-[140%] text-textColorDefault text-center whitespace-normal",
                            children: t("ss_builder_confirm_delete_aff_block_content")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mt-3 mb-1 text-[#666]",
                            children: t("ss_builder_confirm_delete_aff_block_label_enter_ok")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Input */.II, {
                            placeholder: t("ss_builder_confirm_delete_aff_block_input_placeholder"),
                            onChange: function(val) {
                                handleCompareConfirmText(val);
                            },
                            className: "input-rounded",
                            maxLength: 20,
                            minLength: 1
                        })
                    ]
                }),
                closeOnAction: true,
                onClose: function() {
                    handleCloseModalConfirmText();
                },
                className: "confirm-text-preview-apply-content",
                header: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CloseCircleIconV2 */.GD, {
                    width: 48,
                    height: 48,
                    fillColor: "#FF3141"
                }),
                title: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: t("ss_builder_confirm_delete_aff_block_warining")
                }),
                actions: [
                    {
                        key: "confirm",
                        text: t("ss_builder_confirm_delete_aff_block_understood"),
                        className: "confirm-text",
                        primary: true,
                        disabled: isEnableConfirm,
                        onClick: function() {
                            return handleRemoveItem();
                        }
                    },
                    {
                        key: "cancel",
                        text: t("ss_builder_cancel_delete_aff_block_btn_label"),
                        className: "cancel-text"
                    }, 
                ]
            }),
            isShowModalHandleLogicTemplate && /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Modal */.u_, {
                visible: isShowModalHandleLogicTemplate,
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: t("ss_builder_choose_a_prototying_method")
                }),
                closeOnAction: true,
                onClose: function() {
                    handleCloseModalConfirmText();
                },
                bodyClassName: "theme-template-selection-modal",
                header: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationTriangleIcon */.Lm, {
                    className: "w-11 h-11",
                    fillColor: "#FF8F1F",
                    onClick: function() {}
                }),
                title: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: t("ss_builder_create_template")
                }),
                actions: [
                    {
                        key: "confirm",
                        text: t("ss_builder_add_new_theme_btn_label"),
                        className: "create-text-template",
                        primary: true,
                        onClick: function() {
                            return handleOpenAndHidePopupAddNewTemplate(true);
                        },
                        style: {
                            padding: "7px 0"
                        }
                    },
                    {
                        key: "confirm",
                        text: t("ss_builder_overwrite_theme_btn_label"),
                        className: "overwrite-text-template",
                        primary: true,
                        onClick: function() {
                            return handleOpenTemplatePopup();
                        },
                        style: {
                            padding: "7px 0"
                        }
                    },
                    {
                        key: "cancel",
                        text: t("ss_builder_cancel_delete_aff_block_btn_label"),
                        className: "cancel-text-template",
                        onClick: function() {
                            return handleLogicShowModalChooseOptionTemplate(false);
                        },
                        style: {
                            padding: "7px 0"
                        }
                    }, 
                ]
            })
        ]
    });
};
/* harmony default export */ var components_MoreElement = (MoreElement);

;// CONCATENATED MODULE: ./src/features/mini-store/share/icons/index.tsx
function icons_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function icons_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            icons_defineProperty(target, key, source[key]);
        });
    }
    return target;
}

var CheckCircleIcon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", icons_objectSpread({}, props, {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M16.0003 2.66699C8.66699 2.66699 2.66699 8.66699 2.66699 16.0003C2.66699 23.3337 8.66699 29.3337 16.0003 29.3337C23.3337 29.3337 29.3337 23.3337 29.3337 16.0003C29.3337 8.66699 23.3337 2.66699 16.0003 2.66699ZM21.6003 13.7337L15.2003 20.1337C14.667 20.667 13.867 20.667 13.3337 20.1337L10.4003 17.2003C9.86699 16.667 9.86699 15.867 10.4003 15.3337C10.9337 14.8003 11.7337 14.8003 12.267 15.3337L14.267 17.3337L19.7337 11.867C20.267 11.3337 21.067 11.3337 21.6003 11.867C22.1337 12.4003 22.1337 13.2003 21.6003 13.7337Z",
            fill: "#52C41A"
        })
    }));
};

// EXTERNAL MODULE: ./src/features/share/hooks/index.ts
var share_hooks = __webpack_require__(16565);
;// CONCATENATED MODULE: ./src/features/mini-store/block/BrandGift/IntroductionService/index.tsx








var IntroductionService = function() {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref = (0,share_hooks/* usePopup */.BF)(), visible = ref.visible, openPopup = ref.openPopup, closePopup = ref.closePopup;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* IntroIcon */.nH, {
                className: "cursor-pointer",
                onClick: openPopup
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* Popup */.GI, {
                visible: visible,
                onMaskClick: closePopup,
                position: "bottom",
                bodyClassName: "adm-popup-body-position-bottom-panel",
                bodyStyle: {
                    backgroundColor: "none"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* SafeArea */.Eq, {
                        position: "top"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()("bg-[#fff] max-width-content-layout m-auto relative h-full max-h-[80vh] overflow-y-scroll "),
                        style: {
                            borderRadius: "8px 8px 0px 0px"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "sticky top-0 flex flex-row text-center items-center justify-center relative bg-white",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-ellipsis whitespace-nowrap overflow-hidden max-w-[70vw] md:max-w-[20vw] text-[18.72px] m-3 font-medium",
                                        children: t("ss_builder_title_introduction_service")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "absolute right-3 flex items-center justify-center gap-3",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CloseIcon */.Tw, {
                                            fillColor: "#999999",
                                            className: "absolute right-4 flex items-center justify-center gap-3 cursor-pointer",
                                            onClick: closePopup,
                                            width: 13,
                                            height: 12
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "px-5 text-[15.6px] flex flex-col gap-3 break-words",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: t("ss_builder_content_1_introduction_service")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-row gap-2 items-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCircleIcon, {
                                                style: {
                                                    minWidth: "32px"
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: t("ss_builder_content_list_1_introduction_service")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-row gap-2 items-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCircleIcon, {
                                                style: {
                                                    minWidth: "32px"
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: t("ss_builder_content_list_2_introduction_service")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-row gap-2 items-center ",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCircleIcon, {
                                                style: {
                                                    minWidth: "32px"
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: t("ss_builder_content_list_3_introduction_service")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "font-medium",
                                        children: t("ss_builder_content_2_introduction_service")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "sticky bottom-0 py-3 px-5 bg-white",
                                style: {
                                    boxShadow: "inset 0px 1px 0px #EEEEEE"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: "bg-[#EE3244] w-full py-2 rounded text-white text-[17px]",
                                    onClick: closePopup,
                                    children: t("ss_builder_button_close_introduction_service")
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* SafeArea */.Eq, {
                        position: "bottom"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var BrandGift_IntroductionService = (IntroductionService);

// EXTERNAL MODULE: ./src/features/block/components/HiddenWarningUI/index.tsx
var HiddenWarningUI = __webpack_require__(62904);
;// CONCATENATED MODULE: ./src/features/block/components/BlockEditorWrapper/index.tsx
function BlockEditorWrapper_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function BlockEditorWrapper_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            BlockEditorWrapper_defineProperty(target, key, source[key]);
        });
    }
    return target;
}

















var BlockEditorWrapper = function(props) {
    var ref, ref1, ref2, ref3;
    var block = props.block, onCancelEdit = props.onCancelEdit, onSave = props.onSave, saveBtn = props.saveBtn, onUpdateBlockData = props.onUpdateBlockData;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var passioPageProfile = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.passioPageProfile;
    });
    var creator_role = passioPageProfile === null || passioPageProfile === void 0 ? void 0 : passioPageProfile.creator_role;
    var isAdminRole = (0,react.useMemo)(function() {
        return creator_role === store_interface/* CREATOR_ROLE_ENUM.ADMIN */.lp.ADMIN;
    }, [
        creator_role
    ]);
    var router = (0,next_router.useRouter)();
    var storedBlock = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.edittingBlock;
    });
    var keyBlock = storedBlock && storedBlock.KEY;
    var positionSlug = storedBlock && storedBlock.position_uid;
    var tabUid = storedBlock && storedBlock.tab_uid;
    var storedBlockData = storedBlock && storedBlock.block_data;
    var _title;
    var blockTitle = (_title = block.title) !== null && _title !== void 0 ? _title : storedBlockData && storedBlockData.title;
    var scrollBottomRef = (0,react.useRef)(null);
    var isEnable = (block === null || block === void 0 ? void 0 : block.enable) || configs_const/* ENABLE_BLOCK */.C5;
    var ref4 = (0,react.useState)(false), forceVisiblePopoverHeader = ref4[0], setForceVisiblePopoverHeader = ref4[1];
    (0,react.useEffect)(function() {
        var castWindow = window;
        castWindow.triggerVisiblePopoverMoreElement = setForceVisiblePopoverHeader;
        (function() {
            if (castWindow.triggerVisiblePopoverMoreElement) {
                castWindow.triggerVisiblePopoverMoreElement = undefined;
                setForceVisiblePopoverHeader(false);
            }
        });
    }, []);
    var handleUpdateStatus = function(status) {
        onUpdateBlockData(BlockEditorWrapper_objectSpread({}, block, {
            enable: status
        }));
    };
    var handeSetEnableBlock = function() {
        var newStatus = Object.is(isEnable, configs_const/* ENABLE_BLOCK */.C5) ? configs_const/* DISABLE_BLOCK */.gK : configs_const/* ENABLE_BLOCK */.C5;
        handleUpdateStatus(newStatus);
    };
    var renderExtraAction = function() {
        var action = /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        switch(block.block_type){
            case block_conf/* BLOCK_TYPE.BRAND_GIFT */.bF.BRAND_GIFT:
                action = /*#__PURE__*/ (0,jsx_runtime.jsx)(BrandGift_IntroductionService, {});
                break;
            case block_conf/* BLOCK_TYPE.AFF_PRODUCT_GROUP */.bF.AFF_PRODUCT_GROUP:
                action = /*#__PURE__*/ (0,jsx_runtime.jsx)(AffiliateProductGroup_AffiliateProductTourOpening, {});
                break;
            case block_conf/* BLOCK_TYPE.COMBINED */.bF.COMBINED:
                action = /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PreviewSetting, {
                    blockData: block
                });
                break;
            default:
                break;
        }
        return action;
    };
    var buttonGroupTourClass = (0,react.useMemo)(function() {
        var btnClassName = "";
        switch(block.block_type){
            case block_conf/* BLOCK_TYPE.AFF_PRODUCT_GROUP */.bF.AFF_PRODUCT_GROUP:
                btnClassName = setting_tour_config/* AFFILIATE_SETTING_TOUR_CLASS_NAME.STEP_8 */.P9.STEP_8;
                break;
            default:
                break;
        }
        return btnClassName;
    }, [
        block.block_type
    ]);
    var blockTypeClass = (ref = block.block_type) === null || ref === void 0 ? void 0 : ref.replaceAll("_", "-");
    var isDisplayUploadProductFile = Number(router === null || router === void 0 ? void 0 : (ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.import) === configs_const/* IS_DISPLAY_IMPORT_PRODUCT_FILE */.yz && (storedBlock === null || storedBlock === void 0 ? void 0 : (ref2 = storedBlock.block_data) === null || ref2 === void 0 ? void 0 : ref2.block_type) === block_conf/* BLOCK_TYPE.AFF_PRODUCT_GROUP */.bF.AFF_PRODUCT_GROUP;
    var _block_type, ref5;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "block-editor-wrapper relative h-full",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "pb-[60px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            id: "block-".concat(blockTypeClass, "-editor-header"),
                            className: "sticky top-0 z-[12]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "relative bg-white",
                                    style: {
                                        boxShadow: "inset 0px -1px 0px #EEEEEE"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* NavBar */.l2, {
                                        backArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* BackAngelIcon */.Nz, {}),
                                        onBack: onCancelEdit,
                                        className: "w-full",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-row text-center items-center justify-center gap-[10px] text-[13px]",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "text-ellipsis whitespace-nowrap overflow-hidden max-w-[70vw] md:max-w-[20vw] text-titleFontSize",
                                                    children: (ref5 = t(block_conf/* BLOCK_TYPE_LANGUAGE_KEY */.wu[(_block_type = block.block_type) !== null && _block_type !== void 0 ? _block_type : storedBlock.block_data.block_type])) !== null && ref5 !== void 0 ? ref5 : blockTitle
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "absolute right-4 flex items-center justify-center gap-[8px]",
                                                    children: [
                                                        renderExtraAction(),
                                                        (keyBlock !== configs_const/* KEY_BLOCK.ADD_NEW */.ne.ADD_NEW || (storedBlock === null || storedBlock === void 0 ? void 0 : (ref3 = storedBlock.block_data) === null || ref3 === void 0 ? void 0 : ref3.block_type) === block_conf/* BLOCK_TYPE.COMBINED */.bF.COMBINED && isAdminRole || isDisplayUploadProductFile) && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MoreElement, {
                                                            isEnable: isEnable,
                                                            sort_order: storedBlockData.sort_order,
                                                            positionSlug: positionSlug,
                                                            tabUid: tabUid,
                                                            blockUid: storedBlockData === null || storedBlockData === void 0 ? void 0 : storedBlockData.uid,
                                                            handeSetEnableBlock: handeSetEnableBlock,
                                                            blockType: storedBlockData.block_type,
                                                            type: storedBlockData.block_type,
                                                            visible: forceVisiblePopoverHeader,
                                                            dataBlock: block,
                                                            KEY: keyBlock
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                }),
                                isEnable != configs_const/* ENABLE_BLOCK */.C5 && /*#__PURE__*/ (0,jsx_runtime.jsx)(HiddenWarningUI/* default */.Z, {
                                    label: t("ss_builder_block_design_hiding_label")
                                })
                            ]
                        }),
                        props.children
                    ]
                }),
                props.footer && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()("max-width-content-class fixed bottom-0 p-2 flex w-full justify-between gap-2 z-[10] bg-[#FFFFFF]", buttonGroupTourClass),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-1/2 text-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                                className: "w-full",
                                onClick: onCancelEdit,
                                children: t("ss_builder_editor_btn-cancel")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-1/2 text-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                                className: "w-full",
                                color: "primary",
                                onClick: onSave,
                                disabled: saveBtn.disabled,
                                loading: saveBtn.loading,
                                children: t("ss_builder_editor_btn-save")
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    ref: scrollBottomRef
                })
            ]
        })
    });
};
/* harmony default export */ var components_BlockEditorWrapper = (BlockEditorWrapper);


/***/ }),

/***/ 73173:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_BlockGroup; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/features/block/config/block-selection.ts + 3 modules
var block_selection = __webpack_require__(60329);
// EXTERNAL MODULE: ./src/features/mini-store/share/hook.ts
var hook = __webpack_require__(25013);
// EXTERNAL MODULE: ./node_modules/antd-mobile/es/index.js + 251 modules
var es = __webpack_require__(27175);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/features/block/config/interface.ts
var config_interface = __webpack_require__(93807);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(31567);
// EXTERNAL MODULE: ./src/features/block/components/BlockSelectionV2/index.tsx + 2 modules
var BlockSelectionV2 = __webpack_require__(99872);
// EXTERNAL MODULE: ./src/features/block/components/BlockSelectionV2/components/BlockSelection/style.module.scss
var style_module = __webpack_require__(3304);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
;// CONCATENATED MODULE: ./src/features/block/components/BlockSelectionV2/components/BlockSelection/index.tsx








var Info = function(param) {
    var title = param.title;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            color: "#1890FF"
        },
        className: "pl-3 flex items-center justify-left text-sm",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "mr-1",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockSelectionV2/* OutLineInfoIcon */.tx, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: title
            })
        ]
    });
};
function BlockSelection(props) {
    var block = props.block, onClick = props.onClick, init = props.init;
    var ref = (0,react.useState)(block.defaultState !== undefined ? block.defaultState : config_interface/* SelectionStateEnum.ENABLE */.O_.ENABLE), displayState = ref[0], setDisplayState = ref[1];
    var ref1 = (0,react.useState)(null), warningKey = ref1[0], setwarningKey = ref1[1];
    var t = (0,useTranslation/* useTranslation */.$)().t;
    (0,react.useEffect)(function() {
        if (block.onLoad) {
            init(block.onLoad, setDisplayState, setwarningKey);
        }
    }, []);
    return displayState !== config_interface/* SelectionStateEnum.HIDDEN */.O_.HIDDEN ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()("mb-2 ".concat(!!warningKey ? "pb-3" : "", " bg-white "), (style_module_default()).rounded, displayState !== config_interface/* SelectionStateEnum.DISABLE */.O_.DISABLE ? (style_module_default()).activeButton : null, (style_module_default()).area1, (style_module_default()).area2),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* List.Item */.aV.Item, {
                disabled: displayState !== config_interface/* SelectionStateEnum.ENABLE */.O_.ENABLE,
                description: t(block.description_key),
                prefix: block.Icon(48, 48),
                onClick: onClick,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()("text-titleFontSize", (style_module_default()).fontSize),
                    style: {
                        fontSize: "18px !important"
                    },
                    children: t(block.name_key)
                })
            }),
            !!warningKey && /*#__PURE__*/ (0,jsx_runtime.jsx)(Info, {
                title: t(warningKey)
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};

// EXTERNAL MODULE: ./src/features/share/configs/const.ts
var configs_const = __webpack_require__(55016);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/js-cookie/dist/js.cookie.mjs
var js_cookie = __webpack_require__(31955);
;// CONCATENATED MODULE: ./src/features/block/components/BlockSelectionV2/components/BlockGroup/index.tsx









var BlockGroup = function(props) {
    var ref, ref1;
    var group = props.group, useAppSelector = props.useAppSelector, positionSlug = props.positionSlug, tabUid = props.tabUid, onSelectBlock = props.onSelectBlock;
    var t = (0,hook/* useAppTranslation */.S)().t;
    var router = (0,next_router.useRouter)();
    var fromQuery = router.query.from;
    var fromCookies = js_cookie/* default.get */.Z.get("from");
    var from = fromCookies || fromQuery;
    var state1 = useAppSelector(function(state) {
        return state;
    });
    var allowService = window["AllowStore"];
    var country = state1 === null || state1 === void 0 ? void 0 : (ref = state1.user) === null || ref === void 0 ? void 0 : (ref1 = ref.kol) === null || ref1 === void 0 ? void 0 : ref1.country;
    var blockLists = group.block_list;
    if (country === configs_const/* COUNTRY_TH */.Un) {
        var ref2;
        blockLists = (ref2 = group.block_list) === null || ref2 === void 0 ? void 0 : ref2.filter(function(block) {
            return !block_selection/* COUNTRY_TH_BLOCK_HIDDEN.includes */.I.includes(block === null || block === void 0 ? void 0 : block.block_type);
        });
    }
    if (from === "app") {
        var ref3;
        blockLists = (ref3 = group.block_list) === null || ref3 === void 0 ? void 0 : ref3.filter(function(block) {
            return !block_selection/* BLOCK_FROM_APP_HIDDEN.includes */.KN.includes(block === null || block === void 0 ? void 0 : block.block_type);
        });
    }
    var header = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mx-[-12px] py-2",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-[15px] text-[#333333]",
                children: t(group.name_key)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-xs text-[#8C8C8C]",
                children: t(group.description_key)
            })
        ]
    });
    return (blockLists === null || blockLists === void 0 ? void 0 : blockLists.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* List */.aV, {
        className: "block-selection mx-3",
        header: header,
        children: blockLists.map(function(block) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockSelection, {
                init: function(fn, setDisplayState, setWarningKey) {
                    return fn(setDisplayState, setWarningKey, positionSlug, tabUid, state1, allowService);
                },
                block: block,
                onClick: function() {
                    return onSelectBlock(block);
                }
            }, block.block_type);
        })
    });
};
/* harmony default export */ var components_BlockGroup = (BlockGroup);


/***/ }),

/***/ 67352:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Categories; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/features/design/components/ListItemScrollHorizontal/index.tsx
var ListItemScrollHorizontal = __webpack_require__(82071);
// EXTERNAL MODULE: ./src/features/share/configs/const.ts
var configs_const = __webpack_require__(55016);
// EXTERNAL MODULE: ./node_modules/antd-mobile/es/index.js + 251 modules
var es = __webpack_require__(27175);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(31567);
;// CONCATENATED MODULE: ./src/features/block/components/BlockSelectionV2/icons.tsx

var EarnMoneyIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#FBB523" : _fillColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "22",
        height: "22",
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                "clip-path": "url(#clip0_38484_650603)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M8.29323 5.05676C8.30589 5.11058 8.36032 5.16496 8.41414 5.17767L13.4307 6.36112C13.4845 6.37378 13.4845 6.39458 13.4307 6.40725L8.41414 7.59044C8.36032 7.6031 8.30594 7.65753 8.29323 7.71135L7.10988 12.7279C7.09722 12.7817 7.07642 12.7817 7.06375 12.7279L5.88066 7.71135C5.868 7.65753 5.81357 7.60315 5.75975 7.59044L0.743002 6.40725C0.689182 6.39458 0.689182 6.37378 0.743002 6.36112L5.75975 5.17767C5.81357 5.16501 5.86795 5.11058 5.88066 5.05676L7.06375 0.0403653C7.07642 -0.0134551 7.09722 -0.0134551 7.10988 0.0403653L8.29323 5.05676ZM11.6332 15.9349C11.6458 15.9887 11.7002 16.0431 11.754 16.0558L15.652 16.9754C15.7058 16.988 15.7058 17.0089 15.652 17.0215L11.754 17.941C11.7002 17.9536 11.6458 18.0081 11.6332 18.0618L10.7137 21.9597C10.7011 22.0134 10.6803 22.0134 10.6676 21.9597L9.74829 18.0618C9.73562 18.0081 9.6812 17.9536 9.62738 17.941L5.72925 17.0215C5.67543 17.0089 5.67543 16.988 5.72925 16.9754L9.62738 16.0558C9.6812 16.0431 9.73557 15.9887 9.74829 15.9349L10.6676 12.037C10.6803 11.9833 10.7011 11.9833 10.7137 12.037L11.6332 15.9349ZM18.1655 9.0055C18.1781 9.05932 18.2326 9.11369 18.2863 9.12641L21.2569 9.82723C21.3107 9.83989 21.3107 9.8607 21.2569 9.87336L18.2863 10.5741C18.2326 10.5867 18.1781 10.6412 18.1655 10.695L17.4647 13.6655C17.452 13.7193 17.4312 13.7193 17.4186 13.6655L16.718 10.695C16.7053 10.6412 16.6509 10.5868 16.5971 10.5741L13.6264 9.87336C13.5726 9.8607 13.5726 9.83989 13.6264 9.82723L16.5971 9.12641C16.6509 9.11374 16.7053 9.05932 16.718 9.0055L17.4186 6.03498C17.4312 5.98116 17.452 5.98116 17.4647 6.03498L18.1655 9.0055Z",
                        fill: fillColor
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                        opacity: "0.02",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M13.4313 6.36133C13.4851 6.37399 13.4851 6.3948 13.4313 6.40746L8.41477 7.5905C8.36095 7.60317 8.30658 7.65759 8.29387 7.71141L7.11037 12.728C7.09766 12.7817 7.0769 12.7817 7.06424 12.728L6.92795 12.1502C6.91529 12.0964 6.91529 12.0084 6.92795 11.9546L7.98431 7.47673C7.99697 7.42291 8.0514 7.36854 8.10522 7.35582L12.779 6.25364C12.8328 6.24097 12.9208 6.24097 12.9746 6.25364L13.4313 6.36133ZM15.6525 16.9756C15.7063 16.9883 15.7063 17.0091 15.6525 17.0217L11.7546 17.941C11.7008 17.9537 11.6464 18.0081 11.6337 18.0619L10.714 21.9597C10.7013 22.0135 10.6805 22.0135 10.6678 21.9597L10.5316 21.383C10.5189 21.3292 10.5188 21.2412 10.5316 21.1874L11.3241 17.8271C11.3368 17.7734 11.3912 17.7189 11.445 17.7063L15.0003 16.868C15.054 16.8553 15.1421 16.8552 15.1959 16.868L15.6525 16.9756ZM21.2571 9.82724C21.3109 9.8399 21.3109 9.86071 21.2571 9.87337L18.2869 10.574C18.2331 10.5867 18.1787 10.6411 18.166 10.6949L17.4654 13.6657C17.4527 13.7194 17.4319 13.7194 17.4193 13.6657L17.283 13.0879C17.2703 13.0341 17.2703 12.9461 17.283 12.8923L17.8565 10.4607C17.8691 10.4069 17.9235 10.3525 17.9773 10.3398L20.6054 9.71965C20.6591 9.70694 20.7472 9.70694 20.801 9.71965L21.2571 9.82724Z",
                            fill: "black"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_38484_650603",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "22",
                        height: "22",
                        fill: "white"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/block/components/BlockSelectionV2/components/Categories/item.tsx






var CategoryItemDetail = function(props) {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref = (0,react.useRef)(null);
    var item = props.item, onSelect = props.onSelect, selected = props.selected;
    var Icon = (0,react.useMemo)(function() {
        var icon = null;
        var type = item === null || item === void 0 ? void 0 : item.value;
        switch(type){
            case configs_const/* BLOCK_FILTER_GROUP_TYPE.MONETIZATION */["if"].MONETIZATION:
                icon = /*#__PURE__*/ (0,jsx_runtime.jsx)(EarnMoneyIcon, {});
                break;
        }
        return icon;
    }, [
        item.value
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            ref: ref,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                style: {
                    whiteSpace: "nowrap",
                    background: selected ? "#FFFFFF" : "#F5F5F5",
                    border: selected ? "1px solid #EE3244" : "none",
                    borderRadius: "99px",
                    height: "32px",
                    padding: "5px 16px"
                },
                onClick: function(e) {
                    e.stopPropagation();
                    onSelect(ref.current);
                },
                block: true,
                shape: "rounded",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "flex flex-row gap-1 text-center items-center",
                    children: [
                        Icon,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                            style: {
                                color: selected ? "#EE3244" : "#333333",
                                lineHeight: "22px"
                            },
                            children: t(item.label)
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var Categories_item = (CategoryItemDetail);

// EXTERNAL MODULE: ./src/features/share/lib/ga-events.ts
var ga_events = __webpack_require__(2991);
// EXTERNAL MODULE: ./src/features/share/lib/index.ts + 1 modules
var lib = __webpack_require__(11116);
// EXTERNAL MODULE: ./src/app/hooks.ts
var hooks = __webpack_require__(65457);
;// CONCATENATED MODULE: ./src/features/block/components/BlockSelectionV2/components/Categories/index.tsx







var Categories = function(param) {
    var items = param.items, onChange = param.onChange, selectedGroup = param.selectedGroup;
    var passioPageProfile = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.passioPageProfile;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            marginTop: "12px",
            backgroundColor: "rgba(255, 255, 255)"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemScrollHorizontal/* default */.Z, {
            children: items.map(function(item, index) {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(Categories_item, {
                    item: item,
                    onSelect: function(ele) {
                        ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.BLOCK_TYPE */.Bt.BLOCK_TYPE, "BlockType_GroupFilter_".concat((0,lib/* handleCapitalizeFirstLetter */.Tz)(item === null || item === void 0 ? void 0 : item.value)), (0,lib/* handleCapitalizeFirstLetter */.Tz)(item === null || item === void 0 ? void 0 : item.value), ga_events/* ACTION_CONFIG.GROUP_FILTER */.AN.GROUP_FILTER);
                        onChange(item.value);
                        ele.scrollIntoView({
                            block: "nearest",
                            behavior: "smooth",
                            inline: "center"
                        });
                    },
                    listItemsDefault: items,
                    selected: selectedGroup === item.value
                }, item.value);
            })
        })
    });
};
/* harmony default export */ var components_Categories = (Categories);


/***/ }),

/***/ 99872:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "tx": function() { return /* binding */ OutLineInfoIcon; },
  "ZP": function() { return /* binding */ BlockSelectionV2; }
});

// UNUSED EXPORTS: EmptySearch

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/app/hooks.ts
var hooks = __webpack_require__(65457);
// EXTERNAL MODULE: ./src/features/block/config/block-selection.ts + 3 modules
var block_selection = __webpack_require__(60329);
// EXTERNAL MODULE: ./src/features/block/config/interface.ts
var config_interface = __webpack_require__(93807);
// EXTERNAL MODULE: ./src/features/block/store/edittingBlockSlice.ts
var edittingBlockSlice = __webpack_require__(18684);
// EXTERNAL MODULE: ./src/features/mini-store/share/hook.ts
var hook = __webpack_require__(25013);
// EXTERNAL MODULE: ./src/features/share/configs/const.ts
var configs_const = __webpack_require__(55016);
// EXTERNAL MODULE: ./src/features/share/icons/index.tsx
var icons = __webpack_require__(64035);
// EXTERNAL MODULE: ./src/features/share/lib/index.ts + 1 modules
var lib = __webpack_require__(11116);
// EXTERNAL MODULE: ./src/features/share/lib/ga-events.ts
var ga_events = __webpack_require__(2991);
// EXTERNAL MODULE: ./node_modules/antd-mobile/es/index.js + 251 modules
var es = __webpack_require__(27175);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/features/block/components/BlockSelectionV2/components/BlockGroup/index.tsx + 1 modules
var BlockGroup = __webpack_require__(73173);
// EXTERNAL MODULE: ./src/features/design/design.config.ts + 88 modules
var design_config = __webpack_require__(56214);
// EXTERNAL MODULE: ./src/features/block/block.conf.ts + 92 modules
var block_conf = __webpack_require__(61086);
// EXTERNAL MODULE: ./src/features/share/icons/block-icons.tsx
var block_icons = __webpack_require__(65679);
;// CONCATENATED MODULE: ./src/features/block/config/data/highlight-group.tsx




var HIGHLIGHT_GROUP = {
    name_key: "ss_builder_highlight_block_label",
    description_key: "",
    slug: configs_const/* BLOCK_FILTER_GROUP_TYPE.HIGHLIGHT */["if"].HIGHLIGHT,
    block_list: [
        {
            name_key: "ss_builder_title_block_affiliate_product",
            block_type: block_conf/* BLOCK_TYPE.AFF_PRODUCT_GROUP */.bF.AFF_PRODUCT_GROUP,
            description_key: "ss_builder_block_affiliate_description",
            Icon: function(width, height) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(block_icons/* AffiliateIconV2 */.Qy, {
                    className: "align-middle inline-block rounded-lg",
                    width: width,
                    height: height
                });
            }
        },
        {
            name_key: block_conf/* BLOCK_TYPE_LANGUAGE_KEY */.wu[block_conf/* BLOCK_TYPE.DIGITAL_PRODUCT */.bF.DIGITAL_PRODUCT],
            block_type: block_conf/* BLOCK_TYPE.DIGITAL_PRODUCT */.bF.DIGITAL_PRODUCT,
            description_key: "ss_builder_block_digital_product_description",
            Icon: function(width, height) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(block_icons/* DigitalProducticonV2 */.Nv, {
                    className: "align-middle inline-block rounded-lg",
                    width: width,
                    height: height
                });
            }
        },
        {
            name_key: block_conf/* BLOCK_TYPE_LANGUAGE_KEY */.wu[block_conf/* BLOCK_TYPE.BIO */.bF.BIO],
            block_type: block_conf/* BLOCK_TYPE.BIO */.bF.BIO,
            description_key: "ss_builder_block_bio_description",
            Icon: function(width, height) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(block_icons/* BioIconColor */.kM, {
                    width: width,
                    height: height
                });
            }
        },
        {
            name_key: block_conf/* BLOCK_TYPE_LANGUAGE_KEY */.wu[block_conf/* BLOCK_TYPE.STORY */.bF.STORY],
            block_type: block_conf/* BLOCK_TYPE.STORY */.bF.STORY,
            description_key: "ss_builder_block_button_story_description",
            Icon: function(width, height) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(block_icons/* SpotLightIconColor */.Lr, {
                    width: width,
                    height: height
                });
            }
        }, 
    ]
};

// EXTERNAL MODULE: ./src/features/share/components/dnd-scrollable/index.tsx
var dnd_scrollable = __webpack_require__(77345);
// EXTERNAL MODULE: ./node_modules/js-cookie/dist/js.cookie.mjs
var js_cookie = __webpack_require__(31955);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(31567);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 16 modules
var react_redux_es = __webpack_require__(92145);
;// CONCATENATED MODULE: ./src/features/block/components/BlockSelectionV2/components/BlockHighlight/index.tsx










var BlockHighlight = function(param) {
    var onSelectItem = param.onSelectItem;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var country = (0,react_redux_es/* useSelector */.v9)(function(state) {
        var ref, ref2;
        return state === null || state === void 0 ? void 0 : (ref = state.user) === null || ref === void 0 ? void 0 : (ref2 = ref.kol) === null || ref2 === void 0 ? void 0 : ref2.country;
    });
    var router = (0,next_router.useRouter)();
    var fromQuery = router.query.from;
    var fromCookies = js_cookie/* default.get */.Z.get("from");
    var from = fromCookies || fromQuery;
    var blockLists = HIGHLIGHT_GROUP.block_list;
    if (country === configs_const/* COUNTRY_TH */.Un) {
        var ref3;
        blockLists = (ref3 = HIGHLIGHT_GROUP.block_list) === null || ref3 === void 0 ? void 0 : ref3.filter(function(block) {
            return !block_selection/* COUNTRY_TH_BLOCK_HIDDEN.includes */.I.includes(block === null || block === void 0 ? void 0 : block.block_type);
        });
    }
    if (from === "app") {
        var ref1;
        blockLists = (ref1 = HIGHLIGHT_GROUP.block_list) === null || ref1 === void 0 ? void 0 : ref1.filter(function(block) {
            return !block_selection/* BLOCK_FROM_APP_HIDDEN.includes */.KN.includes(block === null || block === void 0 ? void 0 : block.block_type);
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "text-[15px] font-normal leading-5 text-[#333333] mb-1",
                children: t("ss_builder_hightlight_block_label")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dnd_scrollable/* default */.Z, {
                children: blockLists.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col items-center justify-center gap-1 min-w-[85px] h-[86px] cursor-pointer",
                        onClick: function() {
                            return onSelectItem(item);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: item.Icon(48, 48)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: t("".concat(item.name_key))
                            })
                        ]
                    }, index);
                })
            })
        ]
    });
};
/* harmony default export */ var components_BlockHighlight = (BlockHighlight);

// EXTERNAL MODULE: ./src/features/block/components/BlockSelectionV2/components/Categories/index.tsx + 2 modules
var Categories = __webpack_require__(67352);
;// CONCATENATED MODULE: ./src/features/block/components/BlockSelectionV2/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
















var OutLineInfoIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M7.49968 0.83252C6.18114 0.83252 4.8922 1.22351 3.79588 1.95606C2.69955 2.6886 1.84506 3.72979 1.34048 4.94796C0.835896 6.16614 0.703874 7.50658 0.961109 8.79979C1.21834 10.093 1.85328 11.2809 2.78563 12.2132C3.71798 13.1456 4.90587 13.7805 6.19908 14.0378C7.49228 14.295 8.83273 14.163 10.0509 13.6584C11.2691 13.1538 12.3103 12.2993 13.0428 11.203C13.7754 10.1067 14.1663 8.81773 14.1663 7.49919C14.1663 6.62371 13.9939 5.7568 13.6589 4.94796C13.3238 4.13913 12.8328 3.4042 12.2137 2.78514C11.5947 2.16608 10.8597 1.67502 10.0509 1.33999C9.24206 1.00496 8.37516 0.83252 7.49968 0.83252ZM8.16634 9.83252C8.16634 10.0093 8.09611 10.1789 7.97108 10.3039C7.84606 10.4289 7.67649 10.4992 7.49968 10.4992C7.32287 10.4992 7.1533 10.4289 7.02827 10.3039C6.90325 10.1789 6.83301 10.0093 6.83301 9.83252V7.83252C6.83301 7.65571 6.90325 7.48614 7.02827 7.36112C7.1533 7.23609 7.32287 7.16585 7.49968 7.16585C7.67649 7.16585 7.84606 7.23609 7.97108 7.36112C8.09611 7.48614 8.16634 7.65571 8.16634 7.83252V9.83252ZM7.49968 6.16585C7.33486 6.16585 7.17374 6.11698 7.0367 6.02541C6.89966 5.93384 6.79285 5.80369 6.72978 5.65142C6.66671 5.49915 6.6502 5.33159 6.68236 5.16994C6.71451 5.00829 6.79388 4.85981 6.91042 4.74326C7.02697 4.62672 7.17545 4.54735 7.3371 4.5152C7.49875 4.48304 7.66631 4.49955 7.81858 4.56262C7.97085 4.62569 8.101 4.7325 8.19257 4.86954C8.28414 5.00659 8.33301 5.1677 8.33301 5.33252C8.33301 5.55353 8.24521 5.76549 8.08893 5.92178C7.93265 6.07806 7.72069 6.16585 7.49968 6.16585Z",
            fill: "#1890FF"
        })
    });
};
var EmptySearch = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "260",
        height: "128",
        viewBox: "0 0 432 431",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M316.151 309.04L286.911 335.49L259.151 304.19C264.518 300.387 269.664 296.28 274.561 291.89C279.44 287.457 284.051 282.738 288.371 277.76L316.151 309.04Z",
                fill: "#EDEDED"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M391.491 422.66C388.44 425.423 384.873 427.557 380.995 428.941C377.118 430.324 373.006 430.93 368.894 430.723C364.782 430.516 360.752 429.5 357.033 427.734C353.314 425.968 349.98 423.485 347.221 420.43L279.911 345.14C279.048 344.185 278.38 343.07 277.948 341.858C277.516 340.646 277.326 339.36 277.391 338.074C277.456 336.789 277.774 335.529 278.327 334.366C278.879 333.204 279.656 332.162 280.611 331.3L312.611 302.38C313.564 301.514 314.679 300.845 315.891 300.411C317.103 299.977 318.389 299.786 319.675 299.851C320.961 299.915 322.221 300.232 323.384 300.784C324.547 301.337 325.589 302.113 326.451 303.07L393.761 378.4C396.522 381.453 398.653 385.021 400.033 388.899C401.413 392.777 402.015 396.889 401.804 401C401.594 405.111 400.574 409.14 398.805 412.857C397.035 416.573 394.55 419.904 391.491 422.66V422.66Z",
                fill: "#CBCBCB"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M291.402 60.8595C229.492 -7.58048 123.402 -12.8505 54.9517 49.0695C29.9193 71.7961 12.3443 101.561 4.534 134.457C-3.27628 167.352 -0.95673 201.841 11.1881 233.394C23.333 264.948 44.7354 292.091 72.5856 311.261C100.436 330.431 133.432 340.731 167.242 340.81C259.312 340.81 334.902 265.24 334.902 173.23C334.877 131.667 319.369 91.6048 291.402 60.8595V60.8595ZM250.322 265.02C232.154 281.444 209.525 292.113 185.295 295.678C161.065 299.244 136.321 295.545 114.193 285.051C92.0643 274.556 73.5442 257.736 60.9736 236.717C48.403 215.698 42.3464 191.424 43.5694 166.963C44.7924 142.503 53.2402 118.954 67.8447 99.2936C82.4493 79.6335 102.555 64.7447 125.62 56.5095C148.685 48.2743 173.674 47.0624 197.427 53.027C221.181 58.9916 242.633 71.8649 259.072 90.0195C281.117 114.386 292.581 146.513 290.94 179.332C289.299 212.15 274.688 242.973 250.322 265.02V265.02Z",
                fill: "#CBCBCB"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M250.312 265.02C232.144 281.439 209.516 292.104 185.289 295.667C161.061 299.229 136.321 295.528 114.196 285.032C92.071 274.536 73.5544 257.716 60.9869 236.699C48.4194 215.682 42.3652 191.41 43.5895 166.952C44.8138 142.495 53.2616 118.949 67.8652 99.2918C82.4687 79.6345 102.572 64.748 125.635 56.5141C148.697 48.2802 173.683 47.0686 197.434 53.0323C221.185 58.9961 242.635 71.8675 259.072 90.0196C269.994 102.082 278.433 116.179 283.904 131.504C289.376 146.829 291.773 163.083 290.96 179.335C290.146 195.587 286.138 211.52 279.163 226.223C272.188 240.925 262.384 254.108 250.312 265.02V265.02Z",
                fill: "#EDEDED"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M278.151 175.399L273.851 198.039C273.65 199.097 273.727 200.189 274.075 201.208C274.424 202.227 275.032 203.137 275.839 203.85C276.646 204.562 277.626 205.052 278.68 205.271C279.734 205.49 280.827 205.431 281.851 205.099L306.591 197.229C317.667 202.285 329.755 204.731 341.924 204.38C354.093 204.029 366.02 200.891 376.786 195.206C387.552 189.521 396.869 181.442 404.022 171.59C411.174 161.738 415.97 150.376 418.041 138.379C420.112 126.382 419.403 114.069 415.967 102.389C412.532 90.7098 406.462 79.9741 398.225 71.009C389.988 62.0439 379.804 55.0884 368.456 50.678C357.109 46.2676 344.901 44.5199 332.771 45.5694C294.561 48.7794 263.601 79.6794 260.371 117.889C258.508 138.651 264.895 159.312 278.151 175.399V175.399Z",
                fill: "#B4B4B4"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M284.621 123.359C284.621 134.237 287.847 144.871 293.89 153.916C299.934 162.96 308.524 170.01 318.574 174.173C328.623 178.336 339.682 179.425 350.351 177.303C361.02 175.18 370.82 169.942 378.512 162.25C386.204 154.558 391.442 144.758 393.564 134.089C395.687 123.42 394.597 112.362 390.434 102.312C386.272 92.2619 379.222 83.672 370.178 77.6286C361.133 71.5851 350.499 68.3594 339.621 68.3594C332.396 68.3515 325.241 69.7688 318.564 72.53C311.888 75.2912 305.821 79.3421 300.713 84.4509C295.604 89.5597 291.553 95.626 288.792 102.302C286.03 108.979 284.613 116.134 284.621 123.359V123.359Z",
                fill: "#EDEDED"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M387.151 35.0095C386.295 34.6135 385.631 33.8948 385.303 33.0104C384.975 32.126 385.01 31.1478 385.401 30.2895L397.241 4.38946C397.438 3.96398 397.717 3.58147 398.062 3.26376C398.407 2.94604 398.811 2.69935 399.251 2.53777C399.691 2.3762 400.159 2.30291 400.627 2.32208C401.096 2.34124 401.556 2.45249 401.981 2.64947C402.407 2.84645 402.789 3.1253 403.107 3.47012C403.425 3.81493 403.671 4.21895 403.833 4.6591C403.994 5.09925 404.068 5.56692 404.049 6.03539C404.029 6.50387 403.918 6.96398 403.721 7.38946L391.871 33.2895C391.472 34.142 390.751 34.8017 389.866 35.124C388.982 35.4463 388.006 35.4052 387.151 35.0095V35.0095Z",
                fill: "#C7C7C7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M363.071 31.4894L353.151 4.83942C352.982 4.40027 352.901 3.93192 352.914 3.46151C352.927 2.99109 353.034 2.52792 353.227 2.09879C353.42 1.66966 353.696 1.28309 354.04 0.961431C354.383 0.639769 354.787 0.389399 355.228 0.224813C355.669 0.0602273 356.138 -0.0153041 356.608 0.0025688C357.079 0.0204417 357.541 0.131364 357.968 0.328939C358.395 0.526514 358.778 0.806809 359.097 1.15362C359.415 1.50042 359.661 1.90686 359.821 2.34942L369.761 29.0394C370.091 29.9252 370.056 30.9059 369.663 31.7658C369.27 32.6257 368.552 33.2942 367.666 33.6244C366.78 33.9546 365.799 33.9194 364.939 33.5265C364.08 33.1336 363.411 32.4152 363.081 31.5294L363.071 31.4894Z",
                fill: "#C7C7C7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M397.552 47.2996C397.389 46.861 397.313 46.3945 397.331 45.9269C397.348 45.4592 397.457 44.9996 397.652 44.5742C397.847 44.1488 398.124 43.766 398.467 43.4478C398.81 43.1296 399.213 42.8821 399.652 42.7196L426.332 32.7896C426.773 32.6086 427.247 32.5182 427.724 32.5239C428.202 32.5297 428.673 32.6313 429.11 32.8229C429.548 33.0145 429.942 33.2921 430.27 33.6391C430.597 33.9861 430.852 34.3956 431.019 34.843C431.185 35.2905 431.26 35.7668 431.238 36.2437C431.217 36.7206 431.1 37.1883 430.894 37.619C430.688 38.0498 430.397 38.4346 430.04 38.7508C429.682 39.067 429.264 39.3081 428.812 39.4596L402.152 49.3996C401.712 49.5659 401.244 49.6434 400.774 49.6277C400.304 49.6121 399.842 49.5035 399.414 49.3082C398.986 49.113 398.602 48.8349 398.282 48.4902C397.962 48.1454 397.714 47.7408 397.552 47.2996V47.2996Z",
                fill: "#C7C7C7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M339.601 131.969C339.133 131.971 338.669 131.88 338.236 131.701C337.803 131.523 337.409 131.261 337.078 130.93C336.746 130.6 336.483 130.207 336.303 129.774C336.124 129.342 336.031 128.878 336.031 128.409C336.211 127.649 334.621 119.239 342.561 115.929C344.017 115.32 345.253 114.282 346.103 112.953C346.954 111.623 347.379 110.067 347.321 108.489C347.218 106.555 346.403 104.727 345.033 103.358C343.664 101.988 341.836 101.173 339.901 101.069C338.864 101.035 337.83 101.209 336.862 101.581C335.893 101.954 335.009 102.518 334.263 103.239C333.517 103.96 332.923 104.824 332.517 105.779C332.112 106.735 331.902 107.762 331.901 108.799C331.901 109.267 331.809 109.73 331.63 110.162C331.451 110.594 331.189 110.986 330.859 111.317C330.528 111.647 330.136 111.91 329.704 112.088C329.272 112.267 328.809 112.359 328.341 112.359C327.874 112.359 327.411 112.267 326.979 112.088C326.547 111.91 326.155 111.647 325.824 111.317C325.493 110.986 325.231 110.594 325.052 110.162C324.873 109.73 324.781 109.267 324.781 108.799C324.772 106.105 325.496 103.459 326.875 101.144C328.254 98.8297 330.236 96.9335 332.61 95.6585C334.983 94.3836 337.659 93.778 340.35 93.9066C343.041 94.0351 345.647 94.8929 347.888 96.3882C350.13 97.8835 351.922 99.96 353.074 102.396C354.226 104.831 354.695 107.534 354.429 110.215C354.163 112.896 353.173 115.455 351.566 117.617C349.958 119.779 347.793 121.463 345.301 122.489C342.301 123.719 343.361 127.109 343.161 128.389C343.164 128.859 343.074 129.324 342.896 129.758C342.718 130.192 342.457 130.587 342.126 130.92C341.795 131.252 341.402 131.516 340.968 131.697C340.535 131.877 340.07 131.97 339.601 131.969V131.969Z",
                fill: "#B4B4B4"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M345.151 143.6C345.153 144.704 344.827 145.784 344.215 146.703C343.603 147.623 342.731 148.339 341.711 148.763C340.691 149.186 339.568 149.298 338.485 149.083C337.402 148.868 336.407 148.336 335.626 147.555C334.845 146.774 334.313 145.779 334.098 144.696C333.883 143.612 333.994 142.49 334.418 141.47C334.841 140.45 335.558 139.578 336.477 138.966C337.396 138.353 338.477 138.028 339.581 138.03C341.058 138.032 342.473 138.62 343.517 139.664C344.561 140.708 345.149 142.123 345.151 143.6Z",
                fill: "#B4B4B4"
            })
        ]
    });
};
function BlockSelectionV2(props) {
    var ref4;
    var backFP = props.backFP, cancleFP = props.cancleFP, positionSlug = props.positionSlug, tabUid = props.tabUid, sortOrder = props.sortOrder, tabListBody = props.tabListBody;
    var tabname = (ref4 = tabListBody === null || tabListBody === void 0 ? void 0 : tabListBody.find(function(item) {
        return item.uid === tabUid;
    })) === null || ref4 === void 0 ? void 0 : ref4.name;
    var t = (0,hook/* useAppTranslation */.S)().t;
    var ref1 = (0,react.useState)(configs_const/* BLOCK_FILTER_GROUP_TYPE.ALL */["if"].ALL), selectedGroup = ref1[0], setSelectedGroup = ref1[1];
    var ref2 = (0,react.useState)(""), keyWord = ref2[0], setKeyWord = ref2[1];
    var ref3 = (0,react.useState)(""), value = ref3[0], setValue = ref3[1];
    var dispatch = (0,hooks/* useAppDispatch */.TL)();
    var positions = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.positions;
    });
    var selectedPositionId = (0,react.useMemo)(function() {
        var position = positions.find(function(item) {
            return item.slug == positionSlug;
        });
        return position.id;
    }, [
        positionSlug,
        positions
    ]);
    var passioPageProfile = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.passioPageProfile;
    });
    var handleSelectItem = function(block) {
        var ref;
        var blockType = ga_events/* BLOCK_TYPE_EVENT_CONFIG */.Aw[block === null || block === void 0 ? void 0 : (ref = block.block_type) === null || ref === void 0 ? void 0 : ref.toUpperCase()] || (0,lib/* handleCapitalizeFirstLetter */.Tz)(block.block_type);
        ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.BLOCK_TYPE */.Bt.BLOCK_TYPE, "BlockType_Select_".concat(blockType), blockType, ga_events/* ACTION_CONFIG.SELECT */.AN.SELECT);
        dispatch((0,edittingBlockSlice/* openPopup */.Mw)({
            block: {
                block_type: block.block_type
            },
            position_uid: positionSlug,
            tab_uid: tabUid,
            KEY: configs_const/* KEY_BLOCK.ADD_NEW */.ne.ADD_NEW,
            position_id: selectedPositionId,
            sort_order: sortOrder
        }));
    };
    var groupData = (0,react.useMemo)(function() {
        var allCategory = {
            value: configs_const/* BLOCK_FILTER_GROUP_TYPE.ALL */["if"].ALL,
            label: t("ss_builder_category_all")
        };
        return [
            allCategory, 
        ].concat(_toConsumableArray(block_selection/* BLOCK_SELECTION_GROUP.map */.A5.map(function(group) {
            return {
                value: group.slug,
                label: t(group.name_key)
            };
        })));
    }, [
        block_selection/* BLOCK_SELECTION_GROUP */.A5,
        t
    ]);
    var blockGroups = (0,react.useMemo)(function() {
        if (Object.is(positionSlug, config_interface/* POSITION_TYPE.EXPAND */.Rz.EXPAND)) {
            var filteredBlockGroups = block_selection/* BLOCK_SELECTION_GROUP.filter */.A5.filter(function(group) {
                if (!Object.is(configs_const/* BLOCK_FILTER_GROUP_TYPE.ALL */["if"].ALL, selectedGroup) && !Object.is(selectedGroup, group.slug)) {
                    return false;
                }
                var isIncludeExpandBlock = group.block_list.find(function(e) {
                    return design_config/* EXPAND_POSITION.includes */.$v.includes(e.block_type);
                });
                return !!isIncludeExpandBlock;
            });
            var expandBlockGroups = filteredBlockGroups.map(function(group) {
                var blocks = group.block_list.filter(function(block) {
                    return design_config/* EXPAND_POSITION.includes */.$v.includes(block.block_type);
                });
                return _objectSpread({}, group, {
                    block_list: blocks
                });
            });
            return expandBlockGroups;
        }
        var groups = block_selection/* BLOCK_SELECTION_GROUP.map */.A5.map(function(group) {
            var blocks = group.block_list.filter(function(block) {
                return !design_config/* EXPAND_POSITION.includes */.$v.includes(block.block_type);
            });
            return _objectSpread({}, group, {
                block_list: blocks
            });
        });
        if (selectedGroup && selectedGroup !== configs_const/* BLOCK_FILTER_GROUP_TYPE.ALL */["if"].ALL) {
            return groups.filter(function(group) {
                return group.slug == selectedGroup;
            });
        }
        return groups;
    }, [
        block_selection/* BLOCK_SELECTION_GROUP */.A5,
        selectedGroup
    ]);
    var searchedGroups = (0,react.useMemo)(function() {
        if (!keyWord) {
            return blockGroups;
        }
        return blockGroups.map(function(group) {
            var blockList = group.block_list.filter(function(block) {
                if (t(block.name_key).toLowerCase().includes(keyWord.toLowerCase().trim())) {
                    return true;
                }
                if (t(block.description_key).toLowerCase().includes(keyWord.toLowerCase().trim())) {
                    return true;
                }
                return false;
            });
            return _objectSpread({}, group, {
                block_list: blockList
            });
        }).filter(function(group) {
            return group.block_list.length > 0;
        });
    }, [
        blockGroups,
        keyWord,
        t
    ]);
    var getPositionText = function(slug) {
        var content = "";
        switch(slug){
            case config_interface/* POSITION_TYPE.HEADER */.Rz.HEADER:
            case config_interface/* POSITION_TYPE.FOOTER */.Rz.FOOTER:
            case config_interface/* POSITION_TYPE.EXPAND */.Rz.EXPAND:
                content = " ".concat(t("ss_builder_add_block_".concat(slug, "_title")));
                break;
            case config_interface/* POSITION_TYPE.BODY */.Rz.BODY:
                content = tabListBody.length > 1 ? " ".concat(tabname) : " ".concat(t("ss_builder_body_title"));
                break;
        }
        return content;
    };
    var noticeBarContent = (0,react.useMemo)(function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "text-center w-full px-2",
            style: {
                lineHeight: 1.31,
                color: "#333",
                fontWeight: 400,
                fontSize: "13px"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center justify-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "mr-2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OutLineInfoIcon, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            t("ss_builder_add_block_to"),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-bold",
                                style: {
                                    fontWeight: "bolder",
                                    lineHeight: "17px"
                                },
                                children: getPositionText(props.positionSlug)
                            })
                        ]
                    })
                ]
            })
        });
    }, [
        t
    ]);
    var handleClearKeyWord = function() {
        ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.BLOCK_TYPE */.Bt.BLOCK_TYPE, ga_events/* BLOCK_TYPE_EVENT_CONFIG.BLOCK_TYPE_SEARCH_CLEAR */.Aw.BLOCK_TYPE_SEARCH_CLEAR, ga_events/* LABEL_CONFIG.CLEAR_SEARCH */.tW.CLEAR_SEARCH, ga_events/* ACTION_CONFIG.SEARCH */.AN.SEARCH);
    };
    var isDisplayBlockHighlight = selectedGroup === configs_const/* BLOCK_FILTER_GROUP_TYPE.ALL */["if"].ALL && !keyWord && positionSlug !== config_interface/* POSITION_TYPE.EXPAND */.Rz.EXPAND;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    position: "sticky",
                    top: 0,
                    zIndex: 99
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* NavBar */.l2, {
                        className: "bg-white sticky",
                        backArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* BackAngelIcon */.Nz, {}),
                        right: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                            onClick: cancleFP,
                            type: "button",
                            color: "primary",
                            fill: "none",
                            children: t("ss_builder_cancel")
                        }),
                        onBack: backFP,
                        children: t("ss_builder_panel_title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex w-full bg-white search-block h-[36px] p-3 pb-0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* SearchBar */.E1, {
                                icon: function() {
                                    return null;
                                },
                                placeholder: t("ss_builder_search_type_block"),
                                onChange: function(val) {
                                    setValue(val);
                                },
                                onSearch: function(val) {
                                    setKeyWord(val);
                                    ga_events/* default.submitEventSearch */.ZP.submitEventSearch(window.location.origin, "addBlock", val);
                                },
                                style: {
                                    width: "100%"
                                },
                                onClear: handleClearKeyWord
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "bg-[#EE3244] flex h-43 w-43 cursor-pointer",
                                style: {
                                    width: "43px",
                                    height: "36px",
                                    borderRadius: "0 6px 6px 0"
                                },
                                onClick: function() {
                                    setKeyWord(value);
                                    ga_events/* default.submitEventSearch */.ZP.submitEventSearch(window.location.origin, "addBlock", value);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* SearchIcon */.W1, {
                                    className: "m-auto"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bg-white p-3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Categories/* default */.Z, {
                            items: groupData,
                            onChange: setSelectedGroup,
                            selectedGroup: selectedGroup
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {
                        style: {
                            margin: 0
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bg-white p-3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* NoticeBar */.P8, {
                        style: {
                            border: "1px dashed #91D5FF",
                            borderRadius: "8px",
                            backgroundColor: " #E6F7FF"
                        },
                        className: "block-selection-tab-bar",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                        color: "info",
                        content: noticeBarContent
                    }),
                    isDisplayBlockHighlight && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt-5"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_BlockHighlight, {
                                onSelectItem: handleSelectItem
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    searchedGroups.map(function(group) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockGroup/* default */.Z, {
                            group: group,
                            onSelectBlock: handleSelectItem,
                            useAppSelector: hooks/* useAppSelector */.CG,
                            positionSlug: positionSlug,
                            tabUid: tabUid
                        }, group.slug);
                    }),
                    searchedGroups.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptySearch, {
                                className: "items-center flex mx-auto mt-6 mb-2"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-base text-center text-black text-neutral-900 font-medium",
                                style: {
                                    fontSize: "15.6px"
                                },
                                children: t("ss_builder_empty_search")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-center text-sm font-normal text-neutral-500",
                                style: {
                                    fontSize: "13px"
                                },
                                children: t("ss_builder_try_new_key")
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 1385:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _app_hooks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65457);
/* harmony import */ var _features_main_store_interface__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30053);
/* harmony import */ var _share_configs_const__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55016);
/* harmony import */ var _share_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64035);
/* harmony import */ var antd_mobile__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27175);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(31567);
/* harmony import */ var _features_share_helper_image__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79704);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_8__);










var TemplateList = function(props) {
    var templateData1 = props.templateData, onSelectTemplate = props.onSelectTemplate, onEditTemplate = props.onEditTemplate, onDeleteTemplate = props.onDeleteTemplate, KEY = props.KEY, onShowHideTemplate = props.onShowHideTemplate;
    var popoverRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_9__/* .useTranslation */ .$)().t;
    var passioPageProfile = (0,_app_hooks__WEBPACK_IMPORTED_MODULE_1__/* .useAppSelector */ .CG)(function(state) {
        return state.passioPageProfile;
    });
    var creator_role = passioPageProfile === null || passioPageProfile === void 0 ? void 0 : passioPageProfile.creator_role;
    var isAdminRole = (0,react__WEBPACK_IMPORTED_MODULE_6__.useMemo)(function() {
        return creator_role === _features_main_store_interface__WEBPACK_IMPORTED_MODULE_2__/* .CREATOR_ROLE_ENUM.ADMIN */ .lp.ADMIN;
    }, [
        creator_role
    ]);
    var getAction = function(item) {
        return [
            {
                key: "edit-template",
                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_4__/* .CommentInformationIcon */ .ci, {
                    className: "w-5 h-5",
                    fillColor: "white"
                }),
                text: t("ss_builder_edit_theme_template_label")
            },
            {
                key: (item === null || item === void 0 ? void 0 : item.status) === 1 ? "hide-template" : "show-template",
                icon: (item === null || item === void 0 ? void 0 : item.status) === 1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_4__/* .EyeVisibleIcon */ .m0, {
                    className: "w-5 h-5"
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_4__/* .EyeHiddenIcon */ .Fl, {
                    className: "w-5 h-5"
                }),
                text: (item === null || item === void 0 ? void 0 : item.status) === 1 ? t("ss_builder_hide_theme_template_label") : t("ss_builder_show_theme_template_label")
            },
            {
                key: "delete-template",
                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_4__/* .DeleteIcon */ .pJ, {
                    className: "w-5 h-5"
                }),
                text: t("ss_builder_delete_theme_template_label")
            }, 
        ];
    };
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(null), selectedTemplateData = ref[0], setSelectedTemplateData = ref[1];
    var handleSelectTemplate = function(data) {
        if (KEY === _share_configs_const__WEBPACK_IMPORTED_MODULE_3__/* .TEMPLATE_RENDER_LIST_KEY.TEMPLATE_OVERWRITE_SELECTION */ .fS.TEMPLATE_OVERWRITE_SELECTION) {
            if (data.id === (selectedTemplateData === null || selectedTemplateData === void 0 ? void 0 : selectedTemplateData.id)) {
                setSelectedTemplateData(null);
                onSelectTemplate(null);
            } else {
                setSelectedTemplateData(data);
                onSelectTemplate(data);
            }
        } else {
            onSelectTemplate(data);
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function() {
        if (!!selectedTemplateData) onSelectTemplate(selectedTemplateData);
    }, [
        selectedTemplateData
    ]);
    var handleClickMoreIcon = function(event) {
        event.preventDefault();
    // event.stopPropagation();
    };
    var handleClickPopoverItem = function(item, id) {
        var key = item && item.key;
        var data = templateData1 === null || templateData1 === void 0 ? void 0 : templateData1.find(function(x) {
            return x.id === id;
        });
        switch(key){
            case "edit-template":
                handleEditTemplate(data);
                break;
            case "delete-template":
                handleDeleteTemplate(id);
                break;
            case "hide-template":
                handleShowHideTemplate(data);
                break;
            case "show-template":
                handleShowHideTemplate(data);
                break;
            default:
        }
    };
    var handleEditTemplate = function(templateData) {
        onEditTemplate(templateData);
    };
    var handleShowHideTemplate = function(templateData) {
        onShowHideTemplate(templateData);
    };
    var handleDeleteTemplate = function(templateId) {
        antd_mobile__WEBPACK_IMPORTED_MODULE_5__/* .Modal.confirm */ .u_.confirm({
            header: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_4__/* .InformationTriangleIcon */ .Lm, {
                className: "w-11 h-11",
                fillColor: "var(--adm-color-primary)",
                onClick: function() {}
            }),
            title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: t("ss_builder_confirm_delete_template_modal_title")
            }),
            content: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "text-[15px] font-normal leading-[140%] text-textColorDefault text-center",
                children: t("ss_builder_confirm_delete_template_modal_content")
            }),
            confirmText: t("ss_builder_confirm_delete_theme_template_modal_btn_label"),
            cancelText: t("ss_builder_cancel_delete_theme_template_modal_btn_label"),
            onConfirm: function() {
                onDeleteTemplate(templateId);
            },
            onCancel: function() {
                return;
            }
        });
    };
    return !!(templateData1 === null || templateData1 === void 0 ? void 0 : templateData1.length) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "px-4 pt-4 pb-[65px] bg-white",
        ref: popoverRef,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "grid grid-cols-3 gap-3 bg-[#fff] mb-3",
            children: templateData1 === null || templateData1 === void 0 ? void 0 : templateData1.map(function(ele, index) {
                var listActions = getAction(ele);
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: classnames__WEBPACK_IMPORTED_MODULE_8___default()("relative cursor-pointer", ele.status !== 1 && "opacity-40"),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    // src={getHorizontalResizeUrl(ele.image)}
                                    // fit="cover"
                                    style: {
                                        background: 'url("'.concat((0,_features_share_helper_image__WEBPACK_IMPORTED_MODULE_7__/* .getHorizontalResizeUrl */ .L)(ele.image), '") center top/cover'),
                                        aspectRatio: "9/16",
                                        borderRadius: "4px",
                                        border: ele.id === (selectedTemplateData === null || selectedTemplateData === void 0 ? void 0 : selectedTemplateData.id) ? "2px solid #EE3244" : "2px solid #00000029",
                                        backgroundPosition: "center top",
                                        backgroundSize: "cover"
                                    },
                                    onClick: function() {
                                        return handleSelectTemplate(ele);
                                    }
                                }),
                                ele.id === (selectedTemplateData === null || selectedTemplateData === void 0 ? void 0 : selectedTemplateData.id) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "absolute top-2 right-2 rounded-full bg-[#EE3244]",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_4__/* .CheckCircleIconV2 */ .lo, {
                                        className: "w-5 h-5 ",
                                        fillColor: "white"
                                    })
                                }),
                                KEY !== _share_configs_const__WEBPACK_IMPORTED_MODULE_3__/* .TEMPLATE_RENDER_LIST_KEY.TEMPLATE_OVERWRITE_SELECTION */ .fS.TEMPLATE_OVERWRITE_SELECTION && isAdminRole && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "absolute top-2 right-2 rounded-[4px] bg-[#00000099] p-[2px]",
                                    onClick: handleClickMoreIcon,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_5__/* .Popover.Menu */ .J2.Menu, {
                                        mode: "dark",
                                        actions: listActions,
                                        placement: "bottom",
                                        trigger: "click",
                                        stopPropagation: [
                                            "click"
                                        ],
                                        getContainer: function() {
                                            return popoverRef.current;
                                        },
                                        onAction: function(item) {
                                            return handleClickPopoverItem(item, ele.id);
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_4__/* .MoreIcon */ .nX, {
                                            className: "w-4 h-4 ",
                                            fillColor: "white"
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "text-xs leading-4 text-[#8C8C8C] mt-2 text-ellipsis overflow-hidden whitespace-nowrap",
                            children: ele.title
                        })
                    ]
                }, ele.id);
            })
        })
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "mt-2",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_5__/* .Image */ .Ee, {
                className: "m-auto",
                src: "https://image.passio.eco/page-builder/ssp-landing-page/product-searching-empty-image.png",
                width: 260,
                height: 128
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "text-center mt-2",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "font-medium text-[15.6px] leading-[20.28px] text-neutral-900",
                        children: t("ss_builder_empty_search")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "mt-1 font-normal text-[13px] leading-[16.9px] text-neutral-500",
                        children: t("ss_builder_try_new_key")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TemplateList);


/***/ }),

/***/ 75363:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _share_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64035);
/* harmony import */ var antd_mobile__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27175);
/* harmony import */ var _share_lib__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11116);
/* harmony import */ var react_select_creatable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68451);
/* harmony import */ var _features_design_components_ThemeTemplateHandler_ThemeTemplateSaving_style_module_scss__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(52889);
/* harmony import */ var _features_design_components_ThemeTemplateHandler_ThemeTemplateSaving_style_module_scss__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_features_design_components_ThemeTemplateHandler_ThemeTemplateSaving_style_module_scss__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _share_components_full_screen_popup__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(40015);
/* harmony import */ var _features_design_components_ThemeTemplateHandler_ThemeTemplatePreviewByImage__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(46393);
/* harmony import */ var _share_configs_const__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(55016);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(31567);
/* harmony import */ var _share_api__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(85861);
/* harmony import */ var _app_hooks__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(65457);
/* harmony import */ var _features_main_store_interface__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(30053);
/* harmony import */ var usehooks_ts__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(5678);
/* harmony import */ var _features_block_block_conf__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(61086);
/* harmony import */ var _share_hooks_toast__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(95880);
/* harmony import */ var _share_hooks_modal__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(5996);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}



















var TEMPLATE_NAME_MAXIMUM = 25;
var regexPattern = /\s+/g;
var KEY_COMMA = ",";
var KEY_ENTER = "Enter";
var createOption = function(label) {
    return {
        label: label,
        value: label
    };
};
var TemplateSaving = function(props) {
    var ref16;
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_17__/* .useTranslation */ .$)().t;
    var ConfirmModal = (0,_share_hooks_modal__WEBPACK_IMPORTED_MODULE_16__/* .useModal */ .dd)().ConfirmModal;
    var KEY = props.KEY, handleCancelTemplateSaving = props.handleCancelTemplateSaving, templateDataSaving = props.templateDataSaving, visible = props.visible, onMaskClick = props.onMaskClick, handleLogicShowModalChooseOptionTemplate = props.handleLogicShowModalChooseOptionTemplate, onUpdateListTemplate = props.onUpdateListTemplate, _handleCloseOverwriteList = props.handleCloseOverwriteList, handleCloseOverwriteList = _handleCloseOverwriteList === void 0 ? function() {
        return null;
    } : _handleCloseOverwriteList;
    var siteSettings = (0,_app_hooks__WEBPACK_IMPORTED_MODULE_11__/* .useAppSelector */ .CG)(function(state) {
        return state.siteSettings;
    });
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({}), templateDataDefault = ref1[0], setTemplateDataDefault = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), valueUrlImage = ref2[0], setValueUrlImage = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), templateNameValue = ref3[0], setTemplateNameValue = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isValidFileFormat = ref4[0], setIsValidFileFormat = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isValidFileSize = ref5[0], setIsValidFileSize = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isOpenPreview = ref6[0], setIsOpenPreview = ref6[1];
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), valueNameImage = ref7[0], setValueNameImage = ref7[1];
    var ref8 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), valueImageBase64 = ref8[0], setValueImageBase64 = ref8[1];
    var ref9 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), uploadedImageArr = ref9[0], setUploadedImageArr = ref9[1];
    var ref10 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), listTemplate = ref10[0], setListTemplate = ref10[1];
    var ref11 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), suggestions = ref11[0], setSuggestions = ref11[1];
    var ref12 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), inputValueTag = ref12[0], setInputValueTag = ref12[1];
    var ref13 = _slicedToArray(react__WEBPACK_IMPORTED_MODULE_2__.useState(), 2), valueTag = ref13[0], setValueTag = ref13[1];
    var ref14 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), tagThemeTemplate = ref14[0], setTagThemeTemplate = ref14[1];
    var ref15 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isOpenMenu = ref15[0], setIsOpenMenu = ref15[1];
    var SuccessToast = (0,_share_hooks_toast__WEBPACK_IMPORTED_MODULE_15__/* .useToast */ .p)().SuccessToast;
    var passioPageProfile = (0,_app_hooks__WEBPACK_IMPORTED_MODULE_11__/* .useAppSelector */ .CG)(function(state) {
        return state.passioPageProfile;
    });
    var creator_role = passioPageProfile === null || passioPageProfile === void 0 ? void 0 : passioPageProfile.creator_role;
    var isAdminRole = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return creator_role === _features_main_store_interface__WEBPACK_IMPORTED_MODULE_12__/* .CREATOR_ROLE_ENUM.ADMIN */ .lp.ADMIN;
    }, [
        creator_role
    ]);
    var user = (0,_app_hooks__WEBPACK_IMPORTED_MODULE_11__/* .useAppSelector */ .CG)(function(state) {
        return state.user;
    });
    var userId = user === null || user === void 0 ? void 0 : (ref16 = user.kol) === null || ref16 === void 0 ? void 0 : ref16._id;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var ref;
        setValueUrlImage(templateDataSaving === null || templateDataSaving === void 0 ? void 0 : templateDataSaving.image);
        setTemplateNameValue(templateDataSaving === null || templateDataSaving === void 0 ? void 0 : templateDataSaving.title);
        setTagThemeTemplate(templateDataSaving === null || templateDataSaving === void 0 ? void 0 : templateDataSaving.tags);
        setTemplateDataDefault(templateDataSaving);
        var tags = templateDataSaving === null || templateDataSaving === void 0 ? void 0 : (ref = templateDataSaving.tags) === null || ref === void 0 ? void 0 : ref.map(function(ele) {
            return {
                label: ele,
                value: ele
            };
        });
        if (tags) {
            setValueTag(tags);
        }
    }, [
        templateDataSaving,
        visible
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var requestTemplateList = function() {
            var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var listTemplateResponse, dataRequest, listTemplateArr;
                return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            listTemplateResponse = null;
                            dataRequest = {
                                per_page: 100,
                                keyword: "",
                                is_admin: isAdminRole,
                                block_type: _features_block_block_conf__WEBPACK_IMPORTED_MODULE_14__/* .BLOCK_TYPE.COMBINED */ .bF.COMBINED
                            };
                            _ctx.prev = 2;
                            _ctx.next = 5;
                            return (0,_share_api__WEBPACK_IMPORTED_MODULE_10__/* .requestSearchTemplate */ .ux)(dataRequest);
                        case 5:
                            listTemplateResponse = _ctx.sent;
                            _ctx.next = 11;
                            break;
                        case 8:
                            _ctx.prev = 8;
                            _ctx.t0 = _ctx["catch"](2);
                            console.log(_ctx.t0);
                        case 11:
                            listTemplateArr = listTemplateResponse === null || listTemplateResponse === void 0 ? void 0 : listTemplateResponse.data;
                            if (listTemplateArr) setListTemplate(listTemplateArr);
                        case 13:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        2,
                        8
                    ]
                ]);
            }));
            return function requestTemplateList() {
                return _ref.apply(this, arguments);
            };
        }();
        requestTemplateList();
    }, [
        isAdminRole
    ]);
    var requestTagList = function() {
        var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var keyword, listTagResponse, dataRequest, options, _args = arguments;
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        keyword = _args.length > 0 && _args[0] !== void 0 ? _args[0] : "";
                        listTagResponse = null;
                        dataRequest = {
                            per_page: 12,
                            type: "block-template",
                            keyword: keyword ? keyword.trim().replaceAll(regexPattern, " ").replaceAll(KEY_COMMA, "") : ""
                        };
                        _ctx.prev = 3;
                        _ctx.next = 6;
                        return (0,_share_api__WEBPACK_IMPORTED_MODULE_10__/* .requestSearchTag */ .sV)(dataRequest);
                    case 6:
                        listTagResponse = _ctx.sent;
                        _ctx.next = 12;
                        break;
                    case 9:
                        _ctx.prev = 9;
                        _ctx.t0 = _ctx["catch"](3);
                        console.log(_ctx.t0);
                    case 12:
                        options = listTagResponse === null || listTagResponse === void 0 ? void 0 : listTagResponse.data.map(function(ele) {
                            return {
                                value: ele.title,
                                label: ele.title
                            };
                        });
                        setSuggestions(options !== null && options !== void 0 ? options : []);
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    3,
                    9
                ]
            ]);
        }));
        return function requestTagList() {
            return _ref.apply(this, arguments);
        };
    }();
    var useDebounceSearch = (0,usehooks_ts__WEBPACK_IMPORTED_MODULE_13__/* .useDebounce */ .Nr)(inputValueTag, 500);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (useDebounceSearch) {
            requestTagList(inputValueTag);
        }
    }, [
        useDebounceSearch
    ]);
    var checkDuplicateNameTheme = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        var themeDuplicatedName = null;
        if (KEY === _share_configs_const__WEBPACK_IMPORTED_MODULE_9__/* .TEMPLATE_KEY.SAVE_NEW */ .ax.SAVE_NEW) {
            themeDuplicatedName = listTemplate === null || listTemplate === void 0 ? void 0 : listTemplate.find(function(x) {
                var ref, ref17, ref18;
                return ((ref17 = x === null || x === void 0 ? void 0 : (ref = x.title) === null || ref === void 0 ? void 0 : ref.trim()) === null || ref17 === void 0 ? void 0 : ref17.toLowerCase()) === ((ref18 = templateNameValue === null || templateNameValue === void 0 ? void 0 : templateNameValue.trim()) === null || ref18 === void 0 ? void 0 : ref18.toLowerCase());
            });
        } else if (KEY === _share_configs_const__WEBPACK_IMPORTED_MODULE_9__/* .TEMPLATE_KEY.EDIT */ .ax.EDIT || KEY === _share_configs_const__WEBPACK_IMPORTED_MODULE_9__/* .TEMPLATE_KEY.OVERWRITE */ .ax.OVERWRITE) {
            var ref19;
            themeDuplicatedName = (ref19 = listTemplate === null || listTemplate === void 0 ? void 0 : listTemplate.filter(function(a) {
                return a.id !== (templateDataSaving === null || templateDataSaving === void 0 ? void 0 : templateDataSaving.id);
            })) === null || ref19 === void 0 ? void 0 : ref19.find(function(x) {
                var ref, ref20, ref21;
                return ((ref20 = x === null || x === void 0 ? void 0 : (ref = x.title) === null || ref === void 0 ? void 0 : ref.trim()) === null || ref20 === void 0 ? void 0 : ref20.toLowerCase()) === ((ref21 = templateNameValue === null || templateNameValue === void 0 ? void 0 : templateNameValue.trim()) === null || ref21 === void 0 ? void 0 : ref21.toLowerCase());
            });
        }
        if (themeDuplicatedName) {
            return true;
        } else return false;
    }, [
        listTemplate,
        templateNameValue
    ]);
    var titlePageRender = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        var titleValue = "";
        switch(KEY){
            case _share_configs_const__WEBPACK_IMPORTED_MODULE_9__/* .TEMPLATE_KEY.SAVE_NEW */ .ax.SAVE_NEW:
                titleValue = t("ss_builder_save_new_template_title");
                break;
            case _share_configs_const__WEBPACK_IMPORTED_MODULE_9__/* .TEMPLATE_KEY.OVERWRITE */ .ax.OVERWRITE:
                titleValue = t("ss_builder_overwrite_template_title");
                break;
            case _share_configs_const__WEBPACK_IMPORTED_MODULE_9__/* .TEMPLATE_KEY.EDIT */ .ax.EDIT:
                titleValue = t("ss_builder_edit_template_title");
                break;
        }
        return titleValue;
    }, [
        KEY
    ]);
    var buttonSaveLabelRender = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        var btnLabel = "";
        switch(KEY){
            case _share_configs_const__WEBPACK_IMPORTED_MODULE_9__/* .TEMPLATE_KEY.SAVE_NEW */ .ax.SAVE_NEW:
                btnLabel = t("ss_builder_add_new_template_btn_label");
                break;
            case _share_configs_const__WEBPACK_IMPORTED_MODULE_9__/* .TEMPLATE_KEY.OVERWRITE */ .ax.OVERWRITE:
                btnLabel = t("ss_builder_overwrite_template_btn_label");
                break;
            case _share_configs_const__WEBPACK_IMPORTED_MODULE_9__/* .TEMPLATE_KEY.EDIT */ .ax.EDIT:
                btnLabel = t("ss_builder_edit_template_btn_label");
                break;
        }
        return btnLabel;
    }, [
        KEY
    ]);
    var handleOpenTemplatePreview = function() {
        setIsOpenPreview(true);
    };
    var handleImageUrl = function(value) {
        var imgFileItems = value && value[value.length - 1];
        if (imgFileItems === null || imgFileItems === void 0 ? void 0 : imgFileItems.isValidFormat) {
            setIsValidFileFormat(true);
            setIsValidFileSize(false);
        } else if (imgFileItems === null || imgFileItems === void 0 ? void 0 : imgFileItems.isValidSize) {
            setIsValidFileFormat(false);
            setIsValidFileSize(true);
        } else {
            setUploadedImageArr(value);
            setValueImageBase64(imgFileItems.dataBase64);
            setValueUrlImage(imgFileItems.url);
            setValueNameImage(imgFileItems.fileName);
            setIsValidFileFormat(false);
            setIsValidFileSize(false);
        }
    };
    var handleChangeTemplateName = function(val) {
        if (val.length <= TEMPLATE_NAME_MAXIMUM) {
            setTemplateNameValue(val);
        }
    };
    var handeSetValueTag = function(value) {
        var newValue = value.map(function(ele) {
            return _objectSpread({}, ele, {
                value: ele.value.trim().replaceAll(regexPattern, " ").replaceAll(KEY_COMMA, ""),
                label: ele.label.trim().replaceAll(regexPattern, " ").replaceAll(KEY_COMMA, "")
            });
        });
        setValueTag(newValue);
        var tagTheme = newValue.map(function(ele) {
            return ele.value;
        });
        setTagThemeTemplate(tagTheme);
    };
    var handeInputChange = function(options, param) {
        var action = param.action;
        setInputValueTag(options);
        setIsOpenMenu(options.length > 1);
    };
    var handleKeyDown = function() {
        var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(event) {
            var inputValueTagTrim;
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (inputValueTag) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        if (!(event.key === KEY_ENTER || event.key === KEY_COMMA)) {
                            _ctx.next = 7;
                            break;
                        }
                        inputValueTagTrim = inputValueTag.trim().replaceAll(regexPattern, " ").replaceAll(KEY_COMMA, "");
                        if (!suggestions.some(function(x) {
                            return x.value === inputValueTagTrim;
                        })) {
                            handeSetValueTag(_toConsumableArray(valueTag).concat([
                                createOption(inputValueTagTrim)
                            ]));
                            setInputValueTag("");
                        } else {
                            if (!valueTag.some(function(x) {
                                return x.value === inputValueTagTrim;
                            })) {
                                handeSetValueTag(_toConsumableArray(valueTag).concat([
                                    createOption(inputValueTagTrim)
                                ]));
                                setInputValueTag("");
                            }
                        }
                        event.preventDefault();
                        return _ctx.abrupt("return");
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleKeyDown(event) {
            return _ref.apply(this, arguments);
        };
    }();
    var isDisableSaveBtn = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        if (KEY === _share_configs_const__WEBPACK_IMPORTED_MODULE_9__/* .TEMPLATE_KEY.SAVE_NEW */ .ax.SAVE_NEW && valueUrlImage && templateNameValue && !checkDuplicateNameTheme) return false;
        if (KEY === _share_configs_const__WEBPACK_IMPORTED_MODULE_9__/* .TEMPLATE_KEY.EDIT */ .ax.EDIT && !checkDuplicateNameTheme && (!!(valueTag === null || valueTag === void 0 ? void 0 : valueTag.length) && JSON.stringify(valueTag === null || valueTag === void 0 ? void 0 : valueTag.map(function(a) {
            return a.value;
        })) !== JSON.stringify(templateDataDefault === null || templateDataDefault === void 0 ? void 0 : templateDataDefault.tags) || templateNameValue !== (templateDataDefault === null || templateDataDefault === void 0 ? void 0 : templateDataDefault.title) || valueImageBase64)) {
            return false;
        }
        if (KEY === _share_configs_const__WEBPACK_IMPORTED_MODULE_9__/* .TEMPLATE_KEY.OVERWRITE */ .ax.OVERWRITE) return false;
        return true;
    }, [
        valueUrlImage,
        templateNameValue,
        KEY,
        checkDuplicateNameTheme,
        templateDataDefault,
        valueTag, 
    ]);
    var createManyTag = function() {
        var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(value) {
            var createTagResponse, dataRequest, listTagArr;
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        createTagResponse = null;
                        dataRequest = {
                            user_id: userId,
                            list_tags: value,
                            type: "block-template"
                        };
                        _ctx.prev = 2;
                        _ctx.next = 5;
                        return (0,_share_api__WEBPACK_IMPORTED_MODULE_10__/* .createManyTagThemeTemplate */ .Dw)(dataRequest);
                    case 5:
                        createTagResponse = _ctx.sent;
                        _ctx.next = 11;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](2);
                        console.log(_ctx.t0);
                    case 11:
                        listTagArr = createTagResponse === null || createTagResponse === void 0 ? void 0 : createTagResponse.data;
                        if (listTagArr.error) {
                            _ctx.next = 14;
                            break;
                        }
                        return _ctx.abrupt("return", true);
                    case 14:
                        return _ctx.abrupt("return", false);
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    8
                ]
            ]);
        }));
        return function createManyTag(value) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleConfirmSaveTemplate = function() {
        var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var castWindow, responseImage, reponse, dataResquestUploadImage, dataRequest, newList, dataRequest1, newList1;
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        castWindow = window;
                        responseImage = null;
                        reponse = null;
                        if (!valueImageBase64) {
                            _ctx.next = 29;
                            break;
                        }
                        dataResquestUploadImage = {
                            id: siteSettings.id,
                            user_id: siteSettings.user_id,
                            name: valueNameImage,
                            content: valueImageBase64
                        };
                        _ctx.prev = 5;
                        _ctx.next = 8;
                        return (0,_share_api__WEBPACK_IMPORTED_MODULE_10__/* .requestUploadImage */ .MR)(dataResquestUploadImage);
                    case 8:
                        responseImage = _ctx.sent;
                        _ctx.next = 14;
                        break;
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](5);
                        console.log(_ctx.t0);
                    case 14:
                        if (!responseImage) {
                            _ctx.next = 27;
                            break;
                        }
                        dataRequest = _objectSpread({}, templateDataSaving, {
                            title: templateNameValue,
                            image: responseImage.url,
                            tags: (valueTag === null || valueTag === void 0 ? void 0 : valueTag.map(function(tag) {
                                return tag.value;
                            })) || []
                        });
                        _ctx.prev = 16;
                        _ctx.next = 19;
                        return (0,_share_api__WEBPACK_IMPORTED_MODULE_10__/* .requestUpdateTemplate */ .mW)(dataRequest);
                    case 19:
                        reponse = _ctx.sent;
                        createManyTag(valueTag === null || valueTag === void 0 ? void 0 : valueTag.map(function(tag) {
                            return tag.value;
                        }));
                        _ctx.next = 26;
                        break;
                    case 23:
                        _ctx.prev = 23;
                        _ctx.t1 = _ctx["catch"](16);
                        console.log(_ctx.t1);
                    case 26:
                        if (/^20[0-9]$/.test(reponse === null || reponse === void 0 ? void 0 : reponse.status.toString())) {
                            if (KEY !== _share_configs_const__WEBPACK_IMPORTED_MODULE_9__/* .TEMPLATE_KEY.SAVE_NEW */ .ax.SAVE_NEW) {
                                newList = listTemplate.map(function(item) {
                                    if (item.id === templateDataSaving.id) return _objectSpread({}, templateDataSaving, {
                                        title: templateNameValue,
                                        image: responseImage.url,
                                        tags: (valueTag === null || valueTag === void 0 ? void 0 : valueTag.map(function(tag) {
                                            return tag.value;
                                        })) || []
                                    });
                                    return item;
                                });
                                onUpdateListTemplate(newList);
                            }
                            handleCancelTemplateSaving();
                            handleLogicShowModalChooseOptionTemplate(false);
                            if (!!handleCloseOverwriteList) {
                                handleCloseOverwriteList();
                            }
                            castWindow.functionHandleOpenCloseTemplateList(true);
                            SuccessToast(KEY === _share_configs_const__WEBPACK_IMPORTED_MODULE_9__/* .TEMPLATE_KEY.OVERWRITE */ .ax.OVERWRITE ? t("ss_builder_overwrite_template_successfully_label") : t("ss_builder_save_new_theme_template_successfully_label"));
                        }
                    case 27:
                        _ctx.next = 41;
                        break;
                    case 29:
                        dataRequest1 = _objectSpread({}, templateDataSaving, {
                            title: templateNameValue,
                            tags: (valueTag === null || valueTag === void 0 ? void 0 : valueTag.map(function(tag) {
                                return tag.value;
                            })) || []
                        });
                        _ctx.prev = 30;
                        _ctx.next = 33;
                        return (0,_share_api__WEBPACK_IMPORTED_MODULE_10__/* .requestUpdateTemplate */ .mW)(dataRequest1);
                    case 33:
                        reponse = _ctx.sent;
                        createManyTag(valueTag === null || valueTag === void 0 ? void 0 : valueTag.map(function(tag) {
                            return tag.value;
                        }));
                        _ctx.next = 40;
                        break;
                    case 37:
                        _ctx.prev = 37;
                        _ctx.t2 = _ctx["catch"](30);
                        console.log(_ctx.t2);
                    case 40:
                        if (/^20[0-9]$/.test(reponse === null || reponse === void 0 ? void 0 : reponse.status.toString())) {
                            if (KEY !== _share_configs_const__WEBPACK_IMPORTED_MODULE_9__/* .TEMPLATE_KEY.SAVE_NEW */ .ax.SAVE_NEW) {
                                newList1 = listTemplate.map(function(item) {
                                    if (item.id === templateDataSaving.id) return _objectSpread({}, templateDataSaving, {
                                        title: templateNameValue,
                                        tags: (valueTag === null || valueTag === void 0 ? void 0 : valueTag.map(function(tag) {
                                            return tag.value;
                                        })) || []
                                    });
                                    return item;
                                });
                                onUpdateListTemplate(newList1);
                            }
                            handleCancelTemplateSaving();
                            handleLogicShowModalChooseOptionTemplate(false);
                            if (!!handleCloseOverwriteList) {
                                handleCloseOverwriteList();
                            }
                            castWindow.functionHandleOpenCloseTemplateList(true);
                            SuccessToast(KEY === _share_configs_const__WEBPACK_IMPORTED_MODULE_9__/* .TEMPLATE_KEY.OVERWRITE */ .ax.OVERWRITE ? t("ss_builder_overwrite_template_successfully_label") : t("ss_builder_save_new_theme_template_successfully_label"));
                        }
                    case 41:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    5,
                    11
                ],
                [
                    16,
                    23
                ],
                [
                    30,
                    37
                ]
            ]);
        }));
        return function handleConfirmSaveTemplate() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCancelAction = function() {
        if (isDisableSaveBtn) {
            handleCancelTemplateSaving();
        } else {
            ConfirmModal({
                icon: _share_hooks_modal__WEBPACK_IMPORTED_MODULE_16__/* .ModalIconConfig.INFO_WARNING_CIRCLE */ .vi.INFO_WARNING_CIRCLE,
                title: t("ss_builder_cancel_edit_block_title"),
                description: t("ss_builder_cancel_edit_block_content"),
                confirmText: t("ss_builder_continue_edit_block_label"),
                cancelText: t("ss_builder_cancel_block_btn_label"),
                onConfirm: function() {
                    return null;
                },
                onCancel: handleCancelTemplateSaving
            });
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_share_components_full_screen_popup__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        visible: visible,
        onMaskClick: function() {
            onMaskClick(false);
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: "pb-[60px]",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    className: "flex flex-row text-center items-center justify-center py-3 gap-[10px] relative bg-white",
                    style: {
                        boxShadow: "inset 0px -1px 0px #EEEEEE"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_3__/* .SaveIcon */ .N, {
                            className: "w-[22px] h-[22px]"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: "text-[18px] leading-6",
                            children: titlePageRender
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    className: "px-4 py-3 bg-white",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            className: "text-[15px] text-[#666666]",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                    className: "text-red-600",
                                    children: "*"
                                }),
                                t("ss_builder_add_new_template_image_title")
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_4__/* .Image */ .Ee, {
                            src: valueUrlImage || "https://image.passio.eco/page-builder/page-builder/images-default/image-validate-default-alert.png",
                            fit: "cover",
                            style: {
                                backgroundSize: "cover",
                                aspectRatio: "16/9",
                                border: "1px solid #D9D9D9"
                            }
                        }),
                        isValidFileFormat && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            className: "flex flex-row gap-1 items-center mt-1",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_3__/* .InformationTriangleIcon */ .Lm, {
                                    fillColor: "#FF3141",
                                    className: "w-4 h-4"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    className: "text-[#FF3141]",
                                    children: t("ss_builder_upload_file_format_invalid_content")
                                })
                            ]
                        }),
                        isValidFileSize && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            className: "flex flex-row gap-1 items-center mt-1",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_3__/* .InformationTriangleIcon */ .Lm, {
                                    fillColor: "#FF3141",
                                    className: "w-4 h-4"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    className: "text-[#FF3141]",
                                    children: t("ss_builder_upload_file_size_invalid_content")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            className: "flex gap-2 mt-4",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .zx, {
                                    size: "middle",
                                    color: "primary",
                                    fill: "outline",
                                    className: "",
                                    onClick: valueUrlImage ? handleOpenTemplatePreview : function() {},
                                    style: {
                                        opacity: !valueUrlImage ? "0.4" : ""
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_3__/* .PreviewThemeIcon */ .gc, {
                                        className: "w-[17px] h-[17px]",
                                        fillColor: "#EE3244"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_4__/* .ImageUploader */ .wA, {
                                    onChange: handleImageUrl,
                                    upload: function(file) {
                                        return (0,_share_lib__WEBPACK_IMPORTED_MODULE_5__/* .mockUpload */ .Hq)(file, 514);
                                    },
                                    className: "image-slider-upload ".concat(uploadedImageArr.length > 0 ? "image-uploaded-hidden" : ""),
                                    value: uploadedImageArr,
                                    // disableUpload={isDisableUploadBtn}
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .zx, {
                                        block: true,
                                        color: "primary",
                                        fill: "solid",
                                        size: "middle",
                                        className: "w-full grow",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                            className: "flex flex-row gap-2 justify-center items-center",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_3__/* .UploadIcon */ .e3, {
                                                    className: "w-[17px] h-[17px]",
                                                    fillColor: "white"
                                                }),
                                                t("ss_builder_upload_button_label")
                                            ]
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_4__/* .Divider */ .iz, {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                    className: "text-[15px] text-[#666666]",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                            className: "text-red-600",
                                            children: "*"
                                        }),
                                        t("ss_builder_add_new_template_name_title")
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_4__/* .Input */ .II, {
                                    placeholder: t("ss_builder_add_new_template_name_placeholder"),
                                    onChange: handleChangeTemplateName,
                                    value: templateNameValue,
                                    maxLength: TEMPLATE_NAME_MAXIMUM
                                }),
                                checkDuplicateNameTheme && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    className: "text-[13px] leading-[17px] text-[#FF3141]",
                                    children: t("ss_builder_duplicated_theme_template_name_warning")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    className: "text-[#999999] text-[13px] leading-[17px] w-full text-right",
                                    children: "".concat(templateNameValue ? templateNameValue.length : 0, "/").concat(TEMPLATE_NAME_MAXIMUM)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_4__/* .Divider */ .iz, {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    className: "text-[15px] text-[#666666] leading-[150%]",
                                    children: t("ss_builder_theme_template_label_tag")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_select_creatable__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                        isClearable: true,
                                        isMulti: true,
                                        options: suggestions,
                                        inputValue: inputValueTag,
                                        onChange: function(newValue) {
                                            return handeSetValueTag(newValue);
                                        },
                                        onInputChange: function(newValue, param) {
                                            var action = param.action;
                                            return handeInputChange(newValue, {
                                                action: action
                                            });
                                        },
                                        onKeyDown: handleKeyDown,
                                        value: valueTag,
                                        placeholder: t("ss_builder_theme_template_label_tag_placeholder"),
                                        classNames: {
                                            control: function(state) {
                                                return "".concat((_features_design_components_ThemeTemplateHandler_ThemeTemplateSaving_style_module_scss__WEBPACK_IMPORTED_MODULE_18___default().borderTag));
                                            }
                                        },
                                        className: "react-select-container",
                                        classNamePrefix: "react-select",
                                        menuIsOpen: isOpenMenu,
                                        components: {
                                            DropdownIndicator: function() {
                                                return null;
                                            },
                                            IndicatorSeparator: function() {
                                                return null;
                                            }
                                        },
                                        formatCreateLabel: function(userInput) {
                                            return "".concat(t("ss_builder_theme_template_format_create_label"), ' "').concat(userInput, '"');
                                        },
                                        noOptionsMessage: function() {
                                            return null;
                                        }
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    className: "max-width-content-class fixed bottom-0 p-2 flex w-full justify-between gap-2 z-[1] bg-[#FFFFFF]",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: "w-1/2 text-center",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .zx, {
                                className: "w-full",
                                onClick: handleCancelAction,
                                children: t("ss_builder_editor_btn-cancel")
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: "w-1/2 text-center",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .zx, {
                                className: "w-full",
                                color: "primary",
                                onClick: function() {
                                    return handleConfirmSaveTemplate();
                                },
                                disabled: isDisableSaveBtn,
                                children: buttonSaveLabelRender
                            })
                        })
                    ]
                }),
                isOpenPreview && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_share_components_full_screen_popup__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    visible: isOpenPreview,
                    onMaskClick: function() {
                        setIsOpenPreview(false);
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_features_design_components_ThemeTemplateHandler_ThemeTemplatePreviewByImage__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        handleCancelThemeTemplatePreview: function() {
                            return setIsOpenPreview(false);
                        },
                        imageSrc: valueUrlImage,
                        KEY: _share_configs_const__WEBPACK_IMPORTED_MODULE_9__/* .THEME_PREVIEW_BY_IMAGE_KEY.PREVIEW */ .cQ.PREVIEW
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TemplateSaving);


/***/ }),

/***/ 60329:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "KN": function() { return /* binding */ BLOCK_FROM_APP_HIDDEN; },
  "A5": function() { return /* binding */ BLOCK_SELECTION_GROUP; },
  "I": function() { return /* binding */ COUNTRY_TH_BLOCK_HIDDEN; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/features/block/block.conf.ts + 92 modules
var block_conf = __webpack_require__(61086);
// EXTERNAL MODULE: ./src/features/share/configs/const.ts
var configs_const = __webpack_require__(55016);
// EXTERNAL MODULE: ./src/features/share/icons/block-icons.tsx
var block_icons = __webpack_require__(65679);
;// CONCATENATED MODULE: ./src/features/block/config/data/basic-group.tsx




var SelectionStateEnum;
(function(SelectionStateEnum) {
    SelectionStateEnum[SelectionStateEnum["ENABLE"] = 1] = "ENABLE";
    SelectionStateEnum[SelectionStateEnum["DISABLE"] = 2] = "DISABLE";
    SelectionStateEnum[SelectionStateEnum["HIDDEN"] = 3] = "HIDDEN";
})(SelectionStateEnum || (SelectionStateEnum = {}));
var BASIC_GROUP = {
    name_key: "ss_builder_basic_title",
    description_key: "ss_builder_basic_group_description",
    slug: configs_const/* BLOCK_FILTER_GROUP_TYPE.BASIC */["if"].BASIC,
    block_list: [
        {
            name_key: block_conf/* BLOCK_TYPE_LANGUAGE_KEY */.wu[block_conf/* BLOCK_TYPE.BUTTON_LINK */.bF.BUTTON_LINK],
            block_type: block_conf/* BLOCK_TYPE.BUTTON_LINK */.bF.BUTTON_LINK,
            description_key: "ss_builder_block_button_link_description",
            Icon: function(width, height) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(block_icons/* ButtonLinkIconColor */.jN, {
                    width: width,
                    height: height
                });
            }
        },
        {
            name_key: block_conf/* BLOCK_TYPE_LANGUAGE_KEY */.wu[block_conf/* BLOCK_TYPE.IMAGE */.bF.IMAGE],
            block_type: block_conf/* BLOCK_TYPE.IMAGE */.bF.IMAGE,
            description_key: "ss_builder_block_image_description",
            Icon: function(width, height) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(block_icons/* ImageIconColor */.o9, {
                    width: width,
                    height: height
                });
            }
        },
        {
            name_key: block_conf/* BLOCK_TYPE_LANGUAGE_KEY */.wu[block_conf/* BLOCK_TYPE.TEXT */.bF.TEXT],
            block_type: block_conf/* BLOCK_TYPE.TEXT */.bF.TEXT,
            description_key: "ss_builder_block_text_description",
            Icon: function(width, height) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(block_icons/* TextIconColor */.HF, {
                    width: width,
                    height: height
                });
            }
        }, 
    ]
};

// EXTERNAL MODULE: ./src/features/block/config/interface.ts
var config_interface = __webpack_require__(93807);
;// CONCATENATED MODULE: ./src/features/block/config/data/advance-group.tsx





var ADVANCE_GROUP = {
    name_key: "ss_builder_advanced_title",
    description_key: "ss_builder_advanced_group_description",
    slug: configs_const/* BLOCK_FILTER_GROUP_TYPE.ADVANCED */["if"].ADVANCED,
    block_list: [
        {
            name_key: block_conf/* BLOCK_TYPE_LANGUAGE_KEY */.wu[block_conf/* BLOCK_TYPE.BIO */.bF.BIO],
            block_type: block_conf/* BLOCK_TYPE.BIO */.bF.BIO,
            description_key: "ss_builder_block_bio_description",
            Icon: function(width, height) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(block_icons/* BioIconColor */.kM, {
                    width: width,
                    height: height
                });
            }
        },
        {
            name_key: block_conf/* BLOCK_TYPE_LANGUAGE_KEY */.wu[block_conf/* BLOCK_TYPE.STORY */.bF.STORY],
            block_type: block_conf/* BLOCK_TYPE.STORY */.bF.STORY,
            description_key: "ss_builder_block_button_story_description",
            Icon: function(width, height) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(block_icons/* SpotLightIconColor */.Lr, {
                    width: width,
                    height: height
                });
            }
        },
        {
            name_key: block_conf/* BLOCK_TYPE_LANGUAGE_KEY */.wu[block_conf/* BLOCK_TYPE.IMAGE_SLIDER */.bF.IMAGE_SLIDER],
            block_type: block_conf/* BLOCK_TYPE.IMAGE_SLIDER */.bF.IMAGE_SLIDER,
            description_key: "ss_builder_block_image_slider_description",
            Icon: function(width, height) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(block_icons/* ImageSliderIconColor */.rG, {
                    width: width,
                    height: height
                });
            }
        },
        {
            name_key: block_conf/* BLOCK_TYPE_LANGUAGE_KEY */.wu[block_conf/* BLOCK_TYPE.BUTTON_MULTI_LINK */.bF.BUTTON_MULTI_LINK],
            block_type: block_conf/* BLOCK_TYPE.BUTTON_MULTI_LINK */.bF.BUTTON_MULTI_LINK,
            description_key: "ss_builder_block_button_multi_description",
            Icon: function(width, height) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(block_icons/* MultiLinksIconColor */.e_, {
                    width: width,
                    height: height
                });
            }
        },
        // {
        //     name_key: "ss_builder_title_block_story",
        //     block_type: BLOCK_TYPE.STORY,
        //     description_key: "ss_builder_block_button_story_description",
        //     Icon: () => <StoryIcon className="align-middle inline-block w-12 h-12" />
        // },
        {
            name_key: block_conf/* BLOCK_TYPE_LANGUAGE_KEY */.wu[block_conf/* BLOCK_TYPE.CARD */.bF.CARD],
            block_type: block_conf/* BLOCK_TYPE.CARD */.bF.CARD,
            description_key: "ss_builder_block_block_card_description",
            Icon: function(width, height) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(block_icons/* CardIconColor */.Vf, {
                    width: width,
                    height: height
                });
            }
        },
        {
            name_key: block_conf/* BLOCK_TYPE_LANGUAGE_KEY */.wu[block_conf/* BLOCK_TYPE.EMBED */.bF.EMBED],
            block_type: block_conf/* BLOCK_TYPE.EMBED */.bF.EMBED,
            description_key: "ss_builder_block_image_embed_description",
            Icon: function(width, height) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(block_icons/* EmbedIconColor */.xC, {
                    width: width,
                    height: height
                });
            }
        },
        {
            name_key: block_conf/* BLOCK_TYPE_LANGUAGE_KEY */.wu[block_conf/* BLOCK_TYPE.IMAGE_GALLERY */.bF.IMAGE_GALLERY],
            block_type: block_conf/* BLOCK_TYPE.IMAGE_GALLERY */.bF.IMAGE_GALLERY,
            description_key: "ss_builder_block_image_gallery_description",
            Icon: function(width, height) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(block_icons/* ImageGalleryIconColor */.mQ, {
                    width: width,
                    height: height
                });
            }
        },
        {
            name_key: "ss_builder_title_block_image_popup",
            block_type: block_conf/* BLOCK_TYPE.IMAGE_POPUP */.bF.IMAGE_POPUP,
            description_key: "ss_builder_block_image_popup_description",
            Icon: function(width, height) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(block_icons/* ImagePopupIcon */.GS, {
                    className: "align-middle inline-block",
                    width: width,
                    height: height
                });
            },
            defaultState: config_interface/* SelectionStateEnum.DISABLE */.O_.DISABLE,
            onLoad: function(setDisplayState, setWarningKey, positionSlug, tabUid, state) {
                var positions = state.positions;
                var expand = positions.find(function(position) {
                    return position.slug == config_interface/* POSITION_TYPE.EXPAND */.Rz.EXPAND;
                });
                var includeInExpand = expand && expand.block_list.find(function(block) {
                    return block.block_type == block_conf/* BLOCK_TYPE.IMAGE_POPUP */.bF.IMAGE_POPUP;
                });
                if (!includeInExpand) {
                    setDisplayState(config_interface/* SelectionStateEnum.ENABLE */.O_.ENABLE);
                } else {
                    setWarningKey("ss_builder_image_popup_warning");
                }
            }
        },
        {
            name_key: block_conf/* BLOCK_TYPE_LANGUAGE_KEY */.wu[block_conf/* BLOCK_TYPE.COMBINED */.bF.COMBINED],
            block_type: block_conf/* BLOCK_TYPE.COMBINED */.bF.COMBINED,
            description_key: "ss_builder_block_list_combined_description",
            Icon: function(width, height) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(block_icons/* CombinedBlockIcon */.o2, {
                    width: width,
                    height: height
                });
            }
        },
        {
            name_key: block_conf/* BLOCK_TYPE_LANGUAGE_KEY */.wu[block_conf/* BLOCK_TYPE.SPACER_AND_DIVIDER */.bF.SPACER_AND_DIVIDER],
            block_type: block_conf/* BLOCK_TYPE.SPACER_AND_DIVIDER */.bF.SPACER_AND_DIVIDER,
            description_key: "ss_builder_block_spacer_and_divider_description",
            Icon: function(width, height) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(block_icons/* SpacerAndDividerIcon */.ox, {
                    width: width,
                    height: height
                });
            }
        }, 
    ]
};

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/features/design/design.config.ts + 88 modules
var design_config = __webpack_require__(56214);
;// CONCATENATED MODULE: ./src/features/block/config/data/revenue-group.tsx








var REVENUE_GROUP = {
    name_key: "ss_builder_revenue_title",
    description_key: "ss_builder_revenue_group_description",
    slug: configs_const/* BLOCK_FILTER_GROUP_TYPE.MONETIZATION */["if"].MONETIZATION,
    block_list: [
        {
            name_key: "ss_builder_title_block_affiliate_product",
            block_type: block_conf/* BLOCK_TYPE.AFF_PRODUCT_GROUP */.bF.AFF_PRODUCT_GROUP,
            description_key: "ss_builder_block_affiliate_description",
            Icon: function(width, height) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(block_icons/* AffiliateIconV2 */.Qy, {
                    className: "align-middle inline-block rounded-lg",
                    width: width,
                    height: height
                });
            }
        },
        {
            name_key: "ss_builder_title_brand_gift_footer",
            block_type: block_conf/* BLOCK_TYPE.BRAND_GIFT_FOOTER */.bF.BRAND_GIFT_FOOTER,
            description_key: "ss_brand_gift_setting_float_icon_footer_description",
            Icon: function(width, height) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(block_icons/* IconBrandGift */.T0, {
                    className: "align-middle inline-block rounded-lg",
                    width: width,
                    height: height
                });
            },
            defaultState: config_interface/* SelectionState.DISABLE */.fP.DISABLE,
            onLoad: function(setDisplayState, setWarningKey, positionSlug, tabUid, state) {
                var positions = state.positions;
                var allowStore = window["AllowStore"];
                if (!(allowStore === null || allowStore === void 0 ? void 0 : allowStore.allow_view_brand_gift)) {
                    setDisplayState(config_interface/* SelectionState.HIDDEN */.fP.HIDDEN);
                    return;
                }
                var expand = positions.find(function(position) {
                    return position.slug == config_interface/* POSITION_TYPE.EXPAND */.Rz.EXPAND;
                });
                var includeInExpand = expand && expand.block_list.find(function(block) {
                    return block.block_type == block_conf/* BLOCK_TYPE.BRAND_GIFT_FOOTER */.bF.BRAND_GIFT_FOOTER;
                });
                var isFloatingFull = expand.block_list.filter(function(e) {
                    return design_config/* BLOCK_TYPE_BY_GROUP.FLOATING.includes */.Vm.FLOATING.includes(e.block_type);
                }).length >= design_config/* COUNT_OF_FLOATING_BLOCK_MAXIMUM */.Y3;
                if (isFloatingFull) {
                    setWarningKey("ss_builder_floating_full");
                } else if (includeInExpand) {
                    setWarningKey("ss_builder_gift_warning");
                } else {
                    setDisplayState(config_interface/* SelectionStateEnum.ENABLE */.O_.ENABLE);
                }
            }
        },
        {
            name_key: "ss_builder_title_block_brand_gift",
            block_type: block_conf/* BLOCK_TYPE.BRAND_GIFT */.bF.BRAND_GIFT,
            description_key: "ss_builder_title_block_brand_gift_description",
            Icon: function(width, height) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(block_icons/* IconBrandGift */.T0, {
                    className: "align-middle inline-block rounded-lg",
                    width: width,
                    height: height
                });
            },
            defaultState: config_interface/* SelectionState.HIDDEN */.fP.HIDDEN,
            onLoad: function(setDisplayState, setWarningKey, positionSlug, tabUid, state) {
                var allowStore = window["AllowStore"];
                if (allowStore === null || allowStore === void 0 ? void 0 : allowStore.allow_view_brand_gift) {
                    setDisplayState(config_interface/* SelectionState.ENABLE */.fP.ENABLE);
                    return;
                }
            }
        },
        {
            name_key: "ss_builder_title_block_virtual_gift",
            block_type: block_conf/* BLOCK_TYPE.GIFT */.bF.GIFT,
            description_key: "ss_builder_block_virtual_gift_description",
            Icon: function(width, height) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(block_icons/* GiftIconV2 */.uR, {
                    className: "align-middle inline-block rounded-lg",
                    width: width,
                    height: height
                });
            },
            defaultState: config_interface/* SelectionState.DISABLE */.fP.DISABLE,
            onLoad: function(setDisplayState, setWarningKey, positionSlug, tabUid, state) {
                var positions = state.positions;
                var allowStore = window["AllowStore"];
                if (!(allowStore === null || allowStore === void 0 ? void 0 : allowStore.allow_view_virtual_gift)) {
                    setDisplayState(config_interface/* SelectionState.HIDDEN */.fP.HIDDEN);
                    return;
                }
                if (positionSlug !== "body") {
                    // Disable in body
                    return;
                }
                // setWarningKey("Hoàn thiện tài khoản để sử dụng block này");
                var header = positions.find(function(position) {
                    return position.slug == "header";
                });
                var includeInHeader = header && header.block_list.find(function(block) {
                    return block.block_type == block_conf/* BLOCK_TYPE.GIFT */.bF.GIFT;
                });
                var footer = positions.find(function(position) {
                    return position.slug == "footer";
                });
                var includeInFooter = footer && footer.block_list.find(function(block) {
                    return block.block_type == block_conf/* BLOCK_TYPE.GIFT */.bF.GIFT;
                });
                if (!includeInHeader && !includeInFooter) {
                    setDisplayState(config_interface/* SelectionState.ENABLE */.fP.ENABLE);
                }
            }
        },
        {
            name_key: "ss_builder_title_block_virtual_gift_footer",
            block_type: block_conf/* BLOCK_TYPE.GIFT_FOOTER */.bF.GIFT_FOOTER,
            description_key: "ss_builder_block_virtual_gift_footer_description",
            Icon: function(width, height) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(block_icons/* GiftIconV2 */.uR, {
                    className: "align-middle inline-block rounded-lg",
                    width: width,
                    height: height
                });
            },
            defaultState: config_interface/* SelectionStateEnum.DISABLE */.O_.DISABLE,
            onLoad: function(setDisplayState, setWarningKey, positionSlug, tabUid, state) {
                var positions = state.positions;
                var allowStore = window["AllowStore"];
                if (!(allowStore === null || allowStore === void 0 ? void 0 : allowStore.allow_view_virtual_gift)) {
                    setDisplayState(config_interface/* SelectionState.HIDDEN */.fP.HIDDEN);
                    return;
                }
                var expand = positions.find(function(position) {
                    return position.slug == config_interface/* POSITION_TYPE.EXPAND */.Rz.EXPAND;
                });
                var includeInExpand = expand && expand.block_list.find(function(block) {
                    return block.block_type == block_conf/* BLOCK_TYPE.GIFT_FOOTER */.bF.GIFT_FOOTER;
                });
                var isFloatingFull = expand.block_list.filter(function(e) {
                    return design_config/* BLOCK_TYPE_BY_GROUP.FLOATING.includes */.Vm.FLOATING.includes(e.block_type);
                }).length >= design_config/* COUNT_OF_FLOATING_BLOCK_MAXIMUM */.Y3;
                if (isFloatingFull) {
                    setWarningKey("ss_builder_floating_full");
                } else if (includeInExpand) {
                    setWarningKey("ss_builder_gift_warning");
                } else {
                    setDisplayState(config_interface/* SelectionStateEnum.ENABLE */.O_.ENABLE);
                }
            }
        },
        // {
        //   name_key: "ss_builder_title_block_truth_or_dare",
        //   block_type: BLOCK_TYPE.TRUTH_OR_DARE,
        //   description_key: "ss_builder_block_truth_or_dare_description",
        //   Icon: (width, height) => (
        //     <TruthOrDareIcon
        //       className="align-middle rounded-lg inline-block"
        //       width={width}
        //       height={height}
        //     />
        //   ),
        //   defaultState: SelectionState.HIDDEN,
        //   onLoad: (
        //     setDisplayState: (state: number) => void,
        //     setWarningKey: (key: string) => void,
        //     positionSlug: string,
        //     tabUid: string,
        //     state: AppState
        //   ) => {
        //     const allowStore = window["AllowStore"];
        //     if (allowStore?.allow_view_tod) {
        //       setDisplayState(SelectionState.ENABLE);
        //       return;
        //     }
        //   },
        // },
        // {
        //   name_key: "ss_builder_title_block_truth_or_dare_footer",
        //   block_type: BLOCK_TYPE.TRUTH_OR_DARE_FOOTER,
        //   description_key: "ss_builder_block_truth_or_dare_footer_description",
        //   Icon: (width, height) => (
        //     <TruthOrDareIcon
        //       className="align-middle inline-block rounded-lg"
        //       width={width}
        //       height={height}
        //     />
        //   ),
        //   defaultState: SelectionStateEnum.DISABLE,
        //   onLoad: (
        //     setDisplayState: (state: number) => void,
        //     setWarningKey: (key: string) => void,
        //     positionSlug: string,
        //     tabUid: string,
        //     state: AppState
        //   ) => {
        //     const { positions } = state;
        //     const expand = positions.find(
        //       (position) => position.slug == POSITION_TYPE.EXPAND
        //     );
        //     const includeInExpand =
        //       expand &&
        //       expand.block_list.find(
        //         (block) => block.block_type == BLOCK_TYPE.TRUTH_OR_DARE_FOOTER
        //       );
        //     const isFloatingFull =
        //       expand.block_list.filter((e) =>
        //         BLOCK_TYPE_BY_GROUP.FLOATING.includes(e.block_type)
        //       ).length >= COUNT_OF_FLOATING_BLOCK_MAXIMUM;
        //     if (isFloatingFull) {
        //       setWarningKey("ss_builder_floating_full");
        //     } else if (includeInExpand) {
        //       setWarningKey("ss_builder_truth_or_dare_warning");
        //     } else {
        //       setDisplayState(SelectionStateEnum.ENABLE);
        //     }
        //   },
        // },
        {
            name_key: "ss_builder_title_block_donation",
            block_type: block_conf/* BLOCK_TYPE.DONATION */.bF.DONATION,
            description_key: "ss_builder_block_donation_description",
            Icon: function(width, height) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(block_icons/* IconDonation */.qN, {
                    className: "align-middle inline-block rounded-lg",
                    width: width,
                    height: height
                });
            },
            defaultState: config_interface/* SelectionState.HIDDEN */.fP.HIDDEN,
            onLoad: function(setDisplayState, setWarningKey, positionSlug, tabUid, state) {
                var allowStore = window["AllowStore"];
                if (allowStore === null || allowStore === void 0 ? void 0 : allowStore.allow_view_donation) {
                    setDisplayState(config_interface/* SelectionState.ENABLE */.fP.ENABLE);
                    return;
                }
            }
        },
        {
            name_key: "ss_builder_title_block_digital_product",
            block_type: block_conf/* BLOCK_TYPE.DIGITAL_PRODUCT */.bF.DIGITAL_PRODUCT,
            description_key: "ss_builder_block_digital_product_description",
            Icon: function(width, height) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(block_icons/* DigitalProducticonV2 */.Nv, {
                    className: "align-middle inline-block rounded-lg",
                    width: width,
                    height: height
                });
            }
        },
        // {
        //   name_key: "ss_builder_title_block_video_shoutout",
        //   block_type: BLOCK_TYPE.VIDEO_SHOUTOUT,
        //   description_key: "ss_builder_title_block_video_shoutout_description",
        //   Icon: (width, height) => (
        //     <IconVideoShoutout
        //       className="align-middle inline-block rounded-lg"
        //       width={width}
        //       height={height}
        //     />
        //   ),
        // },
        {
            name_key: "ss_builder_title_block_brand_rating",
            block_type: block_conf/* BLOCK_TYPE.BRAND_RATING */.bF.BRAND_RATING,
            description_key: "ss_builder_title_block_brand_rating_description",
            Icon: function() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(block_icons/* IconBrandRating */.Fg, {
                    className: "align-middle inline-block w-12 h-12 rounded-lg"
                });
            },
            defaultState: config_interface/* SelectionStateEnum.HIDDEN */.O_.HIDDEN,
            onLoad: function(setDisplayState, setWarningKey, positionSlug, tabUid, state) {
                var allowStore = window["AllowStore"];
                if (allowStore === null || allowStore === void 0 ? void 0 : allowStore.allow_view_brand_rating) {
                    setDisplayState(config_interface/* SelectionState.ENABLE */.fP.ENABLE);
                    return;
                }
            }
        },
        {
            name_key: "ss_builder_title_block_booking_profile",
            block_type: block_conf/* BLOCK_TYPE.BOOKING_PROFILE */.bF.BOOKING_PROFILE,
            description_key: "ss_builder_title_block_booking_profile_description",
            defaultState: config_interface/* SelectionState.ENABLE */.fP.ENABLE,
            onLoad: function(setDisplayState, setWarningKey, positionSlug, tabUid, state) {
                var ref;
                if ((state === null || state === void 0 ? void 0 : (ref = state.bookingProfile) === null || ref === void 0 ? void 0 : ref.finish_onboard) !== configs_const/* FINISH_ONBOARDING */.wT) {
                    setDisplayState(config_interface/* SelectionState.DISABLE */.fP.DISABLE);
                    setWarningKey("ss_builder_title_block_booking_profile_warning");
                }
            },
            Icon: function(width, height) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(block_icons/* BookingProfileBlockIcon */.mc, {
                    className: "align-middle inline-block rounded-lg",
                    width: width,
                    height: height
                });
            }
        }, 
    ]
};

;// CONCATENATED MODULE: ./src/features/block/config/block-selection.ts




var BLOCK_SELECTION_GROUP = [
    BASIC_GROUP,
    ADVANCE_GROUP,
    REVENUE_GROUP, 
];
var COUNTRY_TH_BLOCK_HIDDEN = [
    block_conf/* BLOCK_TYPE.DIGITAL_PRODUCT */.bF.DIGITAL_PRODUCT,
    block_conf/* BLOCK_TYPE.GIFT */.bF.GIFT,
    block_conf/* BLOCK_TYPE.GIFT_FOOTER */.bF.GIFT_FOOTER,
    block_conf/* BLOCK_TYPE.DONATION */.bF.DONATION,
    block_conf/* BLOCK_TYPE.BRAND_RATING */.bF.BRAND_RATING,
    block_conf/* BLOCK_TYPE.BRAND_GIFT */.bF.BRAND_GIFT,
    block_conf/* BLOCK_TYPE.BRAND_GIFT_FOOTER */.bF.BRAND_GIFT_FOOTER,
    block_conf/* BLOCK_TYPE.TRUTH_OR_DARE */.bF.TRUTH_OR_DARE,
    block_conf/* BLOCK_TYPE.TRUTH_OR_DARE_FOOTER */.bF.TRUTH_OR_DARE_FOOTER, 
];
var BLOCK_FROM_APP_HIDDEN = [
    block_conf/* BLOCK_TYPE.DIGITAL_PRODUCT */.bF.DIGITAL_PRODUCT,
    block_conf/* BLOCK_TYPE.GIFT */.bF.GIFT,
    block_conf/* BLOCK_TYPE.GIFT_FOOTER */.bF.GIFT_FOOTER,
    block_conf/* BLOCK_TYPE.DONATION */.bF.DONATION, 
];


/***/ }),

/***/ 52790:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ useBlockEditV2Context; },
/* harmony export */   "s": function() { return /* binding */ BlockEditV2Context; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var BlockEditV2Context = react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);
var useBlockEditV2Context = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(BlockEditV2Context);
};


/***/ }),

/***/ 83289:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ useGetSizeImageByUrl; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _libs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22814);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



var useGetSizeImageByUrl = function(url) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), imageWidth = ref[0], setImageWidth = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), imageHeight = ref1[0], setImageHeight = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var getBackgorundImageWidth = function() {
            var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var imageUrl, img;
                return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            imageUrl = url;
                            _ctx.next = 3;
                            return (0,_libs__WEBPACK_IMPORTED_MODULE_2__/* .getMeta */ .xZ)(imageUrl);
                        case 3:
                            img = _ctx.sent;
                            setImageWidth(img === null || img === void 0 ? void 0 : img.width);
                            setImageHeight(img === null || img === void 0 ? void 0 : img.height);
                        case 6:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function getBackgorundImageWidth() {
                return _ref.apply(this, arguments);
            };
        }();
        getBackgorundImageWidth();
    }, [
        url
    ]);
    return {
        width: imageWidth,
        height: imageHeight
    };
};


/***/ }),

/***/ 60746:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}


var BlockHeading = function(props) {
    var title = props.title, blockType = props.blockType, subtitle = props.subtitle, titleStyle = props.titleStyle, subtitleStyle = props.subtitleStyle, blockUid = props.blockUid;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: (title || subtitle) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "block-heading-class",
            id: blockUid ? "".concat(blockUid, "-heading") : "",
            children: [
                title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                    className: "block-title ".concat(blockType, "-title"),
                    id: blockUid ? "".concat(blockUid, "-title") : "",
                    style: _objectSpread({
                        color: "var(--heading-color-6)",
                        wordBreak: "break-word"
                    }, titleStyle),
                    children: title
                }),
                subtitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "block-subtitle ".concat(blockType, "-subtitle"),
                    id: blockUid ? "".concat(blockUid, "-subtitle") : "",
                    style: _objectSpread({
                        color: "var(--text-color-4)",
                        whiteSpace: "pre-wrap"
                    }, subtitleStyle),
                    children: subtitle
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BlockHeading);


/***/ }),

/***/ 15879:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _features_block_block_editor_Combined_const__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96790);
/* harmony import */ var _share_configs_const__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55016);
/* harmony import */ var _share_lib__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11116);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _features_block_hooks_useGetSizeImageByUrl__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(83289);
/* harmony import */ var _share_hooks__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(16565);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}








var AdvancedSettingWrapper = function(props) {
    var children = props.children, advancedSetting = props.advancedSetting;
    var ref = advancedSetting || {}, border_color = ref.border_color, border_type = ref.border_type, border_width = ref.border_width, color_gradient_1 = ref.color_gradient_1, color_gradient_2 = ref.color_gradient_2, color_gradient_direction = ref.color_gradient_direction, color_paragraph = ref.color_paragraph, color_solid = ref.color_solid, color_title = ref.color_title, color_type = ref.color_type, custom_radius = ref.custom_radius, image_direction = ref.image_direction, image_opacity = ref.image_opacity, image_overlay_color = ref.image_overlay_color, image_url = ref.image_url, radius_type = ref.radius_type, shadow_color = ref.shadow_color, shadow_type = ref.shadow_type, use_advanced_setting = ref.use_advanced_setting, use_block_space = ref.use_block_space, use_border = ref.use_border, use_color = ref.use_color, use_image = ref.use_image, use_image_mask = ref.use_image_mask, image_transparent = ref.image_transparent;
    var blockContentRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var ref1 = (0,_share_hooks__WEBPACK_IMPORTED_MODULE_7__/* .useResizeObserveElement */ .pM)(blockContentRef), blockContentHeight = ref1.height;
    //Calculate the height of the block content = contentHeight + paddingY * 2 + borderWidth * 2
    var contentHeight = blockContentHeight + 12 * 2 + border_width * 2;
    var getHeightAndWidth = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        if (use_advanced_setting) {
            if (use_block_space) return {
                width: "calc(100% - 24px)",
                height: contentHeight
            };
            return {
                width: "100%",
                height: "100%"
            };
        } else return {
            width: "100%",
            height: "100%"
        };
    }, [
        use_block_space,
        use_advanced_setting,
        contentHeight
    ]);
    var getBorderRadius = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        if (!use_advanced_setting) return;
        if (radius_type === _features_block_block_editor_Combined_const__WEBPACK_IMPORTED_MODULE_2__/* .RADIUS_STYLE_ROUNDED */ .Ro) return {
            borderRadius: "8px"
        };
        if (radius_type === _features_block_block_editor_Combined_const__WEBPACK_IMPORTED_MODULE_2__/* .RADIUS_STYLE_CUSTOM */ .U1) return {
            borderRadius: "".concat(custom_radius, "px")
        };
        return {};
    }, [
        radius_type,
        custom_radius,
        use_advanced_setting
    ]);
    var getShadow = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        if (!use_advanced_setting) return;
        if (shadow_type === _share_configs_const__WEBPACK_IMPORTED_MODULE_3__/* .BUTTON_SETTING_SHADOW_STYLE.SOFT_SHADOW */ .r8.SOFT_SHADOW) return {
            boxShadow: "0px 3px 6px 0px ".concat(shadow_color)
        };
        if (shadow_type === _share_configs_const__WEBPACK_IMPORTED_MODULE_3__/* .BUTTON_SETTING_SHADOW_STYLE.HARD_SHADOW */ .r8.HARD_SHADOW) return {
            boxShadow: "5px 5px 0px 0px ".concat(shadow_color)
        };
        return {};
    }, [
        shadow_type,
        shadow_color,
        use_advanced_setting
    ]);
    var getBorder = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        if (!use_advanced_setting || !use_border) return {};
        return {
            borderColor: border_color,
            borderWidth: border_width,
            borderStyle: border_type
        };
    }, [
        border_color,
        border_width,
        border_type,
        use_advanced_setting,
        use_border, 
    ]);
    var ref2 = (0,_features_block_hooks_useGetSizeImageByUrl__WEBPACK_IMPORTED_MODULE_6__/* .useGetSizeImageByUrl */ .R)(image_url), backgroundImageWidth = ref2.width;
    var getStyleBackgroundWithImage = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        if (!use_image && !image_url || !use_advanced_setting) return {};
        var isCoverBackground = backgroundImageWidth >= 512 || backgroundImageWidth < 512 && image_direction === "center";
        return {
            backgroundImage: 'url("'.concat(image_url, '")'),
            opacity: image_opacity / 100,
            filter: "blur(".concat(image_transparent, "px)"),
            backgroundPosition: image_direction || "center",
            backgroundSize: isCoverBackground ? "cover" : ""
        };
    }, [
        use_image,
        image_url,
        image_opacity,
        image_transparent,
        image_direction,
        use_advanced_setting,
        backgroundImageWidth, 
    ]);
    var getStyleBackgroundWithColor = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        if (!use_color || !use_advanced_setting) return {};
        else {
            if (color_type === _features_block_block_editor_Combined_const__WEBPACK_IMPORTED_MODULE_2__/* .COLOR_TYPE_SOLID */ .XQ) {
                return {
                    backgroundColor: color_solid
                };
            } else {
                return {
                    backgroundImage: "linear-gradient(".concat(color_gradient_direction !== null && color_gradient_direction !== void 0 ? color_gradient_direction : "circle", ", ").concat((0,_share_lib__WEBPACK_IMPORTED_MODULE_4__/* .getHexColor */ .Xv)(color_gradient_1, 300), ", ").concat((0,_share_lib__WEBPACK_IMPORTED_MODULE_4__/* .getHexColor */ .Xv)(color_gradient_2, 300), ")")
                };
            }
        }
    }, [
        use_color,
        color_type,
        color_solid,
        color_gradient_direction,
        color_gradient_1,
        color_gradient_2,
        use_advanced_setting, 
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        style: {
            height: contentHeight,
            width: "100%"
        },
        className: "block-advanced-setting",
        children: [
            use_advanced_setting && use_image_mask && use_image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "absolute left-[50%] translate-x-[-50%] block z-[3]",
                style: _objectSpread({
                    backgroundColor: image_overlay_color
                }, getHeightAndWidth, getBorderRadius, getBorder, getShadow)
            }),
            use_advanced_setting && use_image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: " absolute left-[50%] translate-x-[-50%] block z-[2]",
                style: _objectSpread({}, getStyleBackgroundWithImage, {
                    backgroundRepeat: "no-repeat"
                }, getHeightAndWidth, getBorderRadius, getShadow)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_5___default()("absolute left-[50%] translate-x-[-50%] block z-[4] py-3"),
                style: _objectSpread({}, getHeightAndWidth, getBorderRadius, getBorder, getShadow, {
                    paddingLeft: (advancedSetting === null || advancedSetting === void 0 ? void 0 : advancedSetting.use_advanced_setting) ? "var(--block-inner-space)" : "",
                    paddingRight: (advancedSetting === null || advancedSetting === void 0 ? void 0 : advancedSetting.use_advanced_setting) ? "var(--block-inner-space)" : ""
                }),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "combined-block-design-content w-full",
                    ref: blockContentRef,
                    children: children
                })
            }),
            use_advanced_setting && use_color && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "absolute left-[50%] translate-x-[-50%] block z-[1]",
                style: _objectSpread({}, getStyleBackgroundWithColor, getHeightAndWidth, getBorderRadius, getShadow)
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AdvancedSettingWrapper);


/***/ }),

/***/ 82454:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _features_design_components_MappingTypeComponent__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5954);



var BlockListsDisplay = function(param) {
    var blocks = param.blocks, blockSpace = param.blockSpace, onGetLatestBlockData = param.onGetLatestBlockData, isApplyGlobalSettings = param.isApplyGlobalSettings;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: blocks === null || blocks === void 0 ? void 0 : blocks.map(function(block, index) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_features_design_components_MappingTypeComponent__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        blockData: block,
                        isApplyBlockSettings: isApplyGlobalSettings,
                        onGetLatestBlockData: onGetLatestBlockData,
                        isHideMoreActions: true
                    }),
                    index !== blocks.length - 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        style: {
                            height: "".concat(blockSpace, "px")
                        }
                    })
                ]
            });
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BlockListsDisplay);


/***/ }),

/***/ 5954:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _design_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56214);
/* harmony import */ var _BlockWrapper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88519);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}




var MappingTypeComponent = function(props1) {
    var blockData = props1.blockData;
    var type = blockData && blockData.block_type;
    var ElementRender = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(props) {
        var Element = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
        if (_design_config__WEBPACK_IMPORTED_MODULE_2__/* .DESIGN_COMPONENT */ .o$[type]) {
            var RenderComponent = _design_config__WEBPACK_IMPORTED_MODULE_2__/* .DESIGN_COMPONENT */ .o$[type];
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RenderComponent, _objectSpread({}, props));
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_BlockWrapper__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, _objectSpread({}, props, {
            children: Element
        }));
    }, [
        type
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ElementRender, _objectSpread({}, props1));
};
/* harmony default export */ __webpack_exports__["Z"] = (MappingTypeComponent);


/***/ }),

/***/ 46393:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _share_configs_const__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55016);
/* harmony import */ var _share_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64035);
/* harmony import */ var _share_lib__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11116);
/* harmony import */ var antd_mobile__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27175);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(31567);
/* harmony import */ var simplebar_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(40077);
/* harmony import */ var simplebar_src_simplebar_css__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(23021);
/* harmony import */ var simplebar_src_simplebar_css__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(simplebar_src_simplebar_css__WEBPACK_IMPORTED_MODULE_7__);









var ThemeTemplatePreviewByImage = function(props) {
    var handleCancelThemeTemplatePreview = props.handleCancelThemeTemplatePreview, imageSrc = props.imageSrc, KEY = props.KEY, handleConfirmThemeTemplatePreview = props.handleConfirmThemeTemplatePreview;
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_8__/* .useTranslation */ .$)().t;
    var buttonSaveLabelRender = (0,react__WEBPACK_IMPORTED_MODULE_5__.useMemo)(function() {
        var btnLabel = "";
        switch(KEY){
            case _share_configs_const__WEBPACK_IMPORTED_MODULE_1__/* .THEME_PREVIEW_BY_IMAGE_KEY.PREVIEW_AND_APPLY */ .cQ.PREVIEW_AND_APPLY:
                btnLabel = t("ss_builder_apply_preview_theme_template_btn_label");
                break;
            case _share_configs_const__WEBPACK_IMPORTED_MODULE_1__/* .THEME_PREVIEW_BY_IMAGE_KEY.PREVIEW_AND_REPLACE */ .cQ.PREVIEW_AND_REPLACE:
                btnLabel = t("ss_builder_replace_preview_theme_template_btn_label");
                break;
        }
        return btnLabel;
    }, [
        KEY
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "w-full",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex flex-row text-center items-center justify-center py-3 gap-[10px] bg-white sticky top-0",
                style: {
                    boxShadow: "inset 0px -1px 0px #EEEEEE"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_2__/* .PreviewThemeIcon */ .gc, {
                        className: "w-6 h-6"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "text-lg leading-6",
                        children: t("ss_builder_preview_theme_template_title")
                    })
                ]
            }),
            (0,_share_lib__WEBPACK_IMPORTED_MODULE_3__/* .isDesktop */ .nI)() ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(simplebar_react__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                forceVisible: "y",
                style: {
                    maxHeight: "calc(100vh - 112px)"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_4__/* .Image */ .Ee, {
                    src: imageSrc,
                    fit: "cover"
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_4__/* .Image */ .Ee, {
                src: imageSrc,
                fit: "cover"
            }),
            KEY === _share_configs_const__WEBPACK_IMPORTED_MODULE_1__/* .THEME_PREVIEW_BY_IMAGE_KEY.PREVIEW */ .cQ.PREVIEW ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "max-width-content-class px-4 py-3 fixed bottom-0 bg-white w-full",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .zx, {
                    block: true,
                    size: "middle",
                    color: "primary",
                    fill: "solid",
                    onClick: function() {
                        return handleCancelThemeTemplatePreview();
                    },
                    children: t("ss_builder_cancel_preview_theme_template_btn_label")
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "max-width-content-class fixed bottom-0 p-2 flex w-full justify-between gap-2 z-[1] bg-[#FFFFFF]",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-1/2 text-center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .zx, {
                            className: "w-full",
                            onClick: handleCancelThemeTemplatePreview,
                            children: t("ss_builder_cancel_preview_theme_template_btn_label")
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-1/2 text-center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .zx, {
                            className: "w-full",
                            color: "primary",
                            onClick: function() {
                                return handleConfirmThemeTemplatePreview();
                            },
                            children: buttonSaveLabelRender
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ThemeTemplatePreviewByImage);


/***/ }),

/***/ 56214:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "dv": function() { return /* binding */ BLOCK_GROUP_TYPE; },
  "Vm": function() { return /* binding */ BLOCK_TYPE_BY_GROUP; },
  "xs": function() { return /* binding */ COUNT_OF_BLOCK_MAXIMUM; },
  "Y3": function() { return /* binding */ COUNT_OF_FLOATING_BLOCK_MAXIMUM; },
  "o$": function() { return /* binding */ DESIGN_COMPONENT; },
  "$v": function() { return /* binding */ EXPAND_POSITION; }
});

// EXTERNAL MODULE: ./src/features/block/block.conf.ts + 92 modules
var block_conf = __webpack_require__(61086);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/features/share/icons/index.tsx
var icons = __webpack_require__(64035);
// EXTERNAL MODULE: ./node_modules/antd-mobile/es/index.js + 251 modules
var es = __webpack_require__(27175);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-lazy-load-image-component/build/index.js
var build = __webpack_require__(72679);
// EXTERNAL MODULE: ./src/features/design/components/BlockHeadingComponent/index.tsx
var BlockHeadingComponent = __webpack_require__(60746);
// EXTERNAL MODULE: ./src/features/design/components/BlockWrapper/index.tsx + 1 modules
var BlockWrapper = __webpack_require__(88519);
// EXTERNAL MODULE: ./node_modules/lodash/orderBy.js
var orderBy = __webpack_require__(75472);
var orderBy_default = /*#__PURE__*/__webpack_require__.n(orderBy);
// EXTERNAL MODULE: ./node_modules/lodash/cloneDeep.js
var cloneDeep = __webpack_require__(50361);
var cloneDeep_default = /*#__PURE__*/__webpack_require__.n(cloneDeep);
;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockAffiliateProduct/index.tsx









var PRODUCT_MAX_DEFAULT = 12;
var BlockAffiliateProduct = function(props) {
    var blockData = props.blockData, positionSlug = props.positionSlug, tabUid = props.tabUid, index1 = props.index, listBlocksSortOrder = props.listBlocksSortOrder, isFirstItem = props.isFirstItem;
    var enable = blockData && blockData.enable;
    var content_attributes = blockData && blockData.content_attributes;
    var style_attributes = blockData && blockData.style_attributes;
    var style_display = style_attributes.style_display;
    var title_product_group = content_attributes.title_product_group, see_more_btn_content = content_attributes.see_more_btn_content, dataProductListArr = content_attributes.items;
    var dataProductListSortOrder = dataProductListArr && orderBy_default()(dataProductListArr, [
        "sort_order"
    ], [
        "asc"
    ]);
    var productListEnable = dataProductListSortOrder && dataProductListSortOrder.filter(function(x) {
        return x.enable === 1;
    });
    var productListDefault = (0,react.useMemo)(function() {
        var productListEnableClone = cloneDeep_default()(productListEnable);
        if (productListEnableClone.length > PRODUCT_MAX_DEFAULT) {
            productListEnableClone.length = PRODUCT_MAX_DEFAULT;
        }
        return productListEnableClone;
    }, [
        productListEnable
    ]);
    var ref = (0,react.useState)(productListDefault), productListDisplay = ref[0], setProductListDisplay = ref[1];
    var SourceTypeRender = function(type) {
        var sourceType = type.sourceType;
        var iconElement = null;
        switch(sourceType){
            case "shopee":
                iconElement = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-row gap-1",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ShopeeIcon */.YP, {
                            className: "w-4 h-4"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-xs leading-4",
                            children: "Shoppe.vn"
                        })
                    ]
                });
                break;
            case "lazada":
                iconElement = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-row gap-1",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* LazadaIcon */.aA, {
                            className: "w-4 h-4"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-xs leading-4",
                            children: "Lazada.vn"
                        })
                    ]
                });
                break;
            case "tiki":
                iconElement = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-row gap-1",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* TikiIcon */.$2, {
                            className: "w-4 h-4"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-xs leading-4",
                            children: "Tiki.vn"
                        })
                    ]
                });
                break;
        }
        return iconElement;
    };
    var styleDisPlayClass = (0,react.useMemo)(function() {
        var className = "";
        switch(style_display){
            case "grid-1":
                className = "grid grid-cols-1 gap-3";
                break;
            case "grid-2":
                className = "grid grid-cols-2 gap-3";
                break;
            case "grid-3":
                className = "grid grid-cols-3 gap-3";
                break;
            case "slide":
                className = "";
                break;
        }
        return className;
    }, [
        style_display
    ]);
    var handleSeeMoreProducts = function(event) {
        event.stopPropagation();
        setProductListDisplay(productListEnable);
    };
    var isDisplayBtnSeeMore = style_display !== "slide" && productListEnable.length > productListDisplay.length;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BlockWrapper/* default */.Z, {
        blockType: blockData.block_type,
        isEnable: enable,
        positionSlug: positionSlug,
        tabUid: tabUid,
        blockUid: blockData === null || blockData === void 0 ? void 0 : blockData.uid,
        index: index1,
        listBlocksSortOrder: listBlocksSortOrder,
        isFirstItem: isFirstItem,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockHeadingComponent/* default */.Z, {
                blockType: blockData.block_type,
                title: title_product_group
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat(styleDisPlayClass, " affiliate-product-wrapper"),
                children: productListDisplay && productListDisplay.map(function(ele, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(build.LazyLoadImage, {
                                //   width={101}
                                //   height={101}
                                src: ele.image,
                                // fit="cover"
                                className: "object-center affiliate-product-image",
                                style: {
                                    backgroundSize: "cover",
                                    aspectRatio: "1/1",
                                    borderRadius: "4px",
                                    margin: "0 auto",
                                    objectFit: "cover",
                                    width: "100%"
                                },
                                onError: function(param) {
                                    var currentTarget = param.currentTarget;
                                    currentTarget.onerror = null; // prevents looping
                                    currentTarget.src = "https://i.ecomobi.com/ssp/passio-page/image-default.png";
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Ellipsis */.mH, {
                                direction: "end",
                                content: ele.title,
                                className: "mt-2 affiliate-product-name",
                                rows: 2
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SourceTypeRender, {
                                    sourceType: ele.source_type
                                })
                            })
                        ]
                    }, index);
                })
            }),
            isDisplayBtnSeeMore && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                    block: true,
                    // color="primary"
                    size: "middle",
                    style: {
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        alignItems: "center",
                        marginTop: "16px",
                        gap: "5px"
                    },
                    onClick: handleSeeMoreProducts,
                    // className="button-border-radius button-background-color button-border-width button-border-color button-border-style button-text-color button-box-shadow affiliate-product-button-see-more middle-button"
                    className: "pp-button",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: see_more_btn_content
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var CommonBlockComponent_BlockAffiliateProduct = (BlockAffiliateProduct);

// EXTERNAL MODULE: ./src/app/hooks.ts
var hooks = __webpack_require__(65457);
// EXTERNAL MODULE: ./src/features/share/configs/const.ts
var configs_const = __webpack_require__(55016);
// EXTERNAL MODULE: ./src/features/share/icons/social-network-icon-svg.tsx
var social_network_icon_svg = __webpack_require__(23110);
;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockBio/const.tsx




var socialLinkIconRender = function(data) {
    var type = data.icon;
    var element = null;
    switch(type){
        case configs_const/* SOCIAL_LINK.FACEBOOK */.Xv.FACEBOOK:
            element = /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* FacebookIcon */.Vq, {
                className: "w-8 h-8 rounded-full"
            });
            break;
        case configs_const/* SOCIAL_LINK.MESSENGER */.Xv.MESSENGER:
            element = /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* MessengerIcon */.qA, {
                className: "w-8 h-8 rounded-full"
            });
            break;
        case configs_const/* SOCIAL_LINK.INSTAGRAM */.Xv.INSTAGRAM:
            element = /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* InstagramIcon */.yu, {
                className: "w-8 h-8 rounded-full"
            });
            break;
        case configs_const/* SOCIAL_LINK.LINKEDIN */.Xv.LINKEDIN:
            element = /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* LinkedInIcon */.nI, {
                className: "w-8 h-8 rounded-full"
            });
            break;
        case configs_const/* SOCIAL_LINK.SNAPCHAT */.Xv.SNAPCHAT:
            element = /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* SnapchatIcon */.Zr, {
                className: "w-8 h-8 rounded-full"
            });
            break;
        case configs_const/* SOCIAL_LINK.LINECHAT */.Xv.LINECHAT:
            element = /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* LineChatIcon */.uG, {
                className: "w-8 h-8 rounded-full"
            });
            break;
        case configs_const/* SOCIAL_LINK.YOUTUBE */.Xv.YOUTUBE:
            element = /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* YoutubeIcon */.LK, {
                className: "w-8 h-8 rounded-full"
            });
            break;
        case configs_const/* SOCIAL_LINK.TIKTOK */.Xv.TIKTOK:
            element = /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* TiktokIcon */.bF, {
                className: "w-8 h-8 rounded-full"
            });
            break;
        case configs_const/* SOCIAL_LINK.TWITCH */.Xv.TWITCH:
            element = /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* TwitchIcon */.jG, {
                className: "w-8 h-8 rounded-full"
            });
            break;
        case configs_const/* SOCIAL_LINK.TWITTER */.Xv.TWITTER:
            element = /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* TwitterIcon */.Zm, {
                className: "w-8 h-8 rounded-full"
            });
            break;
        case configs_const/* SOCIAL_LINK.WHATSAPP */.Xv.WHATSAPP:
            element = /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* WhatsappIcon */.ud, {
                className: "w-8 h-8 rounded-full"
            });
            break;
        case configs_const/* SOCIAL_LINK.DISCORD */.Xv.DISCORD:
            element = /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* DiscordIcon */.D7, {
                className: "w-8 h-8 rounded-full"
            });
            break;
        case configs_const/* SOCIAL_LINK.BEHANCE */.Xv.BEHANCE:
            element = /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* BehanceIcon */.wE, {
                className: "w-8 h-8 rounded-full"
            });
            break;
        case configs_const/* SOCIAL_LINK.DRIBBLE */.Xv.DRIBBLE:
            element = /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* DribbleIcon */.Ir, {
                className: "w-8 h-8 rounded-full"
            });
            break;
        case configs_const/* SOCIAL_LINK.PINTEREST */.Xv.PINTEREST:
            element = /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* PinterestIcon */.cH, {
                className: "w-8 h-8 rounded-full"
            });
            break;
        case configs_const/* SOCIAL_LINK.EMAIL */.Xv.EMAIL:
            element = /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* EmailIcon */.LQ, {
                className: "w-8 h-8 rounded-full"
            });
            break;
        case configs_const/* SOCIAL_LINK.TEL */.Xv.TEL:
            element = /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* TelIcon */.lj, {
                className: "w-8 h-8 rounded-full"
            });
            break;
        case configs_const/* SOCIAL_LINK.LEMON8 */.Xv.LEMON8:
            element = /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* Lemon8Icon */.UI, {
                className: "w-8 h-8 rounded-full"
            });
            break;
        case configs_const/* SOCIAL_LINK.OTHER */.Xv.OTHER:
            element = /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* GeneralLinkIcon */.n1, {
                className: "w-8 h-8 rounded-full"
            });
            break;
        default:
            element = /*#__PURE__*/ (0,jsx_runtime.jsx)(social_network_icon_svg/* GeneralLinkIcon */.n1, {
                className: "w-8 h-8 rounded-full"
            });
    }
    return element;
};

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 14 modules
var swiper_react = __webpack_require__(88494);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(21082);
// EXTERNAL MODULE: ./node_modules/swiper/modules/effect-fade/effect-fade.min.css
var effect_fade_min = __webpack_require__(83029);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 94 modules
var swiper_esm = __webpack_require__(88116);
// EXTERNAL MODULE: ./node_modules/swiper/modules/autoplay/autoplay.min.css
var autoplay_min = __webpack_require__(33731);
;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockBio/BioLayouts/CoverImage.tsx











var CoverImage = function(props) {
    var content_attributes = props.content_attributes, style_attributes = props.style_attributes, paramsURL = props.paramsURL;
    var ref = content_attributes || {}, bio_cover_image_list = ref.bio_cover_image_list, bio_image_ratio = ref.bio_image_ratio, bio_auto_switch = ref.bio_auto_switch;
    var style_display = style_attributes.style_display;
    var swiperRef = (0,react.useRef)(null);
    var dataImageSliderSortOrder = bio_cover_image_list && orderBy_default()(bio_cover_image_list, [
        "sort_order"
    ], [
        "asc"
    ]);
    var imageCoverEnable = dataImageSliderSortOrder === null || dataImageSliderSortOrder === void 0 ? void 0 : dataImageSliderSortOrder.filter(function(x) {
        return x.enable === 1;
    });
    var avatarAboveCoverImage = style_display === configs_const/* BIO_DISPLAY_STYLES.STYLE5 */.uT.STYLE5 || style_display === configs_const/* BIO_DISPLAY_STYLES.STYLE6 */.uT.STYLE6 || style_display === configs_const/* BIO_DISPLAY_STYLES.STYLE7 */.uT.STYLE7;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "relative mb-3 cursor-pointer",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
            className: classnames_default()(avatarAboveCoverImage && "custom-swiper-indicator", imageCoverEnable.length === 1 && "disable-swiper-indicator"),
            modules: [
                swiper_esm/* Pagination */.tl,
                swiper_esm/* Navigation */.W_,
                swiper_esm/* Autoplay */.pt
            ],
            setWrapperSize: false,
            spaceBetween: 12,
            slidesPerView: 1,
            onSlideChange: function() {
                return console.log("slide change");
            },
            onSwiper: function(swiper) {
                return console.log(swiper);
            },
            pagination: {
                clickable: true
            },
            onBeforeInit: function(swiper) {
                swiperRef.current = swiper;
            },
            loop: (imageCoverEnable === null || imageCoverEnable === void 0 ? void 0 : imageCoverEnable.length) > 1,
            // speed={50}
            autoplay: (content_attributes === null || content_attributes === void 0 ? void 0 : content_attributes.bio_auto_switch) ? {
                delay: 5000
            } : false,
            children: imageCoverEnable === null || imageCoverEnable === void 0 ? void 0 : imageCoverEnable.map(function(ele, index) {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                        src: ele.image,
                        fit: "cover",
                        style: {
                            backgroundSize: "cover",
                            aspectRatio: bio_image_ratio,
                            pointerEvents: (paramsURL === null || paramsURL === void 0 ? void 0 : paramsURL.isDisableLink) ? "none" : "unset"
                        },
                        className: "image-border-radius"
                    })
                }, ele === null || ele === void 0 ? void 0 : ele.uid);
            })
        })
    });
};
/* harmony default export */ var BioLayouts_CoverImage = (CoverImage);

;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockBio/BioLayouts/Avatar.tsx


var Avatar = function(props) {
    var size = props.size, url = props.url, _className = props.className, className = _className === void 0 ? "" : _className, _sizeBorder = props.sizeBorder, sizeBorder = _sizeBorder === void 0 ? 1 : _sizeBorder, _color = props.color, color = _color === void 0 ? "rgba(0, 0, 0, 0.16)" : _color;
    var newUrl = url || "https://image.passio.eco/page-builder/page-builder/images-default/bio-default.svg";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: className,
        style: {
            width: size,
            height: size,
            borderRadius: "100%",
            /* eslint-disable */ WebkitBoxShadow: "inset 0px 0px 0px ".concat(sizeBorder, "px ").concat(color),
            MozBoxShadow: "inset 0px 0px 0px ".concat(sizeBorder, "px ").concat(color),
            boxShadow: "inset 0px 0px 0px ".concat(sizeBorder, "px ").concat(color),
            background: 'url("'.concat(newUrl, '") center center / cover')
        }
    });
};
/* harmony default export */ var BioLayouts_Avatar = (Avatar);

// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(31567);
// EXTERNAL MODULE: ./node_modules/draftjs-to-html/lib/draftjs-to-html.js
var draftjs_to_html = __webpack_require__(89265);
var draftjs_to_html_default = /*#__PURE__*/__webpack_require__.n(draftjs_to_html);
// EXTERNAL MODULE: ./node_modules/dompurify/dist/purify.js
var purify = __webpack_require__(27856);
;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockBio/BioLayouts/BioContent.tsx







var BioContent = function(props) {
    var data = props.data, _isCenter = props.isCenter, isCenter = _isCenter === void 0 ? false : _isCenter, _className = props.className, className = _className === void 0 ? "" : _className;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var refOfElement = (0,react.useRef)();
    var ref2 = (0,react.useState)(true), isExpand = ref2[0], setIsExpand = ref2[1];
    var ref1 = (0,react.useState)(false), isShowButton = ref1[0], setIsShowButton = ref1[1];
    var cleanBioContent = (0,react.useMemo)(function() {
        var bioContent = "";
        if (data) {
            if (typeof data == "string") {
                bioContent = data;
            } else {
                bioContent = draftjs_to_html_default()(data);
            }
        }
        return purify.sanitize(bioContent);
    }, [
        data
    ]);
    (0,react.useEffect)(function() {
        var height;
        var timer = setTimeout(function() {
            if (refOfElement) {
                var ref;
                height = (ref = refOfElement.current) === null || ref === void 0 ? void 0 : ref.offsetHeight;
                if (height) {
                    setIsShowButton(parseInt(height) > 80);
                }
            }
        }, 300);
        return function() {
            return clearTimeout(timer);
        };
    }, [
        cleanBioContent
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: refOfElement,
                className: classnames_default()("w-full bio-content", isShowButton && isExpand && "bio-collapse", className),
                style: {
                    color: "var(--text-color-6)"
                },
                dangerouslySetInnerHTML: {
                    __html: cleanBioContent
                }
            }),
            isShowButton && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("cursor-pointer mt-1 text-[13px] font-medium flex gap-x-1 w-fit", isCenter && "mx-auto"),
                onClick: function() {
                    return setIsExpand(!isExpand);
                },
                children: [
                    isExpand ? t("ss_builder_expand") : t("ss_builder_collapse"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "my-auto",
                        children: isExpand ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ExpandIcon */.Qq, {
                            className: "",
                            fillColor: "var(--text-color-6)"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CollapseIcon */.W5, {
                            className: "",
                            fillColor: "var(--text-color-6)"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var BioLayouts_BioContent = (BioContent);

;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockBio/BioLayouts/BookingProfile.tsx




var BookingProfile = function(param) {
    var bioBookingProfileTitle = param.bioBookingProfileTitle, bioBookingProfileDescription = param.bioBookingProfileDescription, bioBookingProfileButtonLabel = param.bioBookingProfileButtonLabel, _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: bioBookingProfileButtonLabel && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()("".concat(className)),
            children: [
                bioBookingProfileTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                    style: {
                        color: "var(--text-color-6)",
                        margin: 0
                    },
                    children: bioBookingProfileTitle
                }),
                bioBookingProfileDescription && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mb-2",
                    style: {
                        color: "var(--text-color-6)"
                    },
                    children: bioBookingProfileDescription
                }),
                bioBookingProfileButtonLabel && /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                    fill: "solid",
                    size: "small",
                    className: "pp-button",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center gap-x-2",
                        children: [
                            bioBookingProfileButtonLabel,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ArrowRightIcon */.LZ, {
                                fillColor: "var(--button-text-color)",
                                style: {
                                    width: "var(--middle-button-font-size)",
                                    height: "var(--middle-button-font-size)"
                                }
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var BioLayouts_BookingProfile = (BookingProfile);

;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockBio/BioLayouts/BioLayout1/index.tsx







var BioLayout1 = function(props) {
    // Layout 1,2,3,4
    var content_attributes = props.content_attributes, style_attributes = props.style_attributes;
    var ref = content_attributes || {}, social_link_items = ref.social_link_items, bio_image = ref.bio_image, bio_name = ref.bio_name, bio_subtitle = ref.bio_subtitle, bio_content = ref.bio_content, bio_show_cover_image = ref.bio_show_cover_image, bio_cover_image_list = ref.bio_cover_image_list, bio_booking_profile_title = ref.bio_booking_profile_title, bio_booking_profile_description = ref.bio_booking_profile_description, bio_booking_profile_button_label = ref.bio_booking_profile_button_label, bio_booking_profile_display = ref.bio_booking_profile_display;
    var style_display = (style_attributes || {}).style_display;
    var socialLinkItemsEnable = (0,react.useMemo)(function() {
        return social_link_items === null || social_link_items === void 0 ? void 0 : social_link_items.filter(function(x) {
            return x.enable === 1;
        });
    }, [
        social_link_items
    ]);
    var coverImageList = (0,react.useMemo)(function() {
        return bio_cover_image_list === null || bio_cover_image_list === void 0 ? void 0 : bio_cover_image_list.filter(function(x) {
            return x.enable === 1;
        });
    }, [
        bio_cover_image_list
    ]);
    var BioContentElement = (0,react.useMemo)(function() {
        var bioElement = null;
        switch(style_display){
            case "style-1":
                bioElement = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col text-center items-center gap-3 w-full bio-wrapper-style-1",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "gap-1 flex flex-col text-center items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BioLayouts_Avatar, {
                                    size: 120,
                                    url: bio_image
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "bio-title-wrapper",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                            className: "w-full bio-name",
                                            style: {
                                                color: "var(--heading-color-6)"
                                            },
                                            children: bio_name
                                        }),
                                        bio_subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "w-full bio-subtitle",
                                            style: {
                                                color: "var(--text-color-6)"
                                            },
                                            children: bio_subtitle
                                        })
                                    ]
                                })
                            ]
                        }),
                        (socialLinkItemsEnable === null || socialLinkItemsEnable === void 0 ? void 0 : socialLinkItemsEnable.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex flex-row gap-3 bio-social-network flex-wrap",
                            children: socialLinkItemsEnable === null || socialLinkItemsEnable === void 0 ? void 0 : socialLinkItemsEnable.map(function(ele, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: socialLinkIconRender(ele)
                                }, index);
                            })
                        }),
                        bio_booking_profile_display && /*#__PURE__*/ (0,jsx_runtime.jsx)(BioLayouts_BookingProfile, {
                            bioBookingProfileTitle: bio_booking_profile_title,
                            bioBookingProfileDescription: bio_booking_profile_description,
                            bioBookingProfileButtonLabel: bio_booking_profile_button_label
                        }),
                        !!bio_content && /*#__PURE__*/ (0,jsx_runtime.jsx)(BioLayouts_BioContent, {
                            data: bio_content,
                            isCenter: true
                        })
                    ]
                });
                break;
            case "style-2":
                bioElement = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col text-left gap-3 bio-wrapper-style-2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col text-left gap-1 ",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BioLayouts_Avatar, {
                                    size: 120,
                                    url: bio_image
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "bio-title-wrapper",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                            className: "bio-name",
                                            style: {
                                                color: "var(--heading-color-6)"
                                            },
                                            children: bio_name
                                        }),
                                        bio_subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "bio-subtitle",
                                            style: {
                                                color: "var(--text-color-6)"
                                            },
                                            children: bio_subtitle
                                        })
                                    ]
                                })
                            ]
                        }),
                        !!bio_content && /*#__PURE__*/ (0,jsx_runtime.jsx)(BioLayouts_BioContent, {
                            data: bio_content
                        }),
                        (socialLinkItemsEnable === null || socialLinkItemsEnable === void 0 ? void 0 : socialLinkItemsEnable.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex flex-row gap-3 bio-social-network flex-wrap",
                            children: socialLinkItemsEnable === null || socialLinkItemsEnable === void 0 ? void 0 : socialLinkItemsEnable.map(function(ele, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: socialLinkIconRender(ele)
                                }, index);
                            })
                        }),
                        bio_booking_profile_display && /*#__PURE__*/ (0,jsx_runtime.jsx)(BioLayouts_BookingProfile, {
                            bioBookingProfileTitle: bio_booking_profile_title,
                            bioBookingProfileDescription: bio_booking_profile_description,
                            bioBookingProfileButtonLabel: bio_booking_profile_button_label
                        })
                    ]
                });
                break;
            case "style-3":
                bioElement = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col text-left gap-3 bio-wrapper-style-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col text-left gap-1",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-row justify-between items-start",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BioLayouts_Avatar, {
                                            size: 80,
                                            url: bio_image
                                        }),
                                        (socialLinkItemsEnable === null || socialLinkItemsEnable === void 0 ? void 0 : socialLinkItemsEnable.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex flex-wrap w-[132px] bio-social-network justify-end",
                                            style: {
                                                width: "132px",
                                                marginLeft: "-6px",
                                                marginRight: "-6px",
                                                maxWidth: "calc(100% - 132px)"
                                            },
                                            children: socialLinkItemsEnable === null || socialLinkItemsEnable === void 0 ? void 0 : socialLinkItemsEnable.map(function(ele, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "overflow-hidden",
                                                    style: {
                                                        width: "32px",
                                                        margin: "0 6px 12px 6px"
                                                    },
                                                    children: socialLinkIconRender(ele)
                                                }, index);
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "bio-title-wrapper",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                            className: "bio-name",
                                            style: {
                                                color: "var(--heading-color-6)"
                                            },
                                            children: bio_name
                                        }),
                                        bio_subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "bio-subtitle",
                                            style: {
                                                color: "var(--text-color-6)"
                                            },
                                            children: bio_subtitle
                                        })
                                    ]
                                })
                            ]
                        }),
                        !!bio_content && /*#__PURE__*/ (0,jsx_runtime.jsx)(BioLayouts_BioContent, {
                            data: bio_content
                        }),
                        bio_booking_profile_display && /*#__PURE__*/ (0,jsx_runtime.jsx)(BioLayouts_BookingProfile, {
                            bioBookingProfileTitle: bio_booking_profile_title,
                            bioBookingProfileDescription: bio_booking_profile_description,
                            bioBookingProfileButtonLabel: bio_booking_profile_button_label
                        })
                    ]
                });
                break;
            case "style-4":
                bioElement = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-row gap-3 bio-wrapper-style-3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BioLayouts_Avatar, {
                            size: 80,
                            url: bio_image
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col gap-3 grow overflow-hidden",
                            style: {
                                width: "calc(100% - 92px)"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "bio-title-wrapper",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                            className: "bio-name",
                                            style: {
                                                color: "var(--heading-color-6)"
                                            },
                                            children: bio_name
                                        }),
                                        bio_subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "bio-subtitle",
                                            style: {
                                                color: "var(--text-color-6)"
                                            },
                                            children: bio_subtitle
                                        })
                                    ]
                                }),
                                !!bio_content && /*#__PURE__*/ (0,jsx_runtime.jsx)(BioLayouts_BioContent, {
                                    data: bio_content,
                                    className: "break-words"
                                }),
                                (socialLinkItemsEnable === null || socialLinkItemsEnable === void 0 ? void 0 : socialLinkItemsEnable.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex flex-row gap-3 bio-social-network flex-wrap",
                                    children: socialLinkItemsEnable === null || socialLinkItemsEnable === void 0 ? void 0 : socialLinkItemsEnable.map(function(ele, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: socialLinkIconRender(ele)
                                        }, index);
                                    })
                                }),
                                bio_booking_profile_display && /*#__PURE__*/ (0,jsx_runtime.jsx)(BioLayouts_BookingProfile, {
                                    bioBookingProfileTitle: bio_booking_profile_title,
                                    bioBookingProfileDescription: bio_booking_profile_description,
                                    bioBookingProfileButtonLabel: bio_booking_profile_button_label
                                })
                            ]
                        })
                    ]
                });
                break;
        }
        return bioElement;
    }, [
        style_display,
        bio_image,
        bio_name,
        bio_subtitle,
        socialLinkItemsEnable,
        bio_content, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            bio_show_cover_image && coverImageList.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(BioLayouts_CoverImage, {
                content_attributes: content_attributes,
                style_attributes: style_attributes
            }),
            BioContentElement
        ]
    });
};
/* harmony default export */ var BioLayouts_BioLayout1 = (BioLayout1);

;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockBio/BioLayouts/BioLayout2/index.tsx








var BioLayout2 = function(props) {
    // Layout 5,6
    var content_attributes = props.content_attributes, style_attributes = props.style_attributes;
    var ref = content_attributes || {}, social_link_items = ref.social_link_items, bio_image = ref.bio_image, bio_name = ref.bio_name, bio_subtitle = ref.bio_subtitle, bio_content = ref.bio_content, bio_show_cover_image = ref.bio_show_cover_image, bio_cover_image_list = ref.bio_cover_image_list, bio_booking_profile_title = ref.bio_booking_profile_title, bio_booking_profile_description = ref.bio_booking_profile_description, bio_booking_profile_button_label = ref.bio_booking_profile_button_label, bio_booking_profile_display = ref.bio_booking_profile_display;
    var style_display = (style_attributes || {}).style_display;
    var socialLinkItemsEnable = (0,react.useMemo)(function() {
        return social_link_items === null || social_link_items === void 0 ? void 0 : social_link_items.filter(function(x) {
            return x.enable === 1;
        });
    }, [
        social_link_items
    ]);
    var coverImageList = (0,react.useMemo)(function() {
        return bio_cover_image_list === null || bio_cover_image_list === void 0 ? void 0 : bio_cover_image_list.filter(function(x) {
            return x.enable === 1;
        });
    }, [
        bio_cover_image_list
    ]);
    var BioContentElement = (0,react.useMemo)(function() {
        var bioElement = null;
        switch(style_display){
            case "style-5":
                bioElement = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()("flex flex-col text-center items-center w-full bio-wrapper-style-1 relative", bio_show_cover_image && coverImageList.length > 0 && "mt-[-90px]"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BioLayouts_Avatar, {
                            size: 120,
                            url: bio_image,
                            className: "relative z-[99]",
                            sizeBorder: 3,
                            color: "rgba(255, 255, 255, 0.75)"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "bio-title-wrapper mt-1",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                    className: "w-full bio-name",
                                    style: {
                                        color: "var(--heading-color-6)"
                                    },
                                    children: bio_name
                                }),
                                bio_subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-full bio-subtitle",
                                    style: {
                                        color: "var(--text-color-6)"
                                    },
                                    children: bio_subtitle
                                })
                            ]
                        }),
                        (socialLinkItemsEnable === null || socialLinkItemsEnable === void 0 ? void 0 : socialLinkItemsEnable.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex flex-row gap-3 bio-social-network flex-wrap mt-3",
                            children: socialLinkItemsEnable === null || socialLinkItemsEnable === void 0 ? void 0 : socialLinkItemsEnable.map(function(ele, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: socialLinkIconRender(ele)
                                }, index);
                            })
                        }),
                        bio_booking_profile_display && /*#__PURE__*/ (0,jsx_runtime.jsx)(BioLayouts_BookingProfile, {
                            bioBookingProfileTitle: bio_booking_profile_title,
                            bioBookingProfileDescription: bio_booking_profile_description,
                            bioBookingProfileButtonLabel: bio_booking_profile_button_label
                        }),
                        !!bio_content && /*#__PURE__*/ (0,jsx_runtime.jsx)(BioLayouts_BioContent, {
                            data: bio_content,
                            isCenter: true,
                            className: " mt-3"
                        })
                    ]
                });
                break;
            case "style-6":
                bioElement = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()("flex flex-col text-left bio-wrapper-style-2 relative", bio_show_cover_image && coverImageList.length > 0 && "mt-[-90px] mx-3"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BioLayouts_Avatar, {
                            size: 120,
                            url: bio_image,
                            className: "relative z-[99]",
                            sizeBorder: 3,
                            color: "rgba(255, 255, 255, 0.75)"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "bio-title-wrapper mt-1",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                    className: "bio-name",
                                    style: {
                                        color: "var(--heading-color-6)"
                                    },
                                    children: bio_name
                                }),
                                bio_subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "bio-subtitle",
                                    style: {
                                        color: "var(--text-color-6)"
                                    },
                                    children: bio_subtitle
                                })
                            ]
                        }),
                        !!bio_content && /*#__PURE__*/ (0,jsx_runtime.jsx)(BioLayouts_BioContent, {
                            data: bio_content,
                            className: " mt-3"
                        }),
                        (socialLinkItemsEnable === null || socialLinkItemsEnable === void 0 ? void 0 : socialLinkItemsEnable.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex flex-row gap-3 bio-social-network flex-wrap mt-3",
                            children: socialLinkItemsEnable === null || socialLinkItemsEnable === void 0 ? void 0 : socialLinkItemsEnable.map(function(ele, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: socialLinkIconRender(ele)
                                }, index);
                            })
                        }),
                        bio_booking_profile_display && /*#__PURE__*/ (0,jsx_runtime.jsx)(BioLayouts_BookingProfile, {
                            bioBookingProfileTitle: bio_booking_profile_title,
                            bioBookingProfileDescription: bio_booking_profile_description,
                            bioBookingProfileButtonLabel: bio_booking_profile_button_label
                        })
                    ]
                });
                break;
        }
        return bioElement;
    }, [
        style_display,
        bio_image,
        bio_name,
        bio_subtitle,
        socialLinkItemsEnable,
        bio_content, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            bio_show_cover_image && coverImageList.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(BioLayouts_CoverImage, {
                content_attributes: content_attributes,
                style_attributes: style_attributes
            }),
            BioContentElement
        ]
    });
};
/* harmony default export */ var BioLayouts_BioLayout2 = (BioLayout2);

;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockBio/BioLayouts/BioLayout3/index.tsx








var BioLayout3 = function(props) {
    // Layout 7
    var content_attributes = props.content_attributes, style_attributes = props.style_attributes;
    var ref = content_attributes || {}, social_link_items = ref.social_link_items, bio_image = ref.bio_image, bio_name = ref.bio_name, bio_subtitle = ref.bio_subtitle, bio_content = ref.bio_content, bio_show_cover_image = ref.bio_show_cover_image, bio_cover_image_list = ref.bio_cover_image_list, bio_booking_profile_title = ref.bio_booking_profile_title, bio_booking_profile_description = ref.bio_booking_profile_description, bio_booking_profile_button_label = ref.bio_booking_profile_button_label, bio_booking_profile_display = ref.bio_booking_profile_display;
    var socialLinkItemsEnable = (0,react.useMemo)(function() {
        return social_link_items === null || social_link_items === void 0 ? void 0 : social_link_items.filter(function(x) {
            return x.enable === 1;
        });
    }, [
        social_link_items
    ]);
    var coverImageList = (0,react.useMemo)(function() {
        return bio_cover_image_list === null || bio_cover_image_list === void 0 ? void 0 : bio_cover_image_list.filter(function(x) {
            return x.enable === 1;
        });
    }, [
        bio_cover_image_list
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            bio_show_cover_image && coverImageList.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(BioLayouts_CoverImage, {
                content_attributes: content_attributes,
                style_attributes: style_attributes
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("flex flex-col text-left bio-wrapper-style-2 relative", bio_show_cover_image && coverImageList.length > 0 && "mt-[-40px] mx-3"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex relative z-[999]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BioLayouts_Avatar, {
                                    className: "relative",
                                    size: 100,
                                    url: bio_image,
                                    sizeBorder: 3,
                                    color: "rgba(255, 255, 255, 0.75)"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "bio-title-wrapper pt-[40px] pl-[12px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        className: "bio-name",
                                        style: {
                                            color: "var(--heading-color-6)"
                                        },
                                        children: bio_name
                                    }),
                                    bio_subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "bio-subtitle",
                                        style: {
                                            color: "var(--text-color-6)"
                                        },
                                        children: bio_subtitle
                                    })
                                ]
                            })
                        ]
                    }),
                    !!bio_content && /*#__PURE__*/ (0,jsx_runtime.jsx)(BioLayouts_BioContent, {
                        data: bio_content,
                        className: " mt-[10px]"
                    }),
                    (socialLinkItemsEnable === null || socialLinkItemsEnable === void 0 ? void 0 : socialLinkItemsEnable.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex flex-row gap-3 bio-social-network flex-wrap mt-3",
                        children: socialLinkItemsEnable === null || socialLinkItemsEnable === void 0 ? void 0 : socialLinkItemsEnable.map(function(ele, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: socialLinkIconRender(ele)
                            }, index);
                        })
                    }),
                    bio_booking_profile_display && /*#__PURE__*/ (0,jsx_runtime.jsx)(BioLayouts_BookingProfile, {
                        bioBookingProfileTitle: bio_booking_profile_title,
                        bioBookingProfileDescription: bio_booking_profile_description,
                        bioBookingProfileButtonLabel: bio_booking_profile_button_label
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var BioLayouts_BioLayout3 = (BioLayout3);

;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockBio/BioLayouts/index.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}






var _obj;
var BIO_LAYOUT = (_obj = {}, _defineProperty(_obj, configs_const/* BIO_DISPLAY_STYLES.STYLE1 */.uT.STYLE1, BioLayouts_BioLayout1), _defineProperty(_obj, configs_const/* BIO_DISPLAY_STYLES.STYLE2 */.uT.STYLE2, BioLayouts_BioLayout1), _defineProperty(_obj, configs_const/* BIO_DISPLAY_STYLES.STYLE3 */.uT.STYLE3, BioLayouts_BioLayout1), _defineProperty(_obj, configs_const/* BIO_DISPLAY_STYLES.STYLE4 */.uT.STYLE4, BioLayouts_BioLayout1), _defineProperty(_obj, configs_const/* BIO_DISPLAY_STYLES.STYLE5 */.uT.STYLE5, BioLayouts_BioLayout2), _defineProperty(_obj, configs_const/* BIO_DISPLAY_STYLES.STYLE6 */.uT.STYLE6, BioLayouts_BioLayout2), _defineProperty(_obj, configs_const/* BIO_DISPLAY_STYLES.STYLE7 */.uT.STYLE7, BioLayouts_BioLayout3), _obj);
var BioLayouts = function(props1) {
    var ref2;
    var BioLayout = (0,react.useCallback)(function(props) {
        var ref;
        var Element = /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        if (BIO_LAYOUT[props === null || props === void 0 ? void 0 : (ref = props.style_attributes) === null || ref === void 0 ? void 0 : ref.style_display]) {
            var ref1;
            var RenderComponent = BIO_LAYOUT[props === null || props === void 0 ? void 0 : (ref1 = props.style_attributes) === null || ref1 === void 0 ? void 0 : ref1.style_display];
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(RenderComponent, _objectSpread({}, props));
        }
        return Element;
    }, [
        props1 === null || props1 === void 0 ? void 0 : (ref2 = props1.style_attributes) === null || ref2 === void 0 ? void 0 : ref2.style_display
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BioLayout, _objectSpread({}, props1));
};
/* harmony default export */ var BlockBio_BioLayouts = (BioLayouts);

;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockBio/index.tsx





var BlockBio = function(props) {
    var ref, ref1;
    var blockData = props.blockData, positionSlug = props.positionSlug, tabUid = props.tabUid, index = props.index, listBlocksSortOrder = props.listBlocksSortOrder, isFirstItem = props.isFirstItem, isApplyBlockSettings = props.isApplyBlockSettings, isHideMoreActions = props.isHideMoreActions;
    var enable = blockData && blockData.enable;
    var content_attributes = blockData === null || blockData === void 0 ? void 0 : blockData.content_attributes;
    var style_attributes = blockData === null || blockData === void 0 ? void 0 : blockData.style_attributes;
    var siteSettings = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.siteSettings;
    });
    var ref2 = (siteSettings === null || siteSettings === void 0 ? void 0 : (ref = siteSettings.display_setting) === null || ref === void 0 ? void 0 : (ref1 = ref.block_setting) === null || ref1 === void 0 ? void 0 : ref1.block_style) || {}, inner_space_number = ref2.inner_space_number, outside_space = ref2.outside_space;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockWrapper/* default */.Z, {
        blockType: blockData === null || blockData === void 0 ? void 0 : blockData.block_type,
        isEnable: enable,
        positionSlug: positionSlug,
        tabUid: tabUid,
        blockUid: blockData === null || blockData === void 0 ? void 0 : blockData.uid,
        index: index,
        listBlocksSortOrder: listBlocksSortOrder,
        outsideSpace: outside_space,
        insideSpace: inner_space_number,
        isFirstItem: isFirstItem,
        isApplyBlockSettings: isApplyBlockSettings,
        isHideMoreActions: isHideMoreActions,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockBio_BioLayouts, {
            content_attributes: content_attributes,
            style_attributes: style_attributes
        })
    });
};
/* harmony default export */ var CommonBlockComponent_BlockBio = (BlockBio);

// EXTERNAL MODULE: ./src/features/share/IconRender/index.tsx
var IconRender = __webpack_require__(39608);
// EXTERNAL MODULE: ./src/features/design/components/CommonBlockComponent/BlockButtonLink/LinkLayouts/style.module.scss
var style_module = __webpack_require__(99279);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockButtonLink/LinkLayouts/TextRightLeftLayout/index.tsx






var TextRightLeftLayout = function(props) {
    var style_attributes = props.style_attributes, content_attributes = props.content_attributes;
    var ref = content_attributes || {}, button_content = ref.button_content, button_icon = ref.button_icon, use_aff_url = ref.use_aff_url, target_url = ref.target_url, origin_url = ref.origin_url, button_description = ref.button_description, image = ref.image;
    var ref1 = style_attributes || {}, button_size = ref1.button_size, button_link_template = ref1.button_link_template, button_link_layout = ref1.button_link_layout, button_link_style = ref1.button_link_style;
    var buttonSizeClass = (0,react.useMemo)(function() {
        var valueClass = null;
        switch(button_size){
            case "small":
                valueClass = "small-button";
                break;
            case "middle":
                valueClass = "middle-button";
                break;
            case "large":
                valueClass = "large-button";
                break;
        }
        return valueClass;
    }, [
        button_size
    ]);
    var isShowIconRight = (0,react.useMemo)(function() {
        return button_link_style === configs_const/* LINK_STYLE_DISPLAY.TEXT_AND_ICON */.Bx.TEXT_AND_ICON && button_icon && button_link_layout === configs_const/* LINK_LAYOUTS.TEXT_RIGHT */.Q5.TEXT_RIGHT;
    }, [
        button_link_style,
        button_icon,
        button_link_layout
    ]);
    var isShowImageRight = (0,react.useMemo)(function() {
        return button_link_style === configs_const/* LINK_STYLE_DISPLAY.TEXT_AND_IMAGE */.Bx.TEXT_AND_IMAGE && image && button_link_layout === configs_const/* LINK_LAYOUTS.TEXT_RIGHT */.Q5.TEXT_RIGHT;
    }, [
        button_link_style,
        image,
        button_link_layout
    ]);
    var isShowIconLeft = (0,react.useMemo)(function() {
        return button_link_style === configs_const/* LINK_STYLE_DISPLAY.TEXT_AND_ICON */.Bx.TEXT_AND_ICON && button_icon && button_link_layout === configs_const/* LINK_LAYOUTS.TEXT_LEFT */.Q5.TEXT_LEFT;
    }, [
        button_link_style,
        button_icon,
        button_link_layout
    ]);
    var isShowImageLeft = (0,react.useMemo)(function() {
        return button_link_style === configs_const/* LINK_STYLE_DISPLAY.TEXT_AND_IMAGE */.Bx.TEXT_AND_IMAGE && image && button_link_layout === configs_const/* LINK_LAYOUTS.TEXT_LEFT */.Q5.TEXT_LEFT;
    }, [
        button_link_style,
        image,
        button_link_layout
    ]);
    var styleButtonLink = (0,react.useMemo)(function() {
        var styleObj = {};
        switch(button_link_template){
            case configs_const/* LINK_TEMPLATE.TEMPLATE1 */.Ei.TEMPLATE1:
                styleObj = {
                    "--background-color": "#FFFFFF",
                    "--border-color": "#333333"
                };
                break;
            case configs_const/* LINK_TEMPLATE.TEMPLATE2 */.Ei.TEMPLATE2:
                styleObj = {
                    "--background-color": "var(--button-bg-color-6)",
                    "--border-color": "var(--button-border-color-6)"
                };
                break;
            case configs_const/* LINK_TEMPLATE.TEMPLATE3 */.Ei.TEMPLATE3:
                styleObj = {
                    "--background-color": "var(--button-bg-color-6)",
                    "--border-color": "var(--button-border-color-6)",
                    boxShadow: "4px 5px 0px #000000"
                };
                break;
        }
        return styleObj;
    }, [
        button_link_template
    ]);
    var buttonClass = (0,react.useMemo)(function() {
        switch(button_link_template){
            case configs_const/* LINK_TEMPLATE.TEMPLATE1 */.Ei.TEMPLATE1:
                return (style_module_default()).template1;
            case configs_const/* LINK_TEMPLATE.TEMPLATE2 */.Ei.TEMPLATE2:
                return (style_module_default()).template2;
            case configs_const/* LINK_TEMPLATE.TEMPLATE3 */.Ei.TEMPLATE3:
                return (style_module_default()).template3;
        }
        return "";
    }, [
        button_link_template
    ]);
    var imageSizeValue = (0,react.useMemo)(function() {
        var valueSize = null;
        switch(button_size){
            case "small":
                valueSize = 38;
                break;
            case "middle":
                valueSize = 60;
                break;
            case "large":
                valueSize = 72;
                break;
        }
        return valueSize;
    }, [
        button_size
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                style: {
                    "--text-color": "unset"
                },
                size: button_size,
                block: true,
                className: "".concat(buttonSizeClass, " ").concat((style_module_default()).buttonStyle, " button-border-radius button-border-width button-border-style button-link-wrapper ").concat(button_link_layout, " ").concat(buttonClass),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-row gap-2 items-center justify-center",
                    children: [
                        isShowIconRight && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconRender/* default */.Z, {
                            iconName: button_icon,
                            fillColor: button_link_template === configs_const/* LINK_TEMPLATE.TEMPLATE1 */.Ei.TEMPLATE1 ? "var(--heading-color-6)" : "var(--button-text-color)"
                        }),
                        isShowImageRight && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                                fit: "cover",
                                src: image,
                                width: imageSizeValue,
                                height: imageSizeValue,
                                className: "rounded"
                            })
                        }),
                        (button_content || button_description) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col gap-1 text-center grow break-words",
                            children: [
                                button_content && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "button-link-content",
                                    style: {
                                        color: button_link_template === configs_const/* LINK_TEMPLATE.TEMPLATE1 */.Ei.TEMPLATE1 ? "var(--heading-color-6)" : "var(--button-text-color)"
                                    },
                                    children: button_content
                                }),
                                button_description && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "button-link-description small",
                                    style: {
                                        color: button_link_template === configs_const/* LINK_TEMPLATE.TEMPLATE1 */.Ei.TEMPLATE1 ? "var(--heading-color-5)" : "var(--button-text-color)"
                                    },
                                    children: button_description
                                })
                            ]
                        }),
                        isShowIconLeft && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconRender/* default */.Z, {
                            iconName: button_icon,
                            fillColor: button_link_template === configs_const/* LINK_TEMPLATE.TEMPLATE1 */.Ei.TEMPLATE1 ? "var(--heading-color-6)" : "var(--button-text-color)"
                        }),
                        isShowImageLeft && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                                fit: "cover",
                                src: image,
                                width: imageSizeValue,
                                height: imageSizeValue,
                                className: "rounded"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute top-0 left-0 block w-full h-full rounded-lg",
                style: {
                    backgroundColor: "transparent"
                }
            })
        ]
    });
};
/* harmony default export */ var LinkLayouts_TextRightLeftLayout = (TextRightLeftLayout);

;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockButtonLink/LinkLayouts/TextUnderLayout/index.tsx






var TextUnderLayout = function(props) {
    var style_attributes = props.style_attributes, content_attributes = props.content_attributes;
    var ref = content_attributes || {}, button_content = ref.button_content, button_icon = ref.button_icon, use_aff_url = ref.use_aff_url, target_url = ref.target_url, origin_url = ref.origin_url, button_description = ref.button_description, image = ref.image;
    var ref1 = style_attributes || {}, button_size = ref1.button_size, button_link_template = ref1.button_link_template, button_link_layout = ref1.button_link_layout, button_link_style = ref1.button_link_style;
    var buttonSizeClass = (0,react.useMemo)(function() {
        var valueClass = null;
        switch(button_size){
            case "small":
                valueClass = "small-button";
                break;
            case "middle":
                valueClass = "middle-button";
                break;
            case "large":
                valueClass = "large-button";
                break;
        }
        return valueClass;
    }, [
        button_size
    ]);
    var isShowIcon = (0,react.useMemo)(function() {
        return button_link_style === configs_const/* LINK_STYLE_DISPLAY.TEXT_AND_ICON */.Bx.TEXT_AND_ICON && button_icon && button_link_layout === configs_const/* LINK_LAYOUTS.TEXT_UNDER */.Q5.TEXT_UNDER;
    }, [
        button_link_style,
        button_icon,
        button_link_layout
    ]);
    var isShowImage = (0,react.useMemo)(function() {
        return button_link_style === configs_const/* LINK_STYLE_DISPLAY.TEXT_AND_IMAGE */.Bx.TEXT_AND_IMAGE && image && button_link_layout === configs_const/* LINK_LAYOUTS.TEXT_UNDER */.Q5.TEXT_UNDER;
    }, [
        button_link_style,
        image,
        button_link_layout
    ]);
    var buttonClass = (0,react.useMemo)(function() {
        switch(button_link_template){
            case configs_const/* LINK_TEMPLATE.TEMPLATE1 */.Ei.TEMPLATE1:
                return (style_module_default()).template1;
            case configs_const/* LINK_TEMPLATE.TEMPLATE2 */.Ei.TEMPLATE2:
                return (style_module_default()).template2;
            case configs_const/* LINK_TEMPLATE.TEMPLATE3 */.Ei.TEMPLATE3:
                return (style_module_default()).template3;
        }
        return "";
    }, [
        button_link_template
    ]);
    var imageSizeValue = (0,react.useMemo)(function() {
        var valueSize = null;
        switch(button_size){
            case "small":
                valueSize = 38;
                break;
            case "middle":
                valueSize = 60;
                break;
            case "large":
                valueSize = 72;
                break;
        }
        return valueSize;
    }, [
        button_size
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                style: {
                    "--text-color": "unset"
                },
                size: button_size,
                block: true,
                className: "".concat(buttonSizeClass, " ").concat((style_module_default()).buttonStyle, " ").concat(buttonClass, "  button-border-radius button-border-width button-border-style button-link-wrapper ").concat(button_link_layout),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col gap-2 items-center justify-center",
                    children: [
                        isShowIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconRender/* default */.Z, {
                            iconName: button_icon,
                            fillColor: button_link_template === configs_const/* LINK_TEMPLATE.TEMPLATE1 */.Ei.TEMPLATE1 ? "var(--heading-color-6)" : "var(--button-text-color)"
                        }),
                        isShowImage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                                fit: "cover",
                                src: image,
                                width: imageSizeValue,
                                height: imageSizeValue,
                                className: "rounded"
                            })
                        }),
                        (button_content || button_description) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col gap-1 text-center grow break-words",
                            children: [
                                button_content && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "button-link-content",
                                    style: {
                                        color: button_link_template === configs_const/* LINK_TEMPLATE.TEMPLATE1 */.Ei.TEMPLATE1 ? "var(--heading-color-6)" : "var(--button-text-color)"
                                    },
                                    children: button_content
                                }),
                                button_description && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "button-link-description small",
                                    style: {
                                        color: button_link_template === configs_const/* LINK_TEMPLATE.TEMPLATE1 */.Ei.TEMPLATE1 ? "var(--heading-color-5)" : "var(--button-text-color)"
                                    },
                                    children: button_description
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute top-0 left-0 block w-full h-full rounded-lg",
                style: {
                    backgroundColor: "transparent"
                }
            })
        ]
    });
};
/* harmony default export */ var LinkLayouts_TextUnderLayout = (TextUnderLayout);

;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockButtonLink/LinkLayouts/index.tsx
function LinkLayouts_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function LinkLayouts_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            LinkLayouts_defineProperty(target, key, source[key]);
        });
    }
    return target;
}





var LinkLayouts_obj;
var LINK_LAYOUT_COMPONENT = (LinkLayouts_obj = {}, LinkLayouts_defineProperty(LinkLayouts_obj, configs_const/* LINK_LAYOUTS.TEXT_RIGHT */.Q5.TEXT_RIGHT, LinkLayouts_TextRightLeftLayout), LinkLayouts_defineProperty(LinkLayouts_obj, configs_const/* LINK_LAYOUTS.TEXT_LEFT */.Q5.TEXT_LEFT, LinkLayouts_TextRightLeftLayout), LinkLayouts_defineProperty(LinkLayouts_obj, configs_const/* LINK_LAYOUTS.TEXT_UNDER */.Q5.TEXT_UNDER, LinkLayouts_TextUnderLayout), LinkLayouts_obj);
var LinkLayouts = function(props1) {
    var ref2;
    var LinkLayoutRender = (0,react.useCallback)(function(props) {
        var ref;
        var Element = /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        if (LINK_LAYOUT_COMPONENT[props === null || props === void 0 ? void 0 : (ref = props.style_attributes) === null || ref === void 0 ? void 0 : ref.button_link_layout]) {
            var ref1;
            var RenderComponent = LINK_LAYOUT_COMPONENT[props === null || props === void 0 ? void 0 : (ref1 = props.style_attributes) === null || ref1 === void 0 ? void 0 : ref1.button_link_layout];
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(RenderComponent, LinkLayouts_objectSpread({}, props));
        }
        return Element;
    }, [
        props1 === null || props1 === void 0 ? void 0 : (ref2 = props1.style_attributes) === null || ref2 === void 0 ? void 0 : ref2.button_link_layout
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkLayoutRender, LinkLayouts_objectSpread({}, props1));
};
/* harmony default export */ var BlockButtonLink_LinkLayouts = (LinkLayouts);

;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockButtonLink/index.tsx
function BlockButtonLink_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function BlockButtonLink_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            BlockButtonLink_defineProperty(target, key, source[key]);
        });
    }
    return target;
}







var setDefaultValueStyleAttributes = function(styleAttributes) {
    var newStyleAttributes = BlockButtonLink_objectSpread({}, styleAttributes);
    if (!newStyleAttributes.button_link_template) {
        newStyleAttributes.button_link_template = configs_const/* LINK_TEMPLATE.TEMPLATE2 */.Ei.TEMPLATE2;
    }
    if (!newStyleAttributes.button_link_layout) {
        newStyleAttributes.button_link_layout = configs_const/* LINK_LAYOUTS.TEXT_RIGHT */.Q5.TEXT_RIGHT;
    }
    if (!newStyleAttributes.button_link_style) {
        newStyleAttributes.button_link_style = configs_const/* LINK_STYLE_DISPLAY.TEXT_AND_ICON */.Bx.TEXT_AND_ICON;
    }
    return newStyleAttributes;
};
var BlockButtonLink = function(props) {
    var ref, ref1, ref2, ref3;
    var blockData = props.blockData, positionSlug = props.positionSlug, tabUid = props.tabUid, index = props.index, listBlocksSortOrder = props.listBlocksSortOrder, isFirstItem = props.isFirstItem, isApplyBlockSettings = props.isApplyBlockSettings, isHideMoreActions = props.isHideMoreActions;
    var enable = blockData && blockData.enable;
    var siteSettings = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.siteSettings;
    });
    var ref4 = (siteSettings === null || siteSettings === void 0 ? void 0 : (ref = siteSettings.display_setting) === null || ref === void 0 ? void 0 : (ref1 = ref.block_setting) === null || ref1 === void 0 ? void 0 : ref1.block_style) || {}, inner_space_number = ref4.inner_space_number, outside_space = ref4.outside_space;
    var content_attributes = blockData && blockData.content_attributes && blockData.content_attributes;
    var style_attributes = setDefaultValueStyleAttributes(blockData.style_attributes);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BlockWrapper/* default */.Z, {
        blockType: blockData === null || blockData === void 0 ? void 0 : blockData.block_type,
        isEnable: enable,
        positionSlug: positionSlug,
        tabUid: tabUid,
        blockUid: blockData === null || blockData === void 0 ? void 0 : blockData.uid,
        index: index,
        listBlocksSortOrder: listBlocksSortOrder,
        outsideSpace: outside_space,
        insideSpace: inner_space_number,
        isFirstItem: isFirstItem,
        isApplyBlockSettings: isApplyBlockSettings,
        isHideMoreActions: isHideMoreActions,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockHeadingComponent/* default */.Z, {
                title: blockData === null || blockData === void 0 ? void 0 : (ref2 = blockData.content_attributes) === null || ref2 === void 0 ? void 0 : ref2.block_title,
                blockType: blockData.block_type,
                subtitle: blockData === null || blockData === void 0 ? void 0 : (ref3 = blockData.content_attributes) === null || ref3 === void 0 ? void 0 : ref3.block_description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockButtonLink_LinkLayouts, {
                content_attributes: content_attributes,
                style_attributes: style_attributes,
                isMultiLink: false
            })
        ]
    });
};
/* harmony default export */ var CommonBlockComponent_BlockButtonLink = (BlockButtonLink);

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/features/block/block-editor/DigitalProduct/api/index.tsx
var api = __webpack_require__(49961);
// EXTERNAL MODULE: ./src/features/share/lib/index.ts + 1 modules
var lib = __webpack_require__(11116);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 16 modules
var react_redux_es = __webpack_require__(92145);
// EXTERNAL MODULE: ./src/features/block/block-editor/DigitalProduct/store/digitalProductSlice.ts
var digitalProductSlice = __webpack_require__(60821);
// EXTERNAL MODULE: ./src/features/block/block-editor/DigitalProduct/config/type.ts
var type = __webpack_require__(710);
;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockDigitalProduct/index.tsx
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}














var BlockDigitalProduct = function(props) {
    var ref6, ref1, ref2, ref3;
    var blockData = props.blockData, positionSlug = props.positionSlug, tabUid = props.tabUid, index1 = props.index, listBlocksSortOrder = props.listBlocksSortOrder, isFirstItem = props.isFirstItem, isApplyBlockSettings = props.isApplyBlockSettings, isHideMoreActions = props.isHideMoreActions;
    var enable = blockData && blockData.enable;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var user = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.user;
    });
    var isDeleteItems = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.digitalProduct.isDeleteItems;
    });
    var siteSettings = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.siteSettings;
    });
    var dispatch = (0,react_redux_es/* useDispatch */.I0)();
    var ref4 = (siteSettings === null || siteSettings === void 0 ? void 0 : (ref6 = siteSettings.display_setting) === null || ref6 === void 0 ? void 0 : (ref1 = ref6.block_setting) === null || ref1 === void 0 ? void 0 : ref1.block_style) || {}, inner_space_number = ref4.inner_space_number, outside_space = ref4.outside_space;
    var ref5 = (0,react.useState)([]), digitalProductArr = ref5[0], setDigitalProductArr = ref5[1];
    var userId = user === null || user === void 0 ? void 0 : (ref2 = user.kol) === null || ref2 === void 0 ? void 0 : ref2._id;
    var countryCode = user === null || user === void 0 ? void 0 : (ref3 = user.kol) === null || ref3 === void 0 ? void 0 : ref3.country;
    var getListProduct = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(dataFetch) {
            var ref, response, params, sortResponse, productData;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        if (!(((ref = blockData.content_attributes) === null || ref === void 0 ? void 0 : ref.hasInit) && !dataFetch)) {
                            _ctx.next = 4;
                            break;
                        }
                        setDigitalProductArr([]);
                        return _ctx.abrupt("return");
                    case 4:
                        ;
                        params = dataFetch ? {
                            ids: dataFetch.join(",")
                        } : {
                            status: 1
                        };
                        _ctx.prev = 6;
                        _ctx.next = 9;
                        return api/* default.listProduct */.Z.listProduct(params);
                    case 9:
                        response = _ctx.sent;
                        _ctx.next = 15;
                        break;
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](6);
                        console.log(_ctx.t0);
                    case 15:
                        if (response && response.success) {
                            sortResponse = dataFetch ? dataFetch.map(function(id) {
                                return response.data.find(function(item) {
                                    return item.id === id;
                                });
                            }) : response.data;
                            productData = sortResponse.filter(Boolean).map(function(item) {
                                return {
                                    name: item.name,
                                    price: item.price,
                                    image_url: (item === null || item === void 0 ? void 0 : item.thumbnails[0]) ? item === null || item === void 0 ? void 0 : item.thumbnails[0].url_small : ""
                                };
                            });
                            if (isDeleteItems) {
                                dispatch(digitalProductSlice/* digitalProductAction.setIsDeleteItems */.t.setIsDeleteItems(false));
                            }
                            setDigitalProductArr(productData);
                        }
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    6,
                    12
                ]
            ]);
        }));
        return function getListProduct(dataFetch) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        var ref, ref7, ref8, ref9;
        var itemData = ((ref = blockData.content_attributes) === null || ref === void 0 ? void 0 : (ref7 = ref.dp_data) === null || ref7 === void 0 ? void 0 : ref7.length) > 0 ? blockData.content_attributes.dp_data : null;
        var itemID = ((ref8 = blockData.content_attributes) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.dp_items) === null || ref9 === void 0 ? void 0 : ref9.length) > 0 ? blockData.content_attributes.dp_items : null;
        if (itemData) {
            setDigitalProductArr(itemData);
        } else {
            getListProduct(itemID);
        }
    }, [
        countryCode,
        userId,
        blockData,
        isDeleteItems
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockWrapper/* default */.Z, {
        blockType: blockData === null || blockData === void 0 ? void 0 : blockData.block_type,
        isEnable: enable,
        positionSlug: positionSlug,
        tabUid: tabUid,
        blockUid: blockData === null || blockData === void 0 ? void 0 : blockData.uid,
        index: index1,
        listBlocksSortOrder: listBlocksSortOrder,
        outsideSpace: outside_space,
        insideSpace: inner_space_number,
        isFirstItem: isFirstItem,
        isApplyBlockSettings: isApplyBlockSettings,
        isHideMoreActions: isHideMoreActions,
        children: digitalProductArr && digitalProductArr.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "grid grid-cols-2 gap-3",
                children: digitalProductArr.map(function(ele, index) {
                    var ref, ref10, ref11;
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                        style: {
                            boxShadow: "0 3px 6px 0 rgb(54 54 54 / 20%)",
                            borderRadius: "8px"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(build.LazyLoadImage, {
                                src: ((ref = ele.category) === null || ref === void 0 ? void 0 : ref.id) === type/* CAT_ID.PHOTO */.m.PHOTO ? ele === null || ele === void 0 ? void 0 : (ref10 = ele.cover_image) === null || ref10 === void 0 ? void 0 : ref10.url : ele.thumbnail ? ele.thumbnail : ele.image_url ? ele.image_url : ((ref11 = ele.thumbnails) === null || ref11 === void 0 ? void 0 : ref11.length) ? ele.thumbnails[0].url : "",
                                className: "object-center rounded-t-lg",
                                style: {
                                    backgroundSize: "cover",
                                    aspectRatio: "1/1",
                                    // margin: "0 auto",
                                    objectFit: "cover",
                                    width: "100%",
                                    maxWidth: "222px"
                                },
                                onError: function(param) {
                                    var currentTarget = param.currentTarget;
                                    currentTarget.onerror = null; // prevents looping
                                    currentTarget.src = "https://i.ecomobi.com/ssp/passio-page/image-default.png";
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "bg-[#FFFFFF] rounded-b-lg",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Ellipsis */.mH, {
                                        direction: "end",
                                        content: (0,lib/* htmlDecode */.l_)(ele.name),
                                        className: "text-base font-bold pt-3 px-2 mb-[5px] text-[#333333]",
                                        rows: 2,
                                        style: {
                                            lineHeight: "var(--paragraph-line-height)"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "px-2 pb-3",
                                        children: ele.price > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-red-600 font-medium",
                                            children: "".concat((0,lib/* formatNumberToCurrencyDonation */.Si)(ele.price), " ").concat((0,lib/* formatUnitSymbol */.Pb)(countryCode))
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-green-500 font-medium",
                                            children: t("ss_builder_digital_product_free_label")
                                        })
                                    })
                                ]
                            })
                        ]
                    }, index);
                })
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col justify-center text-center gap-2 mt-5",
            style: {
                opacity: "60%"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                    src: "https://image.passio.eco/page-builder/page-builder/images-default/product-empty-image-default.png"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "lead-2",
                            style: {
                                color: "var(--text-color-6)"
                            },
                            children: t("ss_builder_product_design_empty_title")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            style: {
                                color: "var(--text-color-5)"
                            },
                            children: t("ss_builder_product_design_empty_description")
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var CommonBlockComponent_BlockDigitalProduct = (BlockDigitalProduct);

// EXTERNAL MODULE: ./src/features/share/helper/validator.ts
var validator = __webpack_require__(52893);
;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockEmbed/index.tsx







var URL_PARAMS_KEY = "{url_params}";
var BlockEmbed = function(props) {
    var ref5, ref1, ref2, ref3;
    var blockData = props.blockData, positionSlug = props.positionSlug, tabUid = props.tabUid, index = props.index, listBlocksSortOrder = props.listBlocksSortOrder, isFirstItem = props.isFirstItem, isApplyBlockSettings = props.isApplyBlockSettings, isHideMoreActions = props.isHideMoreActions;
    var enable = blockData && blockData.enable;
    var siteSettings = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.siteSettings;
    });
    var ref4 = (siteSettings === null || siteSettings === void 0 ? void 0 : (ref5 = siteSettings.display_setting) === null || ref5 === void 0 ? void 0 : (ref1 = ref5.block_setting) === null || ref1 === void 0 ? void 0 : ref1.block_style) || {}, inner_space_number = ref4.inner_space_number, outside_space = ref4.outside_space;
    var transformEmbedContent = function(embedString) {
        var listAttrs = (0,validator/* extractAttrFromString */.as)(embedString);
        var titleAttr = listAttrs === null || listAttrs === void 0 ? void 0 : listAttrs.find(function(e) {
            return e[0] === "title";
        });
        var titleValueClean = titleAttr && titleAttr.length > 1 && titleAttr[1].replaceAll(">", "&gt;").replaceAll("<", "&lt;").replaceAll('"', "&quot;").replaceAll("'", "&#39;");
        var newEmbedString = embedString.replace(/(?:title=(.+?)"+)/, 'title="'.concat(titleValueClean, '"'));
        return newEmbedString;
    };
    var cleanEmbedCode = (0,react.useMemo)(function() {
        var ref;
        var embed = transformEmbedContent(blockData === null || blockData === void 0 ? void 0 : (ref = blockData.content_attributes) === null || ref === void 0 ? void 0 : ref.embed_code);
        if ((0,validator/* checkDirtyCodeIframe */.iO)(embed)) {
            if (embed === null || embed === void 0 ? void 0 : embed.includes(URL_PARAMS_KEY)) {
                embed = embed.replaceAll(URL_PARAMS_KEY, "");
            }
            return embed;
        }
        return "";
    }, [
        blockData
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BlockWrapper/* default */.Z, {
        blockType: blockData === null || blockData === void 0 ? void 0 : blockData.block_type,
        isEnable: enable,
        positionSlug: positionSlug,
        tabUid: tabUid,
        blockUid: blockData === null || blockData === void 0 ? void 0 : blockData.uid,
        index: index,
        listBlocksSortOrder: listBlocksSortOrder,
        outsideSpace: outside_space,
        insideSpace: inner_space_number,
        isFirstItem: isFirstItem,
        isApplyBlockSettings: isApplyBlockSettings,
        isHideMoreActions: isHideMoreActions,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockHeadingComponent/* default */.Z, {
                blockType: blockData.block_type,
                title: blockData === null || blockData === void 0 ? void 0 : (ref2 = blockData.content_attributes) === null || ref2 === void 0 ? void 0 : ref2.block_heading,
                subtitle: blockData === null || blockData === void 0 ? void 0 : (ref3 = blockData.content_attributes) === null || ref3 === void 0 ? void 0 : ref3.block_description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative w-full h-full",
                dangerouslySetInnerHTML: {
                    __html: cleanEmbedCode
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute top-0 left-0 block w-full h-full text-center block-border-radius",
                style: {
                    backgroundColor: "transparent"
                }
            })
        ]
    });
};
/* harmony default export */ var CommonBlockComponent_BlockEmbed = (BlockEmbed);

;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockImage/index.tsx






var BlockImage = function(props) {
    var ref, ref1;
    var blockData = props.blockData, positionSlug = props.positionSlug, tabUid = props.tabUid, index = props.index, listBlocksSortOrder = props.listBlocksSortOrder, isFirstItem = props.isFirstItem, isApplyBlockSettings = props.isApplyBlockSettings, isHideMoreActions = props.isHideMoreActions;
    var enable = blockData && blockData.enable;
    var siteSettings = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.siteSettings;
    });
    var ref2 = (siteSettings === null || siteSettings === void 0 ? void 0 : (ref = siteSettings.display_setting) === null || ref === void 0 ? void 0 : (ref1 = ref.block_setting) === null || ref1 === void 0 ? void 0 : ref1.block_style) || {}, inner_space_number = ref2.inner_space_number, outside_space = ref2.outside_space;
    var style_attibutes = blockData === null || blockData === void 0 ? void 0 : blockData.style_attributes;
    var content_attributes = blockData === null || blockData === void 0 ? void 0 : blockData.content_attributes;
    var ref3 = style_attibutes || {}, ratio = ref3.ratio, image_orientation = ref3.image_orientation;
    var ref4 = content_attributes || {}, block_heading = ref4.block_heading, block_description = ref4.block_description, dataImage = ref4.image;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BlockWrapper/* default */.Z, {
        blockType: blockData === null || blockData === void 0 ? void 0 : blockData.block_type,
        isEnable: enable,
        positionSlug: positionSlug,
        tabUid: tabUid,
        blockUid: blockData === null || blockData === void 0 ? void 0 : blockData.uid,
        index: index,
        listBlocksSortOrder: listBlocksSortOrder,
        outsideSpace: outside_space,
        insideSpace: inner_space_number,
        isFirstItem: isFirstItem,
        isApplyBlockSettings: isApplyBlockSettings,
        isHideMoreActions: isHideMoreActions,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockHeadingComponent/* default */.Z, {
                blockType: blockData.block_type,
                title: block_heading,
                subtitle: block_description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                className: "image-design image-border-radius",
                src: dataImage,
                fit: "cover",
                style: {
                    backgroundSize: "cover",
                    aspectRatio: ratio
                }
            })
        ]
    });
};
/* harmony default export */ var CommonBlockComponent_BlockImage = (BlockImage);

;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockImageSlider/index.tsx
function BlockImageSlider_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function BlockImageSlider_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            BlockImageSlider_defineProperty(target, key, source[key]);
        });
    }
    return target;
}








var BlockImageSlider = function(props) {
    var ref8, ref1, ref2;
    var blockData = props.blockData, positionSlug = props.positionSlug, tabUid = props.tabUid, index1 = props.index, listBlocksSortOrder = props.listBlocksSortOrder, isFirstItem = props.isFirstItem, isApplyBlockSettings = props.isApplyBlockSettings, isHideMoreActions = props.isHideMoreActions;
    var enable = blockData && blockData.enable;
    var siteSettings = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.siteSettings;
    });
    var ref3 = (siteSettings === null || siteSettings === void 0 ? void 0 : (ref8 = siteSettings.display_setting) === null || ref8 === void 0 ? void 0 : (ref1 = ref8.block_setting) === null || ref1 === void 0 ? void 0 : ref1.block_style) || {}, inner_space_number = ref3.inner_space_number, outside_space = ref3.outside_space;
    var style_attibutes = blockData === null || blockData === void 0 ? void 0 : blockData.style_attributes;
    var content_attributes = blockData === null || blockData === void 0 ? void 0 : blockData.content_attributes;
    var ref4 = style_attibutes || {}, enable_dot = ref4.enable_dot, ratio = ref4.ratio, enable_arrow = ref4.enable_arrow, enable_auto_play = ref4.enable_auto_play;
    var ref5 = content_attributes || {}, block_heading = ref5.block_heading, block_description = ref5.block_description, dataImageSliderArr = ref5.items;
    var dataImageSliderSortOrder = dataImageSliderArr && orderBy_default()(dataImageSliderArr, [
        "sort_order"
    ], [
        "asc"
    ]);
    var imageSliderEnable = dataImageSliderSortOrder === null || dataImageSliderSortOrder === void 0 ? void 0 : dataImageSliderSortOrder.filter(function(x) {
        return x.enable === 1;
    });
    var isDisplayArrowSlideBtn = (0,react.useMemo)(function() {
        return enable_arrow && (imageSliderEnable === null || imageSliderEnable === void 0 ? void 0 : imageSliderEnable.length) > 1;
    }, [
        enable_arrow,
        imageSliderEnable
    ]);
    var ref6 = (0,react.useRef)(null);
    var ref7 = (0,react.useState)(0), imageIndex = ref7[0], setImageIndex = ref7[1];
    var handlePreviousImage = function(event) {
        var ref;
        event.preventDefault();
        (ref = ref6.current) === null || ref === void 0 ? void 0 : ref.swipePrev();
    };
    var handleNextImage = function(event) {
        var ref;
        event.preventDefault();
        (ref = ref6.current) === null || ref === void 0 ? void 0 : ref.swipeNext();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BlockWrapper/* default */.Z, {
        blockType: blockData === null || blockData === void 0 ? void 0 : blockData.block_type,
        isEnable: enable,
        positionSlug: positionSlug,
        tabUid: tabUid,
        blockUid: blockData === null || blockData === void 0 ? void 0 : blockData.uid,
        index: index1,
        listBlocksSortOrder: listBlocksSortOrder,
        outsideSpace: outside_space,
        insideSpace: inner_space_number,
        isFirstItem: isFirstItem,
        isApplyBlockSettings: isApplyBlockSettings,
        isHideMoreActions: isHideMoreActions,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockHeadingComponent/* default */.Z, {
                blockType: blockData.block_type,
                title: block_heading,
                subtitle: block_description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Swiper */.tq, BlockImageSlider_objectSpread({
                        allowTouchMove: false,
                        ref: ref6,
                        autoplay: enable_auto_play,
                        loop: true
                    }, enable_dot && imageSliderEnable.length > 1 ? {} : {
                        indicator: function() {
                            return null;
                        }
                    }, {
                        indicatorProps: {
                            color: "primary"
                        },
                        onIndexChange: function(val) {
                            return setImageIndex(val);
                        },
                        children: imageSliderEnable && Array.isArray(imageSliderEnable) && imageSliderEnable.map(function(ele, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Swiper.Item */.tq.Item, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                                    src: ele.image,
                                    fit: "cover",
                                    style: {
                                        backgroundSize: "cover",
                                        aspectRatio: ratio
                                    },
                                    className: "image-border-radius"
                                })
                            }, index);
                        })
                    })),
                    isDisplayArrowSlideBtn && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-row justify-between absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] w-full",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                                style: {
                                    // opacity: "40%",
                                    padding: "2px",
                                    borderRadius: "100%",
                                    border: "none",
                                    boxShadow: "0px 0px 12px rgba(0, 0, 0, 0.16)"
                                },
                                onClick: handlePreviousImage,
                                className: "button-background-color",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* PreviousImageSliderIcon */._L, {
                                    fillColor: "var(--button-text-color)"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                                style: {
                                    // opacity: "40%",
                                    padding: "2px",
                                    borderRadius: "100%",
                                    border: "none",
                                    boxShadow: "0px 0px 12px rgba(0, 0, 0, 0.16)"
                                },
                                onClick: handleNextImage,
                                className: "button-background-color",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* NextImageSliderIcon */.Mq, {
                                    fillColor: "var(--button-text-color)"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-[13px] leading-4 py-1 text-center",
                style: {
                    color: "var(--text-color-6)"
                },
                children: (ref2 = imageSliderEnable[imageIndex]) === null || ref2 === void 0 ? void 0 : ref2.image_description
            })
        ]
    });
};
/* harmony default export */ var CommonBlockComponent_BlockImageSlider = (BlockImageSlider);

// EXTERNAL MODULE: ./src/features/share/components/dnd-scrollable/index.tsx
var dnd_scrollable = __webpack_require__(77345);
;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockStory/index.tsx









var BlockStory = function(props) {
    var ref, ref1;
    var blockData = props.blockData, positionSlug = props.positionSlug, tabUid = props.tabUid, index = props.index, listBlocksSortOrder = props.listBlocksSortOrder, isFirstItem = props.isFirstItem, isApplyBlockSettings = props.isApplyBlockSettings, isHideMoreActions = props.isHideMoreActions;
    var enable = blockData && blockData.enable;
    var siteSettings = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.siteSettings;
    });
    var ref2 = (siteSettings === null || siteSettings === void 0 ? void 0 : (ref = siteSettings.display_setting) === null || ref === void 0 ? void 0 : (ref1 = ref.block_setting) === null || ref1 === void 0 ? void 0 : ref1.block_style) || {}, inner_space_number = ref2.inner_space_number, outside_space = ref2.outside_space;
    var ref3 = (blockData === null || blockData === void 0 ? void 0 : blockData.content_attributes) || {}, block_heading = ref3.block_heading, block_description = ref3.block_description, dataImageArr = ref3.items, size_of_image = ref3.size_of_image, _type_of_image = ref3.type_of_image, type_of_image = _type_of_image === void 0 ? configs_const/* ROUND_PHOTO */.xY : _type_of_image;
    var dataImageSortOrder = dataImageArr && orderBy_default()(dataImageArr, [
        "sort_order"
    ], [
        "asc"
    ]);
    var imageArrEnable = dataImageSortOrder && dataImageSortOrder.filter(function(x) {
        return x.enable === 1;
    });
    var sizeImage = (0,react.useMemo)(function() {
        switch(size_of_image){
            case configs_const/* SMAll */.NQ:
                return "84px";
            case configs_const/* MIDDLE */.uo:
                return "100px";
            case configs_const/* BIG */.JE:
                return "125px";
            default:
                return "100px";
        }
    }, [
        size_of_image
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BlockWrapper/* default */.Z, {
        blockType: blockData === null || blockData === void 0 ? void 0 : blockData.block_type,
        isEnable: enable,
        positionSlug: positionSlug,
        tabUid: tabUid,
        blockUid: blockData === null || blockData === void 0 ? void 0 : blockData.uid,
        index: index,
        listBlocksSortOrder: listBlocksSortOrder,
        outsideSpace: outside_space,
        insideSpace: inner_space_number,
        isFirstItem: isFirstItem,
        isApplyBlockSettings: isApplyBlockSettings,
        isHideMoreActions: isHideMoreActions,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockHeadingComponent/* default */.Z, {
                blockType: blockData.block_type,
                title: block_heading,
                subtitle: block_description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dnd_scrollable/* default */.Z, {
                className: "custom-gap",
                children: imageArrEnable && Array.isArray(imageArrEnable) && imageArrEnable.map(function(ele, index) {
                    // const urlResize = `${DOMAIN_RESIZE_IMG}${
                    //   ele?.image?.split("builder")[1]
                    // }`;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "gap-[4px] flex flex-col",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    WebkitBoxShadow: "inset 0px 0px 0px 1px rgba(0, 0, 0, 0.2)",
                                    MozBoxShadow: "inset 0px 0px 0px 1px rgba(0, 0, 0, 0.2)",
                                    boxShadow: "inset 0px 0px 0px 1px rgba(0, 0, 0, 0.2)",
                                    // background: `url(${urlResize}) center center / cover`,
                                    background: 'url("'.concat(ele === null || ele === void 0 ? void 0 : ele.image, '") center center / cover'),
                                    width: sizeImage,
                                    height: sizeImage,
                                    borderRadius: type_of_image === configs_const/* ROUND_PHOTO */.xY ? "9999px" : "4px"
                                }
                            }),
                            ele.title && /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Ellipsis */.mH, {
                                className: "text-center story-title",
                                content: ele.title,
                                rows: 2,
                                style: {
                                    maxWidth: sizeImage
                                }
                            })
                        ]
                    }, ele.uid);
                })
            })
        ]
    });
};
/* harmony default export */ var CommonBlockComponent_BlockStory = (BlockStory);

// EXTERNAL MODULE: ./src/features/block/store/edittingBlockSlice.ts
var edittingBlockSlice = __webpack_require__(18684);
// EXTERNAL MODULE: ./src/features/design/store/externalStateSlice.ts
var externalStateSlice = __webpack_require__(42372);
// EXTERNAL MODULE: ./src/features/main/store/dynamicSlice.ts
var dynamicSlice = __webpack_require__(24865);
// EXTERNAL MODULE: ./src/features/main/store/positionsSlice.ts + 2 modules
var positionsSlice = __webpack_require__(99265);
// EXTERNAL MODULE: ./src/features/share/HOC/portal.tsx
var portal = __webpack_require__(62944);
// EXTERNAL MODULE: ./node_modules/use-double-tap/dist/index.module.js
var index_module = __webpack_require__(90767);
// EXTERNAL MODULE: ./src/features/design/components/ProductTour/product-tour-config.ts
var product_tour_config = __webpack_require__(35445);
// EXTERNAL MODULE: ./src/features/design/components/ListItemScrollHorizontal/index.tsx
var ListItemScrollHorizontal = __webpack_require__(82071);
;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockTabs/TabStyleDisplay/IconStyle/index.tsx



var IconStyle = function(props) {
    var tab = props.tab;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "min-h-[24px] flex flex-row gap-[6px] text-center items-center justify-center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconRender/* default */.Z, {
            iconName: tab.icon
        })
    });
};
/* harmony default export */ var TabStyleDisplay_IconStyle = (IconStyle);

;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockTabs/TabStyleDisplay/TextAndIconStyle/index.tsx




var TextAndIconStyle = function(props) {
    var tab = props.tab, style_attributes = props.style_attributes;
    var ref = style_attributes || {}, tab_layout = ref.tab_layout, tab_width_display = ref.tab_width_display, tab_template = ref.tab_template;
    var layoutRender1 = (0,react.useMemo)(function() {
        var element = null;
        switch(tab_layout){
            case configs_const/* TAB_LAYOUT.TEXT_RIGHT */.Ic.TEXT_RIGHT:
                element = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "min-h-[24px] flex flex-row gap-[6px] text-center items-center justify-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconRender/* default */.Z, {
                            iconName: tab.icon,
                            className: "w-[20px] h-[20px]"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                            style: {
                                color: "unset",
                                margin: "unset",
                                whiteSpace: tab_width_display === configs_const/* TAB_WIDTH_DISPLAY.EQUAL */.Aw.EQUAL ? "normal" : "unset",
                                wordBreak: tab_width_display === configs_const/* TAB_WIDTH_DISPLAY.EQUAL */.Aw.EQUAL ? "break-word" : "unset"
                            },
                            children: tab.name
                        })
                    ]
                });
                break;
            case configs_const/* TAB_LAYOUT.TEXT_UNDER */.Ic.TEXT_UNDER:
                element = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "min-h-[24px] flex flex-col gap-[6px] text-center items-center justify-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "box_icon",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconRender/* default */.Z, {
                                iconName: tab.icon,
                                className: "w-[20px] h-[20px]"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                            style: {
                                color: "unset",
                                margin: "unset",
                                whiteSpace: tab_width_display === configs_const/* TAB_WIDTH_DISPLAY.EQUAL */.Aw.EQUAL ? "normal" : "unset",
                                wordBreak: tab_width_display === configs_const/* TAB_WIDTH_DISPLAY.EQUAL */.Aw.EQUAL ? "break-word" : "unset"
                            },
                            children: tab.name
                        })
                    ]
                });
                break;
        }
        return element;
    }, [
        tab_layout,
        tab.icon,
        tab.name
    ]);
    var layoutRender2 = (0,react.useMemo)(function() {
        var element = null;
        switch(tab_layout){
            case configs_const/* TAB_LAYOUT.TEXT_RIGHT */.Ic.TEXT_RIGHT:
                element = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "min-h-[24px] flex flex-row gap-[6px] text-center items-center justify-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconRender/* default */.Z, {
                            iconName: tab.icon,
                            className: "w-[16px] h-[16px]"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "h7",
                            style: {
                                color: "unset",
                                margin: "unset",
                                whiteSpace: tab_width_display === configs_const/* TAB_WIDTH_DISPLAY.EQUAL */.Aw.EQUAL ? "normal" : "unset",
                                wordBreak: tab_width_display === configs_const/* TAB_WIDTH_DISPLAY.EQUAL */.Aw.EQUAL ? "break-word" : "unset"
                            },
                            children: tab.name
                        })
                    ]
                });
                break;
            case configs_const/* TAB_LAYOUT.TEXT_UNDER */.Ic.TEXT_UNDER:
                element = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "min-h-[24px] flex flex-col gap-[6px] text-center h-full",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "box_icon m-auto",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconRender/* default */.Z, {
                                    iconName: tab.icon,
                                    className: "w-[20px] h-[20px]"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "h7",
                                style: {
                                    color: "unset",
                                    margin: "unset",
                                    whiteSpace: tab_width_display === configs_const/* TAB_WIDTH_DISPLAY.EQUAL */.Aw.EQUAL ? "normal" : "unset",
                                    wordBreak: tab_width_display === configs_const/* TAB_WIDTH_DISPLAY.EQUAL */.Aw.EQUAL ? "break-word" : "unset"
                                },
                                children: tab.name
                            })
                        ]
                    })
                });
                break;
        }
        return element;
    }, [
        tab_layout,
        tab.icon,
        tab.name
    ]);
    var layoutRender = (0,react.useMemo)(function() {
        var element = null;
        switch(tab_width_display){
            case configs_const/* TAB_WIDTH_DISPLAY.AUTO */.Aw.AUTO:
                element = layoutRender1;
                break;
            case configs_const/* TAB_WIDTH_DISPLAY.EQUAL */.Aw.EQUAL:
                element = layoutRender2;
                break;
        }
        return element;
    }, [
        tab_width_display,
        layoutRender1,
        layoutRender2
    ]);
    return layoutRender;
};
/* harmony default export */ var TabStyleDisplay_TextAndIconStyle = (TextAndIconStyle);

;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockTabs/TabStyleDisplay/TextStyle/index.tsx




var TextStyle = function(props) {
    var tab = props.tab, style_attributes = props.style_attributes;
    var ref = style_attributes || {}, tab_width_display = ref.tab_width_display, tab_template = ref.tab_template;
    var textRender = (0,react.useMemo)(function() {
        var element = null;
        switch(tab_width_display){
            case configs_const/* TAB_WIDTH_DISPLAY.AUTO */.Aw.AUTO:
                element = /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                    style: {
                        color: "unset",
                        margin: "unset"
                    },
                    children: tab.name
                });
                break;
            case configs_const/* TAB_WIDTH_DISPLAY.EQUAL */.Aw.EQUAL:
                element = /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "h7",
                    style: {
                        color: "unset",
                        margin: "unset"
                    },
                    children: tab.name
                });
                break;
        }
        return element;
    }, [
        tab_width_display,
        tab.name
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()("text-center h-full", tab_template === configs_const/* TAB_TEMPLATE.TEMPLATE_2 */.um.TEMPLATE_2 ? "flex items-center justify-center" : ""),
        style: {
            whiteSpace: tab_width_display === configs_const/* TAB_WIDTH_DISPLAY.EQUAL */.Aw.EQUAL ? "normal" : "unset",
            wordBreak: tab_width_display === configs_const/* TAB_WIDTH_DISPLAY.EQUAL */.Aw.EQUAL ? "break-word" : "unset"
        },
        children: textRender
    });
};
/* harmony default export */ var TabStyleDisplay_TextStyle = (TextStyle);

;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockTabs/TabStyleDisplay/index.tsx
function TabStyleDisplay_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function TabStyleDisplay_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            TabStyleDisplay_defineProperty(target, key, source[key]);
        });
    }
    return target;
}






var TabStyleDisplay_obj;
var TAB_STYLE_COMPONENT = (TabStyleDisplay_obj = {}, TabStyleDisplay_defineProperty(TabStyleDisplay_obj, configs_const/* TAB_DISPLAY.TEXT_AND_ICON */.Nu.TEXT_AND_ICON, TabStyleDisplay_TextAndIconStyle), TabStyleDisplay_defineProperty(TabStyleDisplay_obj, configs_const/* TAB_DISPLAY.TEXT */.Nu.TEXT, TabStyleDisplay_TextStyle), TabStyleDisplay_defineProperty(TabStyleDisplay_obj, configs_const/* TAB_DISPLAY.ICON */.Nu.ICON, TabStyleDisplay_IconStyle), TabStyleDisplay_obj);
var TabStyleDisplay = function(props1) {
    //   const { style_attributes, tab } = props;
    var TabLayoutRender = (0,react.useCallback)(function(props) {
        var ref;
        var Element = /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        if (TAB_STYLE_COMPONENT[props === null || props === void 0 ? void 0 : (ref = props.style_attributes) === null || ref === void 0 ? void 0 : ref.display_style]) {
            var ref1;
            var RenderComponent = TAB_STYLE_COMPONENT[props === null || props === void 0 ? void 0 : (ref1 = props.style_attributes) === null || ref1 === void 0 ? void 0 : ref1.display_style];
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(RenderComponent, TabStyleDisplay_objectSpread({}, props));
        }
        return Element;
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TabLayoutRender, TabStyleDisplay_objectSpread({}, props1));
};
/* harmony default export */ var BlockTabs_TabStyleDisplay = (TabStyleDisplay);

;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockTabs/TabTemplateStyle/TemplateStyle1/index.tsx
function TemplateStyle1_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function TemplateStyle1_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            TemplateStyle1_defineProperty(target, key, source[key]);
        });
    }
    return target;
}







var TemplateStyle1 = function(props) {
    var ref1 = (0,react.useRef)(null);
    var item = props.item, onSelect = props.onSelect, selected = props.selected, style_attributes = props.style_attributes, onDoubleTab = props.onDoubleTab;
    var tab_template = (style_attributes === null || style_attributes === void 0 ? void 0 : style_attributes.tab_template) || configs_const/* TAB_TEMPLATE.TEMPLATE_1 */.um.TEMPLATE_1;
    var bindDoubleTapToBlock = (0,index_module/* useDoubleTap */.i)(function() {
        onDoubleTab && onDoubleTab();
    }, 300, {
        onSingleTap: function(e) {
            e.stopPropagation();
            onSelect(ref1.current);
        }
    });
    (0,react.useEffect)(function() {
        var ref;
        if (selected) (ref = ref1.current) === null || ref === void 0 ? void 0 : ref.scrollIntoView({
            block: "nearest",
            behavior: "smooth",
            inline: "center"
        });
    }, [
        selected
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        ref: ref1,
        className: "h-full",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, TemplateStyle1_objectSpread({
            block: true,
            size: "middle",
            style: {
                whiteSpace: "nowrap",
                border: "none",
                color: selected ? "var(--adm-color-primary)" : "var(--heading-color-6)",
                borderBottom: selected ? "2px solid var(--adm-color-primary)" : "2px solid var(--block-tab-background-color)",
                borderRadius: "0px",
                opacity: (item === null || item === void 0 ? void 0 : item.enable) !== 1 ? "40%" : "",
                height: "100%",
                "--background-color": "none"
            }
        }, bindDoubleTapToBlock, {
            // onClick={(e) => {
            // }}
            className: classnames_default()("".concat(tab_template), selected && "tab-active-class"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockTabs_TabStyleDisplay, {
                style_attributes: style_attributes,
                tab: item
            })
        }))
    });
};
/* harmony default export */ var TabTemplateStyle_TemplateStyle1 = (TemplateStyle1);

;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockTabs/TabTemplateStyle/TemplateStyle2/index.tsx
function TemplateStyle2_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function TemplateStyle2_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            TemplateStyle2_defineProperty(target, key, source[key]);
        });
    }
    return target;
}







var TemplateStyle2 = function(props) {
    var ref1 = (0,react.useRef)(null);
    var item = props.item, onSelect = props.onSelect, selected = props.selected, style_attributes = props.style_attributes, onDoubleTab = props.onDoubleTab;
    var tab_layout = style_attributes === null || style_attributes === void 0 ? void 0 : style_attributes.tab_layout;
    var display_style = style_attributes === null || style_attributes === void 0 ? void 0 : style_attributes.display_style;
    var tab_template = (style_attributes === null || style_attributes === void 0 ? void 0 : style_attributes.tab_template) || configs_const/* TAB_TEMPLATE.TEMPLATE_2 */.um.TEMPLATE_2;
    (0,react.useEffect)(function() {
        var ref;
        if (selected) (ref = ref1.current) === null || ref === void 0 ? void 0 : ref.scrollIntoView({
            block: "nearest",
            behavior: "smooth",
            inline: "center"
        });
    }, [
        selected
    ]);
    var border = "none";
    var textColor = "var(--heading-color-6)";
    var backgroundColor = "unset";
    if (tab_layout !== configs_const/* TAB_LAYOUT.TEXT_UNDER */.Ic.TEXT_UNDER) {
        border = selected ? "1px solid var(--button-bg-color-6)" : "1px solid var(--heading-color-2)";
        textColor = selected ? "var(--button-text-color)" : "var(--heading-color-6)";
        backgroundColor = selected ? "var(--button-bg-color-6)" : "unset";
    }
    var bindDoubleTapToBlock = (0,index_module/* useDoubleTap */.i)(function() {
        onDoubleTab && onDoubleTab();
    }, 300, {
        onSingleTap: function(e) {
            e.stopPropagation();
            onSelect(ref1.current);
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        ref: ref1,
        className: "h-full",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, TemplateStyle2_objectSpread({
            block: true,
            size: "middle",
            style: {
                whiteSpace: "nowrap",
                "--background-color": backgroundColor,
                "--text-color": textColor,
                "--border-radius": "20px",
                backgroundColor: backgroundColor,
                border: border,
                opacity: (item === null || item === void 0 ? void 0 : item.enable) !== 1 ? "40%" : "",
                height: "100%"
            }
        }, bindDoubleTapToBlock, {
            // onClick={(e) => {
            //   e.stopPropagation();
            //   onSelect(ref.current);
            // }}
            className: classnames_default()("".concat(tab_template), selected && "tab-active-class"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockTabs_TabStyleDisplay, {
                style_attributes: style_attributes,
                tab: item
            })
        }))
    });
};
/* harmony default export */ var TabTemplateStyle_TemplateStyle2 = (TemplateStyle2);

;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockTabs/TabTemplateStyle/index.tsx
function TabTemplateStyle_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function TabTemplateStyle_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            TabTemplateStyle_defineProperty(target, key, source[key]);
        });
    }
    return target;
}





var TabTemplateStyle_obj;
var TAB_TEMPLATE_COMPONENT = (TabTemplateStyle_obj = {}, TabTemplateStyle_defineProperty(TabTemplateStyle_obj, configs_const/* TAB_TEMPLATE.TEMPLATE_1 */.um.TEMPLATE_1, TabTemplateStyle_TemplateStyle1), TabTemplateStyle_defineProperty(TabTemplateStyle_obj, configs_const/* TAB_TEMPLATE.TEMPLATE_2 */.um.TEMPLATE_2, TabTemplateStyle_TemplateStyle2), TabTemplateStyle_obj);
var TabTemplateStyle = function(props1) {
    var item = props1.item, onSelect = props1.onSelect, selected = props1.selected, style_attributes = props1.style_attributes, onDoubleTab = props1.onDoubleTab;
    var TabTemplateRender = (0,react.useCallback)(function(props) {
        var ref;
        var Element = /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        var ref1;
        var tab_template = (ref1 = props === null || props === void 0 ? void 0 : (ref = props.style_attributes) === null || ref === void 0 ? void 0 : ref.tab_template) !== null && ref1 !== void 0 ? ref1 : configs_const/* TAB_TEMPLATE.TEMPLATE_1 */.um.TEMPLATE_1;
        if (TAB_TEMPLATE_COMPONENT[tab_template]) {
            var RenderComponent = TAB_TEMPLATE_COMPONENT[tab_template];
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(RenderComponent, TabTemplateStyle_objectSpread({}, props));
        }
        return Element;
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TabTemplateRender, {
        style_attributes: style_attributes,
        item: item,
        onSelect: onSelect,
        selected: selected,
        onDoubleTab: onDoubleTab
    });
};
/* harmony default export */ var BlockTabs_TabTemplateStyle = (TabTemplateStyle);

;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockTabs/TabWidthStyle/AutoTabWidth/index.tsx




var AutoTabWidth = function(props) {
    var tabListBody = props.tabListBody, style_attributes = props.style_attributes, onUpdateTabActive = props.onUpdateTabActive, tabActiveDefault = props.tabActiveDefault, onDoubleTab = props.onDoubleTab;
    var ref = (0,react.useState)(tabActiveDefault || tabListBody[0].uid), activeTab = ref[0], setActiveTab = ref[1];
    (0,react.useEffect)(function() {
        if (tabActiveDefault) {
            setActiveTab(tabActiveDefault);
        }
    }, [
        tabActiveDefault
    ]);
    (0,react.useEffect)(function() {
        if (activeTab) onUpdateTabActive(activeTab);
    }, [
        activeTab
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemScrollHorizontal/* default */.Z, {
            children: tabListBody === null || tabListBody === void 0 ? void 0 : tabListBody.map(function(item, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockTabs_TabTemplateStyle, {
                    item: item,
                    onSelect: function(ele) {
                        setActiveTab(item.uid);
                        ele.scrollIntoView({
                            block: "nearest",
                            behavior: "smooth",
                            inline: "center"
                        });
                    },
                    onDoubleTab: onDoubleTab,
                    selected: activeTab === item.uid,
                    style_attributes: style_attributes
                }, index);
            })
        })
    });
};
/* harmony default export */ var TabWidthStyle_AutoTabWidth = (AutoTabWidth);

;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockTabs/TabWidthStyle/EqualTabWidth/index.tsx



var EqualTabWidth = function(props) {
    var tabListBody = props.tabListBody, style_attributes = props.style_attributes, onUpdateTabActive = props.onUpdateTabActive, tabActiveDefault = props.tabActiveDefault, onDoubleTab = props.onDoubleTab;
    // const activedTabDefault = useMemo(
    //   () => tabListBody?.find((x) => x.isDefault === true)?.uid,
    //   [tabListBody]
    // );
    var ref = (0,react.useState)(tabActiveDefault || tabListBody[0].uid), activeTab = ref[0], setActiveTab = ref[1];
    (0,react.useEffect)(function() {
        if (tabActiveDefault) {
            setActiveTab(tabActiveDefault);
        }
    }, [
        tabActiveDefault
    ]);
    (0,react.useEffect)(function() {
        if (activeTab) onUpdateTabActive(activeTab);
    }, [
        activeTab
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "max-width-content-class flex flex-row gap-2",
        children: tabListBody.map(function(item, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    width: "".concat(500 / tabListBody.length, "px")
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockTabs_TabTemplateStyle, {
                    item: item,
                    onSelect: function(ele) {
                        setActiveTab(item.uid);
                    },
                    onDoubleTab: onDoubleTab,
                    selected: activeTab === item.uid,
                    style_attributes: style_attributes
                }, index)
            }, index);
        })
    });
};
/* harmony default export */ var TabWidthStyle_EqualTabWidth = (EqualTabWidth);

;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockTabs/TabWidthStyle/index.tsx
function TabWidthStyle_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function TabWidthStyle_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            TabWidthStyle_defineProperty(target, key, source[key]);
        });
    }
    return target;
}





var TabWidthStyle_obj;
var TAB_WIDTH_COMPONENT = (TabWidthStyle_obj = {}, TabWidthStyle_defineProperty(TabWidthStyle_obj, configs_const/* TAB_WIDTH_DISPLAY.AUTO */.Aw.AUTO, TabWidthStyle_AutoTabWidth), TabWidthStyle_defineProperty(TabWidthStyle_obj, configs_const/* TAB_WIDTH_DISPLAY.EQUAL */.Aw.EQUAL, TabWidthStyle_EqualTabWidth), TabWidthStyle_obj);
var TabWidthStyleDisplay = function(props1) {
    var TabWidthLayoutRender = (0,react.useCallback)(function(props) {
        var ref;
        var Element = /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        if (TAB_WIDTH_COMPONENT[props === null || props === void 0 ? void 0 : (ref = props.style_attributes) === null || ref === void 0 ? void 0 : ref.tab_width_display]) {
            var ref1;
            var RenderComponent = TAB_WIDTH_COMPONENT[props === null || props === void 0 ? void 0 : (ref1 = props.style_attributes) === null || ref1 === void 0 ? void 0 : ref1.tab_width_display];
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(RenderComponent, TabWidthStyle_objectSpread({}, props));
        }
        return Element;
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TabWidthLayoutRender, TabWidthStyle_objectSpread({}, props1));
};
/* harmony default export */ var TabWidthStyle = (TabWidthStyleDisplay);

// EXTERNAL MODULE: ./src/features/share/lib/ga-events.ts
var ga_events = __webpack_require__(2991);
;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockTabs/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function BlockTabs_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function BlockTabs_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            BlockTabs_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}




















var BlockTabs = function(props) {
    var ref17, ref1, ref2, ref3, ref4, ref5, ref6;
    var blockData = props.blockData, positionSlug1 = props.positionSlug, tabUid = props.tabUid, index = props.index, listBlocksSortOrder = props.listBlocksSortOrder, isFirstItem = props.isFirstItem;
    var enable = blockData && blockData.enable;
    var blockUid1 = blockData && blockData.uid;
    var isEnable = enable;
    var dispatch = (0,hooks/* useAppDispatch */.TL)();
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var siteSettings = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.siteSettings;
    });
    var ref7 = (siteSettings === null || siteSettings === void 0 ? void 0 : (ref17 = siteSettings.display_setting) === null || ref17 === void 0 ? void 0 : (ref1 = ref17.block_setting) === null || ref1 === void 0 ? void 0 : ref1.block_style) || {}, inner_space_number = ref7.inner_space_number, outside_space = ref7.outside_space;
    var introduceDoubleTap = (0,hooks/* useAppSelector */.CG)(function(state) {
        var ref;
        return state === null || state === void 0 ? void 0 : (ref = state.externalState) === null || ref === void 0 ? void 0 : ref.introduce_double_tap;
    });
    var popoverRef = (0,react.useRef)(null);
    var dynamicConfig = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.dynamicConfig;
    });
    var tabMenuHeightRef = (0,react.useRef)(null);
    var passioPageProfile = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.passioPageProfile;
    });
    var tabListBody = (0,react.useMemo)(function() {
        return blockData && blockData.content_attributes && blockData.content_attributes.tabListBody;
    }, [
        blockData
    ]);
    var ref8, ref9, ref10, ref11;
    var style_attributes = BlockTabs_objectSpread({}, blockData.style_attributes, {
        display_style: (ref8 = blockData === null || blockData === void 0 ? void 0 : (ref2 = blockData.style_attributes) === null || ref2 === void 0 ? void 0 : ref2.display_style) !== null && ref8 !== void 0 ? ref8 : configs_const/* TAB_DISPLAY.TEXT_AND_ICON */.Nu.TEXT_AND_ICON,
        ghim_style: (ref9 = blockData === null || blockData === void 0 ? void 0 : (ref3 = blockData.style_attributes) === null || ref3 === void 0 ? void 0 : ref3.ghim_style) !== null && ref9 !== void 0 ? ref9 : configs_const/* TAB_GHIM_STYLE.NOT_GHIM */.EK.NOT_GHIM,
        tab_layout: (ref10 = blockData === null || blockData === void 0 ? void 0 : (ref4 = blockData.style_attributes) === null || ref4 === void 0 ? void 0 : ref4.tab_layout) !== null && ref10 !== void 0 ? ref10 : configs_const/* TAB_LAYOUT.TEXT_RIGHT */.Ic.TEXT_RIGHT,
        tab_width_display: (ref11 = blockData === null || blockData === void 0 ? void 0 : (ref5 = blockData.style_attributes) === null || ref5 === void 0 ? void 0 : ref5.tab_width_display) !== null && ref11 !== void 0 ? ref11 : configs_const/* TAB_WIDTH_DISPLAY.AUTO */.Aw.AUTO
    });
    var display_style = style_attributes && style_attributes.display_style;
    var ghim_style = style_attributes && style_attributes.ghim_style;
    var position_style = style_attributes && style_attributes.position_style;
    var tab_template = style_attributes && style_attributes.tab_template;
    var tab_shadow_enable = style_attributes && style_attributes.tab_shadow_enable || configs_const/* TAB_SETTING.SHADOW_ENABLE */.bp.SHADOW_ENABLE;
    var tab_shadow_color = style_attributes && style_attributes.tab_shadow_color || configs_const/* TAB_SETTING.SHADOW_COLOR */.bp.SHADOW_COLOR;
    var activeKeyTabState = dynamicConfig && dynamicConfig.tabs && dynamicConfig.tabs.activeKeyTab;
    var positionTabMenuState = dynamicConfig && dynamicConfig.tabs && dynamicConfig.tabs.positionTabMenu;
    var activeKey = (0,react.useMemo)(function() {
        var isExistActiveTab = tabListBody === null || tabListBody === void 0 ? void 0 : tabListBody.find(function(x) {
            return (x === null || x === void 0 ? void 0 : x.uid) === activeKeyTabState;
        });
        if (activeKeyTabState && isExistActiveTab) {
            return activeKeyTabState;
        } else {
            var ref;
            var tabDefault = tabListBody && tabListBody.find(function(x) {
                return x.isDefault === true;
            });
            var activeKeyDefault = tabDefault ? tabDefault === null || tabDefault === void 0 ? void 0 : tabDefault.uid : (ref = tabListBody[0]) === null || ref === void 0 ? void 0 : ref.uid;
            return activeKeyDefault;
        }
    }, [
        activeKeyTabState,
        tabListBody
    ]);
    var ref12 = (0,react.useState)(activeKey), tabActive = ref12[0], setTabActive = ref12[1];
    var ref13 = (0,react.useState)(positionTabMenuState), checkTabMenuPosition = ref13[0], setCheckTabMenuPosition = ref13[1];
    var ref14 = (0,react.useState)(null), tabBarHeaderHeight = ref14[0], setTabBarHeaderHeight = ref14[1];
    var ref15 = (0,react.useState)(null), tabBarFooterHeight = ref15[0], setTabBarFooterHeight = ref15[1];
    (0,react.useEffect)(function() {
        if (activeKey) setTabActive(activeKey);
    }, [
        activeKey
    ]);
    (0,react.useEffect)(function() {
        if (ghim_style === "auto-ghim") {
            var mobileElement = document.querySelector(".mobile-layout");
            mobileElement.addEventListener("scroll", handleStickyTabMenu);
            return function() {
                mobileElement.removeEventListener("scroll", handleStickyTabMenu);
            };
        }
    }, [
        ghim_style
    ]);
    var handleStickyTabMenu = (0,react.useCallback)(function(e) {
        var mobileElement = document.querySelector(".mobile-layout");
        var tabMenuStickyElement = document.querySelector(".".concat(configs_const/* TAB_STICKY_CLASS */.WL));
        var footerDesignElement = document.querySelector(".footer-design");
        var mobileElementScrollTop = mobileElement.scrollTop;
        var distanceFooterWithTopScreen = footerDesignElement && footerDesignElement.getBoundingClientRect().top;
        var distanceTabMenuWithTopScreen = tabMenuStickyElement && tabMenuStickyElement.getBoundingClientRect().top;
        if (distanceFooterWithTopScreen <= 57) {
            setCheckTabMenuPosition("hidden");
        } else if (mobileElementScrollTop <= tabMenuHeightRef.current) {
            setCheckTabMenuPosition("");
        } else if (distanceTabMenuWithTopScreen <= 57) {
            if (!tabMenuHeightRef.current) {
                tabMenuHeightRef.current = mobileElementScrollTop;
            }
            setCheckTabMenuPosition(configs_const/* POSITION_STICKY */.xG);
        }
    }, [
        tabMenuHeightRef.current,
        positionTabMenuState
    ]);
    (0,react.useEffect)(function() {
        if (tabActive && ghim_style === "auto-ghim" && checkTabMenuPosition === configs_const/* POSITION_STICKY */.xG) {
            var bodyDesignElement = document.querySelector(".body-design");
            var mobileElement = document.querySelector(".mobile-layout");
            var bodyTop = bodyDesignElement.offsetTop;
            mobileElement.scrollTop = bodyTop - 104;
        }
    }, [
        tabActive,
        ghim_style
    ]);
    (0,react.useEffect)(function() {
        var topTimeOut = null;
        var loadTopHeight = function() {
            var tabBarHeaderElement = document.querySelector(".tab-bar-design-header");
            if (tabBarHeaderElement) {
                setTabBarHeaderHeight(tabBarHeaderElement.offsetHeight);
            } else {
                topTimeOut = setTimeout(loadTopHeight, 300);
            }
        };
        var bottomTimeOut = null;
        var loadBottomHeight = function() {
            var tabBarFooterElement = document.querySelector(".tab-bar-footer");
            if (tabBarFooterElement) {
                setTabBarFooterHeight(tabBarFooterElement.offsetHeight);
            } else {
                bottomTimeOut = setTimeout(loadBottomHeight, 300);
            }
        };
        loadTopHeight();
        loadBottomHeight();
        return function() {
            if (topTimeOut) {
                clearTimeout(topTimeOut);
            }
            if (bottomTimeOut) {
                clearTimeout(bottomTimeOut);
            }
        };
    }, []);
    var handleChangeTab = function(key) {
        setTabActive(key);
        dispatch((0,dynamicSlice/* setParamsTab */.qS)({
            data: {
                activeKeyTab: key
            }
        }));
    };
    var handleClickEditTab = function(event) {
        if (event === null || event === void 0 ? void 0 : event.defaultPrevented) {
            return;
        }
        dispatch((0,edittingBlockSlice/* openPopup */.Mw)({
            block: blockData,
            position_uid: positionSlug1,
            tab_uid: tabUid,
            KEY: configs_const/* KEY_BLOCK.EDIT */.ne.EDIT
        }));
    };
    var actions1 = [
        {
            key: configs_const/* ACTION_BLOCK.VISIBLE_BLOCK */.am.VISIBLE_BLOCK,
            icon: isEnable === configs_const/* ENABLE_BLOCK */.C5 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* EyeVisibleIcon */.m0, {
                className: "",
                width: 20,
                height: 20
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* EyeHiddenIcon */.Fl, {
                className: "",
                width: 20,
                height: 20
            }),
            text: isEnable === configs_const/* ENABLE_BLOCK */.C5 ? t("ss_builder_hide_block_label") : t("ss_builder_show_block_label")
        },
        {
            key: configs_const/* ACTION_BLOCK.MOVE_UP_BLOCK */.am.MOVE_UP_BLOCK,
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ArrowUp */.a2, {
                className: "",
                width: 20,
                height: 20,
                fillColor: "#fff"
            }),
            text: t("ss_builder_move_up_block_label")
        },
        {
            key: configs_const/* ACTION_BLOCK.MOVE_DOWN_BLOCK */.am.MOVE_DOWN_BLOCK,
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ArrowDown */.K5, {
                className: "",
                width: 20,
                height: 20,
                fillColor: "#fff"
            }),
            text: t("ss_builder_move_down_block_label")
        },
        {
            key: configs_const/* ACTION_BLOCK.EDIT_BLOCK */.am.EDIT_BLOCK,
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* EditTabIcon */.jJ, {
                className: "",
                width: 20,
                height: 20,
                fillColor: "#fff"
            }),
            text: t("ss_builder_edit_block_label")
        }, 
    ];
    var onMoveBlock = function(action) {
        var startIndex = index;
        var endIndex = action === "down" ? startIndex + 1 : startIndex - 1;
        if (endIndex < 0 || startIndex === endIndex) {
            return;
        }
        var itemsOrder = reorder(startIndex, endIndex);
        dispatch((0,positionsSlice/* sortBlock */.K6)({
            itemsOrder: itemsOrder,
            positionSlug: positionSlug1,
            tabUid: tabUid
        }));
    };
    var reorder = function(startIndex, endIndex) {
        var result = Array.from(listBlocksSortOrder);
        var ref = _slicedToArray(result.splice(startIndex, 1), 1), removed = ref[0];
        result.splice(endIndex, 0, removed);
        var orderedBlockList = result.map(function(ele, idx) {
            return BlockTabs_objectSpread({}, ele, {
                sort_order: idx + 1
            });
        });
        return orderedBlockList;
    };
    var onDisableEnableBlock = function(positionSlug, blockUid, blockStatus) {
        dispatch((0,positionsSlice/* disableEnableBlock */.a8)({
            positionSlug: positionSlug,
            blockUid: blockUid,
            blockStatus: blockStatus,
            tabUid: tabUid
        }));
    };
    var handleEnableDisableBlock = function() {
        var blockStatus = isEnable === configs_const/* ENABLE_BLOCK */.C5 ? configs_const/* DISABLE_BLOCK */.gK : configs_const/* ENABLE_BLOCK */.C5;
        onDisableEnableBlock(positionSlug1, blockUid1, blockStatus);
        es/* Toast.show */.FN.show({
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CheckCircleIcon */.rE, {
                className: "text-center inline-block w-[30px] h-[30px]",
                fillColor: "#00B578"
            }),
            content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-center",
                children: isEnable === configs_const/* ENABLE_BLOCK */.C5 ? t("ss_builder_disable_block_successfully_label") : t("ss_builder_enable_block_successfully_label")
            })
        });
    };
    var blockTypeEvent = ga_events/* BLOCK_TYPE_EVENT_CONFIG */.Aw[(ref6 = block_conf/* BLOCK_TYPE.TAB_BAR */.bF.TAB_BAR) === null || ref6 === void 0 ? void 0 : ref6.toUpperCase()] || (0,lib/* handleCapitalizeFirstLetter */.Tz)(block_conf/* BLOCK_TYPE.TAB_BAR */.bF.TAB_BAR);
    var handleUpdateStatusIntroduceDoubleTap = function() {
        dispatch((0,externalStateSlice/* setIntroduceDoubleTapState */.n_)(externalStateSlice/* IntroduceDoubleTapEnum.FALSE */.G_.FALSE));
    };
    var openModalIntroduceDoubleTap = function() {
        var isDontShowAgain = false;
        es/* Modal.alert */.u_.alert({
            image: "https://image.passio.eco/page-builder/page-builder/position-modal/introduce-edit-block.svg",
            title: t("ss_builder_introduce_double_tap_title"),
            className: "modal-product-tour modal-default",
            content: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-[15px] font-normal leading-[140%] text-textColorDefault text-center",
                        children: t("ss_builder_introduce_double_tap_content")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Checkbox */.XZ, {
                        block: true,
                        onChange: function(val) {
                            return isDontShowAgain = val;
                        },
                        className: "mt-5 radio_introduce",
                        children: t("ss_builder_introduce_double_tap_label_check")
                    })
                ]
            }),
            confirmText: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "flex items-center w-full justify-center gap-2 leading-[140%] text-[17px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* PenIcon */.Mw, {
                        width: 17,
                        height: 17,
                        fillColor: "#fff"
                    }),
                    " ",
                    t("ss_builder_introduce_double_tap_button")
                ]
            }),
            onConfirm: function() {
                if (isDontShowAgain) {
                    handleUpdateStatusIntroduceDoubleTap();
                }
                handleClickEditTab();
                ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.BLOCK */.Bt.BLOCK, "Block_GoEditPopover_".concat(blockTypeEvent), blockTypeEvent, ga_events/* ACTION_CONFIG.START_EDITING_POPOVER */.AN.START_EDITING_POPOVER);
                return;
            }
        });
    };
    var handleClickPopoverItem = function(item) {
        var key = item === null || item === void 0 ? void 0 : item.key;
        switch(key){
            case configs_const/* ACTION_BLOCK.VISIBLE_BLOCK */.am.VISIBLE_BLOCK:
                handleEnableDisableBlock();
                break;
            case configs_const/* ACTION_BLOCK.MOVE_UP_BLOCK */.am.MOVE_UP_BLOCK:
                onMoveBlock("up");
                break;
            case configs_const/* ACTION_BLOCK.MOVE_DOWN_BLOCK */.am.MOVE_DOWN_BLOCK:
                onMoveBlock("down");
                break;
            case configs_const/* ACTION_BLOCK.EDIT_BLOCK */.am.EDIT_BLOCK:
                if (introduceDoubleTap == externalStateSlice/* IntroduceDoubleTapEnum.TRUE */.G_.TRUE) {
                    openModalIntroduceDoubleTap();
                } else {
                    handleClickEditTab();
                    ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.BLOCK */.Bt.BLOCK, "Block_GoEditPopover_".concat(blockTypeEvent), blockTypeEvent, ga_events/* ACTION_CONFIG.START_EDITING_POPOVER */.AN.START_EDITING_POPOVER);
                }
                break;
            default:
                if (introduceDoubleTap == externalStateSlice/* IntroduceDoubleTapEnum.TRUE */.G_.TRUE) {
                    openModalIntroduceDoubleTap();
                } else {
                    handleClickEditTab();
                    ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.BLOCK */.Bt.BLOCK, "Block_GoEditPopover_".concat(blockTypeEvent), blockTypeEvent, ga_events/* ACTION_CONFIG.START_EDITING_POPOVER */.AN.START_EDITING_POPOVER);
                }
        }
    };
    var actionMoreElement = actions1;
    var ref16 = (0,react.useState)(false), forceVisible = ref16[0], setForceVisible = ref16[1];
    if (ghim_style === configs_const/* TAB_GHIM_STYLE.ALWAYS_GHIM */.EK.ALWAYS_GHIM || listBlocksSortOrder.length === 1) {
        actionMoreElement = actions1.filter(function(actions) {
            return actions.key !== configs_const/* ACTION_BLOCK.MOVE_DOWN_BLOCK */.am.MOVE_DOWN_BLOCK && actions.key !== configs_const/* ACTION_BLOCK.MOVE_UP_BLOCK */.am.MOVE_UP_BLOCK;
        });
    } else if (index === listBlocksSortOrder.length - 1) {
        actionMoreElement = actions1.filter(function(actions) {
            return actions.key !== configs_const/* ACTION_BLOCK.MOVE_DOWN_BLOCK */.am.MOVE_DOWN_BLOCK;
        });
    } else if (index === 0) {
        actionMoreElement = actions1.filter(function(actions) {
            return actions.key !== configs_const/* ACTION_BLOCK.MOVE_UP_BLOCK */.am.MOVE_UP_BLOCK;
        });
    }
    (0,react.useEffect)(function() {
        var castWindow = window;
        if (isFirstItem) {
            castWindow.triggerVisiblePopoverBlock = setForceVisible;
        }
        (function() {
            if (castWindow.triggerVisiblePopoverBlock) {
                castWindow.triggerVisiblePopoverBlock = undefined;
                setForceVisible(false);
            }
        });
    }, [
        isFirstItem
    ]);
    var checkGhimStyle = (0,react.useMemo)(function() {
        return ghim_style === configs_const/* TAB_GHIM_STYLE.ALWAYS_GHIM */.EK.ALWAYS_GHIM || ghim_style === configs_const/* TAB_GHIM_STYLE.AUTO_GHIM */.EK.AUTO_GHIM && checkTabMenuPosition !== configs_const/* POSITION_STICKY */.xG;
    }, [
        ghim_style,
        checkTabMenuPosition,
        position_style
    ]);
    var tabContentElementRender = (0,react.useMemo)(function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()(configs_const/* TAB_STICKY_CLASS */.WL, product_tour_config/* PRODUCT_TOUR_CLASS_NAME.STEP_5 */.uN.STEP_5, isFirstItem ? "".concat(product_tour_config/* PRODUCT_TOUR_CLASS_NAME.STEP_12 */.uN.STEP_12, " ").concat(product_tour_config/* PRODUCT_TOUR_CLASS_NAME.STEP_13 */.uN.STEP_13) : "", tab_template === configs_const/* TAB_TEMPLATE.TEMPLATE_2 */.um.TEMPLATE_2 ? "py-2" : "", checkGhimStyle ? "" : "block-border-radius"),
                    style: {
                        borderBottom: position_style === configs_const/* TAB_POSITION.TOP */.Fe.TOP && checkGhimStyle ? "1px solid rgba(132, 132, 132, 0.3)" : "none",
                        borderTop: position_style === configs_const/* TAB_POSITION.BOTTOM */.Fe.BOTTOM && checkGhimStyle ? "1px solid rgba(132, 132, 132, 0.3)" : "none",
                        paddingLeft: "".concat(inner_space_number, "px"),
                        paddingRight: "".concat(inner_space_number, "px")
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TabWidthStyle, {
                        style_attributes: style_attributes,
                        tabListBody: tabListBody,
                        onUpdateTabActive: handleChangeTab,
                        tabActiveDefault: tabActive,
                        onDoubleTab: handleClickEditTab
                    })
                }),
                enable !== 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()("absolute top-0 left-0 block w-full h-full text-center", ghim_style === "not-ghim" ? "rounded-lg" : ""),
                    style: {
                        backgroundColor: "rgba(255, 255, 255, 0.8)"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            position: "relative",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* EyeVisibleIcon */.m0, {
                                className: "align-middle inline-block",
                                fillColor: "#333"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[#333]",
                                children: t("ss_builder_block_design_hiding_label")
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex flex-row items-center justify-center absolute right-1 top-1 w-[32px] h-[32px] gap-[15px] cursor-pointer",
                    style: {
                        backgroundColor: "rgba(0, 0, 0, 0.15)",
                        borderRadius: "100px",
                        border: "1px solid rgba(255, 255, 255, 0.1)"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative",
                        ref: popoverRef,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Popover.Menu */.J2.Menu, BlockTabs_objectSpread({}, forceVisible ? {
                            visible: true
                        } : {}, {
                            className: isFirstItem ? product_tour_config/* PRODUCT_TOUR_CLASS_NAME.STEP_3 */.uN.STEP_3 : "",
                            mode: "dark",
                            actions: actionMoreElement,
                            placement: position_style === configs_const/* TAB_POSITION.BOTTOM */.Fe.BOTTOM ? "top-end" : "bottom-end",
                            trigger: "click",
                            stopPropagation: [
                                "click"
                            ],
                            getContainer: function() {
                                return document.querySelector(".design-class");
                            },
                            onAction: function(item) {
                                return handleClickPopoverItem(item);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* MoreIcon */.nX, {
                                fillColor: "#fff",
                                className: ""
                            })
                        }))
                    })
                })
            ]
        });
    }, [
        ghim_style,
        tabListBody,
        enable,
        style_attributes,
        checkGhimStyle,
        tabActive, 
    ]);
    var tabContentElementRenderWithStyle = (0,react.useMemo)(function() {
        var tabElement = null;
        switch(ghim_style){
            case configs_const/* TAB_GHIM_STYLE.NOT_GHIM */.EK.NOT_GHIM:
                tabElement = tabContentElementRender;
                break;
            case configs_const/* TAB_GHIM_STYLE.ALWAYS_GHIM */.EK.ALWAYS_GHIM:
                var style = position_style === configs_const/* TAB_POSITION.TOP */.Fe.TOP ? {
                    top: "".concat(tabBarHeaderHeight, "px")
                } : {
                    bottom: "".concat(tabBarFooterHeight, "px")
                };
                tabElement = /*#__PURE__*/ (0,jsx_runtime.jsx)(portal/* default */.Z, {
                    elementId: "tabMenuDesignPortal",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: configs_const/* BLOCK_TAB_MENU_DESIGN_CLASS */.BC,
                        className: "max-width-content-class tab-design-always-ghim fixed z-[5] w-full left-[50%] translate-x-[-50%]",
                        style: style,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()("relative block-tab-background-color", product_tour_config/* PRODUCT_TOUR_CLASS_NAME.STEP_5 */.uN.STEP_5),
                            children: tabContentElementRender
                        })
                    })
                });
                break;
            case "auto-ghim":
                if (checkTabMenuPosition === configs_const/* POSITION_STICKY */.xG) {
                    tabElement = /*#__PURE__*/ (0,jsx_runtime.jsx)(portal/* default */.Z, {
                        elementId: "tabMenuDesignPortal",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "max-width-content-class tab-design-auto-ghim fixed z-[2] w-full top-[57px] left-[50%] translate-x-[-50%]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "relative block-tab-background-color",
                                children: tabContentElementRender
                            })
                        })
                    });
                } else if (checkTabMenuPosition === "hidden") {
                    tabElement = null;
                } else tabElement = tabContentElementRender;
                break;
        }
        return tabElement;
    }, [
        ghim_style,
        position_style,
        checkTabMenuPosition,
        tabContentElementRender,
        tabBarHeaderHeight,
        tabBarFooterHeight, 
    ]);
    var productTourTabClassSticky = checkGhimStyle ? "" : product_tour_config/* PRODUCT_TOUR_CLASS_NAME.STEP_5 */.uN.STEP_5;
    var bindDoubleTapToBlock = (0,index_module/* useDoubleTap */.i)(function(event) {
        handleClickEditTab(event);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", BlockTabs_objectSpread({}, bindDoubleTapToBlock, {
        className: classnames_default()("block-tabs-class block-border-radius block-border-width block-border-style block-border-color block-custom-style block-background-color relative", checkTabMenuPosition === configs_const/* POSITION_STICKY */.xG ? configs_const/* TAB_STICKY_CLASS */.WL : "", productTourTabClassSticky),
        style: {
            boxShadow: tab_shadow_enable && ghim_style !== configs_const/* TAB_GHIM_STYLE.ALWAYS_GHIM */.EK.ALWAYS_GHIM ? "0 4px 4px ".concat(tab_shadow_color) : "none",
            marginLeft: ghim_style === configs_const/* TAB_GHIM_STYLE.NOT_GHIM */.EK.NOT_GHIM && outside_space ? "12px" : "0px",
            marginRight: ghim_style === configs_const/* TAB_GHIM_STYLE.NOT_GHIM */.EK.NOT_GHIM && outside_space ? "12px" : "0px",
            backdropFilter: checkGhimStyle ? "none" : "blur(var(--block-background-blur))"
        },
        children: tabListBody && Array.isArray(tabListBody) && tabListBody.length > 0 && tabContentElementRenderWithStyle
    }));
};
/* harmony default export */ var CommonBlockComponent_BlockTabs = (BlockTabs);

// EXTERNAL MODULE: ./node_modules/i18next/dist/esm/i18next.js
var i18next = __webpack_require__(36609);
// EXTERNAL MODULE: ./src/features/share/icons/solid-icon.tsx
var solid_icon = __webpack_require__(77105);
// EXTERNAL MODULE: ./src/features/share/components/full-screen-popup/index.tsx
var full_screen_popup = __webpack_require__(40015);
// EXTERNAL MODULE: ./src/features/share/hooks/index.ts
var share_hooks = __webpack_require__(16565);
;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockText/index.tsx












var MAX_HEIGHT_BLOCK_WRAPPER = 276;
var BlockText = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var blockData = props.blockData, positionSlug = props.positionSlug, tabUid = props.tabUid, index = props.index, listBlocksSortOrder = props.listBlocksSortOrder, isFirstItem = props.isFirstItem, isApplyBlockSettings = props.isApplyBlockSettings, isHideMoreActions = props.isHideMoreActions;
    var enable = blockData && blockData.enable;
    var draft_content = ((blockData === null || blockData === void 0 ? void 0 : blockData.content_attributes) || {}).draft_content;
    var content = typeof draft_content === "string" ? draft_content : draftjs_to_html_default()(draft_content);
    var siteSettings = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.siteSettings;
    });
    var ref6 = (siteSettings === null || siteSettings === void 0 ? void 0 : (ref = siteSettings.display_setting) === null || ref === void 0 ? void 0 : (ref1 = ref.block_setting) === null || ref1 === void 0 ? void 0 : ref1.block_style) || {}, inner_space_number = ref6.inner_space_number, outside_space = ref6.outside_space;
    var cleanContent = purify.sanitize(content);
    var wrapperRef = (0,react.useRef)();
    var ref7 = (0,react.useState)(false), isOpenPopupDetail = ref7[0], setIsOpenPopupDetail = ref7[1];
    var handleOpenPopupDetail = function(status) {
        setIsOpenPopupDetail(status);
    };
    var ref8 = (0,share_hooks/* useResizeObserveElement */.pM)(wrapperRef), elementHeight = ref8.height;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BlockWrapper/* default */.Z, {
        blockType: blockData === null || blockData === void 0 ? void 0 : blockData.block_type,
        isEnable: enable,
        positionSlug: positionSlug,
        tabUid: tabUid,
        blockUid: blockData === null || blockData === void 0 ? void 0 : blockData.uid,
        index: index,
        listBlocksSortOrder: listBlocksSortOrder,
        outsideSpace: outside_space,
        insideSpace: inner_space_number,
        isFirstItem: isFirstItem,
        isApplyBlockSettings: isApplyBlockSettings,
        isHideMoreActions: isHideMoreActions,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()("block-content-wrapper", elementHeight > MAX_HEIGHT_BLOCK_WRAPPER ? "mask-image" : ""),
                style: {
                    maxHeight: elementHeight > MAX_HEIGHT_BLOCK_WRAPPER ? "".concat(MAX_HEIGHT_BLOCK_WRAPPER, "px") : ""
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    ref: wrapperRef,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockHeadingComponent/* default */.Z, {
                            blockType: blockData.block_type,
                            title: blockData === null || blockData === void 0 ? void 0 : (ref2 = blockData.content_attributes) === null || ref2 === void 0 ? void 0 : ref2.block_heading,
                            subtitle: blockData === null || blockData === void 0 ? void 0 : (ref3 = blockData.content_attributes) === null || ref3 === void 0 ? void 0 : ref3.block_description
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-content break-words overflow-hidden",
                            style: {
                                color: "var(--text-color-6)"
                            },
                            dangerouslySetInnerHTML: {
                                __html: cleanContent
                            }
                        })
                    ]
                })
            }),
            elementHeight > MAX_HEIGHT_BLOCK_WRAPPER && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "btn-view-more-text",
                onClick: function() {
                    return handleOpenPopupDetail(true);
                },
                children: [
                    (0,i18next.t)("ss_builder_block_text_see_more_btn_default_title"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(solid_icon/* AngelRightSIcon */.Fj, {
                        width: 16,
                        height: 16
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(full_screen_popup/* default */.Z, {
                visible: isOpenPopupDetail,
                onMaskClick: function() {
                    return setIsOpenPopupDetail(false);
                },
                className: "full-popup-block-text",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "popup-wrapper-block-text",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockHeadingComponent/* default */.Z, {
                            blockType: blockData.block_type,
                            title: blockData === null || blockData === void 0 ? void 0 : (ref4 = blockData.content_attributes) === null || ref4 === void 0 ? void 0 : ref4.block_heading,
                            subtitle: blockData === null || blockData === void 0 ? void 0 : (ref5 = blockData.content_attributes) === null || ref5 === void 0 ? void 0 : ref5.block_description
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-[32px] h-[32px] p-1 cursor-pointer absolute right-2 top-2 flex justify-center items-center",
                            onClick: function() {
                                return handleOpenPopupDetail(false);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(solid_icon/* ModalCloseIcon */.Su, {
                                width: 24,
                                height: 24,
                                fillColor: "#333"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-content break-words overflow-hidden mt-3 design-class",
                            dangerouslySetInnerHTML: {
                                __html: cleanContent
                            }
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var CommonBlockComponent_BlockText = (BlockText);

// EXTERNAL MODULE: ./src/features/block/block-editor/AffiliateProductGroup/AffiliateProductAddNew/index.tsx + 6 modules
var AffiliateProductAddNew = __webpack_require__(84825);
// EXTERNAL MODULE: ./src/features/share/components/lazy-image/index.tsx
var lazy_image = __webpack_require__(70464);
// EXTERNAL MODULE: ./src/features/block/block-editor/AffiliateProductGroup/AffiliateProductEdit/index.tsx + 2 modules
var AffiliateProductEdit = __webpack_require__(22023);
// EXTERNAL MODULE: ./src/features/block/block-editor/AffiliateProductGroup/AffiliateProductMovingPanel/index.tsx
var AffiliateProductMovingPanel = __webpack_require__(31153);
// EXTERNAL MODULE: ./src/features/block/block-editor/AffiliateProductGroup/ProductListItems/index.tsx
var ProductListItems = __webpack_require__(7804);
// EXTERNAL MODULE: ./src/features/share/components/PopupComponent/index.tsx
var PopupComponent = __webpack_require__(21043);
// EXTERNAL MODULE: ./src/features/share/hooks/modal.tsx
var modal = __webpack_require__(5996);
// EXTERNAL MODULE: ./src/features/share/hooks/toast.tsx
var toast = __webpack_require__(95880);
;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockAffiliateProductGroup/ProductMoreActions/index.tsx
function ProductMoreActions_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ProductMoreActions_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ProductMoreActions_defineProperty(target, key, source[key]);
        });
    }
    return target;
}














var ProductMoreActions = function(param) {
    var onUpdateProductGroupData = param.onUpdateProductGroupData, productData = param.productData, affiliateProductGroupData = param.affiliateProductGroupData, productGroupMaximum = param.productGroupMaximum, _fromSwiperList = param.fromSwiperList, fromSwiperList = _fromSwiperList === void 0 ? false : _fromSwiperList;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var SuccessToast = (0,toast/* useToast */.p)().SuccessToast;
    var ConfirmModal = (0,modal/* useModal */.dd)().ConfirmModal;
    var ref2 = (0,react.useState)(false), isOpenProductEdit = ref2[0], setIsOpenProductEdit = ref2[1];
    var ref1 = (0,react.useState)(false), isOpenProductMovingPanel = ref1[0], setIsOpenProductMovingPanel = ref1[1];
    var onDisableProduct = function() {
        var newData = affiliateProductGroupData === null || affiliateProductGroupData === void 0 ? void 0 : affiliateProductGroupData.map(function(ele) {
            if (ele.uid === productGroupId) {
                return ProductMoreActions_objectSpread({}, ele, {
                    content_attributes: ProductMoreActions_objectSpread({}, ele.content_attributes, {
                        items: ele.content_attributes.items.map(function(item) {
                            if (item.uid === productData.uid) {
                                return ProductMoreActions_objectSpread({}, item, {
                                    enable: configs_const/* STATUS.DISABLE */.Q_.DISABLE
                                });
                            }
                            return item;
                        })
                    })
                });
            }
            return ele;
        });
        onUpdateProductGroupData(newData);
        SuccessToast(t("ss_builder_disable_product_successfully_label"));
    };
    var confirmDeleteProduct = function() {
        var onConfirm = function() {
            var newData = affiliateProductGroupData === null || affiliateProductGroupData === void 0 ? void 0 : affiliateProductGroupData.map(function(ele) {
                if (ele.uid === productGroupId) {
                    return ProductMoreActions_objectSpread({}, ele, {
                        content_attributes: ProductMoreActions_objectSpread({}, ele.content_attributes, {
                            items: ele.content_attributes.items.filter(function(item) {
                                return item.uid !== productData.uid;
                            })
                        })
                    });
                }
                return ele;
            });
            onUpdateProductGroupData(newData);
            SuccessToast(t("ss_builder_delete_product_successfully_label"));
        };
        ConfirmModal({
            title: t("ss_builder_confirm_delete_product_modal_title"),
            description: t("ss_builder_confirm_delete_product_modal_content"),
            confirmText: t("ss_builder_confirm_delete_product_label"),
            cancelText: t("ss_builder_cancel_delete_product_label"),
            onConfirm: onConfirm
        });
    };
    var options = [
        {
            key: ProductListItems/* ActionEnum.EDIT_PRODUCT */.X.EDIT_PRODUCT,
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* EditTabIcon */.jJ, {
                className: "fill-white",
                width: 20,
                height: 20,
                fillColor: "#fff"
            }),
            text: t("ss_builder_edit_block_label"),
            onClick: function() {
                return setIsOpenProductEdit(true);
            }
        },
        {
            key: ProductListItems/* ActionEnum.VISIBLE_HIDE_PRODUCT */.X.VISIBLE_HIDE_PRODUCT,
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* EyeVisibleIcon */.m0, {
                className: "fill-white",
                width: 20,
                height: 20
            }),
            text: t("ss_builder_hide_product_label"),
            onClick: onDisableProduct
        },
        {
            key: ProductListItems/* ActionEnum.DELETE_PRODUCT */.X.DELETE_PRODUCT,
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* DeleteIcon */.pJ, {
                className: "fill-white",
                width: 20,
                height: 20,
                fillColor: "#fff"
            }),
            text: t("ss_builder_delete_product_label"),
            onClick: confirmDeleteProduct
        },
        {
            key: ProductListItems/* ActionEnum.MOVE_PRODUCT */.X.MOVE_PRODUCT,
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* FolderArrowRightIcon */.Ao, {
                className: "w-5 h-5",
                fillColor: "white"
            }),
            text: t("ss_builder_move_product_label"),
            onClick: function() {
                return setIsOpenProductMovingPanel(true);
            }
        }, 
    ];
    var productGroupId = (0,react.useMemo)(function() {
        var value = null;
        affiliateProductGroupData === null || affiliateProductGroupData === void 0 ? void 0 : affiliateProductGroupData.forEach(function(ele) {
            var productLists = ele.content_attributes.items;
            productLists.forEach(function(item) {
                if (item.uid === productData.uid) {
                    value = ele.uid;
                }
            });
        });
        return value;
    }, [
        productData,
        affiliateProductGroupData
    ]);
    var handleConfirmAffiliateProductMovingPanel = (0,react.useCallback)(function(newProductGroupId) {
        var productDataAddNew = null;
        var affiliateProductGroupDataClone = cloneDeep_default()(affiliateProductGroupData);
        affiliateProductGroupDataClone.forEach(function(element) {
            if (element.uid === productGroupId) {
                var ref;
                var productList = element === null || element === void 0 ? void 0 : (ref = element.content_attributes) === null || ref === void 0 ? void 0 : ref.items;
                productDataAddNew = productList.find(function(x) {
                    return x.uid === productData.uid;
                });
            }
        });
        //Add more product into the new product group
        var productGroupDataAfterAddingProductId = affiliateProductGroupDataClone.map(function(element) {
            if (element.uid === newProductGroupId) {
                var ref;
                var productList = element === null || element === void 0 ? void 0 : (ref = element.content_attributes) === null || ref === void 0 ? void 0 : ref.items;
                productDataAddNew && productList.unshift(productDataAddNew);
                var newProductListSortOrder = productList.map(function(ele, index) {
                    return ProductMoreActions_objectSpread({}, ele, {
                        sort_order: index + 1
                    });
                });
                return ProductMoreActions_objectSpread({}, element, {
                    content_attributes: ProductMoreActions_objectSpread({}, element.content_attributes, {
                        items: newProductListSortOrder
                    })
                });
            } else return element;
        });
        //Remove product from the old product group
        var productGroupDataAfterRemovingProductId = productGroupDataAfterAddingProductId.map(function(element) {
            if (element.uid === productGroupId) {
                var ref;
                var productList = element === null || element === void 0 ? void 0 : (ref = element.content_attributes) === null || ref === void 0 ? void 0 : ref.items;
                var productListRemovedProductId = productList.filter(function(x) {
                    return x.uid !== productData.uid;
                });
                var productListRemovedProductIdSortOrder = productListRemovedProductId.map(function(ele, index) {
                    return ProductMoreActions_objectSpread({}, ele, {
                        sort_order: index + 1
                    });
                });
                return ProductMoreActions_objectSpread({}, element, {
                    content_attributes: ProductMoreActions_objectSpread({}, element.content_attributes, {
                        items: productListRemovedProductIdSortOrder
                    })
                });
            } else return element;
        });
        onUpdateProductGroupData(productGroupDataAfterRemovingProductId);
        SuccessToast(t("ss_builder_move_product_successfully_label"));
    }, [
        affiliateProductGroupData,
        productData,
        productGroupId
    ]);
    var optionsFilter = (0,react.useMemo)(function() {
        var optionsClone = Array.from(options);
        var isHideMovingProductOption = (affiliateProductGroupData === null || affiliateProductGroupData === void 0 ? void 0 : affiliateProductGroupData.length) <= 1;
        if (isHideMovingProductOption) {
            optionsClone = optionsClone.filter(function(option) {
                return option.key !== ProductListItems/* ActionEnum.MOVE_PRODUCT */.X.MOVE_PRODUCT;
            });
        }
        return optionsClone;
    }, [
        options,
        affiliateProductGroupData
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Popover.Menu */.J2.Menu, {
                mode: "dark",
                actions: optionsFilter,
                placement: "bottom-end",
                trigger: "click",
                stopPropagation: [
                    "click"
                ],
                getContainer: function() {
                    return fromSwiperList ? document.getElementById("passio-aff-swiper-list") : document.getElementById("passio-design-class");
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-8 h-8 p-1",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "cursor-pointer w-full h-full flex items-center justify-center rounded-full",
                        style: {
                            backgroundColor: "rgba(0, 0, 0, 0.15)",
                            // backdropFilter: "blur(15px)",
                            border: "1px solid rgba(255, 255, 255, 0.1)"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* MoreIcon */.nX, {
                            className: "w-4 h-4",
                            fillColor: "#FFFFFF"
                        })
                    })
                })
            }),
            isOpenProductEdit && /*#__PURE__*/ (0,jsx_runtime.jsx)(full_screen_popup/* default */.Z, {
                visible: isOpenProductEdit,
                onMaskClick: function() {
                    return setIsOpenProductEdit(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AffiliateProductEdit/* default */.Z, {
                    productData: productData,
                    activeProductGroup: productGroupId,
                    callBackCancelAffiliateProductEdit: function() {
                        return setIsOpenProductEdit(false);
                    },
                    callBackSaveAffiliateProductEdit: function(val) {
                        return onUpdateProductGroupData(val);
                    },
                    affiliateProductGroupData: affiliateProductGroupData,
                    callbackAddNewAffiliateProductGroup: function(val) {
                        return onUpdateProductGroupData(val);
                    },
                    productGroupMaximum: productGroupMaximum
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupComponent/* default */.Z, {
                visible: isOpenProductMovingPanel,
                onMaskClick: function() {
                    return setIsOpenProductMovingPanel(false);
                },
                title: t("ss_builder_affiliate_product_moving_panel_title"),
                onClose: function() {
                    return setIsOpenProductMovingPanel(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AffiliateProductMovingPanel/* default */.Z, {
                    callbackCancelAffiliateProductMovingPanel: function() {
                        return setIsOpenProductMovingPanel(false);
                    },
                    callbackConfirmAffiliateProductMovingPanel: handleConfirmAffiliateProductMovingPanel,
                    allowedMovingAffiliateProductGroup: affiliateProductGroupData === null || affiliateProductGroupData === void 0 ? void 0 : affiliateProductGroupData.filter(function(x) {
                        return x.uid !== productGroupId;
                    }),
                    productMovingQuantity: 1
                })
            })
        ]
    });
};
/* harmony default export */ var BlockAffiliateProductGroup_ProductMoreActions = (ProductMoreActions);

// EXTERNAL MODULE: ./src/features/block/block-editor/AffiliateProductGroup/context.tsx
var context = __webpack_require__(69283);
// EXTERNAL MODULE: ./src/features/share/helper/image.ts
var helper_image = __webpack_require__(79704);
;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockAffiliateProductGroup/ProductDetail/ProductDetailStyle1/index.tsx









var ProductDetailStyle1 = function(props) {
    var ref, ref1, ref2;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var product = props.product, styleAttributes = props.styleAttributes, affiliateProductGroupData = props.affiliateProductGroupData, productGroupMaximum = props.productGroupMaximum, onUpdateProductGroupData = props.onUpdateProductGroupData, _fromSwiperList = props.fromSwiperList, fromSwiperList = _fromSwiperList === void 0 ? false : _fromSwiperList;
    var ref3 = (0,context/* useAffiliateContext */.U)(), frameData = ref3.frameData, usingFrame = ref3.usingFrame;
    var threeItemOnRows = styleAttributes.item_on_row === configs_const/* PRODUCT_ON_ROW.THREE */.J_.THREE || styleAttributes.style_display === "grid-3";
    var isHot = product === null || product === void 0 ? void 0 : (ref = product.label_product) === null || ref === void 0 ? void 0 : ref.includes(configs_const/* LABEL_PRODUCT.HOT */.u.HOT);
    var isFavourite = product === null || product === void 0 ? void 0 : (ref1 = product.label_product) === null || ref1 === void 0 ? void 0 : ref1.includes(configs_const/* LABEL_PRODUCT.FAVOURITE */.u.FAVOURITE);
    var isSale = product === null || product === void 0 ? void 0 : (ref2 = product.label_product) === null || ref2 === void 0 ? void 0 : ref2.includes(configs_const/* LABEL_PRODUCT.SALE */.u.SALE);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative",
                id: "affiliate-product-item-".concat(product.uid),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute top-0 right-0 z-[12]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockAffiliateProductGroup_ProductMoreActions, {
                            productData: product,
                            affiliateProductGroupData: affiliateProductGroupData,
                            productGroupMaximum: productGroupMaximum,
                            onUpdateProductGroupData: onUpdateProductGroupData,
                            fromSwiperList: fromSwiperList
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(lazy_image/* default */.ZP, {
                        src: product.image,
                        // fit="cover"
                        width: 512,
                        height: 512,
                        className: "object-center affiliate-product-image",
                        style: {
                            backgroundSize: "cover",
                            aspectRatio: "1/1",
                            borderRadius: "4px",
                            margin: "0 auto",
                            objectFit: "cover",
                            width: "100%",
                            outline: "solid rgba(0, 0, 0, 0.16) 1px",
                            outlineOffset: "-1px"
                        },
                        onError: function(param) {
                            var currentTarget = param.currentTarget;
                            currentTarget.onerror = null; // prevents looping
                            currentTarget.src = "https://i.ecomobi.com/ssp/passio-page/image-default.png";
                        }
                    }, product.uid),
                    threeItemOnRows && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "gap-0.5 absolute flex z-[11]",
                        style: {
                            top: "8px",
                            left: "8px"
                        },
                        children: [
                            isSale && /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* SaleIcon */.rG, {
                                width: 16,
                                height: 16
                            }),
                            isFavourite && /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* FavouriteIcon */.EL, {
                                width: 16,
                                height: 16
                            })
                        ]
                    }),
                    !threeItemOnRows && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            isFavourite && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute",
                                style: {
                                    top: "8px",
                                    left: "-3px",
                                    zIndex: 11
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "favourite ",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-label default-font-family px-1 ",
                                        children: t("ss_builder_affiliate_product_label_product_like")
                                    })
                                })
                            }),
                            isSale && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute ",
                                style: {
                                    top: "8px",
                                    right: "8px",
                                    zIndex: 11
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "sale ",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-label default-font-family px-1",
                                        children: t("ss_builder_affiliate_product_label_product_discount")
                                    })
                                })
                            })
                        ]
                    }),
                    usingFrame && frameData && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute top-0 left-0 z-10",
                        style: {
                            background: 'url("'.concat((0,helper_image/* getHorizontalResizeUrl */.L)(frameData.urlEU, 512), '") no-repeat left bottom/ contain'),
                            aspectRatio: "1/1",
                            borderRadius: "4px",
                            width: "100%",
                            height: "auto"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "ellipsis-text affiliate-product-name",
                style: {
                    marginTop: "7.5px",
                    color: "var(--text-color-6)"
                },
                children: [
                    isHot && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        style: {
                            marginRight: "2px"
                        },
                        children: [
                            threeItemOnRows && /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* HotIcon */.q7, {
                                className: "inline mb-1",
                                width: 16,
                                height: 16
                            }),
                            !threeItemOnRows && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "hot mb-1",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-label default-font-family px-1",
                                    children: t("ss_builder_affiliate_product_label_product_hot")
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: product.title
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ProductDetail_ProductDetailStyle1 = (ProductDetailStyle1);

;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockAffiliateProductGroup/ProductStyleDisplay/ProductStyleGrid/index.tsx




var ProductStyleGrid = function(props) {
    var products = props.products, styleAttributes = props.styleAttributes, affiliateProductGroupData = props.affiliateProductGroupData, onUpdateProductGroupData = props.onUpdateProductGroupData, productGroupMaximum = props.productGroupMaximum;
    var style_display = styleAttributes.style_display, item_on_row = styleAttributes.item_on_row;
    var productListEnable = products === null || products === void 0 ? void 0 : products.filter(function(x) {
        return x.enable === 1;
    });
    var oldDisplayValueStyle = (0,react.useMemo)(function() {
        var gridStyleValue = null;
        switch(style_display){
            case "grid-1":
                gridStyleValue = {
                    display: "grid",
                    gridTemplateColumns: "repeat(1, minmax(0, 1fr))",
                    gap: "12px"
                };
                break;
            case "grid-2":
                gridStyleValue = {
                    display: "grid",
                    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                    gap: "12px"
                };
                break;
            case "grid-3":
                gridStyleValue = {
                    display: "grid",
                    gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
                    gap: "12px"
                };
                break;
        }
        return gridStyleValue;
    }, [
        style_display
    ]);
    var displayValueStyle = (0,react.useMemo)(function() {
        var gridStyleValue = null;
        switch(item_on_row){
            case configs_const/* PRODUCT_ON_ROW.ONE */.J_.ONE:
                gridStyleValue = {
                    display: "grid",
                    gridTemplateColumns: "repeat(1, minmax(0, 1fr))",
                    gap: "12px"
                };
                break;
            case configs_const/* PRODUCT_ON_ROW.TWO */.J_.TWO:
                gridStyleValue = {
                    display: "grid",
                    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                    gap: "12px"
                };
                break;
            case configs_const/* PRODUCT_ON_ROW.THREE */.J_.THREE:
                gridStyleValue = {
                    display: "grid",
                    gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
                    gap: "12px"
                };
                break;
        }
        return gridStyleValue;
    }, [
        item_on_row
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "affiliate-product-wrapper",
            style: style_display.includes("grid-") ? oldDisplayValueStyle : displayValueStyle,
            children: productListEnable === null || productListEnable === void 0 ? void 0 : productListEnable.map(function(ele, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetail_ProductDetailStyle1, {
                    product: ele,
                    styleAttributes: styleAttributes,
                    affiliateProductGroupData: affiliateProductGroupData,
                    onUpdateProductGroupData: onUpdateProductGroupData,
                    productGroupMaximum: productGroupMaximum
                }, index);
            })
        })
    });
};
/* harmony default export */ var ProductStyleDisplay_ProductStyleGrid = (ProductStyleGrid);

// EXTERNAL MODULE: ./node_modules/lodash/slice.js
var slice = __webpack_require__(12571);
var slice_default = /*#__PURE__*/__webpack_require__.n(slice);
;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockAffiliateProductGroup/ProductStyleDisplay/ProductStyleSlide/component/SeeAll.tsx



var SeeMoreIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _width = param.width, width = _width === void 0 ? 25 : _width, _height = param.height, height = _height === void 0 ? 25 : _height, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#FFF" : _fillColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        fill: "none",
        viewBox: "0 0 25 25",
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_5885_756968)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        fillOpacity: "0.01",
                        d: "M0 0H24V24H0z",
                        transform: "translate(.6 .499)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "24",
                        height: "24",
                        x: "0.601",
                        y: "0.499",
                        fill: fillColor,
                        rx: "12"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M16.14 11.789l-5.66-5.65a.999.999 0 00-1.42 0 1 1 0 000 1.41l4.95 5-4.95 4.95a1 1 0 000 1.41 1 1 0 00.71.3 1.001 1.001 0 00.71-.3l5.66-5.65a1 1 0 000-1.47z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_5885_756968",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0H24V24H0z",
                        transform: "translate(.6 .499)"
                    })
                })
            })
        ]
    });
};
var SeeAll = function(param) {
    var height = param.height, handleClickShowAll = param.handleClickShowAll;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "h-full flex items-center flex-col justify-center cursor-pointer",
        style: {
            height: height
        },
        onClick: handleClickShowAll,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SeeMoreIcon, {
                fillColor: "var(--adm-color-primary)",
                className: "cursor-pointer"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-2 text-[13px] font-normal leading-[131%] cursor-pointer",
                style: {
                    color: "var(--adm-color-primary)"
                },
                children: t("ss_builder_product_swiper_see_all")
            })
        ]
    });
};
/* harmony default export */ var component_SeeAll = (SeeAll);

// EXTERNAL MODULE: ./node_modules/lodash/flatten.js
var flatten = __webpack_require__(85564);
var flatten_default = /*#__PURE__*/__webpack_require__.n(flatten);
// EXTERNAL MODULE: ./node_modules/lodash/chunk.js
var chunk = __webpack_require__(8400);
var chunk_default = /*#__PURE__*/__webpack_require__.n(chunk);
;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockAffiliateProductGroup/ProductStyleDisplay/ProductStyleSlide/component/ListProduct.tsx
function ListProduct_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function ListProduct_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                ListProduct_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                ListProduct_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}









var ListProduct = function(param1) {
    var onCancel = param1.onCancel, listProduct = param1.listProduct, styleAttributes = param1.styleAttributes, affiliateProductGroupData = param1.affiliateProductGroupData, onUpdateProductGroupData = param1.onUpdateProductGroupData, productGroupMaximum = param1.productGroupMaximum, allProductLists = param1.allProductLists;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref = (0,react.useState)([]), data = ref[0], setData = ref[1];
    var ref1 = (0,react.useState)(true), hasMore1 = ref1[0], setHasMore = ref1[1];
    var ref2 = (0,react.useState)(0), count = ref2[0], setCount = ref2[1];
    var listProductChunk = (0,react.useMemo)(function() {
        return chunk_default()(allProductLists, 12);
    }, [
        allProductLists
    ]);
    (0,react.useEffect)(function() {
        setData(flatten_default()(listProductChunk.slice(0, count + 1)));
    }, [
        allProductLists
    ]);
    var loadMore = function() {
        var _ref = ListProduct_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setHasMore(data.length < allProductLists.length);
                        if (listProductChunk[count]) {
                            // setData((val) => [...val, ...listProductChunk[count]]);
                            setData(flatten_default()(listProductChunk.slice(0, count + 1)));
                            setCount(function(val) {
                                return val + 1;
                            });
                        }
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function loadMore() {
            return _ref.apply(this, arguments);
        };
    }();
    var InfiniteScrollContent = function(param) {
        var hasMore = param.hasMore;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: hasMore ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        style: {
                            color: "#999999"
                        },
                        children: t("ss_builder_loading_label")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* DotLoading */.k_, {
                        style: {
                            color: "#999999"
                        }
                    })
                ]
            }) : null
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* NavBar */.l2, {
                backArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* BackAngelIcon */.Nz, {}),
                onBack: onCancel,
                className: "max-width-content-class w-full bg-[#FFFFFF] fixed top-0 z-[99]",
                style: {
                    borderBottom: "1px solid #EEE"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-neutral-900 font-normal text-[18.72px] leading-[130%]",
                    children: t("ss_builder_digital_product_list_title")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "pb-5 px-3 pt-[45px] bg-[#FFFFFF] h-full ",
                id: "passio-aff-swiper-list",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "grid grid-cols-2 gap-3 pt-3",
                        children: data === null || data === void 0 ? void 0 : data.map(function(ele, idx) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetail_ProductDetailStyle1, {
                                product: ele,
                                styleAttributes: styleAttributes,
                                affiliateProductGroupData: affiliateProductGroupData,
                                onUpdateProductGroupData: onUpdateProductGroupData,
                                productGroupMaximum: productGroupMaximum,
                                fromSwiperList: true
                            }, idx);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "aff-swiper-infinite-scroll",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* InfiniteScroll */.v_, {
                            loadMore: loadMore,
                            hasMore: hasMore1,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfiniteScrollContent, {
                                hasMore: hasMore1
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var component_ListProduct = (ListProduct);

;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockAffiliateProductGroup/ProductStyleDisplay/ProductStyleSlide/index.tsx
function ProductStyleSlide_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return ProductStyleSlide_arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || ProductStyleSlide_unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function ProductStyleSlide_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return ProductStyleSlide_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ProductStyleSlide_arrayLikeToArray(o, minLen);
}









var ProductStyleSlide = function(props) {
    var ref2;
    var products = props.products, styleAttributes = props.styleAttributes, affiliateProductGroupData = props.affiliateProductGroupData, onUpdateProductGroupData = props.onUpdateProductGroupData, productGroupMaximum = props.productGroupMaximum, allProductLists = props.allProductLists;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var refElement = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(false), visible = ref1[0], setVisible = ref1[1];
    var productClone = (allProductLists === null || allProductLists === void 0 ? void 0 : allProductLists.length) > 12 ? _toConsumableArray(slice_default()(products, 0, 12)).concat([
        {
            showAll: true
        }
    ]) : _toConsumableArray(products);
    var heightOfElement = (0,react.useMemo)(function() {
        var ref;
        return refElement === null || refElement === void 0 ? void 0 : (ref = refElement.current) === null || ref === void 0 ? void 0 : ref.offsetHeight;
    }, [
        refElement === null || refElement === void 0 ? void 0 : (ref2 = refElement.current) === null || ref2 === void 0 ? void 0 : ref2.offsetHeight
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: refElement,
                className: "max-h-[225px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                    slidesPerView: 2.5,
                    spaceBetween: 8,
                    children: productClone.map(function(ele, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            children: index === 12 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(component_SeeAll, {
                                height: heightOfElement,
                                handleClickShowAll: function() {
                                    return setVisible(true);
                                }
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetail_ProductDetailStyle1, {
                                product: ele,
                                styleAttributes: styleAttributes,
                                affiliateProductGroupData: affiliateProductGroupData,
                                onUpdateProductGroupData: onUpdateProductGroupData,
                                productGroupMaximum: productGroupMaximum
                            }, index)
                        }, index);
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(full_screen_popup/* default */.Z, {
                visible: visible,
                onMaskClick: function() {
                    setVisible(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(component_ListProduct, {
                    onCancel: function() {
                        return setVisible(false);
                    },
                    listProduct: products,
                    styleAttributes: styleAttributes,
                    affiliateProductGroupData: affiliateProductGroupData,
                    onUpdateProductGroupData: onUpdateProductGroupData,
                    productGroupMaximum: productGroupMaximum,
                    allProductLists: allProductLists
                })
            })
        ]
    });
};
/* harmony default export */ var ProductStyleDisplay_ProductStyleSlide = (ProductStyleSlide);

;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockAffiliateProductGroup/ProductDetail/ProductDetailStyle2/index.tsx











var ProductDetailStyle2 = function(props) {
    var ref, ref1, ref2;
    var product = props.product, item_on_row = props.item_on_row, affiliateProductGroupData = props.affiliateProductGroupData, productGroupMaximum = props.productGroupMaximum, onUpdateProductGroupData = props.onUpdateProductGroupData;
    var ref3 = (0,context/* useAffiliateContext */.U)(), frameData = ref3.frameData, usingFrame = ref3.usingFrame;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var isHot = product === null || product === void 0 ? void 0 : (ref = product.label_product) === null || ref === void 0 ? void 0 : ref.includes(configs_const/* LABEL_PRODUCT.HOT */.u.HOT);
    var isFavourite = product === null || product === void 0 ? void 0 : (ref1 = product.label_product) === null || ref1 === void 0 ? void 0 : ref1.includes(configs_const/* LABEL_PRODUCT.FAVOURITE */.u.FAVOURITE);
    var isSale = product === null || product === void 0 ? void 0 : (ref2 = product.label_product) === null || ref2 === void 0 ? void 0 : ref2.includes(configs_const/* LABEL_PRODUCT.SALE */.u.SALE);
    var threeItemOnRows = item_on_row === configs_const/* PRODUCT_ON_ROW.THREE */.J_.THREE;
    var rowEllipsis = (0,react.useMemo)(function() {
        switch(item_on_row){
            case configs_const/* PRODUCT_ON_ROW.ONE */.J_.ONE:
                return 6;
            case configs_const/* PRODUCT_ON_ROW.TWO */.J_.TWO:
                return 3;
            case configs_const/* PRODUCT_ON_ROW.THREE */.J_.THREE:
                return 3;
        }
    }, [
        item_on_row
    ]);
    var paddingText = (0,react.useMemo)(function() {
        switch(item_on_row){
            case configs_const/* PRODUCT_ON_ROW.ONE */.J_.ONE:
                return 6;
            case configs_const/* PRODUCT_ON_ROW.TWO */.J_.TWO:
                return 3;
            case configs_const/* PRODUCT_ON_ROW.THREE */.J_.THREE:
                return 2;
        }
    }, [
        item_on_row
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative",
        id: "affiliate-product-item-".concat(product.uid),
        children: [
            usingFrame && frameData && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute top-0 left-0 z-[12]",
                style: {
                    background: 'url("'.concat((0,helper_image/* getHorizontalResizeUrl */.L)(frameData.urlEU, 512), '") no-repeat left bottom/ contain'),
                    aspectRatio: "1/1",
                    borderRadius: "4px",
                    width: "100%",
                    height: "auto"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute top-0 right-0 z-[14]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockAffiliateProductGroup_ProductMoreActions, {
                    productData: product,
                    affiliateProductGroupData: affiliateProductGroupData,
                    productGroupMaximum: productGroupMaximum,
                    onUpdateProductGroupData: onUpdateProductGroupData
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(lazy_image/* default */.ZP, {
                src: product.image,
                // fit="cover"
                width: 512,
                height: 512,
                className: "object-center affiliate-product-image",
                style: {
                    backgroundSize: "cover",
                    aspectRatio: "1/1",
                    borderRadius: "4px",
                    margin: "0 auto",
                    objectFit: "cover",
                    width: "100%",
                    outline: "solid rgba(0, 0, 0, 0.16) 1px",
                    outlineOffset: "-1px"
                },
                onError: function(param) {
                    var currentTarget = param.currentTarget;
                    currentTarget.onerror = null; // prevents looping
                    currentTarget.src = "https://i.ecomobi.com/ssp/passio-page/image-default.png";
                }
            }, product.uid),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute top-0 left-0 block w-full h-full text-center z-[11]",
                style: {
                    backgroundColor: "#000000",
                    opacity: "0.6",
                    borderRadius: "4px"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()("absolute w-full z-[13]", "px-".concat(paddingText)),
                style: {
                    // top: "50%",
                    // left: "50%",
                    // transform: "translate(-50%, -50%)",
                    top: "80%",
                    left: "80%",
                    transform: "translate(-80%, -80%)"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Ellipsis */.mH, {
                    direction: "end",
                    content: product.title,
                    className: "lead-1 text-neutral-50 text-center affiliate-product-name",
                    rows: rowEllipsis,
                    style: {
                        lineHeight: "150%"
                    }
                })
            }),
            threeItemOnRows && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "absolute flex w-full justify-center gap-1 z-[13]",
                style: {
                    top: "8%",
                    left: "8%",
                    transform: "translate(-8%, -8%)"
                },
                children: [
                    isHot && /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* HotIcon */.q7, {
                        className: "inline",
                        width: 16,
                        height: 16
                    }),
                    isSale && /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* SaleIcon */.rG, {
                        width: 16,
                        height: 16
                    }),
                    isFavourite && /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* FavouriteIcon */.EL, {
                        width: 16,
                        height: 16
                    })
                ]
            }),
            !threeItemOnRows && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "absolute top-2 left-[-3px] z-[13]",
                        children: [
                            isFavourite && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "favourite-label",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-label default-font-family px-1 ",
                                    children: t("ss_builder_affiliate_product_label_product_like")
                                })
                            }),
                            isHot && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "hot-label",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-label default-font-family px-1 ",
                                    children: t("ss_builder_affiliate_product_label_product_hot")
                                })
                            })
                        ]
                    }),
                    isSale && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute top-2 right-2 z-[13]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "sale",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-label default-font-family px-1 ",
                                children: t("ss_builder_affiliate_product_label_product_discount")
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ProductDetail_ProductDetailStyle2 = (ProductDetailStyle2);

;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockAffiliateProductGroup/ProductStyleDisplay/ProductStyleTextOverImage/index.tsx




var ProductStyleTextOverImage = function(props) {
    var products = props.products, styleAttributes = props.styleAttributes, affiliateProductGroupData = props.affiliateProductGroupData, onUpdateProductGroupData = props.onUpdateProductGroupData, productGroupMaximum = props.productGroupMaximum;
    var style_display = styleAttributes.style_display, item_on_row = styleAttributes.item_on_row;
    var productListEnable = products === null || products === void 0 ? void 0 : products.filter(function(x) {
        return x.enable === 1;
    });
    var displayValueStyle = (0,react.useMemo)(function() {
        var gridStyleValue = null;
        switch(item_on_row){
            case configs_const/* PRODUCT_ON_ROW.ONE */.J_.ONE:
                gridStyleValue = {
                    display: "grid",
                    gridTemplateColumns: "repeat(1, minmax(0, 1fr))",
                    gap: "12px"
                };
                break;
            case configs_const/* PRODUCT_ON_ROW.TWO */.J_.TWO:
                gridStyleValue = {
                    display: "grid",
                    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                    gap: "12px"
                };
                break;
            case configs_const/* PRODUCT_ON_ROW.THREE */.J_.THREE:
                gridStyleValue = {
                    display: "grid",
                    gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
                    gap: "12px"
                };
                break;
        }
        return gridStyleValue;
    }, [
        item_on_row
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "affiliate-product-wrapper",
            style: displayValueStyle,
            children: productListEnable === null || productListEnable === void 0 ? void 0 : productListEnable.map(function(ele, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetail_ProductDetailStyle2, {
                    product: ele,
                    item_on_row: item_on_row,
                    affiliateProductGroupData: affiliateProductGroupData,
                    onUpdateProductGroupData: onUpdateProductGroupData,
                    productGroupMaximum: productGroupMaximum
                }, index);
            })
        })
    });
};
/* harmony default export */ var ProductStyleDisplay_ProductStyleTextOverImage = (ProductStyleTextOverImage);

;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockAffiliateProductGroup/ProductDetail/ProductDetailStyle3/index.tsx









var ProductDetailStyle3 = function(props) {
    var ref, ref1, ref2;
    var product = props.product, productIndex = props.productIndex, affiliateProductGroupData = props.affiliateProductGroupData, productGroupMaximum = props.productGroupMaximum, onUpdateProductGroupData = props.onUpdateProductGroupData;
    var ref3 = (0,context/* useAffiliateContext */.U)(), frameData = ref3.frameData, usingFrame = ref3.usingFrame;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var isHot = product === null || product === void 0 ? void 0 : (ref = product.label_product) === null || ref === void 0 ? void 0 : ref.includes(configs_const/* LABEL_PRODUCT.HOT */.u.HOT);
    var isFavourite = product === null || product === void 0 ? void 0 : (ref1 = product.label_product) === null || ref1 === void 0 ? void 0 : ref1.includes(configs_const/* LABEL_PRODUCT.FAVOURITE */.u.FAVOURITE);
    var isSale = product === null || product === void 0 ? void 0 : (ref2 = product.label_product) === null || ref2 === void 0 ? void 0 : ref2.includes(configs_const/* LABEL_PRODUCT.SALE */.u.SALE);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "grid grid-cols-2 gap-3",
        children: [
            productIndex % 2 !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Ellipsis */.mH, {
                direction: "end",
                content: product.title,
                className: "m-auto text-center affiliate-product-name",
                rows: 6,
                style: {
                    color: "var(--heading-color-6)"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative",
                id: "affiliate-product-item-".concat(product.uid),
                children: [
                    usingFrame && frameData && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute top-0 left-0 z-10",
                        style: {
                            background: 'url("'.concat((0,helper_image/* getHorizontalResizeUrl */.L)(frameData.urlEU, 512), '") no-repeat left bottom/ contain'),
                            aspectRatio: "1/1",
                            borderRadius: "4px",
                            width: "100%",
                            height: "auto"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute top-0 right-0 z-[12]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockAffiliateProductGroup_ProductMoreActions, {
                            productData: product,
                            affiliateProductGroupData: affiliateProductGroupData,
                            productGroupMaximum: productGroupMaximum,
                            onUpdateProductGroupData: onUpdateProductGroupData
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(lazy_image/* default */.ZP, {
                        src: product.image,
                        // fit="cover"
                        width: 512,
                        height: 512,
                        className: "object-center affiliate-product-image",
                        style: {
                            backgroundSize: "cover",
                            aspectRatio: "1/1",
                            borderRadius: "4px",
                            margin: "0 auto",
                            objectFit: "cover",
                            width: "100%",
                            outline: "solid rgba(0, 0, 0, 0.16) 1px",
                            outlineOffset: "-1px"
                        },
                        onError: function(param) {
                            var currentTarget = param.currentTarget;
                            currentTarget.onerror = null; // prevents looping
                            currentTarget.src = "https://i.ecomobi.com/ssp/passio-page/image-default.png";
                        }
                    }, product.uid),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "absolute z-[11]",
                        style: {
                            top: "8px",
                            left: "-3px"
                        },
                        children: [
                            isFavourite && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "favourite-label ",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-label default-font-family px-1 ",
                                    children: t("ss_builder_affiliate_product_label_product_like")
                                })
                            }),
                            isHot && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "hot-label",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-label default-font-family px-1 ",
                                    children: t("ss_builder_affiliate_product_label_product_hot")
                                })
                            })
                        ]
                    }),
                    isSale && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute top-2 right-2 z-[11]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "sale",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-label default-font-family px-1 ",
                                children: t("ss_builder_affiliate_product_label_product_discount")
                            })
                        })
                    })
                ]
            }),
            productIndex % 2 === 0 && // <div className="text-center m-auto affiliate-product-name">
            //   {product.title}
            // </div>
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Ellipsis */.mH, {
                direction: "end",
                content: product.title,
                className: "m-auto text-center affiliate-product-name",
                rows: 6,
                style: {
                    color: "var(--heading-color-6)"
                }
            })
        ]
    });
};
/* harmony default export */ var ProductDetail_ProductDetailStyle3 = (ProductDetailStyle3);

;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockAffiliateProductGroup/ProductStyleDisplay/ProductStyleZigzag/index.tsx



var ProductStyleZigzag = function(props) {
    var products = props.products, productGroupId = props.productGroupId, affiliateProductGroupData = props.affiliateProductGroupData, onUpdateProductGroupData = props.onUpdateProductGroupData, productGroupMaximum = props.productGroupMaximum;
    var productListEnable = products === null || products === void 0 ? void 0 : products.filter(function(x) {
        return x.enable === 1;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "grid grid-cols-1 gap-3 affiliate-product-wrapper",
            children: productListEnable === null || productListEnable === void 0 ? void 0 : productListEnable.map(function(ele, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetail_ProductDetailStyle3, {
                    product: ele,
                    productIndex: index,
                    productGroupId: productGroupId,
                    affiliateProductGroupData: affiliateProductGroupData,
                    onUpdateProductGroupData: onUpdateProductGroupData,
                    productGroupMaximum: productGroupMaximum
                }, index);
            })
        })
    });
};
/* harmony default export */ var ProductStyleDisplay_ProductStyleZigzag = (ProductStyleZigzag);

;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockAffiliateProductGroup/ProductStyleDisplay/index.tsx
function ProductStyleDisplay_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ProductStyleDisplay_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ProductStyleDisplay_defineProperty(target, key, source[key]);
        });
    }
    return target;
}







var ProductStyleDisplay_obj;
var PRODUCT_LAYOUT_COMPONENT = (ProductStyleDisplay_obj = {}, ProductStyleDisplay_defineProperty(ProductStyleDisplay_obj, configs_const/* PRODUCT_DISPLAY_STYLES.GRID */.y$.GRID, ProductStyleDisplay_ProductStyleGrid), ProductStyleDisplay_defineProperty(ProductStyleDisplay_obj, configs_const/* PRODUCT_DISPLAY_STYLES.SLIDE */.y$.SLIDE, ProductStyleDisplay_ProductStyleSlide), ProductStyleDisplay_defineProperty(ProductStyleDisplay_obj, configs_const/* PRODUCT_DISPLAY_STYLES.TEXT_OVER_IMAGE */.y$.TEXT_OVER_IMAGE, ProductStyleDisplay_ProductStyleTextOverImage), ProductStyleDisplay_defineProperty(ProductStyleDisplay_obj, configs_const/* PRODUCT_DISPLAY_STYLES.ZIGZAG */.y$.ZIGZAG, ProductStyleDisplay_ProductStyleZigzag), ProductStyleDisplay_obj);
var ProductStyleDisplay = function(props1) {
    var ProductListLayoutRender = (0,react.useCallback)(function(props) {
        var ref, ref1, ref2;
        var Element = /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        var styleDisplay = (props === null || props === void 0 ? void 0 : (ref = props.styleAttributes) === null || ref === void 0 ? void 0 : (ref1 = ref.style_display) === null || ref1 === void 0 ? void 0 : ref1.includes("grid-")) ? "grid" : props === null || props === void 0 ? void 0 : (ref2 = props.styleAttributes) === null || ref2 === void 0 ? void 0 : ref2.style_display;
        if (PRODUCT_LAYOUT_COMPONENT[styleDisplay]) {
            var RenderComponent = PRODUCT_LAYOUT_COMPONENT[styleDisplay];
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(RenderComponent, ProductStyleDisplay_objectSpread({}, props));
        }
        return Element;
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductListLayoutRender, ProductStyleDisplay_objectSpread({}, props1));
};
/* harmony default export */ var BlockAffiliateProductGroup_ProductStyleDisplay = (ProductStyleDisplay);

;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockAffiliateProductGroup/ProductListsDisplay/index.tsx







var ProductListsDisplay = function(props) {
    var style_attributes = props.style_attributes, productGroupItem = props.productGroupItem, see_more_btn_content = props.see_more_btn_content, affiliateProductGroupData = props.affiliateProductGroupData, productGroupMaximum = props.productGroupMaximum, onUpdateProductGroupData = props.onUpdateProductGroupData;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var allProductLists = (0,react.useMemo)(function() {
        var ref, ref1;
        var productLists = (productGroupItem === null || productGroupItem === void 0 ? void 0 : (ref = productGroupItem.content_attributes) === null || ref === void 0 ? void 0 : (ref1 = ref.items) === null || ref1 === void 0 ? void 0 : ref1.filter(function(x) {
            return (x === null || x === void 0 ? void 0 : x.enable) === 1;
        })) || [];
        return productLists;
    }, [
        productGroupItem
    ]);
    var productListsRenderDefault = (0,react.useMemo)(function() {
        var allProductListsClone = cloneDeep_default()(allProductLists);
        if (allProductListsClone && allProductListsClone.length > configs_const/* PRODUCT_MAX_DEFAULT */.tk) {
            allProductListsClone.length = configs_const/* PRODUCT_MAX_DEFAULT */.tk;
        }
        return allProductListsClone;
    }, [
        allProductLists
    ]);
    var ref2 = (0,react.useState)(productListsRenderDefault), productListsRender = ref2[0], setProductListRender = ref2[1];
    (0,react.useEffect)(function() {
        if (productListsRenderDefault) {
            setProductListRender(productListsRenderDefault);
        }
    }, [
        JSON.stringify(productListsRenderDefault)
    ]);
    var isDisplayBtnSeeMore = (0,react.useMemo)(function() {
        if (allProductLists.length <= configs_const/* PRODUCT_MAX_DEFAULT */.tk || productListsRender.length === allProductLists.length || style_attributes.style_display === configs_const/* SLIDE */.jj) {
            return false;
        } else return true;
    }, [
        allProductLists,
        productListsRender
    ]);
    var handleSeeMoreProducts = (0,react.useCallback)(function(event) {
        event.stopPropagation();
        var allProductListsClone = cloneDeep_default()(allProductLists);
        if (allProductLists.length - productListsRender.length < configs_const/* PRODUCT_MAX_DEFAULT */.tk) {
            allProductListsClone.length = productListsRender.length + (allProductLists.length - productListsRender.length);
        } else {
            allProductListsClone.length = productListsRender.length + configs_const/* PRODUCT_MAX_DEFAULT */.tk;
        }
        setProductListRender(allProductListsClone);
    }, [
        allProductLists,
        productListsRender
    ]);
    var isEnabled = (productGroupItem === null || productGroupItem === void 0 ? void 0 : productGroupItem.enable) === 1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: allProductLists.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        opacity: !isEnabled ? "60%" : ""
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockAffiliateProductGroup_ProductStyleDisplay, {
                        products: productListsRender,
                        styleAttributes: style_attributes,
                        affiliateProductGroupData: affiliateProductGroupData,
                        onUpdateProductGroupData: onUpdateProductGroupData,
                        productGroupMaximum: productGroupMaximum,
                        allProductLists: allProductLists
                    })
                }),
                isDisplayBtnSeeMore && /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                    block: true,
                    // color="primary"
                    size: "middle",
                    style: {
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        alignItems: "center",
                        marginTop: "16px",
                        gap: "5px"
                    },
                    onClick: handleSeeMoreProducts,
                    className: "pp-button",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: see_more_btn_content
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col justify-center text-center gap-2 mt-5 mb-[16px]",
            style: {
                opacity: !isEnabled ? "60%" : ""
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                    src: "https://image.passio.eco/page-builder/page-builder/empty-product/Empty-product.svg",
                    // width={80}
                    height: 80,
                    className: "mx-[auto]"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "lead-2",
                            style: {
                                color: "var(--text-color-6)"
                            },
                            children: t("ss_builder_product_design_empty_title")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            style: {
                                color: "var(--text-color-5)"
                            },
                            children: t("ss_builder_to_add_products_please_press_the_add_button_above")
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var BlockAffiliateProductGroup_ProductListsDisplay = (ProductListsDisplay);

// EXTERNAL MODULE: ./src/features/block/block-editor/AffiliateProductGroup/AffiliateProductGroupManagement/AffiliateProductGroupAddNew/index.tsx
var AffiliateProductGroupAddNew = __webpack_require__(39603);
// EXTERNAL MODULE: ./src/features/block/block-editor/AffiliateProductGroup/ProductListLayoutHandler/index.tsx + 2 modules
var ProductListLayoutHandler = __webpack_require__(96223);
;// CONCATENATED MODULE: ./src/features/share/components/ButtonSavingGroup/index.tsx




var ButtonSavingGroup = function(props) {
    var onCancel = props.onCancel, onSave = props.onSave, cancelLabel = props.cancelLabel, saveLabel = props.saveLabel, disabled = props.disabled, loading = props.loading, className = props.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()("max-width-content-class fixed bottom-0 p-2 flex w-full justify-between gap-2 z-[10] bg-[#FFFFFF]", className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-1/2 text-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                    className: "w-full",
                    onClick: onCancel,
                    children: cancelLabel
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-1/2 text-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                    className: "w-full",
                    color: "primary",
                    onClick: onSave,
                    disabled: disabled,
                    loading: loading,
                    children: saveLabel
                })
            })
        ]
    });
};
/* harmony default export */ var components_ButtonSavingGroup = (ButtonSavingGroup);

;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockAffiliateProductGroup/ProductListOfGroupDisplay/GroupTitleComponent/ProductGroupQuickEdit/HeaderComponent/index.tsx






var HeaderComponent = function(props) {
    var onCancel = props.onCancel, title = props.title, isEnable = props.isEnable, groupId = props.groupId, onRemoveGroup = props.onRemoveGroup, onVisibleGroup = props.onVisibleGroup, onOpenEditGroup = props.onOpenEditGroup;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var popoverContainerRef = (0,react.useRef)(null);
    var actions = [
        {
            key: GroupActions.EDIT_GROUP_NAME,
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* LineRename */.cR, {
                className: "fill-white",
                width: 20,
                height: 20,
                fillColor: "#fff"
            }),
            text: t("ss_builder_edit_product_group_label")
        },
        {
            key: GroupActions.VISIBLE_HIDE_GROUP,
            icon: isEnable === 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* EyeVisibleIcon */.m0, {
                className: "fill-white",
                width: 20,
                height: 20
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* EyeHiddenIcon */.Fl, {
                className: "fill-white",
                width: 20,
                height: 20
            }),
            text: isEnable === 1 ? t("ss_builder_hide_product_group_label") : t("ss_builder_show_product_group_label")
        },
        {
            key: GroupActions.DELETE_GROUP,
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* DeleteIcon */.pJ, {
                className: "fill-white",
                width: 20,
                height: 20,
                fillColor: "#fff"
            }),
            text: t("ss_builder_delete_product_group_label")
        }, 
    ];
    var handleClickPopoverItem = function(item) {
        var key = item === null || item === void 0 ? void 0 : item.key;
        switch(key){
            case GroupActions.EDIT_GROUP_NAME:
                onOpenEditGroup();
                break;
            case GroupActions.VISIBLE_HIDE_GROUP:
                var newStatus = isEnable === 1 ? 2 : 1;
                onVisibleGroup(newStatus);
                break;
            case GroupActions.DELETE_GROUP:
                onRemoveGroup();
                break;
            default:
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "sticky top-0 z-[11]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative bg-white",
                style: {
                    boxShadow: "inset 0px -1px 0px #EEEEEE"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* NavBar */.l2, {
                    backArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* BackAngelIcon */.Nz, {}),
                    onBack: onCancel,
                    className: "w-full",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-row text-center items-center justify-center gap-[10px] text-[13px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-ellipsis whitespace-nowrap overflow-hidden max-w-[70vw] md:max-w-[20vw] text-titleFontSize",
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute right-4 flex items-center justify-center gap-[8px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "relative",
                                    ref: popoverContainerRef,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Popover.Menu */.J2.Menu, {
                                        mode: "dark",
                                        actions: actions,
                                        placement: "bottom-end",
                                        trigger: "click",
                                        stopPropagation: [
                                            "click"
                                        ],
                                        getContainer: function() {
                                            return popoverContainerRef.current;
                                        },
                                        onAction: function(item) {
                                            return handleClickPopoverItem(item);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* MoreIcon */.nX, {
                                            className: "fill-black cursor-pointer"
                                        })
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            isEnable !== 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bg-[#FFF3E9] flex justify-center items-center p-2 gap-[10px]",
                style: {
                    borderWidth: "1px 0px",
                    borderStyle: "solid",
                    borderColor: "#FFF3E9"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* EyeVisibleIcon */.m0, {
                        className: "align-middle inline-block fill-black",
                        fillColor: "#FF6010",
                        width: 18,
                        height: 18
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-[#FF6010]",
                        children: t("ss_builder_group_is_hiding_label")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ProductGroupQuickEdit_HeaderComponent = (HeaderComponent);

;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockAffiliateProductGroup/ProductListOfGroupDisplay/GroupTitleComponent/ProductGroupQuickEdit/index.tsx
function ProductGroupQuickEdit_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function ProductGroupQuickEdit_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function ProductGroupQuickEdit_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function ProductGroupQuickEdit_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                ProductGroupQuickEdit_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                ProductGroupQuickEdit_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function ProductGroupQuickEdit_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ProductGroupQuickEdit_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function ProductGroupQuickEdit_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ProductGroupQuickEdit_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ProductGroupQuickEdit_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ProductGroupQuickEdit_slicedToArray(arr, i) {
    return ProductGroupQuickEdit_arrayWithHoles(arr) || ProductGroupQuickEdit_iterableToArrayLimit(arr, i) || ProductGroupQuickEdit_unsupportedIterableToArray(arr, i) || ProductGroupQuickEdit_nonIterableRest();
}
function ProductGroupQuickEdit_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return ProductGroupQuickEdit_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ProductGroupQuickEdit_arrayLikeToArray(o, minLen);
}
















var ProductGroupQuickEdit = function(props) {
    var ref5;
    var affiliateProductGroupData = props.affiliateProductGroupData, activeProductGroup = props.activeProductGroup, productGroupMaximum = props.productGroupMaximum, onCancelProductGroupQuickEdit = props.onCancelProductGroupQuickEdit, blockData = props.blockData, positionSlug = props.positionSlug, tabUid = props.tabUid, isCreatedNew = props.isCreatedNew, _onGetLatestBlockData = props.onGetLatestBlockData, onGetLatestBlockData = _onGetLatestBlockData === void 0 ? function() {} : _onGetLatestBlockData;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var SuccessToast = (0,toast/* useToast */.p)().SuccessToast;
    var ref1 = (0,modal/* useModal */.dd)(), ErrorModal = ref1.ErrorModal, ConfirmModal = ref1.ConfirmModal;
    var dispatch = (0,hooks/* useAppDispatch */.TL)();
    var siteSettings = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.siteSettings;
    });
    var extraData = {
        user_id: siteSettings.user_id
    };
    var stickyRef = (0,react.useRef)(null);
    var ref2 = (0,react.useState)(false), isSticky = ref2[0], setIsSticky = ref2[1];
    var ref3 = (0,react.useState)(affiliateProductGroupData), newProductGroupData = ref3[0], setNewProductGroupData = ref3[1];
    var ref4 = (0,react.useState)(false), isOpenGroupAddNew = ref4[0], setIsOpenGroupAddNew = ref4[1];
    var affiliateProductGroupListEnable = (0,react.useMemo)(function() {
        return newProductGroupData === null || newProductGroupData === void 0 ? void 0 : newProductGroupData.filter(function(x) {
            return x.enable === 1;
        });
    }, [
        newProductGroupData
    ]);
    var activedProductGroupData = (0,react.useMemo)(function() {
        return newProductGroupData === null || newProductGroupData === void 0 ? void 0 : newProductGroupData.find(function(x) {
            return x.uid === activeProductGroup;
        });
    }, [
        newProductGroupData,
        activeProductGroup
    ]);
    (0,react.useEffect)(function() {
        if (affiliateProductGroupData) setNewProductGroupData(affiliateProductGroupData);
    }, [
        affiliateProductGroupData
    ]);
    (0,react.useEffect)(function() {
        var ref = stickyRef.current;
        var observer = new IntersectionObserver(function(param) {
            var _param = ProductGroupQuickEdit_slicedToArray(param, 1), e = _param[0];
            setIsSticky(e.intersectionRatio < 1);
        }, {
            threshold: [
                1
            ]
        });
        if (ref) observer.observe(ref);
        return function() {
            return observer.unobserve(ref);
        };
    }, [
        stickyRef
    ]);
    var stickyTop = (activedProductGroupData === null || activedProductGroupData === void 0 ? void 0 : activedProductGroupData.enable) === 1 ? 45 : 82;
    var updateAndCancelGroup = function(data) {
        if (positionSlug) {
            dispatch((0,positionsSlice/* updateBlock */.Df)({
                tabUid: tabUid,
                positionSlug: positionSlug,
                blockData: data
            }));
        }
        onGetLatestBlockData(data);
        onCancelProductGroupQuickEdit();
    };
    var handleSave = function() {
        var _ref = ProductGroupQuickEdit_asyncToGenerator(runtime_default().mark(function _callee() {
            var newDataAffiliateProduct, newData;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        newDataAffiliateProduct = ProductGroupQuickEdit_objectSpread({}, blockData, {
                            content_attributes: ProductGroupQuickEdit_objectSpread({}, blockData.content_attributes, {
                                items: newProductGroupData,
                                is_created_new: isCreatedNew
                            })
                        });
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return (0,block_conf/* requestPostLinkMiddlewareV2 */.lO)(newDataAffiliateProduct, extraData);
                    case 4:
                        newData = _ctx.sent;
                        if (newData) {
                            updateAndCancelGroup(newData);
                        }
                        _ctx.next = 12;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](1);
                        dispatch((0,dynamicSlice/* setDynamicParams */.B9)({
                            data: {
                                isErrorNetwork: true
                            }
                        }));
                        return _ctx.abrupt("return");
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    8
                ]
            ]);
        }));
        return function handleSave() {
            return _ref.apply(this, arguments);
        };
    }();
    var isDisableSaveBtn = (0,react.useMemo)(function() {
        return !!(JSON.stringify(newProductGroupData) === JSON.stringify(affiliateProductGroupData));
    }, [
        affiliateProductGroupData,
        newProductGroupData
    ]);
    var handleRemoveGroup = function() {
        var newGroupData = newProductGroupData === null || newProductGroupData === void 0 ? void 0 : newProductGroupData.filter(function(x) {
            return (x === null || x === void 0 ? void 0 : x.uid) !== activedProductGroupData.uid;
        });
        if (affiliateProductGroupListEnable.length <= 1 && (activedProductGroupData === null || activedProductGroupData === void 0 ? void 0 : activedProductGroupData.enable) === 1) {
            var ref;
            ErrorModal({
                title: t("ss_builder_delete_product_group_error_title"),
                icon: modal/* ModalIconConfig.INFO_WARNING_TRIANGLE */.vi.INFO_WARNING_TRIANGLE,
                description: t("ss_builder_delete_product_group_error_content", {
                    group_name: activedProductGroupData === null || activedProductGroupData === void 0 ? void 0 : (ref = activedProductGroupData.content_attributes) === null || ref === void 0 ? void 0 : ref.title_product_group
                }),
                confirmText: t("ss_builder_delete_product_group_error_btn_confirm_label")
            });
        } else {
            var ref6;
            var onConfirm = function() {
                var newDataAffiliateProduct = ProductGroupQuickEdit_objectSpread({}, blockData, {
                    content_attributes: ProductGroupQuickEdit_objectSpread({}, blockData.content_attributes, {
                        items: newGroupData,
                        is_created_new: isCreatedNew
                    })
                });
                updateAndCancelGroup(newDataAffiliateProduct);
                SuccessToast(t("ss_builder_delete_product_group_successfully_label"));
            };
            ConfirmModal({
                title: t("ss_builder_confirm_delete_product_group_modal_title"),
                description: t("ss_builder_confirm_delete_product_group_modal_description", {
                    group_name: activedProductGroupData === null || activedProductGroupData === void 0 ? void 0 : (ref6 = activedProductGroupData.content_attributes) === null || ref6 === void 0 ? void 0 : ref6.title_product_group
                }),
                confirmText: t("ss_builder_confirm_delete_product_label"),
                cancelText: t("ss_builder_cancel_delete_product_label"),
                onConfirm: onConfirm
            });
        }
    };
    var handleVisibleGroup = function(status) {
        var newGroupData = newProductGroupData === null || newProductGroupData === void 0 ? void 0 : newProductGroupData.map(function(ele) {
            return (ele === null || ele === void 0 ? void 0 : ele.uid) === activedProductGroupData.uid ? ProductGroupQuickEdit_objectSpread({}, ele, {
                enable: status
            }) : ele;
        });
        if ((activedProductGroupData === null || activedProductGroupData === void 0 ? void 0 : activedProductGroupData.enable) !== 1) {
            setNewProductGroupData(newGroupData);
            SuccessToast(t("ss_builder_enable_product_group_successfully_label"));
        } else {
            if (affiliateProductGroupListEnable.length >= 2) {
                var ref;
                var onConfirm = function() {
                    setNewProductGroupData(newGroupData);
                    SuccessToast(t("ss_builder_disable_product_group_successfully_label"));
                };
                ConfirmModal({
                    title: t("ss_builder_confirm_hide_product_group_modal_title"),
                    description: t("ss_builder_confirm_hide_product_group_modal_description", {
                        group_name: activedProductGroupData === null || activedProductGroupData === void 0 ? void 0 : (ref = activedProductGroupData.content_attributes) === null || ref === void 0 ? void 0 : ref.title_product_group
                    }),
                    confirmText: t("ss_builder_confirm_hide_product_label"),
                    cancelText: t("ss_builder_cancel_hide_product_label"),
                    onConfirm: onConfirm
                });
            } else {
                var ref7;
                ErrorModal({
                    title: t("ss_builder_hide_product_group_error_title"),
                    description: t("ss_builder_hide_product_group_error_content", {
                        group_name: activedProductGroupData === null || activedProductGroupData === void 0 ? void 0 : (ref7 = activedProductGroupData.content_attributes) === null || ref7 === void 0 ? void 0 : ref7.title_product_group
                    }),
                    confirmText: t("ss_builder_hide_product_group_error_btn_confirm_label")
                });
            }
        }
    };
    var handleAddNewProductGroup = function(data) {
        var ref;
        var newTitle = (data === null || data === void 0 ? void 0 : (ref = data.content_attributes) === null || ref === void 0 ? void 0 : ref.title_product_group) || (data === null || data === void 0 ? void 0 : data.title);
        var newGroupData = newProductGroupData === null || newProductGroupData === void 0 ? void 0 : newProductGroupData.map(function(ele) {
            return (ele === null || ele === void 0 ? void 0 : ele.uid) === (data === null || data === void 0 ? void 0 : data.uid) ? ProductGroupQuickEdit_objectSpread({}, ele, {
                title: newTitle,
                content_attributes: ProductGroupQuickEdit_objectSpread({}, ele.content_attributes, {
                    title_product_group: newTitle
                })
            }) : ele;
        });
        setNewProductGroupData(newGroupData);
        setIsOpenGroupAddNew(false);
        SuccessToast(t("ss_builder_change_name_product_group_successfully_label"));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductGroupQuickEdit_HeaderComponent, {
                onCancel: onCancelProductGroupQuickEdit,
                title: activedProductGroupData === null || activedProductGroupData === void 0 ? void 0 : (ref5 = activedProductGroupData.content_attributes) === null || ref5 === void 0 ? void 0 : ref5.title_product_group,
                isEnable: activedProductGroupData === null || activedProductGroupData === void 0 ? void 0 : activedProductGroupData.enable,
                groupId: activedProductGroupData.uid,
                onRemoveGroup: handleRemoveGroup,
                onVisibleGroup: handleVisibleGroup,
                onOpenEditGroup: function() {
                    return setIsOpenGroupAddNew(true);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute w-full z-[9] top-0 left-0",
                ref: stickyRef,
                style: {
                    height: "".concat(stickyTop, "px")
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pb-[65px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductListLayoutHandler/* default */.Z, {
                    affiliateProductGroupData: newProductGroupData,
                    activeProductGroup: activeProductGroup,
                    onUpdateProductGroupData: function(data) {
                        return setNewProductGroupData(data);
                    },
                    isSticky: isSticky,
                    productGroupMaximum: productGroupMaximum,
                    stickyTop: stickyTop
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ButtonSavingGroup, {
                onCancel: onCancelProductGroupQuickEdit,
                onSave: handleSave,
                saveLabel: t("ss_builder_editor_btn-save"),
                cancelLabel: t("ss_builder_editor_btn-cancel"),
                disabled: isDisableSaveBtn
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupComponent/* default */.Z, {
                visible: isOpenGroupAddNew,
                // onMaskClick={() => setIsOpenGroupAddNew(false)}
                title: t("ss_builder_add_new_affiliate_product_group_btn_label"),
                onClose: function() {
                    return setIsOpenGroupAddNew(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AffiliateProductGroupAddNew/* default */.Z, {
                    onCancelAffiliateProductGroupAddNew: function() {
                        return setIsOpenGroupAddNew(false);
                    },
                    affiliateProductGroupDefault: activedProductGroupData,
                    onSaveAffiliateProductGroupAddNew: handleAddNewProductGroup,
                    affiliateProductGroupList: affiliateProductGroupData
                })
            })
        ]
    });
};
/* harmony default export */ var GroupTitleComponent_ProductGroupQuickEdit = (ProductGroupQuickEdit);

;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockAffiliateProductGroup/ProductListOfGroupDisplay/GroupTitleComponent/QuickActionsComponent/index.tsx
function QuickActionsComponent_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function QuickActionsComponent_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function QuickActionsComponent_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function QuickActionsComponent_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function QuickActionsComponent_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function QuickActionsComponent_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            QuickActionsComponent_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function QuickActionsComponent_slicedToArray(arr, i) {
    return QuickActionsComponent_arrayWithHoles(arr) || QuickActionsComponent_iterableToArrayLimit(arr, i) || QuickActionsComponent_unsupportedIterableToArray(arr, i) || QuickActionsComponent_nonIterableRest();
}
function QuickActionsComponent_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return QuickActionsComponent_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return QuickActionsComponent_arrayLikeToArray(o, minLen);
}













var GroupActions;
(function(GroupActions) {
    GroupActions["VISIBLE_HIDE_GROUP"] = "visible-hide-group";
    GroupActions["MOVE_UP_GROUP"] = "move-up-group";
    GroupActions["MOVE_DOWN_GROUP"] = "move-down-group";
    GroupActions["EDIT_GROUP"] = "edit-group";
    GroupActions["EDIT_GROUP_NAME"] = "edit-group-name";
    GroupActions["DELETE_GROUP"] = "delete-group";
})(GroupActions || (GroupActions = {}));
var GroupVisibleHidden;
(function(GroupVisibleHidden) {
    GroupVisibleHidden[GroupVisibleHidden["VISIBLE"] = 1] = "VISIBLE";
    GroupVisibleHidden[GroupVisibleHidden["HIDDEN"] = 2] = "HIDDEN";
})(GroupVisibleHidden || (GroupVisibleHidden = {}));
var QuickActionsComponent = function(param) {
    var groupItem = param.groupItem, productGroupId = param.productGroupId, affiliateProductGroupData = param.affiliateProductGroupData, productGroupMaximum = param.productGroupMaximum, blockData = param.blockData, positionSlug = param.positionSlug, tabUid = param.tabUid, isCreatedNew = param.isCreatedNew, _onGetLatestBlockData = param.onGetLatestBlockData, onGetLatestBlockData = _onGetLatestBlockData === void 0 ? function(data) {} : _onGetLatestBlockData;
    var popoverContainerRef = (0,react.useRef)(null);
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var dispatch = (0,hooks/* useAppDispatch */.TL)();
    var ref3 = (0,modal/* useModal */.dd)(), ErrorModal = ref3.ErrorModal, ConfirmModal = ref3.ConfirmModal;
    var SuccessToast = (0,toast/* useToast */.p)().SuccessToast;
    var ref1 = (0,react.useState)(false), isOpenGroupEdit = ref1[0], setIsOpenGroupEdit = ref1[1];
    var ref2 = (0,react.useState)(false), isOpenAddNewProductGroup = ref2[0], setIsOpenAddNewProductGroup = ref2[1];
    var isEnable = groupItem === null || groupItem === void 0 ? void 0 : groupItem.enable;
    var groupIndex = affiliateProductGroupData === null || affiliateProductGroupData === void 0 ? void 0 : affiliateProductGroupData.findIndex(function(x) {
        return (x === null || x === void 0 ? void 0 : x.uid) === (groupItem === null || groupItem === void 0 ? void 0 : groupItem.uid);
    });
    var affiliateProductGroupListEnable = (0,react.useMemo)(function() {
        return affiliateProductGroupData === null || affiliateProductGroupData === void 0 ? void 0 : affiliateProductGroupData.filter(function(x) {
            return (x === null || x === void 0 ? void 0 : x.enable) === 1;
        });
    }, [
        JSON.stringify(affiliateProductGroupData)
    ]);
    var actions = [
        {
            key: GroupActions.EDIT_GROUP,
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* EditTabIcon */.jJ, {
                className: "fill-white",
                width: 20,
                height: 20,
                fillColor: "#fff"
            }),
            text: t("ss_builder_edit_block_label")
        },
        {
            key: GroupActions.MOVE_UP_GROUP,
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ArrowUp */.a2, {
                className: "fill-white",
                width: 20,
                height: 20,
                fillColor: "#fff"
            }),
            text: t("ss_builder_move_up_block_label")
        },
        {
            key: GroupActions.MOVE_DOWN_GROUP,
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ArrowDown */.K5, {
                className: "fill-white",
                width: 20,
                height: 20,
                fillColor: "#fff"
            }),
            text: t("ss_builder_move_down_block_label")
        },
        {
            key: GroupActions.VISIBLE_HIDE_GROUP,
            icon: isEnable === GroupVisibleHidden.VISIBLE ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* EyeVisibleIcon */.m0, {
                className: "fill-white",
                width: 20,
                height: 20
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* EyeHiddenIcon */.Fl, {
                className: "fill-white",
                width: 20,
                height: 20
            }),
            text: isEnable === GroupVisibleHidden.VISIBLE ? t("ss_builder_hide_product_group_label") : t("ss_builder_show_product_group_label")
        },
        {
            key: GroupActions.EDIT_GROUP_NAME,
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* LineRename */.cR, {
                className: "fill-white",
                width: 20,
                height: 20,
                fillColor: "#fff"
            }),
            text: t("ss_builder_edit_product_group_label")
        },
        {
            key: GroupActions.DELETE_GROUP,
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* DeleteIcon */.pJ, {
                className: "fill-white",
                width: 20,
                height: 20,
                fillColor: "#fff"
            }),
            text: t("ss_builder_delete_product_group_label")
        }, 
    ];
    var handleClickPopoverItem = function(item) {
        var key = item === null || item === void 0 ? void 0 : item.key;
        switch(key){
            case GroupActions.EDIT_GROUP:
                onEditGroup();
                break;
            case GroupActions.MOVE_UP_GROUP:
                onMoveGroup("up");
                break;
            case GroupActions.MOVE_DOWN_GROUP:
                onMoveGroup("down");
                break;
            case GroupActions.VISIBLE_HIDE_GROUP:
                var newStatus = isEnable === 1 ? 2 : 1;
                onVisibleHideGroup(newStatus);
                break;
            case GroupActions.EDIT_GROUP_NAME:
                onEditGroupName();
                break;
            case GroupActions.DELETE_GROUP:
                onRemoveGroup();
                break;
        }
    };
    var onEditGroup = function() {
        setIsOpenGroupEdit(true);
    };
    var actionsFilter = (0,react.useMemo)(function() {
        var actionsClone = actions;
        if (groupIndex === 0) {
            actionsClone = actionsClone === null || actionsClone === void 0 ? void 0 : actionsClone.filter(function(x) {
                return (x === null || x === void 0 ? void 0 : x.key) !== GroupActions.MOVE_UP_GROUP;
            });
        }
        if (groupIndex === (affiliateProductGroupData === null || affiliateProductGroupData === void 0 ? void 0 : affiliateProductGroupData.length) - 1) {
            actionsClone = actionsClone === null || actionsClone === void 0 ? void 0 : actionsClone.filter(function(x) {
                return (x === null || x === void 0 ? void 0 : x.key) !== GroupActions.MOVE_DOWN_GROUP;
            });
        }
        if ((affiliateProductGroupData === null || affiliateProductGroupData === void 0 ? void 0 : affiliateProductGroupData.length) <= 1) {
            actionsClone = actionsClone === null || actionsClone === void 0 ? void 0 : actionsClone.filter(function(x) {
                return (x === null || x === void 0 ? void 0 : x.key) === GroupActions.EDIT_GROUP || (x === null || x === void 0 ? void 0 : x.key) === GroupActions.EDIT_GROUP_NAME || (x === null || x === void 0 ? void 0 : x.key) === GroupActions.VISIBLE_HIDE_GROUP;
            });
        }
        return actionsClone;
    }, [
        groupIndex,
        actions
    ]);
    var handleUpdateBlock = function(data) {
        var newDataAffiliateProduct = QuickActionsComponent_objectSpread({}, blockData, {
            content_attributes: QuickActionsComponent_objectSpread({}, blockData.content_attributes, {
                items: data,
                is_created_new: isCreatedNew
            })
        });
        if (positionSlug) {
            dispatch((0,positionsSlice/* updateBlock */.Df)({
                tabUid: tabUid,
                positionSlug: positionSlug,
                blockData: newDataAffiliateProduct
            }));
        }
        onGetLatestBlockData(newDataAffiliateProduct);
    };
    var onMoveGroup = function(action) {
        var startIndex = groupIndex;
        var endIndex = action === "down" ? startIndex + 1 : startIndex - 1;
        if (endIndex < 0 || startIndex === endIndex) {
            return;
        }
        var itemsOrder = reorder(startIndex, endIndex);
        handleUpdateBlock(itemsOrder);
    };
    var reorder = function(startIndex, endIndex) {
        var result = Array.from(affiliateProductGroupData);
        var ref = QuickActionsComponent_slicedToArray(result.splice(startIndex, 1), 1), removed = ref[0];
        result.splice(endIndex, 0, removed);
        var orderedBlockList = result.map(function(ele, idx) {
            return QuickActionsComponent_objectSpread({}, ele, {
                sort_order: idx + 1
            });
        });
        return orderedBlockList;
    };
    var onVisibleHideGroup = function(status) {
        var newGroupData = affiliateProductGroupData === null || affiliateProductGroupData === void 0 ? void 0 : affiliateProductGroupData.map(function(ele) {
            return (ele === null || ele === void 0 ? void 0 : ele.uid) === (groupItem === null || groupItem === void 0 ? void 0 : groupItem.uid) ? QuickActionsComponent_objectSpread({}, ele, {
                enable: status
            }) : ele;
        });
        if (isEnable !== 1) {
            handleUpdateBlock(newGroupData);
            SuccessToast(t("ss_builder_enable_product_group_successfully_label"));
        } else {
            if (affiliateProductGroupListEnable.length >= 2) {
                var ref;
                var onConfirm = function() {
                    handleUpdateBlock(newGroupData);
                    SuccessToast(t("ss_builder_disable_product_group_successfully_label"));
                };
                ConfirmModal({
                    title: t("ss_builder_confirm_hide_product_group_modal_title"),
                    description: t("ss_builder_confirm_hide_product_group_modal_description", {
                        group_name: groupItem === null || groupItem === void 0 ? void 0 : (ref = groupItem.content_attributes) === null || ref === void 0 ? void 0 : ref.title_product_group
                    }),
                    confirmText: t("ss_builder_confirm_hide_product_label"),
                    cancelText: t("ss_builder_cancel_hide_product_label"),
                    onConfirm: onConfirm
                });
            } else {
                var ref4;
                ErrorModal({
                    title: t("ss_builder_hide_product_group_error_title"),
                    description: t("ss_builder_hide_product_group_error_content", {
                        group_name: groupItem === null || groupItem === void 0 ? void 0 : (ref4 = groupItem.content_attributes) === null || ref4 === void 0 ? void 0 : ref4.title_product_group
                    }),
                    confirmText: t("ss_builder_hide_product_group_error_btn_confirm_label")
                });
            }
        }
    };
    var onRemoveGroup = function() {
        var newGroupData = affiliateProductGroupData === null || affiliateProductGroupData === void 0 ? void 0 : affiliateProductGroupData.filter(function(x) {
            return (x === null || x === void 0 ? void 0 : x.uid) !== groupItem.uid;
        });
        if (affiliateProductGroupListEnable.length <= 1 && isEnable === 1) {
            var ref;
            ErrorModal({
                title: t("ss_builder_delete_product_group_error_title"),
                description: t("ss_builder_delete_product_group_error_content", {
                    group_name: groupItem === null || groupItem === void 0 ? void 0 : (ref = groupItem.content_attributes) === null || ref === void 0 ? void 0 : ref.title_product_group
                }),
                confirmText: t("ss_builder_delete_product_group_error_btn_confirm_label")
            });
        } else {
            var ref5;
            var onConfirm = function() {
                handleUpdateBlock(newGroupData);
                SuccessToast(t("ss_builder_delete_product_group_successfully_label"));
            };
            ConfirmModal({
                title: t("ss_builder_confirm_delete_product_group_modal_title"),
                description: t("ss_builder_confirm_delete_product_group_modal_description", {
                    group_name: groupItem === null || groupItem === void 0 ? void 0 : (ref5 = groupItem.content_attributes) === null || ref5 === void 0 ? void 0 : ref5.title_product_group
                }),
                confirmText: t("ss_builder_confirm_delete_product_label"),
                cancelText: t("ss_builder_cancel_delete_product_label"),
                onConfirm: onConfirm
            });
        }
    };
    var onEditGroupName = function() {
        setIsOpenAddNewProductGroup(true);
    };
    var handleEditGroup = function(data) {
        var newGroupData = affiliateProductGroupData === null || affiliateProductGroupData === void 0 ? void 0 : affiliateProductGroupData.map(function(ele) {
            return (ele === null || ele === void 0 ? void 0 : ele.uid) === (data === null || data === void 0 ? void 0 : data.uid) ? data : ele;
        });
        handleUpdateBlock(newGroupData);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: popoverContainerRef,
        onClick: function(e) {
            return e.stopPropagation();
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Popover.Menu */.J2.Menu, {
                mode: "dark",
                actions: actionsFilter,
                placement: "bottom-end",
                trigger: "click",
                stopPropagation: [
                    "click"
                ],
                getContainer: function() {
                    return document.querySelector(".design-content-class");
                },
                onAction: function(item) {
                    return handleClickPopoverItem(item);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                    size: "mini",
                    style: {
                        border: "1px solid #EEEEEE",
                        borderRadius: "4px",
                        width: "26px",
                        height: "26px",
                        padding: "0px"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* MoreIcon */.nX, {
                        className: "fill-black m-auto",
                        width: 13,
                        height: 13
                    })
                })
            }),
            isOpenGroupEdit && /*#__PURE__*/ (0,jsx_runtime.jsx)(full_screen_popup/* default */.Z, {
                visible: isOpenGroupEdit,
                onMaskClick: function() {
                    return setIsOpenGroupEdit(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GroupTitleComponent_ProductGroupQuickEdit, {
                    onCancelProductGroupQuickEdit: function() {
                        return setIsOpenGroupEdit(false);
                    },
                    affiliateProductGroupData: affiliateProductGroupData,
                    activeProductGroup: productGroupId || groupItem.uid,
                    blockData: blockData,
                    productGroupMaximum: productGroupMaximum,
                    positionSlug: positionSlug,
                    tabUid: tabUid,
                    isCreatedNew: isCreatedNew,
                    onGetLatestBlockData: onGetLatestBlockData
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupComponent/* default */.Z, {
                visible: isOpenAddNewProductGroup,
                // onMaskClick={() => setIsOpenAddNewProductGroup(false)}
                title: t("ss_builder_edit_name_affiliate_product_group_title"),
                onClose: function() {
                    return setIsOpenAddNewProductGroup(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AffiliateProductGroupAddNew/* default */.Z, {
                    onCancelAffiliateProductGroupAddNew: function() {
                        return setIsOpenAddNewProductGroup(false);
                    },
                    affiliateProductGroupDefault: groupItem,
                    onSaveAffiliateProductGroupAddNew: handleEditGroup,
                    affiliateProductGroupList: affiliateProductGroupData
                })
            })
        ]
    });
};
/* harmony default export */ var GroupTitleComponent_QuickActionsComponent = (QuickActionsComponent);

;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockAffiliateProductGroup/ProductListOfGroupDisplay/GroupTitleComponent/index.tsx
function GroupTitleComponent_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function GroupTitleComponent_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return GroupTitleComponent_arrayLikeToArray(arr);
}
function GroupTitleComponent_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function GroupTitleComponent_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function GroupTitleComponent_toConsumableArray(arr) {
    return GroupTitleComponent_arrayWithoutHoles(arr) || GroupTitleComponent_iterableToArray(arr) || GroupTitleComponent_unsupportedIterableToArray(arr) || GroupTitleComponent_nonIterableSpread();
}
function GroupTitleComponent_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return GroupTitleComponent_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return GroupTitleComponent_arrayLikeToArray(o, minLen);
}







var GroupTitleComponent = function(props) {
    var ref1;
    var productGroupId = props.productGroupId, affiliateProductGroupData = props.affiliateProductGroupData, groupItem = props.groupItem, productGroupMaximum = props.productGroupMaximum, blockData = props.blockData, positionSlug = props.positionSlug, tabUid = props.tabUid, isCreatedNew = props.isCreatedNew, onAddNewProduct = props.onAddNewProduct, _onGetLatestBlockData = props.onGetLatestBlockData, onGetLatestBlockData = _onGetLatestBlockData === void 0 ? function() {} : _onGetLatestBlockData;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var title = groupItem === null || groupItem === void 0 ? void 0 : (ref1 = groupItem.content_attributes) === null || ref1 === void 0 ? void 0 : ref1.title_product_group;
    var isFulledProductsAllGroups = (0,react.useMemo)(function() {
        var existedProductArr = [];
        affiliateProductGroupData.forEach(function(x) {
            var ref;
            var affiliateProductArr = (x === null || x === void 0 ? void 0 : (ref = x.content_attributes) === null || ref === void 0 ? void 0 : ref.items) || [];
            existedProductArr = GroupTitleComponent_toConsumableArray(existedProductArr).concat(GroupTitleComponent_toConsumableArray(affiliateProductArr));
        });
        return !!((existedProductArr === null || existedProductArr === void 0 ? void 0 : existedProductArr.length) >= configs_const/* MAX_PRODUCTS_ALL_GROUPS */.A);
    }, [
        JSON.stringify(affiliateProductGroupData)
    ]);
    var isAllowedToAddProducts = (0,react.useMemo)(function() {
        var ref, ref2, ref3, ref4;
        return productGroupId ? ((ref4 = (ref = affiliateProductGroupData === null || affiliateProductGroupData === void 0 ? void 0 : affiliateProductGroupData.find(function(x) {
            return (x === null || x === void 0 ? void 0 : x.uid) === productGroupId;
        })) === null || ref === void 0 ? void 0 : (ref2 = ref.content_attributes) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.items) === null || ref3 === void 0 ? void 0 : ref3.filter(function(y) {
            return (y === null || y === void 0 ? void 0 : y.is_cleanup_lock) === 1;
        })) === null || ref4 === void 0 ? void 0 : ref4.length) < configs_const/* PRODUCT_MAX */.Kh : true;
    }, [
        productGroupId,
        JSON.stringify(affiliateProductGroupData)
    ]);
    var isDisableAddProductBtn = !!(isFulledProductsAllGroups || !isAllowedToAddProducts);
    var isEnabled = (groupItem === null || groupItem === void 0 ? void 0 : groupItem.enable) === 1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-row items-center justify-between mb-3",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                    style: {
                        color: "var(--heading-color-6)",
                        opacity: !isEnabled ? "60%" : ""
                    },
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-row gap-2 items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* Button */.zx, {
                            size: "mini",
                            style: {
                                backgroundColor: "#2563EB",
                                borderRadius: "4px",
                                color: "#FFFFFF",
                                border: "1px solid #2563EB",
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: "4px",
                                opacity: isDisableAddProductBtn ? "40%" : "",
                                height: "26px",
                                padding: "3px 8px"
                            },
                            onClick: onAddNewProduct,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* AddIcon */.T8, {
                                    className: "w-[13px] h-[13px]"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: t("ss_builder_add_new_label")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GroupTitleComponent_QuickActionsComponent, {
                            groupItem: groupItem,
                            productGroupId: productGroupId,
                            affiliateProductGroupData: affiliateProductGroupData,
                            productGroupMaximum: productGroupMaximum,
                            blockData: blockData,
                            positionSlug: positionSlug,
                            tabUid: tabUid,
                            isCreatedNew: isCreatedNew,
                            onGetLatestBlockData: onGetLatestBlockData
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var ProductListOfGroupDisplay_GroupTitleComponent = (GroupTitleComponent);

;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockAffiliateProductGroup/ProductListOfGroupDisplay/index.tsx
function ProductListOfGroupDisplay_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function ProductListOfGroupDisplay_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                ProductListOfGroupDisplay_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                ProductListOfGroupDisplay_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function ProductListOfGroupDisplay_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ProductListOfGroupDisplay_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ProductListOfGroupDisplay_defineProperty(target, key, source[key]);
        });
    }
    return target;
}











var ProductListOfGroupDisplay = function(props) {
    var id = props.id, item = props.item, affiliateProductGroupData = props.affiliateProductGroupData, blockData = props.blockData, tabUid = props.tabUid, positionSlug = props.positionSlug, isCreatedNew = props.isCreatedNew, productGroupId1 = props.productGroupId, productGroupMaximum = props.productGroupMaximum, onUpdateProductGroupId = props.onUpdateProductGroupId, onUpdateProductGroupData = props.onUpdateProductGroupData, _onGetLatestBlockData = props.onGetLatestBlockData, onGetLatestBlockData = _onGetLatestBlockData === void 0 ? function() {} : _onGetLatestBlockData;
    var dispatch = (0,hooks/* useAppDispatch */.TL)();
    var siteSettings = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.siteSettings;
    });
    var extraData = {
        user_id: siteSettings.user_id
    };
    var ref = (0,react.useState)(false), isOpenAddNewProduct = ref[0], setIsOpenAddNewProduct = ref[1];
    var ref1 = (0,react.useState)(null), activeProductGroup = ref1[0], setActiveProductGroup = ref1[1];
    var content_attributes = blockData === null || blockData === void 0 ? void 0 : blockData.content_attributes;
    var style_attributes = blockData === null || blockData === void 0 ? void 0 : blockData.style_attributes;
    var see_more_btn_content = content_attributes.see_more_btn_content;
    var handleOpenAddAffiliateProduct = function(e) {
        e.stopPropagation();
        setActiveProductGroup(function() {
            return item === null || item === void 0 ? void 0 : item.uid;
        });
        setIsOpenAddNewProduct(function() {
            return true;
        });
    };
    var handleSaveAffiliateProductAddNew = function() {
        var _ref = ProductListOfGroupDisplay_asyncToGenerator(runtime_default().mark(function _callee(data, activedProductGroup) {
            var newDataAffiliateProduct, newData;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        newDataAffiliateProduct = ProductListOfGroupDisplay_objectSpread({}, blockData, {
                            content_attributes: ProductListOfGroupDisplay_objectSpread({}, blockData.content_attributes, {
                                items: data,
                                is_created_new: isCreatedNew
                            })
                        });
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return (0,block_conf/* requestPostLinkMiddlewareV2 */.lO)(newDataAffiliateProduct, extraData);
                    case 4:
                        newData = _ctx.sent;
                        if (newData) {
                            activedProductGroup && onUpdateProductGroupId(activedProductGroup);
                            if (positionSlug) {
                                dispatch((0,positionsSlice/* updateBlock */.Df)({
                                    tabUid: tabUid,
                                    positionSlug: positionSlug,
                                    blockData: newData
                                }));
                            }
                            onGetLatestBlockData(newData);
                            setIsOpenAddNewProduct(false);
                        }
                        _ctx.next = 12;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](1);
                        dispatch((0,dynamicSlice/* setDynamicParams */.B9)({
                            data: {
                                isErrorNetwork: true
                            }
                        }));
                        return _ctx.abrupt("return");
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    8
                ]
            ]);
        }));
        return function handleSaveAffiliateProductAddNew(data, activedProductGroup) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleAddNewAffiliateProductGroup = function(data, productGroupId) {
        var newDataAffiliateProduct = ProductListOfGroupDisplay_objectSpread({}, blockData, {
            content_attributes: ProductListOfGroupDisplay_objectSpread({}, blockData.content_attributes, {
                items: data,
                is_created_new: isCreatedNew
            })
        });
        onUpdateProductGroupId(productGroupId);
        if (positionSlug) {
            dispatch((0,positionsSlice/* updateBlock */.Df)({
                tabUid: tabUid,
                positionSlug: positionSlug,
                blockData: newDataAffiliateProduct
            }));
        }
        onGetLatestBlockData(newDataAffiliateProduct);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: id,
        className: "mt-5",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductListOfGroupDisplay_GroupTitleComponent, {
                groupItem: item,
                onAddNewProduct: handleOpenAddAffiliateProduct,
                productGroupId: productGroupId1,
                affiliateProductGroupData: affiliateProductGroupData,
                productGroupMaximum: productGroupMaximum,
                blockData: blockData,
                positionSlug: positionSlug,
                tabUid: tabUid,
                isCreatedNew: isCreatedNew,
                onGetLatestBlockData: onGetLatestBlockData
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockAffiliateProductGroup_ProductListsDisplay, {
                productGroupItem: item,
                style_attributes: style_attributes,
                see_more_btn_content: see_more_btn_content,
                affiliateProductGroupData: affiliateProductGroupData,
                onUpdateProductGroupData: onUpdateProductGroupData,
                productGroupMaximum: productGroupMaximum
            }),
            isOpenAddNewProduct && /*#__PURE__*/ (0,jsx_runtime.jsx)(full_screen_popup/* default */.Z, {
                visible: isOpenAddNewProduct,
                onMaskClick: function() {
                    return setIsOpenAddNewProduct(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AffiliateProductAddNew/* default */.Z, {
                    callbackCancelAffiliateProductAddNew: function() {
                        return setIsOpenAddNewProduct(false);
                    },
                    callbackSaveAffiliateProductAddNew: handleSaveAffiliateProductAddNew,
                    affiliateProductGroupData: affiliateProductGroupData,
                    activeProductGroup: activeProductGroup,
                    callbackAddNewAffiliateProductGroup: handleAddNewAffiliateProductGroup,
                    productGroupMaximum: productGroupMaximum
                })
            })
        ]
    });
};
/* harmony default export */ var BlockAffiliateProductGroup_ProductListOfGroupDisplay = (ProductListOfGroupDisplay);

;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockAffiliateProductGroup/AddNewProductButton/index.tsx
function AddNewProductButton_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function AddNewProductButton_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return AddNewProductButton_arrayLikeToArray(arr);
}
function AddNewProductButton_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function AddNewProductButton_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                AddNewProductButton_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                AddNewProductButton_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function AddNewProductButton_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function AddNewProductButton_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function AddNewProductButton_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function AddNewProductButton_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            AddNewProductButton_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function AddNewProductButton_toConsumableArray(arr) {
    return AddNewProductButton_arrayWithoutHoles(arr) || AddNewProductButton_iterableToArray(arr) || AddNewProductButton_unsupportedIterableToArray(arr) || AddNewProductButton_nonIterableSpread();
}
function AddNewProductButton_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return AddNewProductButton_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return AddNewProductButton_arrayLikeToArray(o, minLen);
}













var AddNewProductButton = function(props) {
    var productGroupId1 = props.productGroupId, affiliateProductGroupData = props.affiliateProductGroupData, blockData = props.blockData, positionSlug = props.positionSlug, tabUid = props.tabUid, productGroupMaximum = props.productGroupMaximum, isCreatedNew = props.isCreatedNew, onUpdateProductGroupId = props.onUpdateProductGroupId, _onGetLatestBlockData = props.onGetLatestBlockData, onGetLatestBlockData = _onGetLatestBlockData === void 0 ? function() {} : _onGetLatestBlockData;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var dispatch = (0,hooks/* useAppDispatch */.TL)();
    var siteSettings = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.siteSettings;
    });
    var extraData = {
        user_id: siteSettings.user_id
    };
    var ref1 = (0,react.useState)(false), isOpenAddNewProduct = ref1[0], setIsOpenAddNewProduct = ref1[1];
    var isFulledProductsAllGroups = (0,react.useMemo)(function() {
        var existedProductArr = [];
        affiliateProductGroupData.forEach(function(x) {
            var ref;
            var affiliateProductArr = (x === null || x === void 0 ? void 0 : (ref = x.content_attributes) === null || ref === void 0 ? void 0 : ref.items) || [];
            existedProductArr = AddNewProductButton_toConsumableArray(existedProductArr).concat(AddNewProductButton_toConsumableArray(affiliateProductArr));
        });
        return !!((existedProductArr === null || existedProductArr === void 0 ? void 0 : existedProductArr.length) >= configs_const/* MAX_PRODUCTS_ALL_GROUPS */.A);
    }, [
        JSON.stringify(affiliateProductGroupData)
    ]);
    var isAllowedToAddProducts = (0,react.useMemo)(function() {
        var ref, ref2, ref3, ref4;
        return productGroupId1 ? ((ref4 = (ref = affiliateProductGroupData === null || affiliateProductGroupData === void 0 ? void 0 : affiliateProductGroupData.find(function(x) {
            return (x === null || x === void 0 ? void 0 : x.uid) === productGroupId1;
        })) === null || ref === void 0 ? void 0 : (ref2 = ref.content_attributes) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.items) === null || ref3 === void 0 ? void 0 : ref3.filter(function(y) {
            return (y === null || y === void 0 ? void 0 : y.is_cleanup_lock) === 1;
        })) === null || ref4 === void 0 ? void 0 : ref4.length) < configs_const/* PRODUCT_MAX */.Kh : true;
    }, [
        productGroupId1,
        JSON.stringify(affiliateProductGroupData)
    ]);
    var productRate = (0,react.useMemo)(function() {
        var ref, ref5, ref6;
        var productsLength = (ref = affiliateProductGroupData === null || affiliateProductGroupData === void 0 ? void 0 : affiliateProductGroupData.find(function(x) {
            return (x === null || x === void 0 ? void 0 : x.uid) === productGroupId1;
        })) === null || ref === void 0 ? void 0 : (ref5 = ref.content_attributes) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.items) === null || ref6 === void 0 ? void 0 : ref6.length;
        return "".concat(productsLength < configs_const/* PRODUCT_MAX */.Kh ? productsLength : configs_const/* PRODUCT_MAX */.Kh, "/").concat(configs_const/* PRODUCT_MAX */.Kh);
    }, [
        JSON.stringify(affiliateProductGroupData),
        productGroupId1
    ]);
    var isEnableOpacity = !!(isFulledProductsAllGroups || !isAllowedToAddProducts);
    var handleOpenAddAffiliateProduct = function(e) {
        e.stopPropagation();
        if (isFulledProductsAllGroups) {
            es/* Modal.show */.u_.show({
                className: "modal-error-class",
                header: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationTriangleIcon */.Lm, {
                    className: "w-12 h-12",
                    fillColor: "#FF8F1F",
                    onClick: function() {}
                }),
                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col text-center items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-lg font-bold leading-[25px] mb-2",
                            children: t("ss_builder_product_total_limitation_warning_title")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "",
                            children: t("ss_builder_product_total_limitation_warning_description", {
                                max_products_all_groups: configs_const/* MAX_PRODUCTS_ALL_GROUPS */.A
                            })
                        })
                    ]
                }),
                closeOnAction: true,
                actions: [
                    {
                        key: "confirm",
                        text: t("ss_builder_confirm_replace_theme_template_understood")
                    }, 
                ]
            });
        } else if (!isAllowedToAddProducts) {
            es/* Modal.show */.u_.show({
                className: "modal-error-class",
                header: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationTriangleIcon */.Lm, {
                    className: "w-12 h-12",
                    fillColor: "#FF8F1F",
                    onClick: function() {}
                }),
                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col text-center items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-lg font-bold leading-[25px] mb-2",
                            children: t("ss_builder_product_total_limitation_warning_title")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "",
                            children: t("ss_builder_product_group_limitation_warning_description", {
                                max_products: configs_const/* PRODUCT_MAX */.Kh
                            })
                        })
                    ]
                }),
                closeOnAction: true,
                actions: [
                    {
                        key: "confirm",
                        text: t("ss_builder_confirm_replace_theme_template_understood")
                    }, 
                ]
            });
        } else {
            setIsOpenAddNewProduct(true);
        }
    };
    var handleSaveAffiliateProductAddNew = function() {
        var _ref = AddNewProductButton_asyncToGenerator(runtime_default().mark(function _callee(data, activedProductGroup) {
            var newDataAffiliateProduct, newData;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        newDataAffiliateProduct = AddNewProductButton_objectSpread({}, blockData, {
                            content_attributes: AddNewProductButton_objectSpread({}, blockData.content_attributes, {
                                items: data,
                                is_created_new: isCreatedNew
                            })
                        });
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return (0,block_conf/* requestPostLinkMiddlewareV2 */.lO)(newDataAffiliateProduct, extraData);
                    case 4:
                        newData = _ctx.sent;
                        if (newData) {
                            activedProductGroup && onUpdateProductGroupId(activedProductGroup);
                            if (positionSlug) {
                                dispatch((0,positionsSlice/* updateBlock */.Df)({
                                    tabUid: tabUid,
                                    positionSlug: positionSlug,
                                    blockData: newData
                                }));
                            }
                            onGetLatestBlockData(newData);
                            setIsOpenAddNewProduct(false);
                        }
                        _ctx.next = 12;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](1);
                        dispatch((0,dynamicSlice/* setDynamicParams */.B9)({
                            data: {
                                isErrorNetwork: true
                            }
                        }));
                        return _ctx.abrupt("return");
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    8
                ]
            ]);
        }));
        return function handleSaveAffiliateProductAddNew(data, activedProductGroup) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleAddNewAffiliateProductGroup = function(data, productGroupId) {
        var newDataAffiliateProduct = AddNewProductButton_objectSpread({}, blockData, {
            content_attributes: AddNewProductButton_objectSpread({}, blockData.content_attributes, {
                items: data,
                is_created_new: isCreatedNew
            })
        });
        onUpdateProductGroupId(productGroupId);
        if (positionSlug) {
            dispatch((0,positionsSlice/* updateBlock */.Df)({
                tabUid: tabUid,
                positionSlug: positionSlug,
                blockData: newDataAffiliateProduct
            }));
        }
        onGetLatestBlockData(newDataAffiliateProduct);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* Button */.zx, {
                block: true,
                size: "middle",
                style: {
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: "12px",
                    gap: "8px",
                    backgroundColor: "#2563EB",
                    borderRadius: "4px",
                    color: "#FFFFFF",
                    border: "none",
                    opacity: isEnableOpacity ? "40%" : ""
                },
                onClick: handleOpenAddAffiliateProduct,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* AddIcon */.T8, {
                        className: "w-[18px] h-[18px]"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: t("ss_builder_add_affiliate_product_list_btn_label")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: productGroupId1 ? productRate : ""
                    })
                ]
            }),
            isOpenAddNewProduct && /*#__PURE__*/ (0,jsx_runtime.jsx)(full_screen_popup/* default */.Z, {
                visible: isOpenAddNewProduct,
                onMaskClick: function() {
                    return setIsOpenAddNewProduct(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AffiliateProductAddNew/* default */.Z, {
                    callbackCancelAffiliateProductAddNew: function() {
                        return setIsOpenAddNewProduct(false);
                    },
                    callbackSaveAffiliateProductAddNew: handleSaveAffiliateProductAddNew,
                    affiliateProductGroupData: affiliateProductGroupData,
                    activeProductGroup: productGroupId1,
                    callbackAddNewAffiliateProductGroup: handleAddNewAffiliateProductGroup,
                    productGroupMaximum: productGroupMaximum
                })
            })
        ]
    });
};
/* harmony default export */ var BlockAffiliateProductGroup_AddNewProductButton = (AddNewProductButton);

;// CONCATENATED MODULE: ./src/features/design/components/ExpandBlockHandler/index.tsx





var STATUS;
(function(STATUS) {
    STATUS["INITIAL"] = "initial";
    STATUS["EXPAND"] = "expand";
    STATUS["COLLAPSE"] = "collapse";
})(STATUS || (STATUS = {}));
var ExpandBlockHandler = function(param) {
    var children = param.children, maxHeight = param.maxHeight, onUpdateStatus = param.onUpdateStatus;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var childrenRef = (0,react.useRef)();
    var buttonRef = (0,react.useRef)();
    var ref2 = (0,react.useState)(true), isHeightLimit = ref2[0], setIsHeighLimt = ref2[1];
    var ref1 = (0,share_hooks/* useResizeObserveElement */.pM)(childrenRef), elementHeight = ref1.height;
    var isChildrenHigher = elementHeight >= maxHeight;
    var isButtonEnable = isChildrenHigher;
    var handleExpandAndCollapse = function() {
        if (!isHeightLimit) {
            setTimeout(function() {
                var ref;
                buttonRef === null || buttonRef === void 0 ? void 0 : (ref = buttonRef.current) === null || ref === void 0 ? void 0 : ref.scrollIntoView({
                    behavior: "smooth",
                    block: "end"
                });
            }, 100);
        }
        setIsHeighLimt(function(state) {
            return !state;
        });
    };
    var buttonContent = (0,react.useMemo)(function() {
        if (isButtonEnable) {
            if (isHeightLimit) {
                onUpdateStatus(STATUS.COLLAPSE);
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-[#FFFFFF] text-[13px] leading-[150%] font-medium whitespace-nowrap",
                            children: t("ss_build_expand_block_label")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* AngelDownIcon */._f, {
                            className: "p-0",
                            width: 16,
                            height: 16,
                            fillColor: "#FFFFFF"
                        })
                    ]
                });
            } else {
                onUpdateStatus(STATUS.EXPAND);
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-[#FFFFFF] text-[13px] leading-[150%] font-medium whitespace-nowrap",
                            children: t("ss_build_collapse_block_label")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* AngelUpIcon */.e8, {
                            className: "p-0",
                            width: 16,
                            height: 16,
                            fillColor: "#FFFFFF"
                        })
                    ]
                });
            }
        } else {
            onUpdateStatus(STATUS.INITIAL);
        }
    }, [
        isHeightLimit,
        isButtonEnable
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            maxHeight: isChildrenHigher && isHeightLimit ? maxHeight : "",
            paddingBottom: isChildrenHigher ? "44px" : ""
        },
        className: "relative overflow-y-clip",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: childrenRef,
                children: children
            }),
            isButtonEnable && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: buttonRef,
                className: "flex flex-row gap-1 justify-center items-center absolute bottom-0 left-[50%] translate-x-[-50%] rounded-[100px] h-8 w-[92px] cursor-pointer z-[15]",
                style: {
                    border: "1px solid rgba(255, 255, 255, 0.1)",
                    backdropFilter: "blur(50px)",
                    padding: "0px 8px 0px 12px",
                    background: "rgba(0, 0, 0, 0.15)"
                },
                onClick: function(e) {
                    e.stopPropagation();
                    handleExpandAndCollapse();
                },
                children: buttonContent
            })
        ]
    });
};
/* harmony default export */ var components_ExpandBlockHandler = (ExpandBlockHandler);

// EXTERNAL MODULE: ./node_modules/antd-mobile/es/utils/sleep.js
var sleep = __webpack_require__(24547);
;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockAffiliateProductGroup/ProductInfiniteScroll/index.tsx
function ProductInfiniteScroll_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function ProductInfiniteScroll_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                ProductInfiniteScroll_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                ProductInfiniteScroll_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}








var ADDITION_COUNT = 3;
var ProductInfiniteScroll = function(props) {
    var limit = props.limit, affiliateProductGroupData = props.affiliateProductGroupData, onUpdateGroupLimitation = props.onUpdateGroupLimitation, productGroupId = props.productGroupId, expandOrCollapseStatus = props.expandOrCollapseStatus;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var dynamicConfig = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.dynamicConfig;
    });
    var isOpenProductTourDynamic = dynamicConfig === null || dynamicConfig === void 0 ? void 0 : dynamicConfig.isOpenProductTourDynamic;
    (0,react.useEffect)(function() {
        if (limit > ADDITION_COUNT) {
            var element = document.getElementById("product-group-".concat(limit - 2));
            if (element) {
                element.scrollIntoView({
                    block: "end",
                    behavior: "smooth"
                });
            }
        }
    }, [
        limit
    ]);
    function loadMoreIcon() {
        return _loadMoreIcon.apply(this, arguments);
    }
    function _loadMoreIcon() {
        _loadMoreIcon = ProductInfiniteScroll_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return (0,sleep/* sleep */._)(500);
                    case 2:
                        onUpdateGroupLimitation(ADDITION_COUNT);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return _loadMoreIcon.apply(this, arguments);
    }
    var InfiniteScrollContent = function(param) {
        var hasMore = param.hasMore;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: hasMore ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        style: {
                            color: "#999999"
                        },
                        children: t("ss_builder_loading_label")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* DotLoading */.k_, {
                        style: {
                            color: "#999999"
                        }
                    })
                ]
            }) : null
        });
    };
    var hasMoreGroup = (0,react.useMemo)(function() {
        return limit < (affiliateProductGroupData === null || affiliateProductGroupData === void 0 ? void 0 : affiliateProductGroupData.length);
    }, [
        limit,
        JSON.stringify(affiliateProductGroupData)
    ]);
    var isShowInfiniteScroll = (0,react.useMemo)(function() {
        return !!(hasMoreGroup && !isOpenProductTourDynamic && !productGroupId && expandOrCollapseStatus !== STATUS.COLLAPSE);
    }, [
        hasMoreGroup,
        isOpenProductTourDynamic,
        productGroupId,
        expandOrCollapseStatus, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: isShowInfiniteScroll && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            id: "product-group-infinite-scroll",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* InfiniteScroll */.v_, {
                loadMore: loadMoreIcon,
                hasMore: hasMoreGroup,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfiniteScrollContent, {
                    hasMore: hasMoreGroup
                })
            })
        })
    });
};
/* harmony default export */ var BlockAffiliateProductGroup_ProductInfiniteScroll = (ProductInfiniteScroll);

;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockAffiliateProductGroup/ProductGroupHandler/ProductGroupItemDetail/index.tsx



var ProductGroupItemDetail = function(props) {
    var ref4 = (0,react.useRef)(null);
    var item = props.item, onSelect = props.onSelect, selected = props.selected;
    var ref1;
    var itemQuantity = (0,react.useMemo)(function() {
        var ref, ref2, ref3;
        return (ref1 = (ref3 = item === null || item === void 0 ? void 0 : (ref = item.content_attributes) === null || ref === void 0 ? void 0 : (ref2 = ref.items) === null || ref2 === void 0 ? void 0 : ref2.filter(function(y) {
            return y.enable === 1;
        })) === null || ref3 === void 0 ? void 0 : ref3.length) !== null && ref1 !== void 0 ? ref1 : 0;
    }, [
        item
    ]);
    var isHideProductGroup = (0,react.useMemo)(function() {
        return !!((item === null || item === void 0 ? void 0 : item.enable) !== 1);
    }, [
        item
    ]);
    (0,react.useEffect)(function() {
        if (selected) ref4.current.scrollIntoView({
            block: "nearest",
            behavior: "smooth",
            inline: "center"
        });
    }, [
        selected
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            ref: ref4,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                style: {
                    whiteSpace: "nowrap",
                    border: "none",
                    opacity: isHideProductGroup ? "40%" : ""
                },
                onClick: function(e) {
                    e.stopPropagation();
                    onSelect(ref4.current);
                },
                block: true,
                shape: "rounded",
                className: selected ? "button-background-color button-text-color" : "bg-neutral-100 text-neutral-700",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                    className: selected ? "button-text-color" : "text-neutral-700",
                    children: "".concat(item === null || item === void 0 ? void 0 : item.title, " (").concat(itemQuantity, ")")
                })
            })
        })
    });
};
/* harmony default export */ var ProductGroupHandler_ProductGroupItemDetail = (ProductGroupItemDetail);

;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockAffiliateProductGroup/ProductGroupHandler/GroupAddNewButton/index.tsx







var GroupAddNewButton = function(param) {
    var affiliateProductGroupData = param.affiliateProductGroupData, onAddNewProductGroup = param.onAddNewProductGroup, productGroupMaximum = param.productGroupMaximum;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref = (0,react.useState)(false), isOpenGroupAddNew = ref[0], setIsOpenGroupAddNew = ref[1];
    var disabled = (affiliateProductGroupData === null || affiliateProductGroupData === void 0 ? void 0 : affiliateProductGroupData.length) >= productGroupMaximum;
    var handleClickAddGroup = function(e) {
        e.stopPropagation();
        if (disabled) {
            es/* Modal.show */.u_.show({
                className: "modal-error-class",
                header: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationTriangleIcon */.Lm, {
                    className: "w-12 h-12",
                    fillColor: "#FF8F1F",
                    onClick: function() {}
                }),
                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col text-center items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-lg font-bold leading-[25px] mb-2",
                            children: t("ss_builder_product_group_total_limitation_warning_title")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "",
                            children: t("ss_builder_product_group_total_limitation_warning_content", {
                                group_quantity_maximum: productGroupMaximum
                            })
                        })
                    ]
                }),
                closeOnAction: true,
                actions: [
                    {
                        key: "confirm",
                        text: t("ss_builder_confirm_replace_theme_template_understood")
                    }, 
                ]
            });
        } else setIsOpenGroupAddNew(true);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-shrink-0 items-center justify-center w-[32px] h-[32px] rounded-full bg-[#2563EB] cursor-pointer ml-[8px]",
                onClick: handleClickAddGroup,
                style: {
                    opacity: disabled ? "40%" : ""
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* AddIcon */.T8, {
                    className: "w-[15px] h-[15px]"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupComponent/* default */.Z, {
                visible: isOpenGroupAddNew,
                // onMaskClick={() => setIsOpenGroupAddNew(false)}
                title: t("ss_builder_add_new_affiliate_product_group_btn_label"),
                onClose: function() {
                    return setIsOpenGroupAddNew(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AffiliateProductGroupAddNew/* default */.Z, {
                    onCancelAffiliateProductGroupAddNew: function() {
                        return setIsOpenGroupAddNew(false);
                    },
                    onSaveAffiliateProductGroupAddNew: onAddNewProductGroup,
                    affiliateProductGroupList: affiliateProductGroupData
                })
            })
        ]
    });
};
/* harmony default export */ var ProductGroupHandler_GroupAddNewButton = (GroupAddNewButton);

;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockAffiliateProductGroup/ProductGroupListSelector/index.tsx



var ProductGroupListSelector = function(props) {
    var options = props.options, columns = props.columns, onSelectItem = props.onSelectItem, valueSelectItem = props.valueSelectItem, onClose = props.onClose;
    var handleSelectItem = function(val) {
        onSelectItem(val[0]);
        onClose();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            maxHeight: "65vh",
            backgroundColor: "#F5F5F5",
            overflow: "auto",
            overscrollBehavior: "contain"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Selector */.Qf, {
            columns: columns,
            onChange: handleSelectItem,
            options: options,
            value: valueSelectItem,
            showCheckMark: false,
            style: {
                padding: "12px",
                "--checked-border": "solid var(--adm-color-primary) 1px",
                "--color": "#FFFFFF"
            }
        })
    });
};
/* harmony default export */ var BlockAffiliateProductGroup_ProductGroupListSelector = (ProductGroupListSelector);

;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockAffiliateProductGroup/ProductGroupHandler/index.tsx
function ProductGroupHandler_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function ProductGroupHandler_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return ProductGroupHandler_arrayLikeToArray(arr);
}
function ProductGroupHandler_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ProductGroupHandler_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function ProductGroupHandler_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ProductGroupHandler_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ProductGroupHandler_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ProductGroupHandler_toConsumableArray(arr) {
    return ProductGroupHandler_arrayWithoutHoles(arr) || ProductGroupHandler_iterableToArray(arr) || ProductGroupHandler_unsupportedIterableToArray(arr) || ProductGroupHandler_nonIterableSpread();
}
function ProductGroupHandler_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return ProductGroupHandler_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ProductGroupHandler_arrayLikeToArray(o, minLen);
}














var ProductGroupHandler = function(param) {
    var productGroupId = param.productGroupId, onSelectGroupId = param.onSelectGroupId, // productGroupListData,
    affiliateProductGroupData = param.affiliateProductGroupData, blockData = param.blockData, isCreatedNew = param.isCreatedNew, tabUid = param.tabUid, positionSlug = param.positionSlug, productGroupMaximum = param.productGroupMaximum, _onGetLatestBlockData = param.onGetLatestBlockData, onGetLatestBlockData = _onGetLatestBlockData === void 0 ? function() {} : _onGetLatestBlockData;
    var dispatch = (0,hooks/* useAppDispatch */.TL)();
    var ref4 = (0,react.useState)(null), newGroupId = ref4[0], setNewGroupId = ref4[1];
    var isDisplayProductGroupListSelectorBtn = (affiliateProductGroupData === null || affiliateProductGroupData === void 0 ? void 0 : affiliateProductGroupData.length) >= 6;
    var ref1 = (0,react.useState)(false), isOpenProductGroupListSelector = ref1[0], setIsOpenProductGroupListSelector = ref1[1];
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var optionData = affiliateProductGroupData === null || affiliateProductGroupData === void 0 ? void 0 : affiliateProductGroupData.map(function(ele) {
        var ref, ref2, ref3;
        var productQuantity = ((ref3 = ele === null || ele === void 0 ? void 0 : (ref = ele.content_attributes) === null || ref === void 0 ? void 0 : (ref2 = ref.items) === null || ref2 === void 0 ? void 0 : ref2.filter(function(y) {
            return y.enable === 1;
        })) === null || ref3 === void 0 ? void 0 : ref3.length) || 0;
        return {
            label: (ele === null || ele === void 0 ? void 0 : ele.enable) === configs_const/* STATUS.ENABLE */.Q_.ENABLE ? "".concat(ele === null || ele === void 0 ? void 0 : ele.title, " (").concat(productQuantity, ")") : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "opacity-40",
                children: "".concat(ele === null || ele === void 0 ? void 0 : ele.title, " (").concat(productQuantity, ")")
            }),
            value: ele === null || ele === void 0 ? void 0 : ele.uid
        };
    });
    (0,react.useEffect)(function() {
        setNewGroupId(null);
    }, [
        productGroupId
    ]);
    (0,react.useEffect)(function() {
        if (newGroupId) {
            onSelectGroupId(newGroupId);
        } else if (productGroupId) {
            onSelectGroupId(productGroupId);
        } else onSelectGroupId(null);
    }, [
        newGroupId,
        JSON.stringify(affiliateProductGroupData)
    ]);
    var handleAddNewProductGroup = function(data) {
        var newAffiliateProductGroupData = ProductGroupHandler_toConsumableArray(affiliateProductGroupData).concat([
            data
        ]);
        var newAffiliateProductGroupDataSortOrder = newAffiliateProductGroupData.map(function(ele, idx) {
            return ProductGroupHandler_objectSpread({}, ele, {
                sort_order: idx + 1
            });
        });
        var newDataAffiliateProduct = ProductGroupHandler_objectSpread({}, blockData, {
            content_attributes: ProductGroupHandler_objectSpread({}, blockData.content_attributes, {
                items: newAffiliateProductGroupDataSortOrder,
                is_created_new: isCreatedNew
            })
        });
        if (positionSlug) {
            dispatch((0,positionsSlice/* updateBlock */.Df)({
                tabUid: tabUid,
                positionSlug: positionSlug,
                blockData: newDataAffiliateProduct
            }));
        }
        onGetLatestBlockData(newDataAffiliateProduct);
        setNewGroupId(data === null || data === void 0 ? void 0 : data.uid);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-row items-center justify-between relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemScrollHorizontal/* default */.Z, {
                        className: classnames_default()(isDisplayProductGroupListSelectorBtn && "mr-[32px]"),
                        children: affiliateProductGroupData.map(function(item, index) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(ProductGroupHandler_ProductGroupItemDetail, {
                                item: item,
                                onSelect: function(ele) {
                                    onSelectGroupId(productGroupId && productGroupId === item.uid ? null : item.uid);
                                },
                                // listItemsDefault={affiliateProductGroupData}
                                selected: productGroupId === (item === null || item === void 0 ? void 0 : item.uid)
                            }, index);
                        })
                    }),
                    isDisplayProductGroupListSelectorBtn && /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                        style: {
                            padding: "4px 8px",
                            borderRadius: "0px 1000px 1000px 0px",
                            position: "absolute",
                            right: "40px",
                            // top: "0px",
                            backgroundColor: "#FFFFFF",
                            boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.1)",
                            height: "full",
                            border: "none",
                            overflow: "hidden"
                        },
                        onClick: function() {
                            setIsOpenProductGroupListSelector(true);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* AngelDownIcon */._f, {
                            height: 23
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductGroupHandler_GroupAddNewButton, {
                        affiliateProductGroupData: affiliateProductGroupData,
                        onAddNewProductGroup: handleAddNewProductGroup,
                        productGroupMaximum: productGroupMaximum
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupComponent/* default */.Z, {
                visible: isOpenProductGroupListSelector,
                onMaskClick: function() {
                    return setIsOpenProductGroupListSelector(false);
                },
                title: t("ss_builder_affiliate_product_group_list_selector_label"),
                onClose: function() {
                    return setIsOpenProductGroupListSelector(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockAffiliateProductGroup_ProductGroupListSelector, {
                    options: optionData,
                    columns: 3,
                    valueSelectItem: productGroupId,
                    onSelectItem: onSelectGroupId,
                    onClose: function() {
                        return setIsOpenProductGroupListSelector(false);
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var BlockAffiliateProductGroup_ProductGroupHandler = (ProductGroupHandler);

// EXTERNAL MODULE: ./src/features/share/configs/rxjs.ts + 20 modules
var rxjs = __webpack_require__(18109);
// EXTERNAL MODULE: ./src/features/block/components/BlockEditV2/index.tsx + 5 modules
var BlockEditV2 = __webpack_require__(13641);
;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockAffiliateProductGroup/index.tsx
function BlockAffiliateProductGroup_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function BlockAffiliateProductGroup_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return BlockAffiliateProductGroup_arrayLikeToArray(arr);
}
function BlockAffiliateProductGroup_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function BlockAffiliateProductGroup_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                BlockAffiliateProductGroup_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                BlockAffiliateProductGroup_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function BlockAffiliateProductGroup_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function BlockAffiliateProductGroup_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function BlockAffiliateProductGroup_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function BlockAffiliateProductGroup_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            BlockAffiliateProductGroup_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function BlockAffiliateProductGroup_toConsumableArray(arr) {
    return BlockAffiliateProductGroup_arrayWithoutHoles(arr) || BlockAffiliateProductGroup_iterableToArray(arr) || BlockAffiliateProductGroup_unsupportedIterableToArray(arr) || BlockAffiliateProductGroup_nonIterableSpread();
}
function BlockAffiliateProductGroup_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return BlockAffiliateProductGroup_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return BlockAffiliateProductGroup_arrayLikeToArray(o, minLen);
}




















var BlockAffiliateProductGroup = function(props) {
    var ref8, ref1;
    var blockData = props.blockData, positionSlug = props.positionSlug, tabUid = props.tabUid, index1 = props.index, listBlocksSortOrder = props.listBlocksSortOrder, isFirstItem = props.isFirstItem, isApplyBlockSettings = props.isApplyBlockSettings, isHideMoreActions = props.isHideMoreActions, _onGetLatestBlockData = props.onGetLatestBlockData, onGetLatestBlockData = _onGetLatestBlockData === void 0 ? function() {} : _onGetLatestBlockData;
    var enable = blockData && blockData.enable;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var dispatch = (0,hooks/* useAppDispatch */.TL)();
    var siteSettings = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.siteSettings;
    });
    var ref2 = (siteSettings === null || siteSettings === void 0 ? void 0 : (ref8 = siteSettings.display_setting) === null || ref8 === void 0 ? void 0 : (ref1 = ref8.block_setting) === null || ref1 === void 0 ? void 0 : ref1.block_style) || {}, inner_space_number = ref2.inner_space_number, outside_space = ref2.outside_space;
    var content_attributes = blockData && blockData.content_attributes;
    var title_product_group = content_attributes.title_product_group, items = content_attributes.items, block_description = content_attributes.block_description, is_created_new = content_attributes.is_created_new, product_group_maximum = content_attributes.product_group_maximum, frameData = content_attributes.frame_of_aff, usingFrame = content_attributes.using_frame;
    var dataProductListGroupArr = (0,react.useMemo)(function() {
        var newCloneItems = cloneDeep_default()(items);
        var newItems = newCloneItems === null || newCloneItems === void 0 ? void 0 : newCloneItems.filter(function(group) {
            var ref;
            return !!((group === null || group === void 0 ? void 0 : group.uid) && (group === null || group === void 0 ? void 0 : group.block_type) === block_conf/* BLOCK_TYPE.AFF_PRODUCT */.bF.AFF_PRODUCT && Array.isArray(group === null || group === void 0 ? void 0 : (ref = group.content_attributes) === null || ref === void 0 ? void 0 : ref.items));
        });
        return newItems;
    }, [
        items
    ]);
    var dataProductListGroupArrFilter = dataProductListGroupArr === null || dataProductListGroupArr === void 0 ? void 0 : dataProductListGroupArr.filter(function(x) {
        return x === null || x === void 0 ? void 0 : x.uid;
    });
    var productGroupIdDefault = (0,react.useMemo)(function() {
        var ref;
        return (dataProductListGroupArrFilter === null || dataProductListGroupArrFilter === void 0 ? void 0 : dataProductListGroupArrFilter.length) <= 1 ? (ref = dataProductListGroupArrFilter[0]) === null || ref === void 0 ? void 0 : ref.uid : null;
    }, [
        JSON.stringify(dataProductListGroupArrFilter)
    ]);
    var ref3 = (0,react.useState)(productGroupIdDefault), productGroupId = ref3[0], setProductGroupId = ref3[1];
    var ref4 = (0,react.useState)(dataProductListGroupArrFilter), affiliateProductGroupData = ref4[0], setAffiliateProductGroupData = ref4[1];
    var ref5 = (0,react.useState)(is_created_new !== null && is_created_new !== void 0 ? is_created_new : false), isCreatedNew = ref5[0], setIsCreatedNew = ref5[1];
    var ref6 = (0,react.useState)(3), limit = ref6[0], setLimit = ref6[1];
    var ref7 = (0,react.useState)(null), expandOrCollapseStatus = ref7[0], setExpandOrCollapseStatus = ref7[1];
    var productGroupQuantityDefaultRef = (0,react.useRef)(affiliateProductGroupData === null || affiliateProductGroupData === void 0 ? void 0 : affiliateProductGroupData.length);
    var displayGroups = (0,react.useMemo)(function() {
        if (productGroupId) {
            return [
                affiliateProductGroupData === null || affiliateProductGroupData === void 0 ? void 0 : affiliateProductGroupData.find(function(x) {
                    return (x === null || x === void 0 ? void 0 : x.uid) === productGroupId;
                }), 
            ];
        }
        return affiliateProductGroupData.slice(0, limit);
    }, [
        JSON.stringify(affiliateProductGroupData),
        limit,
        productGroupId
    ]);
    var productGroupMaximumRef = (0,react.useRef)(product_group_maximum);
    var extraData = {
        user_id: siteSettings.user_id
    };
    var handleUpdateTabsBody = function(data) {
        dispatch((0,positionsSlice/* updateTabsBody */.g2)({
            data: data
        }));
    };
    var extraFunction = {
        handleUpdateTabsBody: handleUpdateTabsBody
    };
    var productGroupMaximum = (0,react.useMemo)(function() {
        var productGroupQuantity = affiliateProductGroupData === null || affiliateProductGroupData === void 0 ? void 0 : affiliateProductGroupData.length;
        var PRODUCT_GROUP_QUANTITY_CHECKING = 25;
        if (productGroupMaximumRef.current) {
            if (productGroupMaximumRef.current === configs_const/* PRODUCT_GROUP_MAXIMUM */.xC) {
                return productGroupMaximumRef.current;
            } else {
                if (productGroupQuantity >= productGroupQuantityDefaultRef.current) {
                    productGroupQuantityDefaultRef.current = productGroupQuantity;
                    return productGroupMaximumRef.current;
                } else {
                    productGroupQuantityDefaultRef.current = productGroupQuantity;
                    if (productGroupMaximumRef.current - productGroupQuantity >= 5) {
                        if (productGroupQuantity + 5 > configs_const/* PRODUCT_GROUP_MAXIMUM */.xC) {
                            productGroupMaximumRef.current = productGroupQuantity + 5;
                            return productGroupQuantity + 5;
                        } else {
                            productGroupMaximumRef.current = configs_const/* PRODUCT_GROUP_MAXIMUM */.xC;
                            return configs_const/* PRODUCT_GROUP_MAXIMUM */.xC;
                        }
                    } else {
                        return productGroupMaximumRef.current;
                    }
                }
            }
        } else {
            if (isCreatedNew) {
                return configs_const/* PRODUCT_GROUP_MAXIMUM */.xC;
            } else {
                if (productGroupQuantity > configs_const/* PRODUCT_GROUP_MAXIMUM */.xC) {
                    if (productGroupQuantity > productGroupQuantityDefaultRef.current) {
                        return productGroupQuantityDefaultRef.current + 5;
                    } else {
                        productGroupQuantityDefaultRef.current = productGroupQuantity;
                        return productGroupQuantity + 5;
                    }
                } else {
                    if (productGroupQuantity > PRODUCT_GROUP_QUANTITY_CHECKING) {
                        if (productGroupQuantity > productGroupQuantityDefaultRef.current) {
                            return productGroupQuantityDefaultRef.current + 5;
                        } else {
                            productGroupQuantityDefaultRef.current = productGroupQuantity;
                            return productGroupQuantity + 5;
                        }
                    } else {
                        setIsCreatedNew(true);
                        return configs_const/* PRODUCT_GROUP_MAXIMUM */.xC;
                    }
                }
            }
        }
    }, [
        isCreatedNew,
        JSON.stringify(affiliateProductGroupData),
        product_group_maximum
    ]);
    (0,react.useEffect)(function() {
        rxjs/* dataService.publish */.c.publish(BlockAffiliateProductGroup_defineProperty({}, blockData === null || blockData === void 0 ? void 0 : blockData.uid, productGroupId));
    }, [
        productGroupId,
        blockData === null || blockData === void 0 ? void 0 : blockData.uid
    ]);
    (0,react.useEffect)(function() {
        if (dataProductListGroupArrFilter) setAffiliateProductGroupData(dataProductListGroupArrFilter);
    }, [
        JSON.stringify(dataProductListGroupArrFilter)
    ]);
    (0,react.useEffect)(function() {
        if (productGroupId && !affiliateProductGroupData.some(function(x) {
            return (x === null || x === void 0 ? void 0 : x.uid) === productGroupId;
        })) {
            setProductGroupId(null);
        }
    }, [
        JSON.stringify(affiliateProductGroupData),
        productGroupId
    ]);
    var isDisplayAddNewBtn = !productGroupId;
    var handleUpdateBlock = function() {
        var _ref = BlockAffiliateProductGroup_asyncToGenerator(runtime_default().mark(function _callee(data) {
            var newDataAffiliateProduct, dataMiđle;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        newDataAffiliateProduct = BlockAffiliateProductGroup_objectSpread({}, blockData, {
                            content_attributes: BlockAffiliateProductGroup_objectSpread({}, blockData.content_attributes, {
                                items: data,
                                is_created_new: isCreatedNew
                            })
                        });
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return (0,BlockEditV2/* runMiddleware */.U)(blockData === null || blockData === void 0 ? void 0 : blockData.block_type, newDataAffiliateProduct, extraData, extraFunction);
                    case 4:
                        dataMiđle = _ctx.sent;
                        _ctx.next = 10;
                        break;
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return");
                    case 10:
                        if (positionSlug) {
                            dispatch((0,positionsSlice/* updateBlock */.Df)({
                                tabUid: tabUid,
                                positionSlug: positionSlug,
                                blockData: dataMiđle
                            }));
                        }
                        onGetLatestBlockData(dataMiđle);
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    7
                ]
            ]);
        }));
        return function handleUpdateBlock(data) {
            return _ref.apply(this, arguments);
        };
    }();
    var isShowSearchBar = (0,react.useMemo)(function() {
        var ref10;
        var dataProductListGroupArrClone = cloneDeep_default()(dataProductListGroupArrFilter);
        var allProductLists = [];
        (ref10 = dataProductListGroupArrClone === null || dataProductListGroupArrClone === void 0 ? void 0 : dataProductListGroupArrClone.filter(function(item) {
            return (item === null || item === void 0 ? void 0 : item.enable) === configs_const/* STATUS.ENABLE */.Q_.ENABLE;
        })) === null || ref10 === void 0 ? void 0 : ref10.forEach(function(ele) {
            var ref, ref9;
            var productListsEnable = (ele === null || ele === void 0 ? void 0 : (ref = ele.content_attributes) === null || ref === void 0 ? void 0 : (ref9 = ref.items) === null || ref9 === void 0 ? void 0 : ref9.filter(function(x) {
                return x.enable === configs_const/* STATUS.ENABLE */.Q_.ENABLE;
            })) || [];
            allProductLists = BlockAffiliateProductGroup_toConsumableArray(allProductLists).concat(BlockAffiliateProductGroup_toConsumableArray(productListsEnable));
        });
        return allProductLists.length > 0;
    }, [
        JSON.stringify(affiliateProductGroupData)
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(context/* AffiliateContext.Provider */.X.Provider, {
        value: {
            frameData: frameData,
            usingFrame: usingFrame
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockWrapper/* default */.Z, {
            blockType: blockData === null || blockData === void 0 ? void 0 : blockData.block_type,
            isEnable: enable,
            positionSlug: positionSlug,
            tabUid: tabUid,
            blockUid: blockData === null || blockData === void 0 ? void 0 : blockData.uid,
            index: index1,
            listBlocksSortOrder: listBlocksSortOrder,
            outsideSpace: outside_space,
            insideSpace: inner_space_number,
            isFirstItem: isFirstItem,
            isApplyBlockSettings: isApplyBlockSettings,
            isHideMoreActions: isHideMoreActions,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_ExpandBlockHandler, {
                maxHeight: configs_const/* AFFILIATE_LAYOUT_MAX_HEIGHT */.aV,
                onUpdateStatus: function(status) {
                    return setExpandOrCollapseStatus(status);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockHeadingComponent/* default */.Z, {
                        title: title_product_group,
                        blockType: blockData.block_type,
                        subtitle: block_description
                    }),
                    isShowSearchBar && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            position: "relative"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* SearchBar */.E1, {
                                placeholder: t("ss_builder_affiliate_product_searching_placeholder"),
                                style: {
                                    marginBottom: "16px"
                                },
                                value: ""
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute top-0 left-0 block w-full h-full cursor-pointer",
                                style: {
                                    backgroundColor: "transparent"
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockAffiliateProductGroup_ProductGroupHandler, {
                        productGroupId: productGroupId,
                        onSelectGroupId: function(val) {
                            return setProductGroupId(val);
                        },
                        affiliateProductGroupData: affiliateProductGroupData,
                        blockData: blockData,
                        isCreatedNew: isCreatedNew,
                        tabUid: tabUid,
                        positionSlug: positionSlug,
                        productGroupMaximum: productGroupMaximum,
                        onGetLatestBlockData: onGetLatestBlockData
                    }),
                    isDisplayAddNewBtn && /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockAffiliateProductGroup_AddNewProductButton, {
                        productGroupId: productGroupId,
                        affiliateProductGroupData: affiliateProductGroupData,
                        blockData: blockData,
                        positionSlug: positionSlug,
                        tabUid: tabUid,
                        productGroupMaximum: productGroupMaximum,
                        isCreatedNew: isCreatedNew,
                        onUpdateProductGroupId: function(val) {
                            return setProductGroupId(val);
                        },
                        onGetLatestBlockData: onGetLatestBlockData
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            displayGroups.map(function(ele, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockAffiliateProductGroup_ProductListOfGroupDisplay, {
                                    id: "product-group-".concat(index + 1),
                                    item: ele,
                                    affiliateProductGroupData: affiliateProductGroupData,
                                    blockData: blockData,
                                    positionSlug: positionSlug,
                                    tabUid: tabUid,
                                    isCreatedNew: isCreatedNew,
                                    productGroupId: productGroupId,
                                    productGroupMaximum: productGroupMaximum,
                                    onUpdateProductGroupId: function(val) {
                                        return setProductGroupId(val);
                                    },
                                    onUpdateProductGroupData: function(data) {
                                        setAffiliateProductGroupData(data);
                                        handleUpdateBlock(data);
                                    },
                                    onGetLatestBlockData: onGetLatestBlockData
                                }, index);
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockAffiliateProductGroup_ProductInfiniteScroll, {
                                limit: limit,
                                onUpdateGroupLimitation: function(count) {
                                    return setLimit(function(state) {
                                        return state + count;
                                    });
                                },
                                affiliateProductGroupData: affiliateProductGroupData,
                                productGroupId: productGroupId,
                                expandOrCollapseStatus: expandOrCollapseStatus
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var CommonBlockComponent_BlockAffiliateProductGroup = (BlockAffiliateProductGroup);

;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockCard/CardDetail/CardDetailLayout1/index.tsx




var CardDetailLayout1 = function(props) {
    var card_title = props.card_title, card_subtitle = props.card_subtitle, card_description = props.card_description, card_image = props.card_image, card_label = props.card_label, card_btn_see_more = props.card_btn_see_more, card_layout = props.card_layout, card_image_ratio = props.card_image_ratio, card_url = props.card_url, item_on_row = props.item_on_row, card_slide_type = props.card_slide_type;
    var isHideCardLabel = (0,react.useMemo)(function() {
        return !card_label || item_on_row === configs_const/* CARD_ITEM_ON_ROW.TWO */.nG.TWO;
    }, [
        card_label,
        item_on_row
    ]);
    var isHideCardButton = (0,react.useMemo)(function() {
        return !card_url || item_on_row === configs_const/* CARD_ITEM_ON_ROW.TWO */.nG.TWO;
    }, [
        card_url,
        item_on_row
    ]);
    var isHideCardDescription = (0,react.useMemo)(function() {
        return !card_description || item_on_row === configs_const/* CARD_ITEM_ON_ROW.TWO */.nG.TWO;
    }, [
        card_description,
        item_on_row
    ]);
    var isDisplayCardText = card_title || card_subtitle || !isHideCardDescription;
    // const cleanCardDescription = DOMPurify.sanitize(
    //   card_description?.replaceAll("\n", "</br>")
    // );
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "card-detail-layout ".concat(card_layout),
        style: {
            marginBottom: card_slide_type === configs_const/* SLIDE_STYLE.NOT_PARTIAL_VISIBLE */.jw.NOT_PARTIAL_VISIBLE ? "20px" : ""
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                        src: card_image,
                        style: {
                            aspectRatio: card_image_ratio,
                            borderRadius: "4px",
                            marginBottom: isDisplayCardText ? "12px" : ""
                        },
                        fit: "cover",
                        className: "card-image"
                    }),
                    !isHideCardLabel && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "card-label text-neutral-900",
                        children: card_label
                    })
                ]
            }),
            isDisplayCardText && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "card-text",
                children: [
                    card_title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        className: "card-title",
                        children: card_title
                    }),
                    card_subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "lead-2 card-subtitle",
                        children: card_subtitle
                    }),
                    !isHideCardDescription && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "card-description",
                        children: card_description
                    })
                ]
            }),
            !isHideCardButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                fill: "solid",
                size: "middle",
                className: "pp-button",
                children: card_btn_see_more
            })
        ]
    });
};
/* harmony default export */ var CardDetail_CardDetailLayout1 = (CardDetailLayout1);

;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockCard/CardDetail/CardDetailLayout2/index.tsx




var CardDetailLayout2 = function(props) {
    var card_title = props.card_title, card_subtitle = props.card_subtitle, card_description = props.card_description, card_image = props.card_image, card_label = props.card_label, card_btn_see_more = props.card_btn_see_more, card_layout = props.card_layout, card_image_ratio = props.card_image_ratio, card_url = props.card_url, item_on_row = props.item_on_row, card_slide_type = props.card_slide_type;
    var isHideCardLabel = (0,react.useMemo)(function() {
        return !card_label || item_on_row === configs_const/* CARD_ITEM_ON_ROW.TWO */.nG.TWO;
    }, [
        card_label,
        item_on_row
    ]);
    var isHideCardButton = (0,react.useMemo)(function() {
        return !card_url || item_on_row === configs_const/* CARD_ITEM_ON_ROW.TWO */.nG.TWO;
    }, [
        card_url,
        item_on_row
    ]);
    var isHideCardDescription = (0,react.useMemo)(function() {
        return !card_description || item_on_row === configs_const/* CARD_ITEM_ON_ROW.TWO */.nG.TWO;
    }, [
        card_description,
        item_on_row
    ]);
    var isDisplayCardText = card_title || card_subtitle || !isHideCardDescription;
    // const cleanCardDescription = DOMPurify.sanitize(
    //   card_description?.replaceAll("\n", "</br>")
    // );
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "card-detail-layout relative ".concat(card_layout),
        style: {
            marginBottom: card_slide_type === configs_const/* SLIDE_STYLE.NOT_PARTIAL_VISIBLE */.jw.NOT_PARTIAL_VISIBLE ? "20px" : ""
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                src: card_image,
                style: {
                    aspectRatio: card_image_ratio,
                    borderRadius: "4px"
                },
                fit: "cover",
                className: "card-image"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute top-0 left-0 block w-full h-full text-center",
                style: {
                    backgroundColor: "#000000",
                    opacity: "0.6",
                    borderRadius: "4px"
                }
            }),
            !isHideCardLabel && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "card-label text-neutral-900",
                children: card_label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "absolute bottom-0 left-0 px-4 w-full pb-4",
                children: [
                    isDisplayCardText && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "card-text",
                        children: [
                            card_title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                className: "card-title text-neutral-50",
                                children: card_title
                            }),
                            card_subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "lead-2 card-subtitle text-neutral-50",
                                children: card_subtitle
                            }),
                            !isHideCardDescription && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "card-description text-neutral-50",
                                children: card_description
                            })
                        ]
                    }),
                    !isHideCardButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                        fill: "solid",
                        size: "middle",
                        className: "pp-button",
                        children: card_btn_see_more
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var CardDetail_CardDetailLayout2 = (CardDetailLayout2);

;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockCard/CardDetail/CardDetailLayout3/index.tsx





var CardDetailLayout3 = function(props) {
    var card_title = props.card_title, card_subtitle = props.card_subtitle, card_image = props.card_image, card_layout = props.card_layout, card_image_ratio = props.card_image_ratio;
    var isDisplayCardText = card_title || card_subtitle;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "card-detail-layout relative ".concat(card_layout, " flex flex-row gap-2 items-center"),
        children: [
            card_layout === configs_const/* CARD_LAYOUTS.LAYOUT_5 */.IT.LAYOUT_5 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                        src: card_image,
                        style: {
                            aspectRatio: card_image_ratio,
                            borderRadius: "4px"
                        },
                        fit: "cover",
                        height: 60
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "card-text w-[30vw] md:w-[10vw] grow text-left",
                        children: [
                            card_title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                className: "card-title",
                                children: card_title
                            }),
                            card_subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "card-subtitle",
                                children: card_subtitle
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* RightArrowIcon */.AD, {
                        className: "w-5 h-5"
                    })
                ]
            }),
            card_layout === configs_const/* CARD_LAYOUTS.LAYOUT_6 */.IT.LAYOUT_6 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    isDisplayCardText && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "card-text w-[30vw] md:w-[10vw] grow text-left",
                        children: [
                            card_title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                className: "card-title",
                                children: card_title
                            }),
                            card_subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "card-subtitle",
                                children: card_subtitle
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                        src: card_image,
                        style: {
                            aspectRatio: card_image_ratio,
                            borderRadius: "4px"
                        },
                        fit: "cover",
                        height: 60
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var CardDetail_CardDetailLayout3 = (CardDetailLayout3);

;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockCard/CardDetail/CardDetailLayout4/index.tsx




var CardDetailLayout4 = function(props) {
    var card_title = props.card_title, card_subtitle = props.card_subtitle, card_image = props.card_image, card_label = props.card_label, card_layout = props.card_layout, card_image_ratio = props.card_image_ratio, item_on_row = props.item_on_row, card_slide_type = props.card_slide_type;
    var isHideCardLabel = (0,react.useMemo)(function() {
        return !card_label || item_on_row === configs_const/* CARD_ITEM_ON_ROW.TWO */.nG.TWO;
    }, [
        card_label,
        item_on_row
    ]);
    var isDisplayCardText = card_title || card_subtitle;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "card-detail-layout relative ".concat(card_layout),
        style: {
            marginBottom: card_slide_type === configs_const/* SLIDE_STYLE.NOT_PARTIAL_VISIBLE */.jw.NOT_PARTIAL_VISIBLE ? "20px" : ""
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                src: card_image,
                style: {
                    aspectRatio: card_image_ratio,
                    borderRadius: "4px"
                },
                fit: "cover",
                className: "card-image"
            }),
            !isHideCardLabel && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "card-label text-neutral-900",
                style: {
                    backdropFilter: "blur(5px)",
                    opacity: "80%"
                },
                children: card_label
            }),
            isDisplayCardText && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "card-text",
                children: [
                    card_title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        className: "card-title text-neutral-800",
                        children: card_title
                    }),
                    card_subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "card-subtitle text-neutral-500",
                        children: card_subtitle
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var CardDetail_CardDetailLayout4 = (CardDetailLayout4);

;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockCard/CardDetail/index.tsx
function CardDetail_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function CardDetail_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            CardDetail_defineProperty(target, key, source[key]);
        });
    }
    return target;
}







var CardDetail_obj;
var CARD_LAYOUT_COMPONENT = (CardDetail_obj = {}, CardDetail_defineProperty(CardDetail_obj, configs_const/* CARD_LAYOUTS.LAYOUT_1 */.IT.LAYOUT_1, CardDetail_CardDetailLayout1), CardDetail_defineProperty(CardDetail_obj, configs_const/* CARD_LAYOUTS.LAYOUT_2 */.IT.LAYOUT_2, CardDetail_CardDetailLayout1), CardDetail_defineProperty(CardDetail_obj, configs_const/* CARD_LAYOUTS.LAYOUT_3 */.IT.LAYOUT_3, CardDetail_CardDetailLayout2), CardDetail_defineProperty(CardDetail_obj, configs_const/* CARD_LAYOUTS.LAYOUT_4 */.IT.LAYOUT_4, CardDetail_CardDetailLayout2), CardDetail_defineProperty(CardDetail_obj, configs_const/* CARD_LAYOUTS.LAYOUT_5 */.IT.LAYOUT_5, CardDetail_CardDetailLayout3), CardDetail_defineProperty(CardDetail_obj, configs_const/* CARD_LAYOUTS.LAYOUT_6 */.IT.LAYOUT_6, CardDetail_CardDetailLayout3), CardDetail_defineProperty(CardDetail_obj, configs_const/* CARD_LAYOUTS.LAYOUT_7 */.IT.LAYOUT_7, CardDetail_CardDetailLayout4), CardDetail_defineProperty(CardDetail_obj, configs_const/* CARD_LAYOUTS.LAYOUT_8 */.IT.LAYOUT_8, CardDetail_CardDetailLayout4), CardDetail_obj);
var CardDetail = function(props1) {
    var style_attributes = props1.style_attributes, card_attributes = props1.card_attributes, card_see_more_btn = props1.card_see_more_btn;
    var ref = style_attributes || {}, card_layout = ref.card_layout, card_slide_type = ref.card_slide_type, card_style = ref.card_style, item_on_row = ref.item_on_row, ratio = ref.ratio;
    var ref1 = card_attributes || {}, image = ref1.image, card_description = ref1.card_description, card_label = ref1.card_label, card_subtitle = ref1.card_subtitle, card_title = ref1.card_title, card_url = ref1.card_url;
    var CardDetailLayoutRender = (0,react.useCallback)(function(props) {
        var Element = /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        if (CARD_LAYOUT_COMPONENT[props === null || props === void 0 ? void 0 : props.card_layout]) {
            var RenderComponent = CARD_LAYOUT_COMPONENT[props === null || props === void 0 ? void 0 : props.card_layout];
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(RenderComponent, CardDetail_objectSpread({}, props));
        }
        return Element;
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CardDetailLayoutRender, {
        card_title: card_title,
        card_subtitle: card_subtitle,
        card_description: card_description,
        card_image: image,
        card_label: card_label,
        card_btn_see_more: card_see_more_btn,
        card_layout: card_layout,
        card_image_ratio: ratio,
        card_url: card_url,
        item_on_row: item_on_row,
        card_style: card_style,
        card_slide_type: card_slide_type
    });
};
/* harmony default export */ var BlockCard_CardDetail = (CardDetail);

;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockCard/CardStyleDisplay/CardStyleGrid/index.tsx





var CardStyleGrid = function(props) {
    var cardItemArr = props.cardItemArr, style_attibutes = props.style_attibutes, see_more_btn_content = props.see_more_btn_content;
    var ref = style_attibutes || {}, card_layout = ref.card_layout, item_on_row = ref.item_on_row;
    var gridCardStyle = (0,react.useMemo)(function() {
        var gridStyleValue = null;
        switch(item_on_row){
            case configs_const/* CARD_ITEM_ON_ROW.ONE */.nG.ONE:
                gridStyleValue = {
                    display: "grid",
                    gridTemplateColumns: "repeat(1, minmax(0, 1fr))",
                    gap: "12px"
                };
                break;
            case configs_const/* CARD_ITEM_ON_ROW.TWO */.nG.TWO:
                gridStyleValue = {
                    display: "grid",
                    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                    gap: "12px"
                };
                break;
            default:
                gridStyleValue = {
                    display: "grid",
                    gridTemplateColumns: "repeat(1, minmax(0, 1fr))",
                    gap: "12px"
                };
        }
        return gridStyleValue;
    }, [
        item_on_row
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: gridCardStyle,
        children: cardItemArr === null || cardItemArr === void 0 ? void 0 : cardItemArr.map(function(ele, index) {
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockCard_CardDetail, {
                        style_attributes: style_attibutes,
                        card_attributes: ele,
                        card_see_more_btn: see_more_btn_content
                    }, ele === null || ele === void 0 ? void 0 : ele.uid),
                    index !== cardItemArr.length - 1 && (card_layout === configs_const/* CARD_LAYOUTS.LAYOUT_5 */.IT.LAYOUT_5 || card_layout === configs_const/* CARD_LAYOUTS.LAYOUT_6 */.IT.LAYOUT_6) && /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {
                        style: {
                            borderColor: "#A3A3A3"
                        }
                    })
                ]
            }, ele === null || ele === void 0 ? void 0 : ele.uid);
        })
    });
};
/* harmony default export */ var CardStyleDisplay_CardStyleGrid = (CardStyleGrid);

// EXTERNAL MODULE: ./node_modules/swiper/modules/pagination/pagination.min.css
var pagination_min = __webpack_require__(36797);
// EXTERNAL MODULE: ./src/features/swiper/uiinitiative-panorama-slider/dist/effect-panorama.esm.js
var effect_panorama_esm = __webpack_require__(7089);
;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockCard/CardStyleDisplay/CardStyleSlide/CardNotPartialVisible/index.tsx



// Import Swiper styles




// import {}
// import TrippleSlider from '../../features/swiper/uiinitiative-triple-slider/src/triple-slider';


var CardNotPartialVisible = function(props) {
    var cardItemArr = props.cardItemArr, style_attibutes = props.style_attibutes, see_more_btn_content = props.see_more_btn_content;
    var itemOnrow = style_attibutes === null || style_attibutes === void 0 ? void 0 : style_attibutes.item_on_row;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
            modules: [
                swiper_esm/* Pagination */.tl,
                swiper_esm/* EffectFade */.xW,
                effect_panorama_esm/* default */.Z
            ],
            setWrapperSize: false,
            spaceBetween: 12,
            slidesPerView: itemOnrow ? parseInt(itemOnrow) : 1,
            onSlideChange: function() {
                return console.log("slide change");
            },
            onSwiper: function(swiper) {
                return console.log(swiper);
            },
            // effect={"panorama"}
            pagination: true,
            allowTouchMove: false,
            children: cardItemArr === null || cardItemArr === void 0 ? void 0 : cardItemArr.map(function(ele, index) {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockCard_CardDetail, {
                        style_attributes: style_attibutes,
                        card_attributes: ele,
                        card_see_more_btn: see_more_btn_content
                    }, ele === null || ele === void 0 ? void 0 : ele.uid)
                });
            })
        })
    });
};
/* harmony default export */ var CardStyleSlide_CardNotPartialVisible = (CardNotPartialVisible);

// EXTERNAL MODULE: ./src/features/main/store/interface.ts
var store_interface = __webpack_require__(30053);
;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockCard/CardStyleDisplay/CardStyleSlide/CardPanorama/index.jsx



// Import Swiper styles



// import {}
// import TrippleSlider from '../../features/swiper/uiinitiative-triple-slider/src/triple-slider';



var CardPanorama = function(props) {
    var cardItemArr = props.cardItemArr, style_attibutes = props.style_attibutes, see_more_btn_content = props.see_more_btn_content;
    var itemOnrow = style_attibutes === null || style_attibutes === void 0 ? void 0 : style_attibutes.item_on_row;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
            modules: [
                swiper_esm/* EffectFade */.xW,
                effect_panorama_esm/* default */.Z
            ],
            setWrapperSize: false,
            // spaceBetween={50}
            slidesPerView: itemOnrow ? parseInt(itemOnrow) : 1,
            // onSlideChange={() => console.log("slide change")}
            // onSwiper={(swiper) => console.log(swiper)}
            effect: "panorama",
            allowTouchMove: false,
            children: cardItemArr === null || cardItemArr === void 0 ? void 0 : cardItemArr.map(function(ele, index) {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockCard_CardDetail, {
                        style_attributes: style_attibutes,
                        card_attributes: ele,
                        card_see_more_btn: see_more_btn_content
                    }, ele === null || ele === void 0 ? void 0 : ele.uid)
                });
            })
        })
    });
};
/* harmony default export */ var CardStyleSlide_CardPanorama = (CardPanorama);

;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockCard/CardStyleDisplay/CardStyleSlide/CardPartialVisibleRight/index.tsx



// Import Swiper styles




// import {}
// import TrippleSlider from '../../features/swiper/uiinitiative-triple-slider/src/triple-slider';


var CardPartialVisibleRight = function(props) {
    var cardItemArr = props.cardItemArr, style_attibutes = props.style_attibutes, see_more_btn_content = props.see_more_btn_content;
    var itemOnrow = style_attibutes === null || style_attibutes === void 0 ? void 0 : style_attibutes.item_on_row;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "card-partial-visible-right",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
            modules: [
                swiper_esm/* Pagination */.tl,
                swiper_esm/* EffectFade */.xW,
                effect_panorama_esm/* default */.Z
            ],
            setWrapperSize: false,
            spaceBetween: 50,
            slidesPerView: itemOnrow ? parseInt(itemOnrow) : 1,
            onSlideChange: function() {
                return console.log("slide change");
            },
            onSwiper: function(swiper) {
                return console.log(swiper);
            },
            children: cardItemArr === null || cardItemArr === void 0 ? void 0 : cardItemArr.map(function(ele, index) {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockCard_CardDetail, {
                        style_attributes: style_attibutes,
                        card_attributes: ele,
                        card_see_more_btn: see_more_btn_content
                    }, ele === null || ele === void 0 ? void 0 : ele.uid)
                });
            })
        })
    });
};
/* harmony default export */ var CardStyleSlide_CardPartialVisibleRight = (CardPartialVisibleRight);

;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockCard/CardStyleDisplay/CardStyleSlide/index.tsx
function CardStyleSlide_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function CardStyleSlide_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            CardStyleSlide_defineProperty(target, key, source[key]);
        });
    }
    return target;
}






var CardStyleSlide_obj;
var CARD_SLIDE_TYPE_COMPONENT = (CardStyleSlide_obj = {}, CardStyleSlide_defineProperty(CardStyleSlide_obj, configs_const/* SLIDE_STYLE.NOT_PARTIAL_VISIBLE */.jw.NOT_PARTIAL_VISIBLE, CardStyleSlide_CardNotPartialVisible), CardStyleSlide_defineProperty(CardStyleSlide_obj, configs_const/* SLIDE_STYLE.PANORAMA */.jw.PANORAMA, CardStyleSlide_CardPanorama), CardStyleSlide_defineProperty(CardStyleSlide_obj, configs_const/* SLIDE_STYLE.PARTIAL_VISIBLE_RIGHT */.jw.PARTIAL_VISIBLE_RIGHT, CardStyleSlide_CardPartialVisibleRight), CardStyleSlide_obj);
var CardStyleSlide = function(props1) {
    var cardItemArr = props1.cardItemArr, style_attibutes = props1.style_attibutes, see_more_btn_content = props1.see_more_btn_content;
    var card_slide_type = (style_attibutes || {}).card_slide_type;
    var CardSlideTypeRender = (0,react.useCallback)(function(props) {
        var Element = /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        if (CARD_SLIDE_TYPE_COMPONENT[props === null || props === void 0 ? void 0 : props.card_slide_type]) {
            var RenderComponent = CARD_SLIDE_TYPE_COMPONENT[props === null || props === void 0 ? void 0 : props.card_slide_type];
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(RenderComponent, CardStyleSlide_objectSpread({}, props));
        }
        return Element;
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CardSlideTypeRender, {
        card_slide_type: card_slide_type,
        cardItemArr: cardItemArr,
        style_attibutes: style_attibutes,
        see_more_btn_content: see_more_btn_content
    });
};
/* harmony default export */ var CardStyleDisplay_CardStyleSlide = (CardStyleSlide);

;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockCard/index.tsx








var BlockCard = function(props) {
    var ref, ref1;
    var blockData = props.blockData, positionSlug = props.positionSlug, tabUid = props.tabUid, index = props.index, listBlocksSortOrder = props.listBlocksSortOrder, isFirstItem = props.isFirstItem, isApplyBlockSettings = props.isApplyBlockSettings, isHideMoreActions = props.isHideMoreActions;
    var enable = blockData && blockData.enable;
    var siteSettings = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.siteSettings;
    });
    var ref2 = (siteSettings === null || siteSettings === void 0 ? void 0 : (ref = siteSettings.display_setting) === null || ref === void 0 ? void 0 : (ref1 = ref.block_setting) === null || ref1 === void 0 ? void 0 : ref1.block_style) || {}, inner_space_number = ref2.inner_space_number, outside_space = ref2.outside_space;
    var style_attributes = blockData === null || blockData === void 0 ? void 0 : blockData.style_attributes;
    var content_attributes = blockData === null || blockData === void 0 ? void 0 : blockData.content_attributes;
    var card_style = (style_attributes || {}).card_style;
    var ref3 = content_attributes || {}, block_heading = ref3.block_heading, block_description = ref3.block_description, cardItemArr = ref3.items, see_more_btn_content = ref3.see_more_btn_content;
    var cardsEnable = cardItemArr === null || cardItemArr === void 0 ? void 0 : cardItemArr.filter(function(x) {
        return x.enable === 1;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BlockWrapper/* default */.Z, {
        blockType: blockData === null || blockData === void 0 ? void 0 : blockData.block_type,
        isEnable: enable,
        positionSlug: positionSlug,
        tabUid: tabUid,
        blockUid: blockData === null || blockData === void 0 ? void 0 : blockData.uid,
        index: index,
        listBlocksSortOrder: listBlocksSortOrder,
        outsideSpace: outside_space,
        insideSpace: inner_space_number,
        isFirstItem: isFirstItem,
        isApplyBlockSettings: isApplyBlockSettings,
        isHideMoreActions: isHideMoreActions,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockHeadingComponent/* default */.Z, {
                blockType: blockData.block_type,
                title: block_heading,
                subtitle: block_description
            }),
            card_style === configs_const/* CARD_STYLE.GRID */.wi.GRID && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardStyleDisplay_CardStyleGrid, {
                style_attibutes: style_attributes,
                cardItemArr: cardsEnable,
                see_more_btn_content: see_more_btn_content
            }),
            card_style === configs_const/* CARD_STYLE.SLIDE */.wi.SLIDE && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardStyleDisplay_CardStyleSlide, {
                style_attibutes: style_attributes,
                cardItemArr: cardsEnable,
                see_more_btn_content: see_more_btn_content
            })
        ]
    });
};
/* harmony default export */ var CommonBlockComponent_BlockCard = (BlockCard);

;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockImageGallery/block-grid.tsx



var BlockImageGalleryGrid = function(props) {
    var imageGalleryList = props.imageGalleryList, number_items_per_row = props.number_items_per_row, ratio = props.ratio;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()("image-gallery-wrapper grid gap-1 grid-cols-".concat(number_items_per_row)),
        children: imageGalleryList && imageGalleryList.map(function(ele, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(build.LazyLoadImage, {
                    src: ele.image,
                    className: "object-center image-gallery-image",
                    style: {
                        backgroundSize: "cover",
                        aspectRatio: ratio,
                        margin: "0 auto",
                        objectFit: "cover",
                        width: "100%"
                    },
                    onError: function(param) {
                        var currentTarget = param.currentTarget;
                        currentTarget.onerror = null; // prevents looping
                        currentTarget.src = "https://i.ecomobi.com/ssp/passio-page/image-default.png";
                    }
                })
            }, index);
        })
    });
};
/* harmony default export */ var block_grid = (BlockImageGalleryGrid);

;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockImageGallery/ImageGalleryStyleSlide/ImageGalleryNotPartialVisible/index.tsx








var ImageNotPartialVisible = function(props) {
    var imageGalleryItemArr = props.imageGalleryItemArr, style_attributes = props.style_attributes;
    var number_items_per_row = style_attributes.number_items_per_row, ratio = style_attributes.ratio;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
            modules: [
                swiper_esm/* Pagination */.tl,
                swiper_esm/* EffectFade */.xW,
                swiper_esm/* Lazy */.oM
            ],
            spaceBetween: 4,
            slidesPerView: number_items_per_row ? parseInt(number_items_per_row) : 1,
            pagination: {
                clickable: true
            },
            lazy: true,
            effect: "slide",
            className: classnames_default()("image-gallery-wrapper"),
            children: imageGalleryItemArr && imageGalleryItemArr.map(function(ele, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mb-5",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: ele.image,
                            className: "object-center image-gallery-image",
                            style: {
                                backgroundSize: "cover",
                                aspectRatio: ratio,
                                margin: "0 auto",
                                objectFit: "cover",
                                width: "100%"
                            },
                            alt: ""
                        })
                    })
                }, index);
            })
        })
    });
};
/* harmony default export */ var ImageGalleryNotPartialVisible = (ImageNotPartialVisible);

;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockImageGallery/ImageGalleryStyleSlide/ImageGalleryPanorama/index.jsx







var ImageGalleryPanorama = function(props) {
    var imageGalleryItemArr = props.imageGalleryItemArr, style_attributes = props.style_attributes;
    var number_items_per_row = style_attributes.number_items_per_row, ratio = style_attributes.ratio;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
            modules: [
                swiper_esm/* EffectFade */.xW,
                effect_panorama_esm/* default */.Z,
                swiper_esm/* Lazy */.oM
            ],
            spaceBetween: 4,
            slidesPerView: number_items_per_row ? parseInt(number_items_per_row) : 1,
            effect: "panorama",
            pagination: {
                clickable: true
            },
            lazy: true,
            children: imageGalleryItemArr === null || imageGalleryItemArr === void 0 ? void 0 : imageGalleryItemArr.map(function(ele, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mb-5",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: ele.image,
                            className: "object-center image-gallery-image",
                            style: {
                                backgroundSize: "cover",
                                aspectRatio: ratio,
                                margin: "0 auto",
                                objectFit: "cover",
                                width: "100%"
                            },
                            alt: ""
                        })
                    })
                }, index);
            })
        })
    });
};
/* harmony default export */ var ImageGalleryStyleSlide_ImageGalleryPanorama = (ImageGalleryPanorama);

;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockImageGallery/ImageGalleryStyleSlide/ImageGalleryPartialVisibleRight/index.tsx








var ImageGalleryPartialVisibleRight = function(props) {
    var imageGalleryItemArr = props.imageGalleryItemArr, style_attributes = props.style_attributes;
    var number_items_per_row = style_attributes.number_items_per_row, ratio = style_attributes.ratio;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
            modules: [
                swiper_esm/* Pagination */.tl,
                swiper_esm/* EffectFade */.xW,
                swiper_esm/* Lazy */.oM
            ],
            spaceBetween: 4,
            slidesPerView: number_items_per_row ? parseInt(number_items_per_row) : 1,
            pagination: {
                clickable: true
            },
            lazy: true,
            effect: "slide",
            className: classnames_default()("image-gallery-wrapper"),
            children: imageGalleryItemArr && imageGalleryItemArr.map(function(ele, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mb-5",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: ele.image,
                            className: "object-center image-gallery-image",
                            style: {
                                backgroundSize: "cover",
                                aspectRatio: ratio,
                                margin: "0 auto",
                                objectFit: "cover",
                                width: "100%"
                            },
                            alt: ""
                        })
                    })
                });
            })
        })
    });
};
/* harmony default export */ var ImageGalleryStyleSlide_ImageGalleryPartialVisibleRight = (ImageGalleryPartialVisibleRight);

;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockImageGallery/ImageGalleryStyleSlide/index.tsx
function ImageGalleryStyleSlide_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ImageGalleryStyleSlide_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ImageGalleryStyleSlide_defineProperty(target, key, source[key]);
        });
    }
    return target;
}






var ImageGalleryStyleSlide_obj;
var IMAGE_GALLERY_SLIDE_TYPE_COMPONENT = (ImageGalleryStyleSlide_obj = {}, ImageGalleryStyleSlide_defineProperty(ImageGalleryStyleSlide_obj, configs_const/* SLIDE_STYLE.NOT_PARTIAL_VISIBLE */.jw.NOT_PARTIAL_VISIBLE, ImageGalleryNotPartialVisible), ImageGalleryStyleSlide_defineProperty(ImageGalleryStyleSlide_obj, configs_const/* SLIDE_STYLE.PANORAMA */.jw.PANORAMA, ImageGalleryStyleSlide_ImageGalleryPanorama), ImageGalleryStyleSlide_defineProperty(ImageGalleryStyleSlide_obj, configs_const/* SLIDE_STYLE.PARTIAL_VISIBLE_RIGHT */.jw.PARTIAL_VISIBLE_RIGHT, ImageGalleryStyleSlide_ImageGalleryPartialVisibleRight), ImageGalleryStyleSlide_obj);
var ImageGalleryStyleSlide = function(props1) {
    var imageGalleryItemArr = props1.imageGalleryItemArr, style_attributes = props1.style_attributes;
    var ImageGallerySlideTypeRender = (0,react.useCallback)(function(props) {
        var ref;
        var Element = /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        if (IMAGE_GALLERY_SLIDE_TYPE_COMPONENT[props === null || props === void 0 ? void 0 : (ref = props.style_attributes) === null || ref === void 0 ? void 0 : ref.slide_style]) {
            var ref1;
            var RenderComponent = IMAGE_GALLERY_SLIDE_TYPE_COMPONENT[props === null || props === void 0 ? void 0 : (ref1 = props.style_attributes) === null || ref1 === void 0 ? void 0 : ref1.slide_style];
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(RenderComponent, ImageGalleryStyleSlide_objectSpread({}, props));
        }
        return Element;
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageGallerySlideTypeRender, {
        imageGalleryItemArr: imageGalleryItemArr,
        style_attributes: style_attributes
    });
};
/* harmony default export */ var BlockImageGallery_ImageGalleryStyleSlide = (ImageGalleryStyleSlide);

// EXTERNAL MODULE: ./node_modules/react-stack-grid/lib/index.js
var react_stack_grid_lib = __webpack_require__(52343);
;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockImageGallery/index.tsx










var BlockImageGallery = function(props) {
    var ref, ref1;
    var blockData = props.blockData, positionSlug = props.positionSlug, tabUid = props.tabUid, index1 = props.index, listBlocksSortOrder = props.listBlocksSortOrder, isFirstItem = props.isFirstItem, isApplyBlockSettings = props.isApplyBlockSettings, isHideMoreActions = props.isHideMoreActions;
    var enable = blockData && blockData.enable;
    var siteSettings = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.siteSettings;
    });
    var ref2 = (siteSettings === null || siteSettings === void 0 ? void 0 : (ref = siteSettings.display_setting) === null || ref === void 0 ? void 0 : (ref1 = ref.block_setting) === null || ref1 === void 0 ? void 0 : ref1.block_style) || {}, inner_space_number = ref2.inner_space_number, outside_space = ref2.outside_space;
    var content_attributes = blockData && blockData.content_attributes;
    var style_attributes = blockData && blockData.style_attributes;
    var style_display = style_attributes.style_display, number_items_per_row = style_attributes.number_items_per_row, ratio = style_attributes.ratio;
    var title_image_gallery = content_attributes.title_image_gallery, description_image_gallery = content_attributes.description_image_gallery, dataImageGalleryListArr = content_attributes.items;
    (0,react.useLayoutEffect)(function() {
        if (dataImageGalleryListArr) {}
    }, [
        dataImageGalleryListArr
    ]);
    var dataImageGalleryListSortOrder = dataImageGalleryListArr && orderBy_default()(dataImageGalleryListArr, [
        "sort_order"
    ], [
        "asc"
    ]);
    var imageGalleryListEnable = dataImageGalleryListSortOrder && dataImageGalleryListSortOrder.filter(function(x) {
        return x.enable === 1;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "".concat(blockData === null || blockData === void 0 ? void 0 : blockData.uid, " ").concat(enable),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BlockWrapper/* default */.Z, {
            blockType: blockData === null || blockData === void 0 ? void 0 : blockData.block_type,
            isEnable: enable,
            positionSlug: positionSlug,
            tabUid: tabUid,
            blockUid: blockData === null || blockData === void 0 ? void 0 : blockData.uid,
            index: index1,
            listBlocksSortOrder: listBlocksSortOrder,
            outsideSpace: outside_space,
            insideSpace: inner_space_number,
            isFirstItem: isFirstItem,
            isApplyBlockSettings: isApplyBlockSettings,
            isHideMoreActions: isHideMoreActions,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockHeadingComponent/* default */.Z, {
                    title: title_image_gallery,
                    blockType: blockData.block_type,
                    subtitle: description_image_gallery
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "w-full h-auto",
                    children: [
                        style_display === configs_const/* STYLE_SLIDE_IMAGE.GRID */.D5.GRID && /*#__PURE__*/ (0,jsx_runtime.jsx)(block_grid, {
                            imageGalleryList: imageGalleryListEnable,
                            number_items_per_row: number_items_per_row,
                            ratio: ratio
                        }),
                        style_display === configs_const/* STYLE_SLIDE_IMAGE.MASONRY */.D5.MASONRY && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_stack_grid_lib/* default */.ZP, {
                            columnWidth: "50%",
                            monitorImagesLoaded: true,
                            children: imageGalleryListEnable === null || imageGalleryListEnable === void 0 ? void 0 : imageGalleryListEnable.map(function(ele, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        alt: ele.name,
                                        src: ele.image,
                                        style: {
                                            maxWidth: "100%",
                                            cursor: "pointer"
                                        }
                                    })
                                }, index);
                            })
                        }),
                        style_display === configs_const/* STYLE_SLIDE_IMAGE.SLIDE */.D5.SLIDE && /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockImageGallery_ImageGalleryStyleSlide, {
                            style_attributes: style_attributes,
                            imageGalleryItemArr: imageGalleryListEnable
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var CommonBlockComponent_BlockImageGallery = (BlockImageGallery);

// EXTERNAL MODULE: ./src/features/mini-store/mini-store.config.tsx + 20 modules
var mini_store_config = __webpack_require__(98267);
// EXTERNAL MODULE: ./src/features/mini-store/share/hook.ts
var hook = __webpack_require__(25013);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var react_query_es = __webpack_require__(88767);
// EXTERNAL MODULE: ./src/features/mini-store/share/api/index.tsx
var share_api = __webpack_require__(25109);
;// CONCATENATED MODULE: ./src/features/mini-store/design/BlockVirtualGift/index.tsx
function BlockVirtualGift_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function BlockVirtualGift_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                BlockVirtualGift_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                BlockVirtualGift_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}











function BlockVirtualGift(props) {
    var ref, ref1;
    var blockData = props.blockData, positionSlug = props.positionSlug, tabUid = props.tabUid, index = props.index, listBlocksSortOrder = props.listBlocksSortOrder, isFirstItem = props.isFirstItem, isApplyBlockSettings = props.isApplyBlockSettings, isHideMoreActions = props.isHideMoreActions;
    var enable = blockData && blockData.enable;
    var dispatch = (0,hooks/* useAppDispatch */.TL)();
    var siteSettings = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.siteSettings;
    });
    var ref2 = (siteSettings === null || siteSettings === void 0 ? void 0 : (ref = siteSettings.display_setting) === null || ref === void 0 ? void 0 : (ref1 = ref.block_setting) === null || ref1 === void 0 ? void 0 : ref1.block_style) || {}, inner_space_number = ref2.inner_space_number, outside_space = ref2.outside_space;
    var allowService = window["AllowStore"];
    var t = (0,hook/* useAppTranslation */.S)().t;
    var loadStore = function() {
        var _ref = BlockVirtualGift_asyncToGenerator(runtime_default().mark(function _callee() {
            var store;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return (0,share_api/* fetchStoreToken */.uL)();
                    case 2:
                        store = _ctx.sent;
                        if (!store) {
                            _ctx.next = 5;
                            break;
                        }
                        return _ctx.abrupt("return", store);
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function loadStore() {
            return _ref.apply(this, arguments);
        };
    }();
    var ref3 = (0,react_query_es.useQuery)("LoadStore", loadStore, {
        refetchOnWindowFocus: false
    }), isLoading = ref3.isLoading, store1 = ref3.data;
    var handlerClick = function(event) {
        if (event === null || event === void 0 ? void 0 : event.defaultPrevented) {
            return;
        }
        dispatch((0,edittingBlockSlice/* openPopup */.Mw)({
            block: blockData,
            position_uid: positionSlug,
            tab_uid: tabUid,
            KEY: configs_const/* KEY_BLOCK.EDIT */.ne.EDIT
        }));
    };
    if (isLoading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: "loading"
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockWrapper/* default */.Z, {
        blockType: blockData === null || blockData === void 0 ? void 0 : blockData.block_type,
        onClick: handlerClick,
        isEnable: enable,
        positionSlug: positionSlug,
        tabUid: tabUid,
        blockUid: blockData === null || blockData === void 0 ? void 0 : blockData.uid,
        index: index,
        listBlocksSortOrder: listBlocksSortOrder,
        outsideSpace: outside_space,
        insideSpace: inner_space_number,
        isFirstItem: isFirstItem,
        isApplyBlockSettings: isApplyBlockSettings,
        isHideMoreActions: isHideMoreActions,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col justify-center items-center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: (!(store1 === null || store1 === void 0 ? void 0 : store1.virtual_gift_status) || !(allowService === null || allowService === void 0 ? void 0 : allowService.allow_view_virtual_gift)) && "opacity-50",
                    src: "https://i.ecomobi.com/ssp/mini-store/virtual-gift/gift-cover.png",
                    alt: ""
                }),
                !!(store1 === null || store1 === void 0 ? void 0 : store1.virtual_gift_status) && (allowService === null || allowService === void 0 ? void 0 : allowService.allow_view_virtual_gift) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                            className: "w-full text-center break-words pt-2 pb-4",
                            children: t("ss_gift_invitation", {
                                user: store1.name
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                            // className={`w-full button-border-radius button-background-color button-border-width button-border-color button-border-style button-text-color button-box-shadow middle-button`}
                            className: "w-full pp-button",
                            children: t("ss_gift_button_preview")
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockButtonMultiLink/ButtonMultiLinkDetail/Layout1/index.tsx






var Layout1 = function(props) {
    var style_attributes = props.style_attributes, content_attributes = props.content_attributes, button_link_image = props.button_link_image, button_link_description = props.button_link_description, button_link_title = props.button_link_title, button_link_layout = props.button_link_layout, button_link_size = props.button_link_size, button_link_style = props.button_link_style, button_link_template = props.button_link_template, button_link_icon = props.button_link_icon, button_link_url_icon = props.button_link_url_icon;
    var ref = content_attributes || {}, button_content = ref.button_content, button_icon = ref.button_icon, use_aff_url = ref.use_aff_url, target_url = ref.target_url, origin_url = ref.origin_url, button_description = ref.button_description, image = ref.image;
    // const {
    //   button_size,
    //   button_link_template,
    //   // button_link_layout,
    //   button_link_style,
    // } = style_attributes || {};
    var buttonSizeClass = (0,react.useMemo)(function() {
        var valueClass = null;
        switch(button_link_size){
            case "small":
                valueClass = "small-button";
                break;
            case "middle":
                valueClass = "middle-button";
                break;
            case "large":
                valueClass = "large-button";
                break;
        }
        return valueClass;
    }, [
        button_link_size
    ]);
    var isShowOnlyIcon = (0,react.useMemo)(function() {
        return button_link_style === configs_const/* LINK_STYLE_DISPLAY.ONLY_ICON */.Bx.ONLY_ICON && button_link_icon;
    }, [
        button_link_style,
        button_link_icon
    ]);
    var isShowOnlyImage = (0,react.useMemo)(function() {
        return button_link_style === configs_const/* LINK_STYLE_DISPLAY.ONLY_IMAGE */.Bx.ONLY_IMAGE && button_link_image;
    }, [
        button_link_style,
        button_link_image
    ]);
    var isShowIconRight = (0,react.useMemo)(function() {
        return button_link_style === configs_const/* LINK_STYLE_DISPLAY.TEXT_AND_ICON */.Bx.TEXT_AND_ICON && button_link_icon && button_link_layout === configs_const/* LINK_LAYOUTS.TEXT_RIGHT */.Q5.TEXT_RIGHT;
    }, [
        button_link_style,
        button_link_icon,
        button_link_layout
    ]);
    var isShowImageRight = (0,react.useMemo)(function() {
        return button_link_style === configs_const/* LINK_STYLE_DISPLAY.TEXT_AND_IMAGE */.Bx.TEXT_AND_IMAGE && button_link_image && button_link_layout === configs_const/* LINK_LAYOUTS.TEXT_LEFT */.Q5.TEXT_LEFT;
    }, [
        button_link_style,
        button_link_image,
        button_link_layout
    ]);
    var isShowIconLeft = (0,react.useMemo)(function() {
        return button_link_style === configs_const/* LINK_STYLE_DISPLAY.TEXT_AND_ICON */.Bx.TEXT_AND_ICON && button_link_icon && button_link_layout === configs_const/* LINK_LAYOUTS.TEXT_LEFT */.Q5.TEXT_LEFT;
    }, [
        button_link_style,
        button_link_icon,
        button_link_layout
    ]);
    var isShowImageLeft = (0,react.useMemo)(function() {
        return button_link_style === configs_const/* LINK_STYLE_DISPLAY.TEXT_AND_IMAGE */.Bx.TEXT_AND_IMAGE && button_link_image && button_link_layout === configs_const/* LINK_LAYOUTS.TEXT_RIGHT */.Q5.TEXT_RIGHT;
    }, [
        button_link_style,
        button_link_image,
        button_link_layout
    ]);
    var styleButtonLink = (0,react.useMemo)(function() {
        var styleObj = {};
        switch(button_link_template){
            case configs_const/* LINK_TEMPLATE.TEMPLATE1 */.Ei.TEMPLATE1:
                styleObj = {
                    "--background-color": "#f0ecec00",
                    "--border-color": "#333333"
                };
                break;
            case configs_const/* LINK_TEMPLATE.TEMPLATE2 */.Ei.TEMPLATE2:
                styleObj = {
                    "--background-color": "var(--button-bg-color-6)",
                    "--border-color": "var(--button-border-color-6)"
                };
                break;
            case configs_const/* LINK_TEMPLATE.TEMPLATE3 */.Ei.TEMPLATE3:
                styleObj = {
                    "--background-color": "var(--button-bg-color-6)",
                    "--border-color": "var(--button-border-color-6)",
                    boxShadow: "4px 5px 0px #000000"
                };
                break;
        }
        return styleObj;
    }, [
        button_link_template
    ]);
    var buttonClass = (0,react.useMemo)(function() {
        switch(button_link_template){
            case configs_const/* LINK_TEMPLATE.TEMPLATE1 */.Ei.TEMPLATE1:
                return (style_module_default()).template1;
            case configs_const/* LINK_TEMPLATE.TEMPLATE2 */.Ei.TEMPLATE2:
                return (style_module_default()).template2;
            case configs_const/* LINK_TEMPLATE.TEMPLATE3 */.Ei.TEMPLATE3:
                return (style_module_default()).template3;
        }
        return "";
    }, [
        button_link_template
    ]);
    var imageSizeValue = (0,react.useMemo)(function() {
        var valueSize = null;
        switch(button_link_size){
            case "small":
                valueSize = 38;
                break;
            case "middle":
                valueSize = 60;
                break;
            case "large":
                valueSize = 72;
                break;
        }
        return valueSize;
    }, [
        button_link_size
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                style: {
                    "--text-color": "unset",
                    height: "100%"
                },
                size: button_link_size,
                block: true,
                className: "".concat(buttonSizeClass, "  ").concat((style_module_default()).buttonStyle, "  button-border-radius button-border-width button-border-style button-link-wrapper  ").concat(button_link_layout, " ").concat(buttonClass),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-row gap-2 items-center justify-center",
                    children: [
                        (isShowIconRight || isShowOnlyIcon) && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconRender/* default */.Z, {
                            iconName: button_link_icon,
                            fillColor: button_link_template === configs_const/* LINK_TEMPLATE.TEMPLATE1 */.Ei.TEMPLATE1 ? "var(--heading-color-6)" : "var(--button-text-color)"
                        }),
                        (isShowImageLeft || isShowOnlyImage) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                                fit: "cover",
                                src: button_link_image,
                                width: imageSizeValue,
                                height: imageSizeValue,
                                className: "rounded"
                            })
                        }),
                        (button_link_title || button_link_description) && button_link_style !== configs_const/* LINK_STYLE_DISPLAY.ONLY_ICON */.Bx.ONLY_ICON && button_link_style !== configs_const/* LINK_STYLE_DISPLAY.ONLY_IMAGE */.Bx.ONLY_IMAGE ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col gap-1 text-center grow break-words",
                            children: [
                                button_link_title && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "button-link-content",
                                    style: {
                                        color: button_link_template === configs_const/* LINK_TEMPLATE.TEMPLATE1 */.Ei.TEMPLATE1 ? "var(--heading-color-6)" : "var(--button-text-color)"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Ellipsis */.mH, {
                                        content: button_link_title,
                                        rows: 3
                                    })
                                }),
                                button_link_description && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "button-link-description small",
                                    style: {
                                        color: button_link_template === configs_const/* LINK_TEMPLATE.TEMPLATE1 */.Ei.TEMPLATE1 ? "var(--heading-color-5)" : "var(--button-text-color)"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Ellipsis */.mH, {
                                        content: button_link_description,
                                        rows: 5
                                    })
                                })
                            ]
                        }) : button_link_style === configs_const/* LINK_STYLE_DISPLAY.ONLY_ICON */.Bx.ONLY_ICON || button_link_style === configs_const/* LINK_STYLE_DISPLAY.ONLY_IMAGE */.Bx.ONLY_IMAGE ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex flex-col gap-1 text-center grow",
                            children: " "
                        }),
                        isShowIconLeft && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconRender/* default */.Z, {
                            iconName: button_link_icon,
                            fillColor: button_link_template === configs_const/* LINK_TEMPLATE.TEMPLATE1 */.Ei.TEMPLATE1 ? "var(--heading-color-6)" : "var(--button-text-color)"
                        }),
                        isShowImageRight && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                                fit: "cover",
                                src: button_link_image,
                                width: imageSizeValue,
                                height: imageSizeValue,
                                className: "rounded"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute top-0 left-0 block w-full h-full rounded-lg",
                style: {
                    backgroundColor: "transparent"
                }
            })
        ]
    });
};
/* harmony default export */ var ButtonMultiLinkDetail_Layout1 = (Layout1);

;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockButtonMultiLink/ButtonMultiLinkDetail/Layout2/index.tsx






var Layout2 = function(props) {
    var style_attributes = props.style_attributes, content_attributes = props.content_attributes, button_link_image = props.button_link_image, button_link_description = props.button_link_description, button_link_title = props.button_link_title, button_link_layout = props.button_link_layout, button_link_size = props.button_link_size, button_link_style = props.button_link_style, button_link_template = props.button_link_template, button_link_icon = props.button_link_icon, button_link_url_icon = props.button_link_url_icon;
    var ref = content_attributes || {}, button_content = ref.button_content, button_icon = ref.button_icon, use_aff_url = ref.use_aff_url, target_url = ref.target_url, origin_url = ref.origin_url, button_description = ref.button_description, image = ref.image;
    // const {
    //   button_size,
    //   button_link_template,
    //   // button_link_layout,
    //   button_link_style,
    // } = style_attributes || {};
    var buttonSizeClass = (0,react.useMemo)(function() {
        var valueClass = null;
        switch(button_link_size){
            case "small":
                valueClass = "small-button";
                break;
            case "middle":
                valueClass = "middle-button";
                break;
            case "large":
                valueClass = "large-button";
                break;
        }
        return valueClass;
    }, [
        button_link_size
    ]);
    var isShowIcon = (0,react.useMemo)(function() {
        return button_link_style === configs_const/* LINK_STYLE_DISPLAY.TEXT_AND_ICON */.Bx.TEXT_AND_ICON && button_link_icon && button_link_layout === configs_const/* LINK_LAYOUTS.TEXT_UNDER */.Q5.TEXT_UNDER;
    }, [
        button_link_style,
        button_link_icon,
        button_link_layout
    ]);
    var isShowImage = (0,react.useMemo)(function() {
        return button_link_style === configs_const/* LINK_STYLE_DISPLAY.TEXT_AND_IMAGE */.Bx.TEXT_AND_IMAGE && button_link_image && button_link_layout === configs_const/* LINK_LAYOUTS.TEXT_UNDER */.Q5.TEXT_UNDER;
    }, [
        button_link_style,
        button_link_image,
        button_link_layout
    ]);
    var isShowOnlyIcon = (0,react.useMemo)(function() {
        return button_link_style === configs_const/* LINK_STYLE_DISPLAY.ONLY_ICON */.Bx.ONLY_ICON && button_link_icon;
    }, [
        button_link_style,
        button_link_icon
    ]);
    var isShowOnlyImage = (0,react.useMemo)(function() {
        return button_link_style === configs_const/* LINK_STYLE_DISPLAY.ONLY_IMAGE */.Bx.ONLY_IMAGE && button_link_image;
    }, [
        button_link_style,
        button_link_image
    ]);
    var styleButtonLink = (0,react.useMemo)(function() {
        var styleObj = {};
        switch(button_link_template){
            case configs_const/* LINK_TEMPLATE.TEMPLATE1 */.Ei.TEMPLATE1:
                styleObj = {
                    "--background-color": "#f0ecec00",
                    "--border-color": "#333333"
                };
                break;
            case configs_const/* LINK_TEMPLATE.TEMPLATE2 */.Ei.TEMPLATE2:
                styleObj = {
                    "--background-color": "var(--button-bg-color-6)",
                    "--border-color": "var(--button-border-color-6)"
                };
                break;
            case configs_const/* LINK_TEMPLATE.TEMPLATE3 */.Ei.TEMPLATE3:
                styleObj = {
                    "--background-color": "var(--button-bg-color-6)",
                    "--border-color": "var(--button-border-color-6)",
                    boxShadow: "4px 5px 0px #000000"
                };
                break;
        }
        return styleObj;
    }, [
        button_link_template
    ]);
    var buttonClass = (0,react.useMemo)(function() {
        switch(button_link_template){
            case configs_const/* LINK_TEMPLATE.TEMPLATE1 */.Ei.TEMPLATE1:
                return (style_module_default()).template1;
            case configs_const/* LINK_TEMPLATE.TEMPLATE2 */.Ei.TEMPLATE2:
                return (style_module_default()).template2;
            case configs_const/* LINK_TEMPLATE.TEMPLATE3 */.Ei.TEMPLATE3:
                return (style_module_default()).template3;
        }
        return "";
    }, [
        button_link_template
    ]);
    var imageSizeValue = (0,react.useMemo)(function() {
        var valueSize = null;
        switch(button_link_size){
            case "small":
                valueSize = 38;
                break;
            case "middle":
                valueSize = 60;
                break;
            case "large":
                valueSize = 72;
                break;
        }
        return valueSize;
    }, [
        button_link_size
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                style: {
                    "--text-color": "unset",
                    height: "100%"
                },
                size: button_link_size,
                block: true,
                className: "".concat(buttonSizeClass, " ").concat((style_module_default()).buttonStyle, " ").concat(buttonClass, "  button-border-radius button-border-width button-border-style button-link-wrapper  ").concat(button_link_layout),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: " flex-row gap-2 items-center justify-center",
                    children: [
                        (isShowIcon || isShowOnlyIcon) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex items-center justify-center break-words",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconRender/* default */.Z, {
                                iconName: button_link_icon,
                                fillColor: button_link_template === configs_const/* LINK_TEMPLATE.TEMPLATE1 */.Ei.TEMPLATE1 ? "var(--heading-color-6)" : "var(--button-text-color)"
                            })
                        }),
                        (isShowImage || isShowOnlyImage) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex items-center justify-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                                fit: "cover",
                                src: button_link_image,
                                width: imageSizeValue,
                                height: imageSizeValue,
                                className: "rounded"
                            })
                        }),
                        (button_link_title || button_link_description) && button_link_style !== configs_const/* LINK_STYLE_DISPLAY.ONLY_ICON */.Bx.ONLY_ICON && button_link_style !== configs_const/* LINK_STYLE_DISPLAY.ONLY_IMAGE */.Bx.ONLY_IMAGE && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col gap-1 text-center grow break-words",
                            children: [
                                button_link_title && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "button-link-content",
                                    style: {
                                        color: button_link_template === configs_const/* LINK_TEMPLATE.TEMPLATE1 */.Ei.TEMPLATE1 ? "var(--heading-color-6)" : "var(--button-text-color)"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Ellipsis */.mH, {
                                        content: button_link_title,
                                        rows: 3
                                    })
                                }),
                                button_link_description && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "button-link-description small",
                                    style: {
                                        color: button_link_template === configs_const/* LINK_TEMPLATE.TEMPLATE1 */.Ei.TEMPLATE1 ? "var(--heading-color-5)" : "var(--button-text-color)"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Ellipsis */.mH, {
                                        content: button_link_description,
                                        rows: 5
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute top-0 left-0 block w-full h-full rounded-lg",
                style: {
                    backgroundColor: "transparent"
                }
            })
        ]
    });
};
/* harmony default export */ var ButtonMultiLinkDetail_Layout2 = (Layout2);

;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockButtonMultiLink/ButtonMultiLinkDetail/Layout3/index.tsx






var Layout3_Layout1 = function(props) {
    var style_attributes = props.style_attributes, content_attributes = props.content_attributes, button_link_image = props.button_link_image, button_link_description = props.button_link_description, button_link_title = props.button_link_title, button_link_layout = props.button_link_layout, button_link_size = props.button_link_size, button_link_style = props.button_link_style, button_link_template = props.button_link_template, button_link_icon = props.button_link_icon, button_link_url_icon = props.button_link_url_icon, index = props.index;
    var ref = content_attributes || {}, button_content = ref.button_content, button_icon = ref.button_icon, use_aff_url = ref.use_aff_url, target_url = ref.target_url, origin_url = ref.origin_url, button_description = ref.button_description, image = ref.image;
    // const {
    //   button_size,
    //   button_link_template,
    //   // button_link_layout,
    //   button_link_style,
    // } = style_attributes || {};
    var buttonSizeClass = (0,react.useMemo)(function() {
        var valueClass = null;
        switch(button_link_size){
            case "small":
                valueClass = "small-button";
                break;
            case "middle":
                valueClass = "middle-button";
                break;
            case "large":
                valueClass = "large-button";
                break;
        }
        return valueClass;
    }, [
        button_link_size
    ]);
    var isShowIconRight = (0,react.useMemo)(function() {
        return (button_link_style === configs_const/* LINK_STYLE_DISPLAY.TEXT_AND_ICON */.Bx.TEXT_AND_ICON || button_link_style === configs_const/* LINK_STYLE_DISPLAY.ONLY_ICON */.Bx.ONLY_ICON) && button_link_icon && Number(index) % 2 === 0;
    }, [
        button_link_style,
        button_link_icon,
        button_link_layout
    ]);
    var isShowImageRight = (0,react.useMemo)(function() {
        return (button_link_style === configs_const/* LINK_STYLE_DISPLAY.TEXT_AND_IMAGE */.Bx.TEXT_AND_IMAGE || button_link_style === configs_const/* LINK_STYLE_DISPLAY.ONLY_IMAGE */.Bx.ONLY_IMAGE) && button_link_image && Number(index) % 2 === 1;
    }, [
        button_link_style,
        button_link_image,
        button_link_layout
    ]);
    var isShowIconLeft = (0,react.useMemo)(function() {
        return (button_link_style === configs_const/* LINK_STYLE_DISPLAY.TEXT_AND_ICON */.Bx.TEXT_AND_ICON || button_link_style === configs_const/* LINK_STYLE_DISPLAY.ONLY_ICON */.Bx.ONLY_ICON) && button_link_icon && Number(index) % 2 === 1;
    }, [
        button_link_style,
        button_link_icon,
        button_link_layout
    ]);
    var isShowImageLeft = (0,react.useMemo)(function() {
        return (button_link_style === configs_const/* LINK_STYLE_DISPLAY.TEXT_AND_IMAGE */.Bx.TEXT_AND_IMAGE || button_link_style === configs_const/* LINK_STYLE_DISPLAY.ONLY_IMAGE */.Bx.ONLY_IMAGE) && button_link_image && Number(index) % 2 === 0;
    }, [
        button_link_style,
        button_link_image,
        button_link_layout
    ]);
    var styleButtonLink = (0,react.useMemo)(function() {
        var styleObj = {};
        switch(button_link_template){
            case configs_const/* LINK_TEMPLATE.TEMPLATE1 */.Ei.TEMPLATE1:
                styleObj = {
                    "--background-color": "#f0ecec00",
                    "--border-color": "#333333"
                };
                break;
            case configs_const/* LINK_TEMPLATE.TEMPLATE2 */.Ei.TEMPLATE2:
                styleObj = {
                    "--background-color": "var(--button-bg-color-6)",
                    "--border-color": "var(--button-border-color-6)"
                };
                break;
            case configs_const/* LINK_TEMPLATE.TEMPLATE3 */.Ei.TEMPLATE3:
                styleObj = {
                    "--background-color": "var(--button-bg-color-6)",
                    "--border-color": "var(--button-border-color-6)",
                    boxShadow: "4px 5px 0px #000000"
                };
                break;
        }
        return styleObj;
    }, [
        button_link_template
    ]);
    var buttonClass = (0,react.useMemo)(function() {
        switch(button_link_template){
            case configs_const/* LINK_TEMPLATE.TEMPLATE1 */.Ei.TEMPLATE1:
                return (style_module_default()).template1;
            case configs_const/* LINK_TEMPLATE.TEMPLATE2 */.Ei.TEMPLATE2:
                return (style_module_default()).template2;
            case configs_const/* LINK_TEMPLATE.TEMPLATE3 */.Ei.TEMPLATE3:
                return (style_module_default()).template3;
        }
        return "";
    }, [
        button_link_template
    ]);
    var imageSizeValue = (0,react.useMemo)(function() {
        var valueSize = null;
        switch(button_link_size){
            case "small":
                valueSize = 38;
                break;
            case "middle":
                valueSize = 60;
                break;
            case "large":
                valueSize = 72;
                break;
        }
        return valueSize;
    }, [
        button_link_size
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                style: {
                    "--text-color": "unset"
                },
                size: button_link_size,
                block: true,
                className: "".concat(buttonSizeClass, " ").concat((style_module_default()).buttonStyle, " ").concat(buttonClass, "  button-border-radius button-border-width button-border-style button-link-wrapper  ").concat(button_link_layout),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-row gap-2 items-center justify-center",
                    children: [
                        isShowIconRight && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconRender/* default */.Z, {
                            iconName: button_link_icon,
                            fillColor: button_link_template === configs_const/* LINK_TEMPLATE.TEMPLATE1 */.Ei.TEMPLATE1 ? "var(--heading-color-6)" : "var(--button-text-color)"
                        }),
                        isShowImageLeft && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                                fit: "cover",
                                src: button_link_image,
                                width: imageSizeValue,
                                height: imageSizeValue,
                                className: "rounded"
                            })
                        }),
                        (button_link_title || button_link_description) && button_link_style !== configs_const/* LINK_STYLE_DISPLAY.ONLY_ICON */.Bx.ONLY_ICON && button_link_style !== configs_const/* LINK_STYLE_DISPLAY.ONLY_IMAGE */.Bx.ONLY_IMAGE ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col gap-1 text-center grow break-words",
                            children: [
                                button_link_title && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "button-link-content",
                                    style: {
                                        color: button_link_template === configs_const/* LINK_TEMPLATE.TEMPLATE1 */.Ei.TEMPLATE1 ? "var(--heading-color-6)" : "var(--button-text-color)"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Ellipsis */.mH, {
                                        content: button_link_title,
                                        rows: 3
                                    })
                                }),
                                button_link_description && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "button-link-description small",
                                    style: {
                                        color: button_link_template === configs_const/* LINK_TEMPLATE.TEMPLATE1 */.Ei.TEMPLATE1 ? "var(--heading-color-5)" : "var(--button-text-color)"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Ellipsis */.mH, {
                                        content: button_link_description,
                                        rows: 5
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex flex-col gap-1 text-center grow"
                        }),
                        isShowIconLeft && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconRender/* default */.Z, {
                            iconName: button_link_icon,
                            fillColor: button_link_template === configs_const/* LINK_TEMPLATE.TEMPLATE1 */.Ei.TEMPLATE1 ? "var(--heading-color-6)" : "var(--button-text-color)"
                        }),
                        isShowImageRight && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                                fit: "cover",
                                src: button_link_image,
                                width: imageSizeValue,
                                height: imageSizeValue,
                                className: "rounded"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute top-0 left-0 block w-full h-full rounded-lg",
                style: {
                    backgroundColor: "transparent"
                }
            })
        ]
    });
};
/* harmony default export */ var Layout3 = (Layout3_Layout1);

;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockButtonMultiLink/ButtonMultiLinkDetail/index.tsx
function ButtonMultiLinkDetail_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ButtonMultiLinkDetail_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ButtonMultiLinkDetail_defineProperty(target, key, source[key]);
        });
    }
    return target;
}






var ButtonMultiLinkDetail_obj;
var BUTTON_MULTI_LINK_LAYOUT_COMPONENT = (ButtonMultiLinkDetail_obj = {}, ButtonMultiLinkDetail_defineProperty(ButtonMultiLinkDetail_obj, configs_const/* LINK_LAYOUTS.TEXT_RIGHT */.Q5.TEXT_RIGHT, ButtonMultiLinkDetail_Layout1), ButtonMultiLinkDetail_defineProperty(ButtonMultiLinkDetail_obj, configs_const/* LINK_LAYOUTS.TEXT_LEFT */.Q5.TEXT_LEFT, ButtonMultiLinkDetail_Layout1), ButtonMultiLinkDetail_defineProperty(ButtonMultiLinkDetail_obj, configs_const/* LINK_LAYOUTS.TEXT_UNDER */.Q5.TEXT_UNDER, ButtonMultiLinkDetail_Layout2), ButtonMultiLinkDetail_defineProperty(ButtonMultiLinkDetail_obj, configs_const/* LINK_LAYOUTS.TEXT_ZIG_ZAG */.Q5.TEXT_ZIG_ZAG, Layout3), ButtonMultiLinkDetail_obj);
var ButtonMultiLinkDetail = function(props1) {
    var ref13;
    var ref1 = props1 === null || props1 === void 0 ? void 0 : props1.blockData, style_attributes = ref1.style_attributes, button_link_attributes = ref1.button_link_attributes, button_link_see_more_btn = ref1.button_link_see_more_btn, content_attributes = ref1.content_attributes;
    var ref2 = style_attributes || {}, button_link_layout = ref2.button_link_layout, button_link_slide_type = ref2.button_link_slide_type, button_link_style = ref2.button_link_style, image_orientation = ref2.image_orientation, item_on_row = ref2.item_on_row, ratio = ref2.ratio, button_size = ref2.button_size;
    var items = (content_attributes || {}).items;
    var gridStyle = (0,react.useMemo)(function() {
        var gridStyleValue = null;
        switch(item_on_row){
            case configs_const/* MULTI_BUTTON_LINK_ITEM_ON_ROW.ONE */.jc.ONE:
                gridStyleValue = {
                    display: "grid",
                    gridTemplateColumns: "repeat(1, minmax(0, 1fr))",
                    gap: "12px"
                };
                break;
            case configs_const/* MULTI_BUTTON_LINK_ITEM_ON_ROW.TWO */.jc.TWO:
                gridStyleValue = {
                    display: "grid",
                    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                    gap: "12px"
                };
                break;
            case configs_const/* MULTI_BUTTON_LINK_ITEM_ON_ROW.THREE */.jc.THREE:
                gridStyleValue = {
                    display: "grid",
                    gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
                    gap: "12px"
                };
                break;
            case configs_const/* MULTI_BUTTON_LINK_ITEM_ON_ROW.FOUR */.jc.FOUR:
                gridStyleValue = {
                    display: "grid",
                    gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
                    gap: "12px"
                };
                break;
            case configs_const/* MULTI_BUTTON_LINK_ITEM_ON_ROW.FIVE */.jc.FIVE:
                gridStyleValue = {
                    display: "grid",
                    gridTemplateColumns: "repeat(5, minmax(0, 1fr))",
                    gap: "12px"
                };
                break;
            case configs_const/* MULTI_BUTTON_LINK_ITEM_ON_ROW.SIX */.jc.SIX:
                gridStyleValue = {
                    display: "grid",
                    gridTemplateColumns: "repeat(6, minmax(0, 1fr))",
                    gap: "12px"
                };
                break;
            default:
                gridStyleValue = {
                    display: "grid",
                    gridTemplateColumns: "repeat(1, minmax(0, 1fr))",
                    gap: "12px"
                };
        }
        return gridStyleValue;
    }, [
        item_on_row
    ]);
    var ButtonMultiLinkDetailLayoutRender = (0,react.useCallback)(function(props) {
        var Element = /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: "DEFAULT"
        });
        if (BUTTON_MULTI_LINK_LAYOUT_COMPONENT[props === null || props === void 0 ? void 0 : props.button_link_layout]) {
            var RenderComponent = BUTTON_MULTI_LINK_LAYOUT_COMPONENT[props === null || props === void 0 ? void 0 : props.button_link_layout];
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(RenderComponent, ButtonMultiLinkDetail_objectSpread({}, props));
        }
        return Element;
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            style: gridStyle,
            children: (ref13 = items === null || items === void 0 ? void 0 : items.filter(function(item) {
                return (item === null || item === void 0 ? void 0 : item.enable) === 1;
            })) === null || ref13 === void 0 ? void 0 : ref13.map(function(item, index) {
                var ref, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonMultiLinkDetailLayoutRender, {
                        button_link_title: item === null || item === void 0 ? void 0 : (ref = item.content_attributes) === null || ref === void 0 ? void 0 : ref.link_title,
                        button_link_description: item === null || item === void 0 ? void 0 : (ref3 = item.content_attributes) === null || ref3 === void 0 ? void 0 : ref3.link_description,
                        button_link_image: item === null || item === void 0 ? void 0 : (ref4 = item.content_attributes) === null || ref4 === void 0 ? void 0 : ref4.image,
                        button_link_layout: item === null || item === void 0 ? void 0 : (ref5 = item.style_attributes) === null || ref5 === void 0 ? void 0 : ref5.button_link_layout,
                        button_link_url: item === null || item === void 0 ? void 0 : (ref6 = item.content_attributes) === null || ref6 === void 0 ? void 0 : ref6.link_url,
                        item_on_row: button_link_layout === configs_const/* LINK_LAYOUTS.TEXT_ZIG_ZAG */.Q5.TEXT_ZIG_ZAG ? 1 : item === null || item === void 0 ? void 0 : (ref7 = item.style_attributes) === null || ref7 === void 0 ? void 0 : ref7.item_on_row,
                        button_link_style: item === null || item === void 0 ? void 0 : (ref8 = item.style_attributes) === null || ref8 === void 0 ? void 0 : ref8.button_link_style,
                        button_link_slide_type: button_link_slide_type,
                        button_link_size: item === null || item === void 0 ? void 0 : (ref9 = item.style_attributes) === null || ref9 === void 0 ? void 0 : ref9.button_size,
                        button_link_icon: item === null || item === void 0 ? void 0 : (ref10 = item.content_attributes) === null || ref10 === void 0 ? void 0 : ref10.button_icon,
                        button_link_url_icon: item === null || item === void 0 ? void 0 : (ref11 = item.content_attributes) === null || ref11 === void 0 ? void 0 : ref11.button_icon_url,
                        index: index,
                        button_link_template: item === null || item === void 0 ? void 0 : (ref12 = item.style_attributes) === null || ref12 === void 0 ? void 0 : ref12.button_link_template
                    })
                }, item.uid);
            })
        })
    });
};
/* harmony default export */ var BlockButtonMultiLink_ButtonMultiLinkDetail = (ButtonMultiLinkDetail);

;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockButtonMultiLink/index.tsx
function BlockButtonMultiLink_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function BlockButtonMultiLink_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            BlockButtonMultiLink_defineProperty(target, key, source[key]);
        });
    }
    return target;
}






var BlockButtonMultiLink = function(props) {
    var ref, ref1, ref2, ref3;
    var blockData = props.blockData, positionSlug = props.positionSlug, tabUid = props.tabUid, index = props.index, listBlocksSortOrder = props.listBlocksSortOrder, isFirstItem = props.isFirstItem, isApplyBlockSettings = props.isApplyBlockSettings, isHideMoreActions = props.isHideMoreActions;
    var enable = blockData && blockData.enable;
    var siteSettings = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.siteSettings;
    });
    var ref4 = (siteSettings === null || siteSettings === void 0 ? void 0 : (ref = siteSettings.display_setting) === null || ref === void 0 ? void 0 : (ref1 = ref.block_setting) === null || ref1 === void 0 ? void 0 : ref1.block_style) || {}, inner_space_number = ref4.inner_space_number, outside_space = ref4.outside_space;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BlockWrapper/* default */.Z, {
        blockType: blockData === null || blockData === void 0 ? void 0 : blockData.block_type,
        isEnable: enable,
        positionSlug: positionSlug,
        tabUid: tabUid,
        blockUid: blockData === null || blockData === void 0 ? void 0 : blockData.uid,
        index: index,
        listBlocksSortOrder: listBlocksSortOrder,
        outsideSpace: outside_space,
        insideSpace: inner_space_number,
        isFirstItem: isFirstItem,
        isApplyBlockSettings: isApplyBlockSettings,
        isHideMoreActions: isHideMoreActions,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockHeadingComponent/* default */.Z, {
                title: blockData === null || blockData === void 0 ? void 0 : (ref2 = blockData.content_attributes) === null || ref2 === void 0 ? void 0 : ref2.button_content,
                blockType: blockData.block_type,
                subtitle: blockData === null || blockData === void 0 ? void 0 : (ref3 = blockData.content_attributes) === null || ref3 === void 0 ? void 0 : ref3.button_description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockButtonMultiLink_ButtonMultiLinkDetail, BlockButtonMultiLink_objectSpread({}, props))
        ]
    });
};
/* harmony default export */ var CommonBlockComponent_BlockButtonMultiLink = (BlockButtonMultiLink);

// EXTERNAL MODULE: ./src/features/block/block-editor/ImagePopup/index.tsx + 6 modules
var ImagePopup = __webpack_require__(69851);
;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/ImagePopup/index.tsx








var ImagePopup_ImagePopup = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var blockData = props.blockData, positionSlug = props.positionSlug, tabUid = props.tabUid, index = props.index, listBlocksSortOrder = props.listBlocksSortOrder, isFirstItem = props.isFirstItem, isApplyBlockSettings = props.isApplyBlockSettings, isHideMoreActions = props.isHideMoreActions;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var siteSettings = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.siteSettings;
    });
    var ref6 = (siteSettings === null || siteSettings === void 0 ? void 0 : (ref = siteSettings.display_setting) === null || ref === void 0 ? void 0 : (ref1 = ref.block_setting) === null || ref1 === void 0 ? void 0 : ref1.block_style) || {}, inner_space_number = ref6.inner_space_number, outside_space = ref6.outside_space;
    var enable = blockData && blockData.enable;
    var firstImageEnable = blockData === null || blockData === void 0 ? void 0 : (ref2 = blockData.content_attributes) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.items) === null || ref3 === void 0 ? void 0 : ref3.find(function(e) {
        return e.enable === configs_const/* STATUS.ENABLE */.Q_.ENABLE;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockWrapper/* default */.Z, {
        blockType: blockData.block_type,
        isEnable: enable,
        positionSlug: positionSlug,
        tabUid: tabUid,
        blockUid: blockData === null || blockData === void 0 ? void 0 : blockData.uid,
        index: index,
        listBlocksSortOrder: listBlocksSortOrder,
        isFirstItem: isFirstItem,
        outsideSpace: outside_space,
        extraStyle: {
            padding: "0",
            border: "0",
            background: "transparent",
            // border: "0",
            borderWidth: "0",
            backdropFilter: "none",
            borderStyle: "none",
            boxShadow: "none"
        },
        // insideSpace={inner_space_number}
        isApplyBlockSettings: isApplyBlockSettings,
        isHideMoreActions: isHideMoreActions,
        children: firstImageEnable ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-auto m-width-[80vw] m-auto",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                                src: firstImageEnable === null || firstImageEnable === void 0 ? void 0 : firstImageEnable.image,
                                className: "rounded-lg m-width-[460px] ",
                                style: {
                                    maxHeight: "calc(100vh - 20px)",
                                    border: "1px solid rgba(130, 130, 130, 0.75)",
                                    background: "rgba(0, 0, 0, 0.4)"
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "absolute bottom-0 right-0 m-1 py-1 px-2 rounded text-white",
                            style: {
                                maxHeight: "calc(100vh - 20px)"
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "absolute bottom-0 right-0 m-1 py-1 px-2 rounded text-white",
                    style: {
                        background: "rgba(38, 38, 38, 0.6)"
                    },
                    children: [
                        blockData === null || blockData === void 0 ? void 0 : (ref4 = blockData.content_attributes) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.items) === null || ref5 === void 0 ? void 0 : ref5.length,
                        "/",
                        ImagePopup/* IMAGE_MAX */.L
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: t("ss_builder_title_block_image_popup")
        })
    });
};
/* harmony default export */ var CommonBlockComponent_ImagePopup = (ImagePopup_ImagePopup);

// EXTERNAL MODULE: ./src/features/block/block-editor/SpacerAndDivider/DividerSetting/index.tsx + 1 modules
var DividerSetting = __webpack_require__(15231);
// EXTERNAL MODULE: ./src/features/block/block-editor/SpacerAndDivider/Preview/SpacerAndDividerSample/DividerImage/index.tsx
var DividerImage = __webpack_require__(66639);
// EXTERNAL MODULE: ./src/features/block/block-editor/SpacerAndDivider/Preview/SpacerAndDividerSample/DividerLine/index.tsx
var DividerLine = __webpack_require__(26124);
;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockSpacerAndDivider/index.tsx







var BlockSpacerAndDivider = function(props) {
    var ref, ref1;
    var blockData = props.blockData, positionSlug = props.positionSlug, tabUid = props.tabUid, index = props.index, listBlocksSortOrder = props.listBlocksSortOrder, isFirstItem = props.isFirstItem, isApplyBlockSettings = props.isApplyBlockSettings, isHideMoreActions = props.isHideMoreActions;
    var enable = blockData && blockData.enable;
    var siteSettings = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.siteSettings;
    });
    var ref2 = (siteSettings === null || siteSettings === void 0 ? void 0 : (ref = siteSettings.display_setting) === null || ref === void 0 ? void 0 : (ref1 = ref.block_setting) === null || ref1 === void 0 ? void 0 : ref1.block_style) || {}, inner_space_number = ref2.inner_space_number, outside_space = ref2.outside_space, block_space = ref2.block_space;
    var ref3 = (blockData === null || blockData === void 0 ? void 0 : blockData.content_attributes) || {}, spacing_value = ref3.spacing_value, divider_thickness = ref3.divider_thickness, divider_color = ref3.divider_color, divider_image = ref3.image;
    var ref4 = (blockData === null || blockData === void 0 ? void 0 : blockData.style_attributes) || {}, divider_type = ref4.divider_type, layout_type = ref4.layout_type;
    var layoutRender = (0,react.useMemo)(function() {
        if (!layout_type) return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "w-full",
            style: {
                height: "".concat(spacing_value, "px")
            }
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "h-full w-full",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        height: "".concat(block_space / 2, "px")
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        height: "".concat(spacing_value / 2, "px")
                    }
                }),
                layout_type === DividerSetting/* LAYOUT_TYPE_ENUM.DEFAULTS */.E.DEFAULTS && /*#__PURE__*/ (0,jsx_runtime.jsx)(DividerLine/* default */.Z, {
                    divider_thickness: divider_thickness,
                    divider_color: divider_color,
                    divider_type: divider_type
                }),
                layout_type === DividerSetting/* LAYOUT_TYPE_ENUM.IMAGE */.E.IMAGE && /*#__PURE__*/ (0,jsx_runtime.jsx)(DividerImage/* default */.Z, {
                    divider_image: divider_image
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        height: "".concat(spacing_value / 2, "px")
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        height: "".concat(block_space / 2, "px")
                    }
                })
            ]
        });
    }, [
        spacing_value,
        layout_type,
        block_space,
        divider_image,
        divider_thickness,
        divider_color,
        divider_type, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockWrapper/* default */.Z, {
        blockType: blockData === null || blockData === void 0 ? void 0 : blockData.block_type,
        isEnable: enable,
        positionSlug: positionSlug,
        tabUid: tabUid,
        blockUid: blockData === null || blockData === void 0 ? void 0 : blockData.uid,
        index: index,
        listBlocksSortOrder: listBlocksSortOrder,
        outsideSpace: outside_space,
        insideSpace: inner_space_number,
        isFirstItem: isFirstItem,
        isApplyBlockSettings: isApplyBlockSettings,
        isHideMoreActions: isHideMoreActions,
        children: layoutRender
    });
};
/* harmony default export */ var CommonBlockComponent_BlockSpacerAndDivider = (BlockSpacerAndDivider);

// EXTERNAL MODULE: ./src/features/design/components/CommonBlockComponent/BlockCombined/AdvancedSettingWrapper/index.tsx
var AdvancedSettingWrapper = __webpack_require__(15879);
// EXTERNAL MODULE: ./src/features/design/components/CommonBlockComponent/BlockCombined/BlockListsDisplay/index.tsx
var BlockListsDisplay = __webpack_require__(82454);
// EXTERNAL MODULE: ./src/features/block/block-editor/Combined/components/PreviewStyleHOC.tsx
var PreviewStyleHOC = __webpack_require__(16841);
;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockCombined/index.tsx
function BlockCombined_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function BlockCombined_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            BlockCombined_defineProperty(target, key, source[key]);
        });
    }
    return target;
}









var BlockCombined = function(props) {
    var ref, ref1;
    var blockData = props.blockData, positionSlug = props.positionSlug, tabUid = props.tabUid, index = props.index, listBlocksSortOrder = props.listBlocksSortOrder, isFirstItem = props.isFirstItem, isApplyBlockSettings = props.isApplyBlockSettings;
    var dispatch = (0,hooks/* useAppDispatch */.TL)();
    var enable = blockData && blockData.enable;
    var ref2 = (blockData === null || blockData === void 0 ? void 0 : blockData.content_attributes) || {}, blocks = ref2.blocks, block_title = ref2.block_title, block_description = ref2.block_description;
    var ref3 = (blockData === null || blockData === void 0 ? void 0 : blockData.style_attributes) || {}, _block_space = ref3.block_space, block_space = _block_space === void 0 ? 12 : _block_space, advanced_setting = ref3.advanced_setting, _is_applied_block_global_settings = ref3.is_applied_block_global_settings, is_applied_block_global_settings = _is_applied_block_global_settings === void 0 ? false : _is_applied_block_global_settings;
    var siteSettings = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.siteSettings;
    });
    var ref4 = (siteSettings === null || siteSettings === void 0 ? void 0 : (ref = siteSettings.display_setting) === null || ref === void 0 ? void 0 : (ref1 = ref.block_setting) === null || ref1 === void 0 ? void 0 : ref1.block_style) || {}, inner_space_number = ref4.inner_space_number, outside_space = ref4.outside_space;
    var enableBlocks = blocks === null || blocks === void 0 ? void 0 : blocks.filter(function(x) {
        return x.enable === 1;
    });
    var handleUpdateCombinedBlockData = function(data) {
        if (data) {
            var newBlocks = blocks.map(function(x) {
                if (x.uid === data.uid) {
                    return data;
                }
                return x;
            });
            dispatch((0,positionsSlice/* updateBlock */.Df)({
                tabUid: tabUid,
                positionSlug: positionSlug,
                blockData: BlockCombined_objectSpread({}, blockData, {
                    content_attributes: BlockCombined_objectSpread({}, blockData.content_attributes, {
                        blocks: newBlocks
                    })
                })
            }));
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PreviewStyleHOC/* default */.Z, {
        elementId: blockData === null || blockData === void 0 ? void 0 : blockData.uid,
        advancedSetting: advanced_setting,
        isAppliedBlockGlobalSettings: is_applied_block_global_settings,
        blockUid: blockData === null || blockData === void 0 ? void 0 : blockData.uid,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockWrapper/* default */.Z, {
            blockType: blockData === null || blockData === void 0 ? void 0 : blockData.block_type,
            isEnable: enable,
            positionSlug: positionSlug,
            tabUid: tabUid,
            blockUid: blockData === null || blockData === void 0 ? void 0 : blockData.uid,
            index: index,
            listBlocksSortOrder: listBlocksSortOrder,
            outsideSpace: outside_space,
            insideSpace: inner_space_number,
            isFirstItem: isFirstItem,
            isApplyBlockSettings: isApplyBlockSettings,
            // useAdvancedSetting={advanced_setting?.use_advanced_setting}
            advancedSetting: advanced_setting,
            children: (advanced_setting === null || advanced_setting === void 0 ? void 0 : advanced_setting.use_advanced_setting) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(AdvancedSettingWrapper/* default */.Z, {
                advancedSetting: advanced_setting,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockHeadingComponent/* default */.Z, {
                        title: block_title,
                        blockType: blockData.block_type,
                        subtitle: block_description,
                        blockUid: blockData.uid
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            marginLeft: is_applied_block_global_settings && outside_space ? "-12px" : "0px",
                            marginRight: is_applied_block_global_settings && outside_space ? "-12px" : "0px"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockListsDisplay/* default */.Z, {
                            blocks: enableBlocks,
                            blockSpace: block_space,
                            onGetLatestBlockData: function(data) {
                                return handleUpdateCombinedBlockData(data);
                            },
                            isApplyGlobalSettings: is_applied_block_global_settings
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockHeadingComponent/* default */.Z, {
                        title: block_title,
                        blockType: blockData.block_type,
                        subtitle: block_description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            marginLeft: is_applied_block_global_settings && outside_space ? "-12px" : "0px",
                            marginRight: is_applied_block_global_settings && outside_space ? "-12px" : "0px"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockListsDisplay/* default */.Z, {
                            blocks: enableBlocks,
                            blockSpace: block_space,
                            onGetLatestBlockData: function(data) {
                                return handleUpdateCombinedBlockData(data);
                            },
                            isApplyGlobalSettings: is_applied_block_global_settings
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var CommonBlockComponent_BlockCombined = (BlockCombined);

;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockBookingProfile/CardContentStyle/index.tsx




var CardContentStyle = function(param) {
    var image = param.image, booking_profile_title = param.booking_profile_title, booking_profile_description = param.booking_profile_description, booking_profile_button_content = param.booking_profile_button_content;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col gap-3 justify-center text-center",
        children: [
            image && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "rounded",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                    className: "w-full rounded",
                    src: image,
                    fit: "cover",
                    style: {
                        aspectRatio: "16/9"
                    }
                })
            }),
            (booking_profile_title || booking_profile_description) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    booking_profile_title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        style: {
                            color: "var(--text-color-6)",
                            margin: 0
                        },
                        children: booking_profile_title
                    }),
                    booking_profile_description && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        style: {
                            color: "var(--text-color-6)",
                            margin: 0
                        },
                        children: booking_profile_description
                    })
                ]
            }),
            booking_profile_button_content && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                    fill: "solid",
                    size: "middle",
                    className: "pp-button",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center gap-x-2",
                        children: [
                            booking_profile_button_content,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ArrowRightIcon */.LZ, {
                                fillColor: "var(--button-text-color)",
                                style: {
                                    width: "var(--middle-button-font-size)",
                                    height: "var(--middle-button-font-size)"
                                }
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var BlockBookingProfile_CardContentStyle = (CardContentStyle);

// EXTERNAL MODULE: ./src/features/block/block-editor/BookingProfile/constant.ts
var constant = __webpack_require__(92338);
;// CONCATENATED MODULE: ./src/features/share/configs/booking-profile.ts
var BOOKING_PROFILE_PATH = "/booking-profile";

// EXTERNAL MODULE: ./src/features/design/components/CommonBlockComponent/BlockBookingProfile/EmbedCodeStyle/style.module.scss
var EmbedCodeStyle_style_module = __webpack_require__(20938);
var EmbedCodeStyle_style_module_default = /*#__PURE__*/__webpack_require__.n(EmbedCodeStyle_style_module);
// EXTERNAL MODULE: ./src/features/share/icons/line-icon.tsx
var line_icon = __webpack_require__(45297);
;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockBookingProfile/EmbedCodeStyle/index.tsx








var EmbedCodeStyle = function(param) {
    var open_new_tab = param.open_new_tab, apply_block_settings = param.apply_block_settings;
    var userInfo = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.user.kol;
    });
    var domain = "https://".concat(userInfo === null || userInfo === void 0 ? void 0 : userInfo.domain).concat(BOOKING_PROFILE_PATH);
    var ref = (0,react.useState)(false), iframeLoaded = ref[0], setIframeLoaded = ref[1];
    var handleIframeLoad = function() {
        setIframeLoaded(true);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative",
                style: {
                    //Đợi khi iframe load được cả trang mới cho hiện lên
                    opacity: !iframeLoaded ? 0 : 1
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                        className: (EmbedCodeStyle_style_module_default()).iframe,
                        src: domain,
                        style: {
                            borderRadius: apply_block_settings ? "calc(var(--block-border-radius)/2)" : "4px"
                        },
                        onLoad: handleIframeLoad
                    }),
                    open_new_tab && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: classnames_default()("flex items-center justify-center absolute w-[32px] h-[32px] right-6 top-[60px] rounded-full"),
                        style: {
                            backgroundColor: "rgba(0, 0, 0, 0.15)",
                            border: "1px solid rgba(255, 255, 255, 0.1)"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(line_icon/* ExportIcon */.Hy, {
                            width: 16,
                            height: 16,
                            fillColor: "#FFFFFF"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute top-0 left-0 block w-full h-full rounded-lg z-[1]",
                        style: {
                            backgroundColor: "transparent"
                        }
                    })
                ]
            }),
            !iframeLoaded && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] z-[2]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* SpinLoading */.wW, {
                    color: "primary",
                    style: {
                        "--size": "40px",
                        margin: "auto"
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var BlockBookingProfile_EmbedCodeStyle = (EmbedCodeStyle);

;// CONCATENATED MODULE: ./src/features/design/components/CommonBlockComponent/BlockBookingProfile/index.tsx






var BlockBookingProfile = function(props) {
    var ref, ref1;
    var blockData = props.blockData, positionSlug = props.positionSlug, tabUid = props.tabUid, index = props.index, listBlocksSortOrder = props.listBlocksSortOrder, isFirstItem = props.isFirstItem, isApplyBlockSettings = props.isApplyBlockSettings, isHideMoreActions = props.isHideMoreActions;
    var enable = blockData && blockData.enable;
    var content_attributes = blockData === null || blockData === void 0 ? void 0 : blockData.content_attributes;
    var style_attributes = blockData === null || blockData === void 0 ? void 0 : blockData.style_attributes;
    var siteSettings = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.siteSettings;
    });
    var ref2 = (siteSettings === null || siteSettings === void 0 ? void 0 : (ref = siteSettings.display_setting) === null || ref === void 0 ? void 0 : (ref1 = ref.block_setting) === null || ref1 === void 0 ? void 0 : ref1.block_style) || {}, inner_space_number = ref2.inner_space_number, outside_space = ref2.outside_space;
    var ref3 = content_attributes || {}, image = ref3.image, booking_profile_title = ref3.booking_profile_title, booking_profile_description = ref3.booking_profile_description, booking_profile_button_content = ref3.booking_profile_button_content, _open_new_tab = ref3.open_new_tab, open_new_tab = _open_new_tab === void 0 ? false : _open_new_tab, _apply_block_settings = ref3.apply_block_settings, apply_block_settings = _apply_block_settings === void 0 ? false : _apply_block_settings;
    var ref4 = style_attributes || {}, _booking_profile_style = ref4.booking_profile_style, booking_profile_style = _booking_profile_style === void 0 ? constant/* BOOKING_PROFILE_STYLE.CARD_CONTENT */.W.CARD_CONTENT : _booking_profile_style;
    var cardContentMode = !!(booking_profile_style === constant/* BOOKING_PROFILE_STYLE.CARD_CONTENT */.W.CARD_CONTENT);
    var embedCodeMode = !!(booking_profile_style === constant/* BOOKING_PROFILE_STYLE.EMBED_CODE */.W.EMBED_CODE);
    //Dùng để kích hoạt việc không áp dụng các thiết lập blocks
    var advancedSetting = embedCodeMode ? {
        use_advanced_setting: !apply_block_settings,
        use_block_space: outside_space
    } : {};
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BlockWrapper/* default */.Z, {
        blockType: blockData === null || blockData === void 0 ? void 0 : blockData.block_type,
        isEnable: enable,
        positionSlug: positionSlug,
        tabUid: tabUid,
        blockUid: blockData === null || blockData === void 0 ? void 0 : blockData.uid,
        index: index,
        listBlocksSortOrder: listBlocksSortOrder,
        outsideSpace: outside_space,
        insideSpace: inner_space_number,
        isFirstItem: isFirstItem,
        isApplyBlockSettings: isApplyBlockSettings,
        isHideMoreActions: isHideMoreActions,
        advancedSetting: advancedSetting,
        children: [
            cardContentMode && /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockBookingProfile_CardContentStyle, {
                image: image,
                booking_profile_title: booking_profile_title,
                booking_profile_description: booking_profile_description,
                booking_profile_button_content: booking_profile_button_content
            }),
            embedCodeMode && /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockBookingProfile_EmbedCodeStyle, {
                apply_block_settings: apply_block_settings,
                open_new_tab: open_new_tab
            })
        ]
    });
};
/* harmony default export */ var CommonBlockComponent_BlockBookingProfile = (BlockBookingProfile);

;// CONCATENATED MODULE: ./src/features/design/design.config.ts
function design_config_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function design_config_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            design_config_defineProperty(target, key, source[key]);
        });
    }
    return target;
}





















var design_config_obj;
var DESIGN_COMPONENT = design_config_objectSpread((design_config_obj = {}, design_config_defineProperty(design_config_obj, block_conf/* BLOCK_TYPE.TEXT */.bF.TEXT, CommonBlockComponent_BlockText), design_config_defineProperty(design_config_obj, block_conf/* BLOCK_TYPE.TAB_BAR */.bF.TAB_BAR, CommonBlockComponent_BlockTabs), design_config_defineProperty(design_config_obj, block_conf/* BLOCK_TYPE.IMAGE_SLIDER */.bF.IMAGE_SLIDER, CommonBlockComponent_BlockImageSlider), design_config_defineProperty(design_config_obj, block_conf/* BLOCK_TYPE.AFF_PRODUCT */.bF.AFF_PRODUCT, CommonBlockComponent_BlockAffiliateProduct), design_config_defineProperty(design_config_obj, block_conf/* BLOCK_TYPE.STORY */.bF.STORY, CommonBlockComponent_BlockStory), design_config_defineProperty(design_config_obj, block_conf/* BLOCK_TYPE.BIO */.bF.BIO, CommonBlockComponent_BlockBio), design_config_defineProperty(design_config_obj, block_conf/* BLOCK_TYPE.IMAGE */.bF.IMAGE, CommonBlockComponent_BlockImage), design_config_defineProperty(design_config_obj, block_conf/* BLOCK_TYPE.BUTTON_LINK */.bF.BUTTON_LINK, CommonBlockComponent_BlockButtonLink), design_config_defineProperty(design_config_obj, block_conf/* BLOCK_TYPE.DIGITAL_PRODUCT */.bF.DIGITAL_PRODUCT, CommonBlockComponent_BlockDigitalProduct), design_config_defineProperty(design_config_obj, block_conf/* BLOCK_TYPE.AFF_PRODUCT_GROUP */.bF.AFF_PRODUCT_GROUP, CommonBlockComponent_BlockAffiliateProductGroup), design_config_defineProperty(design_config_obj, block_conf/* BLOCK_TYPE.EMBED */.bF.EMBED, CommonBlockComponent_BlockEmbed), design_config_defineProperty(design_config_obj, block_conf/* BLOCK_TYPE.CARD */.bF.CARD, CommonBlockComponent_BlockCard), design_config_defineProperty(design_config_obj, block_conf/* BLOCK_TYPE.IMAGE_GALLERY */.bF.IMAGE_GALLERY, CommonBlockComponent_BlockImageGallery), design_config_defineProperty(design_config_obj, block_conf/* BLOCK_TYPE.GIFT */.bF.GIFT, BlockVirtualGift), design_config_defineProperty(design_config_obj, block_conf/* BLOCK_TYPE.BUTTON_MULTI_LINK */.bF.BUTTON_MULTI_LINK, CommonBlockComponent_BlockButtonMultiLink), design_config_defineProperty(design_config_obj, block_conf/* BLOCK_TYPE.IMAGE_POPUP */.bF.IMAGE_POPUP, CommonBlockComponent_ImagePopup), design_config_defineProperty(design_config_obj, block_conf/* BLOCK_TYPE.SPACER_AND_DIVIDER */.bF.SPACER_AND_DIVIDER, CommonBlockComponent_BlockSpacerAndDivider), design_config_defineProperty(design_config_obj, block_conf/* BLOCK_TYPE.COMBINED */.bF.COMBINED, CommonBlockComponent_BlockCombined), design_config_defineProperty(design_config_obj, block_conf/* BLOCK_TYPE.BOOKING_PROFILE */.bF.BOOKING_PROFILE, CommonBlockComponent_BlockBookingProfile), design_config_obj), mini_store_config/* MINI_STORE_DESIGN_COMPONENT */.vi);
// expand position config
var EXPAND_POSITION = [
    block_conf/* BLOCK_TYPE.IMAGE_POPUP */.bF.IMAGE_POPUP,
    block_conf/* BLOCK_TYPE.GIFT_FOOTER */.bF.GIFT_FOOTER,
    block_conf/* BLOCK_TYPE.TRUTH_OR_DARE_FOOTER */.bF.TRUTH_OR_DARE_FOOTER,
    block_conf/* BLOCK_TYPE.BRAND_GIFT_FOOTER */.bF.BRAND_GIFT_FOOTER, 
];
var BLOCK_GROUP_TYPE;
(function(BLOCK_GROUP_TYPE) {
    BLOCK_GROUP_TYPE["POPUP"] = "POPUP";
    BLOCK_GROUP_TYPE["FLOATING"] = "FLOATING";
})(BLOCK_GROUP_TYPE || (BLOCK_GROUP_TYPE = {}));
var COUNT_OF_FLOATING_BLOCK_MAXIMUM = 2;
var COUNT_OF_BLOCK_MAXIMUM = 10;
var _obj1;
var BLOCK_TYPE_BY_GROUP = (_obj1 = {}, design_config_defineProperty(_obj1, BLOCK_GROUP_TYPE.POPUP, [
    "image_popup"
]), design_config_defineProperty(_obj1, BLOCK_GROUP_TYPE.FLOATING, [
    "gift_footer",
    // "tod_footer",
    "brand_gift_footer", 
]), _obj1);


/***/ }),

/***/ 42458:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "B": function() { return /* binding */ BorderIcon; },
  "Z": function() { return /* binding */ BlockSetting; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/app/hooks.ts
var hooks = __webpack_require__(65457);
// EXTERNAL MODULE: ./src/features/setting/helper/index.ts
var helper = __webpack_require__(92407);
// EXTERNAL MODULE: ./src/features/setting/hooks/index.tsx
var setting_hooks = __webpack_require__(12272);
// EXTERNAL MODULE: ./src/features/share/configs/const.ts
var configs_const = __webpack_require__(55016);
// EXTERNAL MODULE: ./src/features/share/thunk/index.tsx
var thunk = __webpack_require__(60580);
// EXTERNAL MODULE: ./node_modules/antd-mobile/es/index.js + 251 modules
var es = __webpack_require__(27175);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(31567);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 16 modules
var react_redux_es = __webpack_require__(92145);
// EXTERNAL MODULE: ./src/features/setting/components/ThemeSetting/ColorPicker/index.tsx + 218 modules
var ColorPicker = __webpack_require__(76034);
// EXTERNAL MODULE: ./src/features/setting/components/ThemeSetting/SettingHeader/index.tsx
var SettingHeader = __webpack_require__(95431);
// EXTERNAL MODULE: ./src/features/setting/components/Icons/index.tsx
var Icons = __webpack_require__(76143);
;// CONCATENATED MODULE: ./src/features/setting/components/ThemeSetting/BlockSetting/components/BlockStyle/index.tsx






var RADIUS_STYLE_SQUARE = "square";
var RADIUS_STYLE_ROUNDED = "rounded";
var RADIUS_STYLE_CUSTOM = "custom";
var MAX_INNER_SPACE_NUMBER = 24;
var masks = {
    0: 0,
    2: "",
    4: "",
    6: "",
    8: "",
    10: "",
    12: "",
    14: "",
    16: "",
    18: "",
    20: "",
    22: "",
    24: "",
    26: "",
    28: "",
    30: "",
    32: "",
    34: "",
    36: "",
    38: "",
    40: "",
    42: "",
    44: "",
    46: "",
    48: 48
};
var masksInnerSpace = {
    0: 0,
    12: 12,
    16: 16,
    20: 20,
    24: 24
};
function BlockStyle(props) {
    var onUpdateRadius = props.onUpdateRadius, defaultValue = props.defaultValue;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref;
    var ref1 = (0,react.useState)((ref = defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.radius_type) !== null && ref !== void 0 ? ref : RADIUS_STYLE_SQUARE), radiusType = ref1[0], setRadiusType = ref1[1];
    var ref2;
    var ref3 = (0,react.useState)((ref2 = defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.radius_value) !== null && ref2 !== void 0 ? ref2 : 0), radiusValue = ref3[0], setRadiusValue = ref3[1];
    var ref4;
    var ref5 = (0,react.useState)((ref4 = defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.inner_space) !== null && ref4 !== void 0 ? ref4 : false), innerSpace = ref5[0], setInnerSpace = ref5[1];
    var ref6;
    var ref7 = (0,react.useState)((ref6 = defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.block_space) !== null && ref6 !== void 0 ? ref6 : configs_const/* BLOCK_SETTING_DEFAULT_VALUE.BLOCK_SPACE */.eJ.BLOCK_SPACE), blockSpace = ref7[0], setBlockSpace = ref7[1];
    var ref8;
    var ref9 = (0,react.useState)((ref8 = defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.inner_space_number) !== null && ref8 !== void 0 ? ref8 : innerSpace ? configs_const/* BLOCK_SETTING_DEFAULT_VALUE.INNER_SPACE_NUMBER */.eJ.INNER_SPACE_NUMBER : 0), innerSpaceNumber = ref9[0], setInnerSpaceNumber = ref9[1];
    var ref10;
    var ref11 = (0,react.useState)((ref10 = defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.outside_space) !== null && ref10 !== void 0 ? ref10 : configs_const/* BLOCK_SETTING_DEFAULT_VALUE.OUTSIDE_SPACE */.eJ.OUTSIDE_SPACE), outsideSpace = ref11[0], setOutsideSpace = ref11[1];
    (0,react.useEffect)(function() {
        onUpdateRadius({
            radius_type: radiusType,
            radius_value: radiusValue,
            inner_space: innerSpace,
            block_space: blockSpace,
            inner_space_number: innerSpaceNumber,
            outside_space: outsideSpace
        });
    }, [
        radiusType,
        radiusValue,
        innerSpace,
        blockSpace,
        innerSpaceNumber,
        outsideSpace, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-base mb-4",
                children: t("ss_builder_theme_setting_block_style")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Selector */.Qf, {
                className: "mb-3",
                columns: 3,
                onChange: function(val) {
                    if (val.length) {
                        setRadiusType(val[0]);
                    }
                },
                options: [
                    {
                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* NoShadowSquareIcon */.mB, {
                            className: "m-auto"
                        }),
                        description: t("ss_builder_square"),
                        value: RADIUS_STYLE_SQUARE
                    },
                    {
                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* NoShadowRoundedIcon */.ak, {
                            className: "m-auto"
                        }),
                        description: t("ss_builder_rounded"),
                        value: RADIUS_STYLE_ROUNDED
                    },
                    {
                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* NoShadowCustomIcon */.H, {
                            className: "m-auto"
                        }),
                        description: t("ss_builder_custom"),
                        value: RADIUS_STYLE_CUSTOM
                    }, 
                ],
                value: [
                    radiusType
                ],
                style: {
                    "--checked-color": "#fff"
                }
            }),
            radiusType == RADIUS_STYLE_CUSTOM && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mb-3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "text-base mb-4 flex justify-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: t("ss_builder_border_radius_label")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "primary-color text-sm",
                                children: [
                                    radiusValue,
                                    " px"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Slider */.iR, {
                        onChange: function(val) {
                            return setRadiusValue(parseInt(val.toString()));
                        },
                        // ticks={true}
                        marks: masks,
                        min: 0,
                        step: 2,
                        max: 48,
                        defaultValue: radiusValue,
                        popover: true
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-base mb-3 flex justify-between",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: t("ss_builder_inner_space")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Slider */.iR, {
                        onChange: function(val) {
                            return setInnerSpaceNumber(parseInt(val.toString()));
                        },
                        marks: masksInnerSpace,
                        min: 0,
                        step: 4,
                        max: MAX_INNER_SPACE_NUMBER,
                        defaultValue: innerSpaceNumber,
                        popover: true,
                        ticks: true
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mb-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-base mb-1",
                        children: t("ss_builder_block_outside_space")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Switch */.rs, {
                        defaultChecked: outsideSpace,
                        uncheckedText: t("ss_builder_off"),
                        checkedText: t("ss_builder_on"),
                        onChange: setOutsideSpace
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-3 pt-3 border-t-gray-200 border-t-[1px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-base mb-1",
                        children: t("ss_builder_block_space")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Slider */.iR, {
                        onChange: function(val) {
                            return setBlockSpace(parseInt(val.toString()) || configs_const/* BLOCK_SETTING_DEFAULT_VALUE.BLOCK_SPACE */.eJ.BLOCK_SPACE);
                        },
                        marks: {
                            12: 12,
                            16: 16,
                            20: 20,
                            24: 24
                        },
                        min: 12,
                        max: 24,
                        step: 4,
                        value: blockSpace !== null && blockSpace !== void 0 ? blockSpace : configs_const/* BLOCK_SETTING_DEFAULT_VALUE.BLOCK_SPACE */.eJ.BLOCK_SPACE,
                        ticks: true
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/features/setting/components/ThemeSetting/BlockSetting/components/Icons/index.tsx
var components_Icons = __webpack_require__(14562);
;// CONCATENATED MODULE: ./src/features/setting/components/ThemeSetting/BlockSetting/components/Preview/index.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}





function Preview(param) {
    var defaultValue = param.defaultValue;
    var BACKGROUND_TYPE_IMAGE = "image";
    var BACKGROUND_TYPE_SOLID = "solid";
    var BACKGROUND_TYPE_GRADENT = "gradient";
    var BACKGROUND_TYPE_COLOR = "color";
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var siteSettings = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.siteSettings;
    });
    var ref = (siteSettings === null || siteSettings === void 0 ? void 0 : siteSettings.display_setting) || {}, background = ref.background, paragraph_setting = ref.paragraph_setting, title_setting = ref.title_setting;
    var ref1 = title_setting || {}, tmp = ref1.font_family, font_family_title = tmp === void 0 ? configs_const/* TITLE_SETTING_DEFAULT_VALUE.FONT_FAMILY */.lI.FONT_FAMILY : tmp, tmp1 = ref1.font_color, font_color_title = tmp1 === void 0 ? configs_const/* TITLE_SETTING_DEFAULT_VALUE.FONT_COLOR */.lI.FONT_COLOR : tmp1, tmp2 = ref1.scale, scale_title = tmp2 === void 0 ? configs_const/* TITLE_SETTING_DEFAULT_VALUE.FONT_SCALE */.lI.FONT_SCALE : tmp2, tmp3 = ref1.font_size, font_size_title = tmp3 === void 0 ? configs_const/* TITLE_SETTING_DEFAULT_VALUE.FONT_SIZE */.lI.FONT_SIZE : tmp3, tmp4 = ref1.font_weight, font_weight_title = tmp4 === void 0 ? configs_const/* TITLE_SETTING_DEFAULT_VALUE.FONT_WEIGHT */.lI.FONT_WEIGHT : tmp4, tmp5 = ref1.line_height, line_height_title = tmp5 === void 0 ? configs_const/* TITLE_SETTING_DEFAULT_VALUE.LINE_HEIGHT */.lI.LINE_HEIGHT : tmp5;
    var ref2 = paragraph_setting || {}, tmp6 = ref2.font_family, font_family_paragraph = tmp6 === void 0 ? configs_const/* PARAGRAPH_SETTING_DEFAULT_VALUE.FONT_FAMILY */.no.FONT_FAMILY : tmp6, tmp7 = ref2.font_color, font_color_paragraph = tmp7 === void 0 ? configs_const/* PARAGRAPH_SETTING_DEFAULT_VALUE.FONT_COLOR */.no.FONT_COLOR : tmp7, tmp8 = ref2.scale, scale_paragraph = tmp8 === void 0 ? configs_const/* PARAGRAPH_SETTING_DEFAULT_VALUE.FONT_SCALE */.no.FONT_SCALE : tmp8, tmp9 = ref2.font_size, font_size_paragraph = tmp9 === void 0 ? configs_const/* PARAGRAPH_SETTING_DEFAULT_VALUE.FONT_SIZE */.no.FONT_SIZE : tmp9, tmp10 = ref2.font_weight, font_weight_paragraph = tmp10 === void 0 ? configs_const/* PARAGRAPH_SETTING_DEFAULT_VALUE.FONT_WEIGHT */.no.FONT_WEIGHT : tmp10, tmp11 = ref2.line_height, line_height_paragraph = tmp11 === void 0 ? configs_const/* PARAGRAPH_SETTING_DEFAULT_VALUE.LINE_HEIGHT */.no.LINE_HEIGHT : tmp11;
    var ref3 = background || {}, _type = ref3.type, type = _type === void 0 ? configs_const/* BACKGROUND_SETTING_DEFAULT_VALUE.BACKGROUND_TYPE */.Vw.BACKGROUND_TYPE : _type, _color = ref3.color, color = _color === void 0 ? configs_const/* BACKGROUND_SETTING_DEFAULT_VALUE.COLOR_SOLID */.Vw.COLOR_SOLID : _color, gradient = ref3.gradient, _image = ref3.image, image = _image === void 0 ? configs_const/* BACKGROUND_SETTING_DEFAULT_VALUE.IMAGE */.Vw.IMAGE : _image, _enable_overlay = ref3.enable_overlay, enable_overlay = _enable_overlay === void 0 ? configs_const/* BACKGROUND_SETTING_DEFAULT_VALUE.OVERLAY_ENABLE */.Vw.OVERLAY_ENABLE : _enable_overlay, _overlay_color = ref3.overlay_color, overlay_color = _overlay_color === void 0 ? configs_const/* BACKGROUND_SETTING_DEFAULT_VALUE.OVERLAY_COLOR */.Vw.OVERLAY_COLOR : _overlay_color, tmp12 = ref3.blur, blurBackgroundSetting = tmp12 === void 0 ? configs_const/* BACKGROUND_SETTING_DEFAULT_VALUE.BLUR */.Vw.BLUR : tmp12;
    var ref4 = defaultValue || {}, block_style = ref4.block_style, block_background = ref4.block_background, block_border = ref4.block_border, block_shadow = ref4.block_shadow;
    var ref5 = block_style || {}, _radius_type = ref5.radius_type, radius_type = _radius_type === void 0 ? configs_const/* BLOCK_SETTING_DEFAULT_VALUE.BLOCK_STYLE */.eJ.BLOCK_STYLE : _radius_type, _radius_value = ref5.radius_value, radius_value = _radius_value === void 0 ? configs_const/* BLOCK_SETTING_DEFAULT_VALUE.BORDER_RADIUS */.eJ.BORDER_RADIUS : _radius_value, _inner_space = ref5.inner_space, inner_space = _inner_space === void 0 ? configs_const/* BLOCK_SETTING_DEFAULT_VALUE.INNER_SPACE */.eJ.INNER_SPACE : _inner_space, _block_space = ref5.block_space, block_space = _block_space === void 0 ? configs_const/* BLOCK_SETTING_DEFAULT_VALUE.BLOCK_SPACE */.eJ.BLOCK_SPACE : _block_space, _inner_space_number = ref5.inner_space_number, inner_space_number = _inner_space_number === void 0 ? configs_const/* BLOCK_SETTING_DEFAULT_VALUE.INNER_SPACE_NUMBER */.eJ.INNER_SPACE_NUMBER : _inner_space_number, _outside_space = ref5.outside_space, outside_space = _outside_space === void 0 ? configs_const/* BLOCK_SETTING_DEFAULT_VALUE.OUTSIDE_SPACE */.eJ.OUTSIDE_SPACE : _outside_space;
    var ref6 = block_background || {}, tmp13 = ref6.color, blockBackgroundColor = tmp13 === void 0 ? configs_const/* BLOCK_SETTING_DEFAULT_VALUE.BACKGROUND_COLOR */.eJ.BACKGROUND_COLOR : tmp13, _blur = ref6.blur, blur = _blur === void 0 ? configs_const/* BLOCK_SETTING_DEFAULT_VALUE.BACKGROUND_BLUR */.eJ.BACKGROUND_BLUR : _blur, tmp14 = ref6.type, type_bg = tmp14 === void 0 ? configs_const/* BACKGROUND_SETTING_DEFAULT_VALUE.BACKGROUND_TYPE */.Vw.BACKGROUND_TYPE : tmp14;
    var ref7 = block_border || {}, tmp15 = ref7.enable, borderEnable = tmp15 === void 0 ? configs_const/* BLOCK_SETTING_DEFAULT_VALUE.BORDER_ENABLE */.eJ.BORDER_ENABLE : tmp15, _border_width = ref7.border_width, border_width = _border_width === void 0 ? configs_const/* BLOCK_SETTING_DEFAULT_VALUE.BORDER_WIDTH */.eJ.BORDER_WIDTH : _border_width, tmp16 = ref7.color, borderColor = tmp16 === void 0 ? configs_const/* BLOCK_SETTING_DEFAULT_VALUE.BORDER_COLOR */.eJ.BORDER_COLOR : tmp16, tmp17 = ref7.type, borderType = tmp17 === void 0 ? configs_const/* BLOCK_SETTING_DEFAULT_VALUE.BORDER_STYLE */.eJ.BORDER_STYLE : tmp17;
    var ref8 = block_shadow || {}, tmp18 = ref8.enable, shadowEnable = tmp18 === void 0 ? configs_const/* BLOCK_SETTING_DEFAULT_VALUE.SHADOW_ENABLE */.eJ.SHADOW_ENABLE : tmp18, tmp19 = ref8.color, shadowColor = tmp19 === void 0 ? configs_const/* BLOCK_SETTING_DEFAULT_VALUE.SHADOW_COLOR */.eJ.SHADOW_COLOR : tmp19;
    var font_size_title_block = font_size_title * scale_title * scale_title * scale_title;
    var boxShadowStyle = shadowEnable === true ? {
        boxShadow: "0px 4px 4px " + shadowColor
    } : {};
    var borderRadiusValue = (0,react.useMemo)(function() {
        var value = "0px";
        if (radius_type === "rounded") {
            value = "8px";
        } else if (radius_type === "custom") {
            value = "".concat(radius_value, "px");
        }
        return value;
    }, [
        radius_type,
        radius_value
    ]);
    var styleBorder = borderEnable === true ? {
        borderWidth: border_width + "px",
        borderStyle: borderType,
        borderColor: borderColor
    } : {
        border: "none"
    };
    var styleBackgroundImage = type === BACKGROUND_TYPE_IMAGE ? {
        backgroundPosition: "center center",
        filter: "blur(".concat(blurBackgroundSetting, "px) "),
        WebkitFilter: "blur(".concat(blurBackgroundSetting, "px) "),
        width: "calc(100% + ".concat(blurBackgroundSetting * 2, "px) "),
        height: "calc(100% + ".concat(blurBackgroundSetting * 2, "px) "),
        transform: "translate(-".concat(blurBackgroundSetting, "px, -").concat(blurBackgroundSetting, "px)")
    } : "";
    var checkStyleBackgroundImage = function() {
        switch(type){
            case BACKGROUND_TYPE_IMAGE:
                return 'url("'.concat(image, '")');
            case BACKGROUND_TYPE_GRADENT:
                return gradient;
            default:
                return "";
        }
    };
    var innerSpaceNumber = typeof inner_space_number === "number" ? "".concat(inner_space_number, "px") : inner_space ? "".concat(configs_const/* BLOCK_SETTING_DEFAULT_VALUE.INNER_SPACE_NUMBER */.eJ.INNER_SPACE_NUMBER, "px") : 0;
    var styleOutsideSpace = outside_space ? {
        marginLeft: "".concat(configs_const/* BLOCK_SETTING_DEFAULT_VALUE.OUTSIDE_SPACE_NUMBER */.eJ.OUTSIDE_SPACE_NUMBER, "px"),
        marginRight: "".concat(configs_const/* BLOCK_SETTING_DEFAULT_VALUE.OUTSIDE_SPACE_NUMBER */.eJ.OUTSIDE_SPACE_NUMBER, "px"),
        width: "calc(100% - ".concat(configs_const/* BLOCK_SETTING_DEFAULT_VALUE.OUTSIDE_SPACE_NUMBER */.eJ.OUTSIDE_SPACE_NUMBER * 2, "px) ")
    } : "";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "bg-white mb-2",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mb-3 mt-1 pt-4 pb-4 w-full h-full relative overflow-hidden",
                children: [
                    type === BACKGROUND_TYPE_IMAGE && enable_overlay === true ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute top-0 left-[50%] translate-x-[-50%] block w-full h-full z-[1]",
                        style: {
                            backgroundColor: overlay_color
                        }
                    }) : "",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute top-0 left-0 w-full h-full bg-cover bg-no-repeat object-cover",
                        style: _objectSpread({
                            backgroundColor: type === BACKGROUND_TYPE_SOLID || type === BACKGROUND_TYPE_COLOR ? color : "",
                            backgroundImage: "".concat(checkStyleBackgroundImage()),
                            borderBottom: "1px solid var(--adm-color-border)"
                        }, styleBackgroundImage)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative z-[3]",
                        style: _objectSpread({}, styleOutsideSpace),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "pt-3 pb-3",
                                style: _objectSpread({
                                    backgroundColor: blockBackgroundColor,
                                    borderRadius: borderRadiusValue,
                                    backdropFilter: "blur(".concat(blur, "px) "),
                                    WebkitBackdropFilter: "blur(".concat(blur, "px) "),
                                    paddingLeft: innerSpaceNumber,
                                    paddingRight: innerSpaceNumber
                                }, styleBorder, boxShadowStyle),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "text-titleFontSize",
                                        style: {
                                            color: font_color_title,
                                            fontSize: font_size_title_block,
                                            lineHeight: line_height_title,
                                            fontWeight: font_weight_title,
                                            fontFamily: font_family_title
                                        },
                                        children: t("ss_builder_1st_block_preview_sample_title")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "content-block-preview",
                                        style: {
                                            color: font_color_paragraph,
                                            fontSize: font_size_paragraph,
                                            lineHeight: line_height_paragraph,
                                            fontWeight: font_weight_paragraph,
                                            fontFamily: font_family_paragraph
                                        },
                                        children: t("ss_builder_1st_block_preview_sample_description")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    height: "".concat(block_space, "px")
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "pt-3 pb-3",
                                style: _objectSpread({
                                    backgroundColor: blockBackgroundColor,
                                    borderRadius: borderRadiusValue,
                                    backdropFilter: "blur(".concat(blur, "px) "),
                                    WebkitBackdropFilter: "blur(".concat(blur, "px) "),
                                    paddingLeft: innerSpaceNumber,
                                    paddingRight: innerSpaceNumber
                                }, styleBorder, boxShadowStyle),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "text-titleFontSize",
                                        style: {
                                            color: font_color_title,
                                            fontSize: font_size_title_block,
                                            lineHeight: line_height_title,
                                            fontWeight: font_weight_title,
                                            fontFamily: font_family_title
                                        },
                                        children: t("ss_builder_2st_block_preview_sample_title")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "content-block-preview",
                                        style: {
                                            color: font_color_paragraph,
                                            fontSize: font_size_paragraph,
                                            lineHeight: line_height_paragraph,
                                            fontWeight: font_weight_paragraph,
                                            fontFamily: font_family_paragraph
                                        },
                                        children: t("ss_builder_2st_block_preview_sample_description")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./src/features/share/components/DisplayColor/index.tsx
var DisplayColor = __webpack_require__(26340);
// EXTERNAL MODULE: ./src/features/share/lib/ga-events.ts
var ga_events = __webpack_require__(2991);
// EXTERNAL MODULE: ./src/features/share/lib/index.ts + 1 modules
var lib = __webpack_require__(11116);
// EXTERNAL MODULE: ./src/features/share/components/PopupComponent/index.tsx
var PopupComponent = __webpack_require__(21043);
// EXTERNAL MODULE: ./src/features/share/icons/index.tsx
var icons = __webpack_require__(64035);
// EXTERNAL MODULE: ./src/features/share/hooks/toast.tsx
var toast = __webpack_require__(95880);
;// CONCATENATED MODULE: ./src/features/setting/components/ThemeSetting/BlockSetting/index.tsx
function BlockSetting_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function BlockSetting_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            BlockSetting_defineProperty(target, key, source[key]);
        });
    }
    return target;
}






















var BlockIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        className: className,
        width: "22",
        height: "22",
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "22",
                height: "22",
                fill: "white",
                fillOpacity: "0.01"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19.2526 1.83447H8.2526C8.00949 1.83447 7.77633 1.93105 7.60442 2.10296C7.43251 2.27487 7.33594 2.50802 7.33594 2.75114V6.41781H5.5026C5.25949 6.41781 5.02633 6.51438 4.85442 6.68629C4.68251 6.8582 4.58594 7.09136 4.58594 7.33447V11.0011H2.7526C2.50949 11.0011 2.27633 11.0977 2.10442 11.2696C1.93251 11.4415 1.83594 11.6747 1.83594 11.9178V19.2511C1.83594 19.4943 1.93251 19.7274 2.10442 19.8993C2.27633 20.0712 2.50949 20.1678 2.7526 20.1678H10.0859C10.3291 20.1678 10.5622 20.0712 10.7341 19.8993C10.906 19.7274 11.0026 19.4943 11.0026 19.2511V17.4178H14.6693C14.9124 17.4178 15.1455 17.3212 15.3175 17.1493C15.4894 16.9774 15.5859 16.7443 15.5859 16.5011V14.6678H19.2526C19.4957 14.6678 19.7289 14.5712 19.9008 14.3993C20.0727 14.2274 20.1693 13.9943 20.1693 13.7511V2.75114C20.1693 2.50802 20.0727 2.27487 19.9008 2.10296C19.7289 1.93105 19.4957 1.83447 19.2526 1.83447ZM9.16927 18.3345H3.66927V12.8345H9.16927V18.3345ZM13.7526 15.5845H11.0026V11.9178C11.0026 11.6747 10.906 11.4415 10.7341 11.2696C10.5622 11.0977 10.3291 11.0011 10.0859 11.0011H6.41927V8.25114H13.7526V15.5845ZM18.3359 12.8345H15.5859V7.33447C15.5859 7.09136 15.4894 6.8582 15.3175 6.68629C15.1455 6.51438 14.9124 6.41781 14.6693 6.41781H9.16927V3.66781H18.3359V12.8345Z",
                fill: "#333333"
            })
        ]
    });
};
var StyleIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        className: className,
        width: "22",
        height: "22",
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "22",
                height: "22",
                fill: "white",
                fillOpacity: "0.01"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18.3359 6.26203C18.336 6.25206 18.3361 6.24028 18.3361 6.22847C18.3361 5.52443 18.0486 4.88754 17.5845 4.42894L17.5842 4.42872C17.1091 3.9727 16.4628 3.69189 15.7509 3.69189C15.0391 3.69189 14.3927 3.9727 13.9167 4.42962L13.9176 4.42877L7.86759 10.4788H7.6659C5.51024 10.5385 3.77882 12.2731 3.72433 14.4245L3.72425 14.4296L3.66925 17.4179C3.66907 17.4249 3.66895 17.4331 3.66895 17.4412C3.66895 17.6932 3.77057 17.9214 3.93514 18.0871L3.93509 18.0871C4.10499 18.2406 4.33122 18.3346 4.57945 18.3346C4.58173 18.3346 4.58401 18.3346 4.58629 18.3346H4.58594L7.57429 18.2796C9.73081 18.225 11.4654 16.4936 11.525 14.3435L11.5251 14.3379V14.1271L17.5843 8.07711C18.0484 7.62109 18.3361 6.98669 18.3361 6.28514C18.3361 6.27707 18.336 6.26899 18.336 6.26091V6.26216L18.3359 6.26203ZM7.56509 16.4462L5.50259 16.5012V14.457C5.52322 13.2579 6.50016 12.2937 7.70229 12.2937C7.70238 12.2937 7.70251 12.2937 7.70259 12.2937C7.70268 12.2937 7.70281 12.2937 7.70294 12.2937C8.79142 12.2937 9.67379 13.176 9.67379 14.2645C9.67379 14.2774 9.67366 14.2903 9.67344 14.3031V14.3012C9.64452 15.4613 8.72186 16.3968 7.56961 16.446L7.56509 16.4461V16.4462ZM16.2918 6.77538L10.911 12.1562C10.7626 11.9369 10.6058 11.7452 10.4335 11.5687L10.4343 11.5695C10.26 11.3946 10.068 11.2376 9.86117 11.1012L9.84764 11.0928L15.2285 5.72118C15.3665 5.58931 15.5538 5.50814 15.7601 5.50814C15.9664 5.50814 16.1539 5.58931 16.2921 5.72144L16.2918 5.72118C16.4224 5.8549 16.5029 6.03795 16.5029 6.23981C16.5029 6.24759 16.5028 6.25541 16.5026 6.26314V6.26203C16.5026 6.2628 16.5026 6.26366 16.5026 6.26456C16.5026 6.46389 16.422 6.64441 16.2917 6.77538H16.2918Z",
                fill: "#333333"
            })
        ]
    });
};
var BackgroundIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        className: className,
        width: "22",
        height: "23",
        viewBox: "0 0 22 23",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_7831_219988)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "22",
                        height: "22",
                        transform: "translate(0 0.00244141)",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M6.41927 14.6702C6.23797 14.6702 6.06074 14.724 5.91 14.8247C5.75925 14.9255 5.64176 15.0686 5.57238 15.2361C5.503 15.4036 5.48485 15.5879 5.52022 15.7657C5.55559 15.9436 5.64289 16.1069 5.77109 16.2351C5.89929 16.3633 6.06262 16.4506 6.24044 16.486C6.41825 16.5213 6.60256 16.5032 6.77006 16.4338C6.93756 16.3644 7.08073 16.2469 7.18145 16.0962C7.28218 15.9454 7.33594 15.7682 7.33594 15.5869C7.33594 15.3438 7.23936 15.1106 7.06745 14.9387C6.89554 14.7668 6.66239 14.6702 6.41927 14.6702ZM17.4743 11.0036L18.6018 9.87608C19.1168 9.36045 19.406 8.6615 19.406 7.93275C19.406 7.20399 19.1168 6.50504 18.6018 5.98941L16.0076 3.40441C15.492 2.88943 14.793 2.60017 14.0643 2.60017C13.3355 2.60017 12.6366 2.88943 12.1209 3.40441L11.0026 4.53191C10.9882 3.81214 10.6921 3.12672 10.178 2.62283C9.66378 2.11894 8.97252 1.83677 8.2526 1.83691H4.58594C3.85659 1.83691 3.15712 2.12665 2.64139 2.64237C2.12567 3.1581 1.83594 3.85757 1.83594 4.58691V17.4202C1.83594 18.1496 2.12567 18.8491 2.64139 19.3648C3.15712 19.8805 3.85659 20.1702 4.58594 20.1702H17.4193C18.1486 20.1702 18.8481 19.8805 19.3638 19.3648C19.8795 18.8491 20.1693 18.1496 20.1693 17.4202V13.7536C20.1694 13.0337 19.8872 12.3424 19.3834 11.8282C18.8795 11.3141 18.194 11.018 17.4743 11.0036ZM9.16927 17.4202C9.16927 17.6634 9.07269 17.8965 8.90078 18.0684C8.72888 18.2403 8.49572 18.3369 8.2526 18.3369H4.58594C4.34282 18.3369 4.10966 18.2403 3.93776 18.0684C3.76585 17.8965 3.66927 17.6634 3.66927 17.4202V4.58691C3.66927 4.3438 3.76585 4.11064 3.93776 3.93873C4.10966 3.76682 4.34282 3.67025 4.58594 3.67025H8.2526C8.49572 3.67025 8.72888 3.76682 8.90078 3.93873C9.07269 4.11064 9.16927 4.3438 9.16927 4.58691V17.4202ZM11.0026 7.11691L13.4226 4.69691C13.5944 4.52618 13.8267 4.43035 14.0689 4.43035C14.311 4.43035 14.5434 4.52618 14.7151 4.69691L17.3093 7.33691C17.48 7.50866 17.5758 7.74099 17.5758 7.98316C17.5758 8.22533 17.48 8.45766 17.3093 8.62941L14.6693 11.2694L11.0026 14.8902V7.11691ZM18.3359 17.4202C18.3359 17.6634 18.2394 17.8965 18.0675 18.0684C17.8955 18.2403 17.6624 18.3369 17.4193 18.3369H10.8376C10.9316 18.0652 10.9842 17.7809 10.9934 17.4936L15.6501 12.8369H17.4193C17.6624 12.8369 17.8955 12.9335 18.0675 13.1054C18.2394 13.2773 18.3359 13.5105 18.3359 13.7536V17.4202Z",
                        fill: "#333333"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_7831_219988",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "22",
                        height: "22",
                        fill: "white",
                        transform: "translate(0 0.00244141)"
                    })
                })
            })
        ]
    });
};
var BorderIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        className: className,
        width: "22",
        height: "23",
        viewBox: "0 0 22 23",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_7831_220095)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "22",
                        height: "22",
                        transform: "translate(0 0.00341797)",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M10.5444 16.9631C10.3631 16.9631 10.1859 17.0168 10.0352 17.1175C9.88442 17.2183 9.76692 17.3614 9.69754 17.5289C9.62816 17.6964 9.61001 17.8807 9.64538 18.0586C9.68075 18.2364 9.76805 18.3997 9.89625 18.5279C10.0245 18.6561 10.1878 18.7434 10.3656 18.7788C10.5434 18.8141 10.7277 18.796 10.8952 18.7266C11.0627 18.6572 11.2059 18.5397 11.3066 18.389C11.4073 18.2382 11.4611 18.061 11.4611 17.8797C11.4611 17.6366 11.3645 17.4034 11.1926 17.2315C11.0207 17.0596 10.7875 16.9631 10.5444 16.9631ZM18.7944 3.21305C18.7944 2.96994 18.6979 2.73678 18.5259 2.56487C18.354 2.39296 18.1209 2.29639 17.8778 2.29639H3.2111C2.96799 2.29639 2.73483 2.39296 2.56292 2.56487C2.39101 2.73678 2.29443 2.96994 2.29443 3.21305V17.8797C2.29443 18.1228 2.39101 18.356 2.56292 18.5279C2.73483 18.6998 2.96799 18.7964 3.2111 18.7964C3.45422 18.7964 3.68737 18.6998 3.85928 18.5279C4.03119 18.356 4.12777 18.1228 4.12777 17.8797V4.12972H17.8778C18.1209 4.12972 18.354 4.03314 18.5259 3.86123C18.6979 3.68933 18.7944 3.45617 18.7944 3.21305ZM14.2111 16.9631C14.0298 16.9631 13.8526 17.0168 13.7018 17.1175C13.5511 17.2183 13.4336 17.3614 13.3642 17.5289C13.2948 17.6964 13.2767 17.8807 13.312 18.0586C13.3474 18.2364 13.4347 18.3997 13.5629 18.5279C13.6911 18.6561 13.8545 18.7434 14.0323 18.7788C14.2101 18.8141 14.3944 18.796 14.5619 18.7266C14.7294 18.6572 14.8726 18.5397 14.9733 18.389C15.074 18.2382 15.1278 18.061 15.1278 17.8797C15.1278 17.6366 15.0312 17.4034 14.8593 17.2315C14.6874 17.0596 14.4542 16.9631 14.2111 16.9631ZM6.87777 16.9631C6.69647 16.9631 6.51924 17.0168 6.36849 17.1175C6.21775 17.2183 6.10026 17.3614 6.03088 17.5289C5.9615 17.6964 5.94334 17.8807 5.97871 18.0586C6.01408 18.2364 6.10139 18.3997 6.22959 18.5279C6.35778 18.6561 6.52112 18.7434 6.69893 18.7788C6.87675 18.8141 7.06106 18.796 7.22856 18.7266C7.39606 18.6572 7.53922 18.5397 7.63995 18.389C7.74067 18.2382 7.79443 18.061 7.79443 17.8797C7.79443 17.6366 7.69786 17.4034 7.52595 17.2315C7.35404 17.0596 7.12088 16.9631 6.87777 16.9631ZM17.8778 5.96305C17.6965 5.96305 17.5192 6.01682 17.3685 6.11754C17.2177 6.21826 17.1003 6.36143 17.0309 6.52893C16.9615 6.69643 16.9433 6.88074 16.9787 7.05855C17.0141 7.23637 17.1014 7.3997 17.2296 7.5279C17.3578 7.6561 17.5211 7.7434 17.6989 7.77877C17.8767 7.81414 18.0611 7.79599 18.2286 7.72661C18.3961 7.65723 18.5392 7.53974 18.6399 7.38899C18.7407 7.23825 18.7944 7.06102 18.7944 6.87972C18.7944 6.6366 18.6979 6.40345 18.5259 6.23154C18.354 6.05963 18.1209 5.96305 17.8778 5.96305ZM17.8778 9.62972C17.6965 9.62972 17.5192 9.68348 17.3685 9.78421C17.2177 9.88493 17.1003 10.0281 17.0309 10.1956C16.9615 10.3631 16.9433 10.5474 16.9787 10.7252C17.0141 10.903 17.1014 11.0664 17.2296 11.1946C17.3578 11.3228 17.5211 11.4101 17.6989 11.4454C17.8767 11.4808 18.0611 11.4627 18.2286 11.3933C18.3961 11.3239 18.5392 11.2064 18.6399 11.0557C18.7407 10.9049 18.7944 10.7277 18.7944 10.5464C18.7944 10.3033 18.6979 10.0701 18.5259 9.89821C18.354 9.7263 18.1209 9.62972 17.8778 9.62972ZM17.8778 13.2964C17.6965 13.2964 17.5192 13.3501 17.3685 13.4509C17.2177 13.5516 17.1003 13.6948 17.0309 13.8623C16.9615 14.0298 16.9433 14.2141 16.9787 14.3919C17.0141 14.5697 17.1014 14.733 17.2296 14.8612C17.3578 14.9894 17.5211 15.0767 17.6989 15.1121C17.8767 15.1475 18.0611 15.1293 18.2286 15.0599C18.3961 14.9906 18.5392 14.8731 18.6399 14.7223C18.7407 14.5716 18.7944 14.3944 18.7944 14.2131C18.7944 13.9699 18.6979 13.7368 18.5259 13.5649C18.354 13.393 18.1209 13.2964 17.8778 13.2964ZM17.8778 16.9631C17.6965 16.9631 17.5192 17.0168 17.3685 17.1175C17.2177 17.2183 17.1003 17.3614 17.0309 17.5289C16.9615 17.6964 16.9433 17.8807 16.9787 18.0586C17.0141 18.2364 17.1014 18.3997 17.2296 18.5279C17.3578 18.6561 17.5211 18.7434 17.6989 18.7788C17.8767 18.8141 18.0611 18.796 18.2286 18.7266C18.3961 18.6572 18.5392 18.5397 18.6399 18.389C18.7407 18.2382 18.7944 18.061 18.7944 17.8797C18.7944 17.6366 18.6979 17.4034 18.5259 17.2315C18.354 17.0596 18.1209 16.9631 17.8778 16.9631Z",
                        fill: "#333333"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_7831_220095",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "22",
                        height: "22",
                        fill: "white",
                        transform: "translate(0 0.00341797)"
                    })
                })
            })
        ]
    });
};
var defaultSettingState = {
    block_style: {
        radius_type: configs_const/* BLOCK_SETTING_DEFAULT_VALUE.BLOCK_STYLE */.eJ.BLOCK_STYLE,
        radius_value: configs_const/* BLOCK_SETTING_DEFAULT_VALUE.BORDER_RADIUS */.eJ.BORDER_RADIUS,
        inner_space: configs_const/* BLOCK_SETTING_DEFAULT_VALUE.INNER_SPACE */.eJ.INNER_SPACE,
        block_space: configs_const/* BLOCK_SETTING_DEFAULT_VALUE.BLOCK_SPACE */.eJ.BLOCK_SPACE,
        inner_space_number: configs_const/* BLOCK_SETTING_DEFAULT_VALUE.INNER_SPACE_NUMBER */.eJ.INNER_SPACE_NUMBER,
        outside_space: configs_const/* BLOCK_SETTING_DEFAULT_VALUE.OUTSIDE_SPACE */.eJ.OUTSIDE_SPACE
    },
    block_background: {
        color: configs_const/* BLOCK_SETTING_DEFAULT_VALUE.BACKGROUND_COLOR */.eJ.BACKGROUND_COLOR,
        blur: configs_const/* BLOCK_SETTING_DEFAULT_VALUE.BACKGROUND_BLUR */.eJ.BACKGROUND_BLUR,
        meta: {}
    },
    block_border: {
        enable: configs_const/* BLOCK_SETTING_DEFAULT_VALUE.BORDER_ENABLE */.eJ.BORDER_ENABLE,
        color: configs_const/* BLOCK_SETTING_DEFAULT_VALUE.BORDER_COLOR */.eJ.BORDER_COLOR,
        color_meta: {},
        type: configs_const/* BLOCK_SETTING_DEFAULT_VALUE.BORDER_STYLE */.eJ.BORDER_STYLE,
        border_width: configs_const/* BLOCK_SETTING_DEFAULT_VALUE.BORDER_WIDTH */.eJ.BORDER_WIDTH
    },
    block_shadow: {
        enable: configs_const/* BLOCK_SETTING_DEFAULT_VALUE.SHADOW_ENABLE */.eJ.SHADOW_ENABLE,
        color: configs_const/* BLOCK_SETTING_DEFAULT_VALUE.SHADOW_COLOR */.eJ.SHADOW_COLOR,
        color_meta: {}
    }
};
function BlockSetting(props) {
    var ref17, ref1;
    var BLUR_BACKGROUND_MAXIMUM = 100;
    var backToAllSetting = props.backToAllSetting, type = props.type;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var SuccessToast = (0,toast/* useToast */.p)().SuccessToast;
    var blockSetting = (0,hooks/* useAppSelector */.CG)(function(state) {
        var ref, ref16;
        return state === null || state === void 0 ? void 0 : (ref = state.siteSettings) === null || ref === void 0 ? void 0 : (ref16 = ref.display_setting) === null || ref16 === void 0 ? void 0 : ref16.block_setting;
    });
    var ref2 = (0,react.useState)(blockSetting !== null && blockSetting !== void 0 ? blockSetting : defaultSettingState), blockSettingData = ref2[0], setBlockSettingData = ref2[1];
    var block_background = blockSettingData.block_background, block_border = blockSettingData.block_border, block_shadow = blockSettingData.block_shadow;
    var passioPageProfile = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.passioPageProfile;
    });
    var ref3 = (0,react.useState)(false), isOpenBackgroudPicker = ref3[0], setIsOpenBackgroundPicker = ref3[1];
    var ref4 = (0,react.useState)(false), isOpenBorderColorPicker = ref4[0], setIsOpenBorderColorPicker = ref4[1];
    var ref5 = (0,react.useState)(false), isOpenShadowColorPicker = ref5[0], setIsOpenShadowColorPicker = ref5[1];
    var dispatch = (0,react_redux_es/* useDispatch */.I0)();
    var saveBlockSetting = function() {
        dispatch((0,thunk/* saveThemeBlockSetting */.v9)(blockSettingData));
        backToAllSetting();
        ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.THEME_SETTINGS */.Bt.THEME_SETTINGS, "ThemeSettings_".concat((0,lib/* handleCapitalizeFirstLetter */.Tz)(type), "_").concat(ga_events/* LABEL_CONFIG.EDIT */.tW.EDIT), ga_events/* LABEL_CONFIG.EDIT */.tW.EDIT, (0,lib/* handleCapitalizeFirstLetter */.Tz)(type));
        SuccessToast(t("ss_builder_save_succesfully_label"));
    };
    var hasChange = (0,setting_hooks/* useHasChange */.wJ)([
        blockSettingData
    ]);
    var onCancel = (0,setting_hooks/* useOnCancel */.RI)(hasChange, backToAllSetting, type);
    var onChangeRadius = function(data) {
        setBlockSettingData(function(state) {
            return BlockSetting_objectSpread({}, state, {
                block_style: data
            });
        });
    };
    var onChangeBlockBackground = function(color) {
        var data = {
            color: color
        };
        setBlockSettingData(function(state) {
            return BlockSetting_objectSpread({}, state, {
                block_background: BlockSetting_objectSpread({}, state.block_background, data)
            });
        });
    };
    var onChangeBorderColor = function(color) {
        var data = {
            color: color
        };
        setBlockSettingData(function(state) {
            return BlockSetting_objectSpread({}, state, {
                block_border: BlockSetting_objectSpread({}, state.block_border, data)
            });
        });
    };
    var onChangeShadowColor = function(color) {
        var data = {
            color: color
        };
        setBlockSettingData(function(state) {
            return BlockSetting_objectSpread({}, state, {
                block_shadow: BlockSetting_objectSpread({}, state.block_shadow, data)
            });
        });
    };
    var onChangeBlockBackgroundBlur = function(blur) {
        setBlockSettingData(function(state) {
            return BlockSetting_objectSpread({}, state, {
                block_background: BlockSetting_objectSpread({}, state.block_background, {
                    blur: blur
                })
            });
        });
    };
    var onUpdateBorderData = function(key, value) {
        setBlockSettingData(function(state) {
            return BlockSetting_objectSpread({}, state, {
                block_border: BlockSetting_objectSpread({}, state.block_border, BlockSetting_defineProperty({}, key, value))
            });
        });
    };
    var onUpdateShadowData = function(key, value) {
        setBlockSettingData(function(state) {
            return BlockSetting_objectSpread({}, state, {
                block_shadow: BlockSetting_objectSpread({}, state.block_shadow, BlockSetting_defineProperty({}, key, value))
            });
        });
    };
    var ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-full pb-14",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SettingHeader/* default */.Z, {
                        title: t("ss_builder_block_setting_title"),
                        Icon: BlockIcon
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "sticky z-[999] top-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Preview, {
                            defaultValue: blockSettingData !== null && blockSettingData !== void 0 ? blockSettingData : {}
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* Collapse */.UO, {
                        defaultActiveKey: [
                            "style",
                            "background",
                            "border",
                            "shadow"
                        ],
                        accordion: false,
                        arrow: function(active) {
                            return active ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* DropDownIcon1 */.yu, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* DropDownIcon2 */.oS, {});
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Collapse.Panel */.UO.Panel, {
                                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "mr-1",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyleIcon, {})
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: t("ss_builder_theme_setting_block_style")
                                            })
                                        ]
                                    })
                                }),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockStyle, {
                                    defaultValue: (ref6 = blockSettingData === null || blockSettingData === void 0 ? void 0 : blockSettingData.block_style) !== null && ref6 !== void 0 ? ref6 : {},
                                    onUpdateRadius: onChangeRadius
                                })
                            }, "style"),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* Collapse.Panel */.UO.Panel, {
                                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "mr-1",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundIcon, {})
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: t("ss_builder_theme_setting_block_background")
                                            })
                                        ]
                                    })
                                }),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-base mb-1",
                                        children: t("ss_builder_block_background_color")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DisplayColor/* default */.Z, {
                                        backgroundColor: block_background.color,
                                        onClickOpenColorPicker: setIsOpenBackgroundPicker
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "text-base mb-1 flex justify-between",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: t("ss_builder_block_background_blur")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "primary-color text-sm",
                                                children: [
                                                    (ref7 = block_background === null || block_background === void 0 ? void 0 : block_background.blur) !== null && ref7 !== void 0 ? ref7 : 0,
                                                    " px"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Slider */.iR, {
                                        onChange: onChangeBlockBackgroundBlur,
                                        // ticks={true}
                                        marks: helper/* blurMarks */.e,
                                        min: 0,
                                        step: 1,
                                        max: BLUR_BACKGROUND_MAXIMUM,
                                        popover: true,
                                        defaultValue: (ref8 = block_background === null || block_background === void 0 ? void 0 : block_background.blur) !== null && ref8 !== void 0 ? ref8 : 0
                                    })
                                ]
                            }, "background"),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* Collapse.Panel */.UO.Panel, {
                                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "mr-1",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BorderIcon, {})
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: t("ss_builder_theme_setting_block_border")
                                            })
                                        ]
                                    })
                                }),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mb-3",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-base mb-4",
                                                children: t("ss_builder_enable_border")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Switch */.rs, {
                                                defaultChecked: (ref9 = block_border === null || block_border === void 0 ? void 0 : block_border.enable) !== null && ref9 !== void 0 ? ref9 : false,
                                                uncheckedText: t("ss_builder_off"),
                                                checkedText: t("ss_builder_on"),
                                                onChange: function(value) {
                                                    return onUpdateBorderData("enable", value);
                                                }
                                            })
                                        ]
                                    }),
                                    (block_border === null || block_border === void 0 ? void 0 : block_border.enable) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "mb-3",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "text-base mb-4",
                                                        children: t("ss_builder_block_border_color")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DisplayColor/* default */.Z, {
                                                        backgroundColor: block_border.color,
                                                        onClickOpenColorPicker: setIsOpenBorderColorPicker
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "mb-4",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "text-base mb-2",
                                                        children: t("ss_builder_block_border_style")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Selector */.Qf, {
                                                        className: "",
                                                        columns: 3,
                                                        onChange: function(val) {
                                                            onUpdateBorderData("type", val.length ? val[0] : "solid");
                                                        },
                                                        options: [
                                                            {
                                                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* NoShadowRoundedIcon */.ak, {
                                                                    className: "m-auto"
                                                                }),
                                                                description: t("ss_builder_border_solid"),
                                                                value: "solid"
                                                            },
                                                            {
                                                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* DotRoundedIcon */.UB, {
                                                                    className: "m-auto"
                                                                }),
                                                                description: t("ss_builder_border_dot"),
                                                                value: "dotted"
                                                            },
                                                            {
                                                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* DashRoundedIcon */.oA, {
                                                                    className: "m-auto"
                                                                }),
                                                                description: t("ss_builder_border_dash"),
                                                                value: "dashed"
                                                            }, 
                                                        ],
                                                        defaultValue: [
                                                            (ref10 = blockSettingData === null || blockSettingData === void 0 ? void 0 : (ref17 = blockSettingData.block_border) === null || ref17 === void 0 ? void 0 : ref17.type) !== null && ref10 !== void 0 ? ref10 : "solid", 
                                                        ],
                                                        style: {
                                                            "--checked-color": "#fff"
                                                        }
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "mb-3",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "text-base mb-4",
                                                        children: t("ss_builder_button_border_width")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Slider */.iR, {
                                                        onChange: function(val) {
                                                            return onUpdateBorderData("border_width", parseInt(val.toString()) || 1);
                                                        },
                                                        marks: {
                                                            1: 1,
                                                            2: 2,
                                                            3: 3,
                                                            4: 4,
                                                            5: 5,
                                                            6: 6,
                                                            7: 7,
                                                            8: 8,
                                                            9: 9,
                                                            10: 10,
                                                            11: 11,
                                                            12: 12
                                                        },
                                                        min: 1,
                                                        max: 12,
                                                        step: 1,
                                                        value: (ref11 = blockSettingData === null || blockSettingData === void 0 ? void 0 : (ref1 = blockSettingData.block_border) === null || ref1 === void 0 ? void 0 : ref1.border_width) !== null && ref11 !== void 0 ? ref11 : 1,
                                                        ticks: true
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }, "border"),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* Collapse.Panel */.UO.Panel, {
                                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "mr-1",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Icons/* ShadowIcon */.vf, {
                                                    className: ""
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: t("ss_builder_theme_setting_block_shadow")
                                            })
                                        ]
                                    })
                                }),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mb-3",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-base mb-4",
                                                children: t("ss_builder_enable_shadow")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Switch */.rs, {
                                                defaultChecked: (ref12 = block_shadow === null || block_shadow === void 0 ? void 0 : block_shadow.enable) !== null && ref12 !== void 0 ? ref12 : false,
                                                uncheckedText: t("ss_builder_off"),
                                                checkedText: t("ss_builder_on"),
                                                onChange: function(value) {
                                                    return onUpdateShadowData("enable", value);
                                                }
                                            })
                                        ]
                                    }),
                                    (block_shadow === null || block_shadow === void 0 ? void 0 : block_shadow.enable) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mb-3",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-base mb-4",
                                                children: t("ss_builder_block_shadow_color")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DisplayColor/* default */.Z, {
                                                backgroundColor: block_shadow.color,
                                                onClickOpenColorPicker: setIsOpenShadowColorPicker
                                            })
                                        ]
                                    })
                                ]
                            }, "shadow")
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "max-width-content-class fixed bottom-0 p-2 flex w-full justify-between gap-2 z-[10] bg-[#FFFFFF]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-1/2 text-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                            onClick: onCancel,
                            className: "adm-button adm-button-default adm-button-shape-default w-full",
                            children: t("ss_builder_close_panel")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-1/2 text-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                            color: "primary",
                            disabled: !hasChange,
                            className: "adm-button adm-button-primary adm-button-shape-default w-full",
                            onClick: function() {
                                saveBlockSetting();
                            },
                            children: t("ss_builder_save")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupComponent/* default */.Z, {
                visible: isOpenBackgroudPicker,
                onMaskClick: function() {
                    return setIsOpenBackgroundPicker(false);
                },
                title: t("ss_builder_color_picker_panel_title"),
                onClose: function() {
                    return setIsOpenBackgroundPicker(false);
                },
                classNameBody: "h-[60vh] popup-hard",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorPicker/* ColorPickerV2 */._, {
                    defaultColor: (ref13 = block_background === null || block_background === void 0 ? void 0 : block_background.color) !== null && ref13 !== void 0 ? ref13 : "white",
                    onCancel: function() {
                        setIsOpenBackgroundPicker(false);
                    },
                    onColorSelected: onChangeBlockBackground
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupComponent/* default */.Z, {
                visible: isOpenBorderColorPicker,
                onMaskClick: function() {
                    return setIsOpenBorderColorPicker(false);
                },
                title: t("ss_builder_color_picker_panel_title"),
                onClose: function() {
                    return setIsOpenBorderColorPicker(false);
                },
                classNameBody: "h-[60vh] popup-hard",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorPicker/* ColorPickerV2 */._, {
                    defaultColor: (ref14 = block_border === null || block_border === void 0 ? void 0 : block_border.color) !== null && ref14 !== void 0 ? ref14 : "black",
                    onCancel: function() {
                        setIsOpenBorderColorPicker(false);
                    },
                    onColorSelected: onChangeBorderColor
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupComponent/* default */.Z, {
                visible: isOpenShadowColorPicker,
                onMaskClick: function() {
                    return setIsOpenShadowColorPicker(false);
                },
                title: t("ss_builder_color_picker_panel_title"),
                onClose: function() {
                    return setIsOpenShadowColorPicker(false);
                },
                classNameBody: "h-[60vh] popup-hard",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorPicker/* ColorPickerV2 */._, {
                    defaultColor: (ref15 = block_shadow === null || block_shadow === void 0 ? void 0 : block_shadow.color) !== null && ref15 !== void 0 ? ref15 : "black",
                    onCancel: function() {
                        setIsOpenShadowColorPicker(false);
                    },
                    onColorSelected: onChangeShadowColor
                })
            })
        ]
    });
};


/***/ }),

/***/ 95431:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SettingHeader; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function SettingHeader(props) {
    var Icon = props.Icon, title = props.title, subTitle = props.subTitle, children = props.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "py-3 px-3 bg-white pb-2",
        style: {
            boxShadow: "inset 0px -1px 0px #EEEEEE"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "block flex",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                        className: "flex-1 m-auto text-center items-center text-lg",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Icon, {
                                className: "inline-block mr-2"
                            }),
                            title
                        ]
                    }),
                    !!children ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex items-center",
                        children: children
                    }) : null
                ]
            }),
            subTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "text-descFontSize text-descColorDefault",
                children: subTitle
            })
        ]
    });
};


/***/ }),

/***/ 92407:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ blurMarks; },
/* harmony export */   "q": function() { return /* binding */ blurMarksBackgroundImage; }
/* harmony export */ });
var getBlurMarks = function() {
    var BLUR_BACKGROUND_MAXIMUM = 100;
    var result = {};
    for(var value = 0; value <= BLUR_BACKGROUND_MAXIMUM; value++){
        if (value == 0 || value == BLUR_BACKGROUND_MAXIMUM) {
            result[value] = value;
        } else {
            result[value] = "";
        }
    }
    return result;
};
var blurMarks = getBlurMarks();
var getBlurMarksBackgroundImage = function() {
    var BLUR_BACKGROUND_MAXIMUM = 30;
    var result = {};
    for(var value = 0; value <= BLUR_BACKGROUND_MAXIMUM; value++){
        if (value == 0 || value == BLUR_BACKGROUND_MAXIMUM) {
            result[value] = value;
        } else {
            result[value] = "";
        }
    }
    return result;
};
var blurMarksBackgroundImage = getBlurMarksBackgroundImage();


/***/ }),

/***/ 12272:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RI": function() { return /* binding */ useOnCancel; },
/* harmony export */   "wJ": function() { return /* binding */ useHasChange; }
/* harmony export */ });
/* unused harmony export usePrevious */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _share_icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64035);
/* harmony import */ var _share_lib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11116);
/* harmony import */ var _share_lib_ga_events__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2991);
/* harmony import */ var antd_mobile__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27175);
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18446);
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lodash_isEqual__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(31567);
/* harmony import */ var _app_hooks__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(65457);









var usePrevious = function(value) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)();
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function() {
        ref.current = value;
    });
    return ref.current;
};
var useHasChange = function(dependencies) {
    var myPreviousState = usePrevious(dependencies);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false), hasChange = ref[0], setHasChange = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function() {
        if (myPreviousState && !lodash_isEqual__WEBPACK_IMPORTED_MODULE_5___default()(myPreviousState, dependencies)) {
            setHasChange(true);
        }
    }, dependencies);
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function() {
        setHasChange(false);
    }, []);
    return hasChange;
};
// export function useHasChange(dependencies: any[]) {
//     const [hasChange, setHasChange] = useState(false);
//     useEffect(() => {
//         setHasChange(true);
//     }, dependencies);
//     useEffect(() => {
//         setHasChange(false);
//     }, []);
//     return hasChange;
// }
function useOnCancel(isEdit, onCancel, type) {
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_8__/* .useTranslation */ .$)().t;
    var passioPageProfile = (0,_app_hooks__WEBPACK_IMPORTED_MODULE_7__/* .useAppSelector */ .CG)(function(state) {
        return state.passioPageProfile;
    });
    var handleCancelBlock = function() {
        if (isEdit) {
            antd_mobile__WEBPACK_IMPORTED_MODULE_4__/* .Modal.confirm */ .u_.confirm({
                header: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_1__/* .InformationIcon */ .Yk, {
                    className: "w-11 h-11",
                    fillColor: "#FF8F1F",
                    onClick: function() {}
                }),
                title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    children: t("ss_builder_cancel_edit_block_title")
                }),
                content: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "text-[15px] font-normal leading-[140%] text-textColorDefault text-center",
                    children: t("ss_builder_cancel_edit_block_content")
                }),
                confirmText: t("ss_builder_continue_edit_block_label"),
                cancelText: t("ss_builder_cancel_block_btn_label"),
                onConfirm: function() {
                    return;
                },
                onCancel: function() {
                    onCancel();
                    _share_lib_ga_events__WEBPACK_IMPORTED_MODULE_3__/* ["default"].submitEventV2 */ .ZP.submitEventV2(passioPageProfile, _share_lib_ga_events__WEBPACK_IMPORTED_MODULE_3__/* .CATEGORY_CONFIG.THEME_SETTINGS */ .Bt.THEME_SETTINGS, "ThemeSettings_".concat((0,_share_lib__WEBPACK_IMPORTED_MODULE_2__/* .handleCapitalizeFirstLetter */ .Tz)(type), "_").concat(_share_lib_ga_events__WEBPACK_IMPORTED_MODULE_3__/* .LABEL_CONFIG.CANCEL */ .tW.CANCEL), _share_lib_ga_events__WEBPACK_IMPORTED_MODULE_3__/* .LABEL_CONFIG.CANCEL */ .tW.CANCEL, (0,_share_lib__WEBPACK_IMPORTED_MODULE_2__/* .handleCapitalizeFirstLetter */ .Tz)(type));
                }
            });
        } else {
            onCancel();
            _share_lib_ga_events__WEBPACK_IMPORTED_MODULE_3__/* ["default"].submitEventV2 */ .ZP.submitEventV2(passioPageProfile, _share_lib_ga_events__WEBPACK_IMPORTED_MODULE_3__/* .CATEGORY_CONFIG.THEME_SETTINGS */ .Bt.THEME_SETTINGS, "ThemeSettings_".concat((0,_share_lib__WEBPACK_IMPORTED_MODULE_2__/* .handleCapitalizeFirstLetter */ .Tz)(type), "_").concat(_share_lib_ga_events__WEBPACK_IMPORTED_MODULE_3__/* .LABEL_CONFIG.CANCEL */ .tW.CANCEL), _share_lib_ga_events__WEBPACK_IMPORTED_MODULE_3__/* .LABEL_CONFIG.CANCEL */ .tW.CANCEL, (0,_share_lib__WEBPACK_IMPORTED_MODULE_2__/* .handleCapitalizeFirstLetter */ .Tz)(type));
        }
    };
    return handleCancelBlock;
}


/***/ }),

/***/ 70464:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZP": function() { return /* binding */ LazyImage; }
/* harmony export */ });
/* unused harmony exports ResizeHelpers, getPassioPageResizedUrl */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72679);
/* harmony import */ var react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_2__);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var DEFAULT_IMAGE = "https://image.passio.eco/page-builder/page-builder/images-default/product-default.jpeg";
var ResizeHelpers = {
    square: [
        32,
        64,
        128,
        256,
        320,
        400,
        512,
        1024,
        2048
    ],
    width: [
        32,
        64,
        128,
        256,
        320,
        400,
        512,
        900,
        1200,
        1920
    ],
    _findSize: function(arr, size) {
        var result;
        for(var i = 0; i < arr.length; i++){
            if (!result && arr[i] >= size) {
                result = arr[i];
                break;
            }
        }
        return result;
    },
    getSquaredSize: function(size) {
        return ResizeHelpers._findSize(ResizeHelpers.square, size);
    },
    createThumbImageSrc: function(src) {
        var width = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, height = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, isThumbnail = arguments.length > 3 ? arguments[3] : void 0;
        if (src.toLowerCase().includes(".svg")) {
            return src;
        }
        if (!width || !src.includes("/ssp/") && !src.includes("/mini-store/") && !src.includes("/ministore-catalog/") || !isThumbnail) return src;
        var size = ResizeHelpers.getSquaredSize(width);
        var position = src.indexOf("/", 8);
        return [
            src.slice(0, position),
            "/".concat(size, "x").concat(size),
            src.slice(position), 
        ].join("");
    }
};
var BUILDER_IMAGE_HOST = "https://passio-prod.s3-ap-southeast-1.amazonaws.com";
var PASSIO_IMAGE_HOST = "https://image.passio.eco";
var getPassioPageResizedUrl = function(url) {
    var width = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 500, height = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 500;
    if (!url) {
        return url;
    }
    if (url.startsWith(BUILDER_IMAGE_HOST) && url.indexOf("passio-prod/builder") !== -1) {
        return url.replace(BUILDER_IMAGE_HOST, PASSIO_IMAGE_HOST).replace("passio-prod/builder", "passio-prod/".concat(width, "x").concat(height, "/builder"));
    } else {
        return url;
    }
};
function LazyImage(props) {
    var src = props.src, width = props.width, height = props.height, alt = props.alt, _isThumbnail = props.isThumbnail, isThumbnail = _isThumbnail === void 0 ? false : _isThumbnail, rest = _objectWithoutProperties(props, [
        "src",
        "width",
        "height",
        "alt",
        "isThumbnail"
    ]);
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isOriginLoad = ref1[0], setIsOriginLoad = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isError = ref2[0], setIsError = ref2[1];
    var imageSrc = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        var ref, ref3;
        if (isError) {
            return DEFAULT_IMAGE;
        }
        if (isOriginLoad) {
            return src;
        }
        var imageWidth = width || ((ref3 = (ref = ref4.current) === null || ref === void 0 ? void 0 : ref.getBoundingClientRect()) === null || ref3 === void 0 ? void 0 : ref3.width) || 200;
        var passioPageUrl = getPassioPageResizedUrl(src, imageWidth, height);
        if (passioPageUrl != imageSrc) {
            return passioPageUrl;
        }
        return ResizeHelpers.createThumbImageSrc(src || "/images/placeholder-square.png", imageWidth, height, isThumbnail);
    }, [
        isOriginLoad,
        isError,
        src
    ]);
    return(// eslint-disable-next-line @next/next/no-img-element
    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_2__.LazyLoadImage, _objectSpread({
        ref: ref4,
        src: imageSrc,
        alt: alt
    }, rest, {
        onError: function() {
            if (!ref4.current) return;
            if (isOriginLoad || imageSrc == src) {
                setIsError(true);
            } else {
                setIsOriginLoad(true);
            }
        // @ts-ignore
        }
    })));
};


/***/ }),

/***/ 77105:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bo": function() { return /* binding */ CrownPremiumIcon; },
/* harmony export */   "CE": function() { return /* binding */ CrownIcon; },
/* harmony export */   "Fj": function() { return /* binding */ AngelRightSIcon; },
/* harmony export */   "Mi": function() { return /* binding */ CardAtmIcon; },
/* harmony export */   "Su": function() { return /* binding */ ModalCloseIcon; },
/* harmony export */   "n6": function() { return /* binding */ SwatchBookIcon; },
/* harmony export */   "n9": function() { return /* binding */ GlobeIcon; },
/* harmony export */   "oS": function() { return /* binding */ CrownFreeIcon; },
/* harmony export */   "te": function() { return /* binding */ DollarIcon; },
/* harmony export */   "yI": function() { return /* binding */ SoundIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var AngelRightSIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#333333" : _fillColor, _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M9.89999 17.1998C9.29999 17.1998 8.89999 16.7998 8.89999 16.1998C8.89999 15.8998 8.99999 15.6998 9.19999 15.4998L12.7 11.9998L9.19999 8.4998C8.79999 8.0998 8.79999 7.4998 9.19999 7.0998C9.59999 6.6998 10.2 6.6998 10.6 7.0998L14.8 11.2998C15.2 11.6998 15.2 12.2998 14.8 12.6998L10.6 16.8998C10.4 17.0998 10.1 17.1998 9.89999 17.1998Z",
            fill: fillColor
        })
    });
};
var ModalCloseIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#999" : _fillColor, _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M6.87282 5.81289C6.58291 5.52298 6.10208 5.52298 5.81216 5.81289C5.52225 6.10281 5.52225 6.58364 5.81216 6.87355L10.9387 12.0001L5.81216 17.1266C5.52225 17.4165 5.52225 17.8973 5.81216 18.1873C6.10208 18.4772 6.58291 18.4772 6.87282 18.1873L11.9993 13.0607L17.1259 18.1873C17.4158 18.4772 17.8966 18.4772 18.1865 18.1873C18.4764 17.8973 18.4764 17.4165 18.1865 17.1266L13.06 12.0001L18.1865 6.87355C18.4764 6.58364 18.4764 6.10281 18.1865 5.81289C17.8966 5.52298 17.4158 5.52298 17.1259 5.81289L11.9993 10.9394L6.87282 5.81289Z",
            fill: fillColor
        })
    });
};
var CrownPremiumIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _width = param.width, width = _width === void 0 ? 14 : _width, _height = param.height, height = _height === void 0 ? 14 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width,
        height: height,
        className: className,
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                clipPath: "url(#clip0_425_720442)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "14",
                        height: "14",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                        clipPath: "url(#clip1_425_720442)",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M12.7433 10.7734H1.52539V13.376H12.7433V10.7734Z",
                                fill: "#FFF0D4"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M1.37598 8.70658L7.01535 0.0625L12.7568 8.70658H1.37598Z",
                                fill: "#FFE0A9"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M12.6742 10.1023L13.9867 2.46875L2.82227 9.8006L12.6742 10.1023Z",
                                fill: "#FFF0D4"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M1.33434 10.0626L0.0751953 2.4375L10.503 10.0626H1.33434Z",
                                fill: "white"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                        id: "clip0_425_720442",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                            width: "14",
                            height: "14",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                        id: "clip1_425_720442",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                            width: "14",
                            height: "14",
                            fill: "white"
                        })
                    })
                ]
            })
        ]
    });
};
var CrownFreeIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _width = param.width, width = _width === void 0 ? 14 : _width, _height = param.height, height = _height === void 0 ? 14 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width,
        height: height,
        className: className,
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                clipPath: "url(#clip0_425_720443)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "14",
                        height: "14",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                        clipPath: "url(#clip1_425_720443)",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M12.7433 10.7734H1.52539V13.376H12.7433V10.7734Z",
                                fill: "#CCCCCC"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M1.37598 8.70658L7.01535 0.0625L12.7568 8.70658H1.37598Z",
                                fill: "url(#paint0_linear_425_720443)"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M12.6742 10.1023L13.9867 2.46875L2.82227 9.8006L12.6742 10.1023Z",
                                fill: "url(#paint1_linear_425_720443)"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M1.33434 10.0626L0.0751953 2.4375L10.503 10.0626H1.33434Z",
                                fill: "#CCCCCC"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("linearGradient", {
                        id: "paint0_linear_425_720443",
                        x1: "7.06637",
                        y1: "0.0625",
                        x2: "7.06637",
                        y2: "8.70658",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                stopColor: "#F9F9F9"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                offset: "1",
                                stopColor: "#706D6D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("linearGradient", {
                        id: "paint1_linear_425_720443",
                        x1: "8.40446",
                        y1: "2.46875",
                        x2: "8.40446",
                        y2: "10.1023",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                stopColor: "#DFDFDF"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                offset: "1",
                                stopColor: "#949292"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                        id: "clip0_425_720443",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                            width: "14",
                            height: "14",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                        id: "clip1_425_720443",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                            width: "14",
                            height: "14",
                            fill: "white"
                        })
                    })
                ]
            })
        ]
    });
};
var CrownIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#999" : _fillColor, _width = param.width, width = _width === void 0 ? 24 : _width, _height = param.height, height = _height === void 0 ? 24 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width,
        height: height,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M21.8462 18.4614H2.61542V22.923H21.8462V18.4614Z",
                fill: "#FA8C00"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M2.35986 14.9229L12.0274 0.104492L21.8698 14.9229H2.35986Z",
                fill: "#FF8C00"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M21.7276 17.3209L23.9775 4.23486L4.83856 16.8037L21.7276 17.3209Z",
                fill: "#EDA500"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M2.28798 17.2416L0.129456 4.16992L18.0057 17.2416H2.28798Z",
                fill: "#FEC400"
            })
        ]
    });
};
var SwatchBookIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#FA8C16" : _fillColor, _width = param.width, width = _width === void 0 ? 20 : _width, _height = param.height, height = _height === void 0 ? 20 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        className: className,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M5.83366 13.3307C5.66884 13.3307 5.50773 13.3796 5.37068 13.4712C5.23364 13.5627 5.12683 13.6929 5.06376 13.8452C5.00069 13.9974 4.98418 14.165 5.01634 14.3266C5.04849 14.4883 5.12786 14.6368 5.2444 14.7533C5.36095 14.8699 5.50943 14.9492 5.67108 14.9814C5.83273 15.0135 6.00029 14.997 6.15256 14.934C6.30483 14.8709 6.43498 14.7641 6.52655 14.627C6.61812 14.49 6.66699 14.3289 6.66699 14.1641C6.66699 13.943 6.5792 13.7311 6.42291 13.5748C6.26663 13.4185 6.05467 13.3307 5.83366 13.3307ZM15.8837 9.9974L16.9087 8.9724C17.3768 8.50365 17.6398 7.86823 17.6398 7.20573C17.6398 6.54323 17.3768 5.90781 16.9087 5.43906L14.5503 3.08906C14.0816 2.62089 13.4462 2.35793 12.7837 2.35793C12.1212 2.35793 11.4857 2.62089 11.017 3.08906L10.0003 4.11406C9.98724 3.45973 9.71808 2.83661 9.25065 2.37853C8.78322 1.92045 8.15479 1.66393 7.50033 1.66406H4.16699C3.50395 1.66406 2.86807 1.92745 2.39923 2.3963C1.93038 2.86514 1.66699 3.50102 1.66699 4.16406V15.8307C1.66699 16.4938 1.93038 17.1297 2.39923 17.5985C2.86807 18.0673 3.50395 18.3307 4.16699 18.3307H15.8337C16.4967 18.3307 17.1326 18.0673 17.6014 17.5985C18.0703 17.1297 18.3337 16.4938 18.3337 15.8307V12.4974C18.3338 11.8429 18.0773 11.2145 17.6192 10.7471C17.1611 10.2796 16.538 10.0105 15.8837 9.9974ZM8.33366 15.8307C8.33366 16.0517 8.24586 16.2637 8.08958 16.42C7.9333 16.5763 7.72134 16.6641 7.50033 16.6641H4.16699C3.94598 16.6641 3.73402 16.5763 3.57774 16.42C3.42146 16.2637 3.33366 16.0517 3.33366 15.8307V4.16406C3.33366 3.94305 3.42146 3.73109 3.57774 3.57481C3.73402 3.41853 3.94598 3.33073 4.16699 3.33073H7.50033C7.72134 3.33073 7.9333 3.41853 8.08958 3.57481C8.24586 3.73109 8.33366 3.94305 8.33366 4.16406V15.8307ZM10.0003 6.46406L12.2003 4.26406C12.3565 4.10885 12.5677 4.02174 12.7878 4.02174C13.008 4.02174 13.2192 4.10885 13.3753 4.26406L15.7337 6.66406C15.8889 6.8202 15.976 7.03141 15.976 7.25156C15.976 7.47172 15.8889 7.68293 15.7337 7.83906L13.3337 10.2391L10.0003 13.5307V6.46406ZM16.667 15.8307C16.667 16.0517 16.5792 16.2637 16.4229 16.42C16.2666 16.5763 16.0547 16.6641 15.8337 16.6641H9.85033C9.93581 16.4171 9.98357 16.1586 9.99199 15.8974L14.2253 11.6641H15.8337C16.0547 11.6641 16.2666 11.7519 16.4229 11.9081C16.5792 12.0644 16.667 12.2764 16.667 12.4974V15.8307Z",
            fill: fillColor
        })
    });
};
var GlobeIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#FA8C16" : _fillColor, _width = param.width, width = _width === void 0 ? 20 : _width, _height = param.height, height = _height === void 0 ? 20 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        className: className,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M17.842 7.19652C17.842 7.19652 17.842 7.19652 17.842 7.15486C17.2548 5.55171 16.1894 4.16759 14.7899 3.18974C13.3904 2.21189 11.7243 1.6875 10.017 1.6875C8.3097 1.6875 6.6436 2.21189 5.24408 3.18974C3.84456 4.16759 2.77916 5.55171 2.19199 7.15486C2.19199 7.15486 2.19199 7.15486 2.19199 7.19652C1.53626 9.0056 1.53626 10.9874 2.19199 12.7965C2.19199 12.7965 2.19199 12.7965 2.19199 12.8382C2.77916 14.4413 3.84456 15.8255 5.24408 16.8033C6.6436 17.7812 8.3097 18.3055 10.017 18.3055C11.7243 18.3055 13.3904 17.7812 14.7899 16.8033C16.1894 15.8255 17.2548 14.4413 17.842 12.8382C17.842 12.8382 17.842 12.8382 17.842 12.7965C18.4977 10.9874 18.4977 9.0056 17.842 7.19652ZM3.55033 11.6632C3.26135 10.5709 3.26135 9.42218 3.55033 8.32986H5.10033C4.96702 9.43697 4.96702 10.5561 5.10033 11.6632H3.55033ZM4.23366 13.3299H5.40033C5.59592 14.0731 5.8755 14.7916 6.23366 15.4715C5.41641 14.9148 4.73324 14.1832 4.23366 13.3299ZM5.40033 6.66319H4.23366C4.72605 5.81243 5.40049 5.08108 6.20866 4.52152C5.85912 5.20256 5.58794 5.92104 5.40033 6.66319ZM9.16699 16.4132C8.14346 15.6621 7.42462 14.5676 7.14199 13.3299H9.16699V16.4132ZM9.16699 11.6632H6.78366C6.62815 10.5575 6.62815 9.43553 6.78366 8.32986H9.16699V11.6632ZM9.16699 6.66319H7.14199C7.42462 5.4255 8.14346 4.33096 9.16699 3.57986V6.66319ZM15.767 6.66319H14.6003C14.4047 5.91999 14.1251 5.20147 13.767 4.52152C14.5842 5.07825 15.2674 5.80981 15.767 6.66319ZM10.8337 3.57986C11.8572 4.33096 12.576 5.4255 12.8587 6.66319H10.8337V3.57986ZM10.8337 16.4132V13.3299H12.8587C12.576 14.5676 11.8572 15.6621 10.8337 16.4132ZM13.217 11.6632H10.8337V8.32986H13.217C13.3725 9.43553 13.3725 10.5575 13.217 11.6632ZM13.792 15.4715C14.1501 14.7916 14.4297 14.0731 14.6253 13.3299H15.792C15.2924 14.1832 14.6092 14.9148 13.792 15.4715ZM16.4503 11.6632H14.9003C14.9681 11.1102 15.0015 10.5536 15.0003 9.99652C15.0012 9.43944 14.9678 8.88283 14.9003 8.32986H16.4503C16.7393 9.42218 16.7393 10.5709 16.4503 11.6632Z",
            fill: fillColor
        })
    });
};
var SoundIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#FA8C16" : _fillColor, _width = param.width, width = _width === void 0 ? 20 : _width, _height = param.height, height = _height === void 0 ? 20 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        className: className,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9.375 17.2943C9.375 17.6359 9.65833 17.9193 10 17.9193C10.3417 17.9193 10.625 17.6359 10.625 17.2943V2.71094C10.625 2.36927 10.3417 2.08594 10 2.08594C9.65833 2.08594 9.375 2.36927 9.375 2.71094V17.2943ZM6.25 15.8359C5.90833 15.8359 5.625 15.5526 5.625 15.2109V4.79427C5.625 4.4526 5.90833 4.16927 6.25 4.16927C6.59167 4.16927 6.875 4.4526 6.875 4.79427V15.2109C6.875 15.5526 6.59167 15.8359 6.25 15.8359ZM2.5 13.7526C2.15833 13.7526 1.875 13.4693 1.875 13.1276V6.8776C1.875 6.53594 2.15833 6.2526 2.5 6.2526C2.84167 6.2526 3.125 6.53594 3.125 6.8776V13.1276C3.125 13.4693 2.84167 13.7526 2.5 13.7526ZM13.75 15.8359C13.4083 15.8359 13.125 15.5526 13.125 15.2109V4.79427C13.125 4.4526 13.4083 4.16927 13.75 4.16927C14.0917 4.16927 14.375 4.4526 14.375 4.79427V15.2109C14.375 15.5526 14.0917 15.8359 13.75 15.8359ZM16.875 13.1276C16.875 13.4693 17.1583 13.7526 17.5 13.7526C17.8417 13.7526 18.125 13.4693 18.125 13.1276V6.8776C18.125 6.53594 17.8417 6.2526 17.5 6.2526C17.1583 6.2526 16.875 6.53594 16.875 6.8776V13.1276Z",
            fill: fillColor
        })
    });
};
var CardAtmIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#FA8C16" : _fillColor, _width = param.width, width = _width === void 0 ? 20 : _width, _height = param.height, height = _height === void 0 ? 20 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        className: className,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M15.8337 3.75H4.16699C3.50395 3.75 2.86807 4.01339 2.39923 4.48223C1.93038 4.95107 1.66699 5.58696 1.66699 6.25V13.75C1.66699 14.413 1.93038 15.0489 2.39923 15.5178C2.86807 15.9866 3.50395 16.25 4.16699 16.25H15.8337C16.4967 16.25 17.1326 15.9866 17.6014 15.5178C18.0703 15.0489 18.3337 14.413 18.3337 13.75V6.25C18.3337 5.58696 18.0703 4.95107 17.6014 4.48223C17.1326 4.01339 16.4967 3.75 15.8337 3.75ZM16.667 13.75C16.667 13.971 16.5792 14.183 16.4229 14.3393C16.2666 14.4955 16.0547 14.5833 15.8337 14.5833H4.16699C3.94598 14.5833 3.73402 14.4955 3.57774 14.3393C3.42146 14.183 3.33366 13.971 3.33366 13.75V6.25C3.33366 6.02899 3.42146 5.81702 3.57774 5.66074C3.73402 5.50446 3.94598 5.41667 4.16699 5.41667H15.8337C16.0547 5.41667 16.2666 5.50446 16.4229 5.66074C16.5792 5.81702 16.667 6.02899 16.667 6.25V13.75ZM13.3337 8.75C12.8906 8.7531 12.4563 8.87389 12.0753 9.1C11.6957 8.87477 11.2633 8.75405 10.822 8.7501C10.3806 8.74615 9.94607 8.85912 9.56252 9.07752C9.17898 9.29592 8.86009 9.61197 8.63826 9.99355C8.41644 10.3751 8.29959 10.8086 8.29959 11.25C8.29959 11.6914 8.41644 12.1249 8.63826 12.5065C8.86009 12.888 9.17898 13.2041 9.56252 13.4225C9.94607 13.6409 10.3806 13.7538 10.822 13.7499C11.2633 13.746 11.6957 13.6252 12.0753 13.4C12.4068 13.5967 12.7793 13.714 13.1637 13.7429C13.5481 13.7718 13.9339 13.7114 14.2911 13.5664C14.6482 13.4215 14.967 13.1959 15.2226 12.9074C15.4781 12.6188 15.6635 12.275 15.7642 11.903C15.8648 11.5309 15.8781 11.1406 15.803 10.7625C15.7278 10.3845 15.5663 10.0289 15.331 9.72364C15.0956 9.41836 14.7929 9.17163 14.4464 9.00273C14.0999 8.83383 13.7191 8.74733 13.3337 8.75ZM10.9753 12.0833C10.9282 12.0874 10.8808 12.0874 10.8337 12.0833C10.6126 12.0833 10.4007 11.9955 10.2444 11.8393C10.0881 11.683 10.0003 11.471 10.0003 11.25C10.0003 11.029 10.0881 10.817 10.2444 10.6607C10.4007 10.5045 10.6126 10.4167 10.8337 10.4167C10.8808 10.4126 10.9282 10.4126 10.9753 10.4167C10.7868 10.9333 10.7868 11.5 10.9753 12.0167V12.0833ZM13.3337 12.0833C13.1688 12.0833 13.0077 12.0345 12.8707 11.9429C12.7336 11.8513 12.6268 11.7212 12.5638 11.5689C12.5007 11.4166 12.4842 11.2491 12.5163 11.0874C12.5485 10.9258 12.6279 10.7773 12.7444 10.6607C12.8609 10.5442 13.0094 10.4648 13.1711 10.4327C13.3327 10.4005 13.5003 10.417 13.6526 10.4801C13.8048 10.5432 13.935 10.65 14.0266 10.787C14.1181 10.9241 14.167 11.0852 14.167 11.25C14.167 11.471 14.0792 11.683 13.9229 11.8393C13.7666 11.9955 13.5547 12.0833 13.3337 12.0833Z",
            fill: fillColor
        })
    });
};
var DollarIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#FA8C16" : _fillColor, _width = param.width, width = _width === void 0 ? 20 : _width, _height = param.height, height = _height === void 0 ? 20 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        className: className,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M11.6667 9.16406H10.8333V5.83073H12.5C12.721 5.83073 12.933 5.91853 13.0893 6.07481C13.2455 6.23109 13.3333 6.44305 13.3333 6.66406C13.3333 6.88508 13.4211 7.09704 13.5774 7.25332C13.7337 7.4096 13.9457 7.4974 14.1667 7.4974C14.3877 7.4974 14.5996 7.4096 14.7559 7.25332C14.9122 7.09704 15 6.88508 15 6.66406C15 6.00102 14.7366 5.36514 14.2678 4.8963C13.7989 4.42745 13.163 4.16406 12.5 4.16406H10.8333V2.4974C10.8333 2.27638 10.7455 2.06442 10.5893 1.90814C10.433 1.75186 10.221 1.66406 10 1.66406C9.77899 1.66406 9.56702 1.75186 9.41074 1.90814C9.25446 2.06442 9.16667 2.27638 9.16667 2.4974V4.16406H8.33333C7.44928 4.16406 6.60143 4.51525 5.97631 5.14037C5.35119 5.76549 5 6.61334 5 7.4974C5 8.38145 5.35119 9.2293 5.97631 9.85442C6.60143 10.4795 7.44928 10.8307 8.33333 10.8307H9.16667V14.1641H7.5C7.27899 14.1641 7.06702 14.0763 6.91074 13.92C6.75446 13.7637 6.66667 13.5517 6.66667 13.3307C6.66667 13.1097 6.57887 12.8978 6.42259 12.7415C6.26631 12.5852 6.05435 12.4974 5.83333 12.4974C5.61232 12.4974 5.40036 12.5852 5.24408 12.7415C5.0878 12.8978 5 13.1097 5 13.3307C5 13.9938 5.26339 14.6297 5.73223 15.0985C6.20107 15.5673 6.83696 15.8307 7.5 15.8307H9.16667V17.4974C9.16667 17.7184 9.25446 17.9304 9.41074 18.0867C9.56702 18.2429 9.77899 18.3307 10 18.3307C10.221 18.3307 10.433 18.2429 10.5893 18.0867C10.7455 17.9304 10.8333 17.7184 10.8333 17.4974V15.8307H11.6667C12.5507 15.8307 13.3986 15.4795 14.0237 14.8544C14.6488 14.2293 15 13.3815 15 12.4974C15 11.6133 14.6488 10.7655 14.0237 10.1404C13.3986 9.51525 12.5507 9.16406 11.6667 9.16406ZM9.16667 9.16406H8.33333C7.89131 9.16406 7.46738 8.98847 7.15482 8.67591C6.84226 8.36335 6.66667 7.93942 6.66667 7.4974C6.66667 7.05537 6.84226 6.63145 7.15482 6.31888C7.46738 6.00632 7.89131 5.83073 8.33333 5.83073H9.16667V9.16406ZM11.6667 14.1641H10.8333V10.8307H11.6667C12.1087 10.8307 12.5326 11.0063 12.8452 11.3189C13.1577 11.6314 13.3333 12.0554 13.3333 12.4974C13.3333 12.9394 13.1577 13.3633 12.8452 13.6759C12.5326 13.9885 12.1087 14.1641 11.6667 14.1641Z",
            fill: fillColor
        })
    });
};


/***/ }),

/***/ 60580:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NP": function() { return /* binding */ getSite; },
/* harmony export */   "PK": function() { return /* binding */ restoreTheme; },
/* harmony export */   "qP": function() { return /* binding */ saveSite; },
/* harmony export */   "v9": function() { return /* binding */ saveThemeBlockSetting; },
/* harmony export */   "vV": function() { return /* binding */ saveColor; },
/* harmony export */   "xF": function() { return /* binding */ publishSite; }
/* harmony export */ });
/* unused harmony exports saveMainColor, saveButtonThemeSetting, saveBackgroundSetting, saveThemeSetting */
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _features_main_store_dynamicSlice__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24865);
/* harmony import */ var _features_main_store_positionsSlice__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99265);
/* harmony import */ var _features_main_store_siteSettingSlice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24882);
/* harmony import */ var _share_api__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85861);
/* harmony import */ var lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50361);
/* harmony import */ var lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23279);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lodash_debounce__WEBPACK_IMPORTED_MODULE_6__);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}







var getSite = function() {
    return function() {
        var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(dispatch, getState) {
            var ref, kol, userId, responseSite, payloadPosition, responseSiteClone;
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ref = getState(), kol = ref.user.kol;
                        userId = kol && kol._id;
                        responseSite = null;
                        _ctx.prev = 3;
                        _ctx.next = 6;
                        return (0,_share_api__WEBPACK_IMPORTED_MODULE_4__/* .fetchSiteSetting */ .Dx)(userId);
                    case 6:
                        responseSite = _ctx.sent;
                        _ctx.next = 12;
                        break;
                    case 9:
                        _ctx.prev = 9;
                        _ctx.t0 = _ctx["catch"](3);
                        console.log(_ctx.t0);
                    case 12:
                        if (responseSite) {
                            payloadPosition = responseSite.positions;
                            responseSiteClone = lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_5___default()(responseSite);
                            if (responseSiteClone) delete responseSiteClone.positions;
                            dispatch((0,_features_main_store_positionsSlice__WEBPACK_IMPORTED_MODULE_2__/* .setPosition */ .wq)({
                                positions: payloadPosition
                            }));
                            dispatch((0,_features_main_store_siteSettingSlice__WEBPACK_IMPORTED_MODULE_3__/* .setSiteInfo */ .cP)({
                                sites: responseSiteClone
                            }));
                        }
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    3,
                    9
                ]
            ]);
        }));
        return function(dispatch, getState) {
            return _ref.apply(this, arguments);
        };
    }();
};
var sending = false;
var timeOut = null;
var handleAutoSave = lodash_debounce__WEBPACK_IMPORTED_MODULE_6___default()(function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(dispatch, dataResquest, callback, getState) {
        var ref, positions, siteSettings, data;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    ref = getState(), positions = ref.positions, siteSettings = ref.siteSettings;
                    data = _objectSpread({}, siteSettings, {
                        positions: positions
                    });
                    if (!sending) {
                        _ctx.next = 9;
                        break;
                    }
                    if (!timeOut) {
                        _ctx.next = 7;
                        break;
                    }
                    clearTimeout(timeOut);
                    return _ctx.abrupt("return");
                case 7:
                    timeOut = setTimeout(function() {
                        return handleAutoSave(dispatch, data, callback, getState);
                    }, 300);
                    return _ctx.abrupt("return");
                case 9:
                    sending = true;
                    _ctx.next = 12;
                    return (0,_share_api__WEBPACK_IMPORTED_MODULE_4__/* .saveSiteSetting */ .c4)(data).then(function(res) {
                        callback(res);
                        sending = false;
                    });
                case 12:
                    _ctx.next = 18;
                    break;
                case 14:
                    _ctx.prev = 14;
                    _ctx.t0 = _ctx["catch"](0);
                    sending = false;
                    dispatch((0,_features_main_store_dynamicSlice__WEBPACK_IMPORTED_MODULE_1__/* .setDynamicParams */ .B9)({
                        data: {
                            isError: true
                        }
                    }));
                case 18:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                14
            ]
        ]);
    }));
    return function(dispatch, dataResquest, callback, getState) {
        return _ref.apply(this, arguments);
    };
}(), 3000);
var handleAutoSaveForBackgroundSetting = lodash_debounce__WEBPACK_IMPORTED_MODULE_6___default()(function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(dispatch, dataResquest, callback, getState, displaySettings) {
        var ref, positions, siteSettings, data;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    ref = getState(), positions = ref.positions, siteSettings = ref.siteSettings;
                    data = _objectSpread({}, siteSettings, {
                        display_setting: displaySettings,
                        positions: positions
                    });
                    if (!sending) {
                        _ctx.next = 9;
                        break;
                    }
                    if (!timeOut) {
                        _ctx.next = 7;
                        break;
                    }
                    clearTimeout(timeOut);
                    return _ctx.abrupt("return");
                case 7:
                    timeOut = setTimeout(function() {
                        return handleAutoSaveForBackgroundSetting(dispatch, data, callback, getState, displaySettings);
                    }, 300);
                    return _ctx.abrupt("return");
                case 9:
                    sending = true;
                    _ctx.next = 12;
                    return (0,_share_api__WEBPACK_IMPORTED_MODULE_4__/* .saveSiteSetting */ .c4)(data).then(function(res) {
                        callback(res);
                        sending = false;
                    });
                case 12:
                    _ctx.next = 18;
                    break;
                case 14:
                    _ctx.prev = 14;
                    _ctx.t0 = _ctx["catch"](0);
                    sending = false;
                    dispatch((0,_features_main_store_dynamicSlice__WEBPACK_IMPORTED_MODULE_1__/* .setDynamicParams */ .B9)({
                        data: {
                            isError: true
                        }
                    }));
                case 18:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                14
            ]
        ]);
    }));
    return function(dispatch, dataResquest, callback, getState, displaySettings) {
        return _ref.apply(this, arguments);
    };
}(), 3000);
var saveSite = function(isAutoSave) {
    var displaySettings = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    return function() {
        var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(dispatch, getState) {
            var isCheckSaveSite, ref, positions, siteSettings, dataResquest, responseSaveSite1, handleResponseData;
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        isCheckSaveSite = false;
                        ref = getState(), positions = ref.positions, siteSettings = ref.siteSettings;
                        dataResquest = _objectSpread({}, siteSettings, {
                            positions: positions
                        });
                        responseSaveSite1 = null;
                        handleResponseData = function(responseSaveSite) {
                            if (responseSaveSite) {
                                isCheckSaveSite = true;
                                var payloadPosition = responseSaveSite.positions;
                                var responseSaveSiteClone = lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_5___default()(responseSaveSite);
                                if (responseSaveSiteClone) delete responseSaveSiteClone.positions;
                                dispatch((0,_features_main_store_positionsSlice__WEBPACK_IMPORTED_MODULE_2__/* .setPosition */ .wq)({
                                    positions: payloadPosition
                                }));
                                dispatch((0,_features_main_store_siteSettingSlice__WEBPACK_IMPORTED_MODULE_3__/* .setSiteInfo */ .cP)({
                                    sites: responseSaveSiteClone
                                }));
                                dispatch((0,_features_main_store_dynamicSlice__WEBPACK_IMPORTED_MODULE_1__/* .setDynamicParams */ .B9)({
                                    data: {
                                        isSaving: false
                                    }
                                }));
                                dispatch((0,_features_main_store_dynamicSlice__WEBPACK_IMPORTED_MODULE_1__/* .setDynamicParams */ .B9)({
                                    data: {
                                        isError: false
                                    }
                                }));
                            } else {
                                dispatch((0,_features_main_store_dynamicSlice__WEBPACK_IMPORTED_MODULE_1__/* .setDynamicParams */ .B9)({
                                    data: {
                                        isError: true
                                    }
                                }));
                            }
                        };
                        _ctx.prev = 5;
                        if (!isAutoSave) {
                            _ctx.next = 10;
                            break;
                        }
                        {
                            if (displaySettings) {
                                handleAutoSaveForBackgroundSetting(dispatch, dataResquest, handleResponseData, getState, displaySettings);
                            } else {
                                handleAutoSave(dispatch, dataResquest, handleResponseData, getState);
                            }
                        }
                        _ctx.next = 15;
                        break;
                    case 10:
                        _ctx.next = 12;
                        return (0,_share_api__WEBPACK_IMPORTED_MODULE_4__/* .saveSiteSetting */ .c4)(dataResquest);
                    case 12:
                        responseSaveSite1 = _ctx.sent;
                        handleResponseData(responseSaveSite1);
                        return _ctx.abrupt("return", isCheckSaveSite);
                    case 15:
                        _ctx.next = 21;
                        break;
                    case 17:
                        _ctx.prev = 17;
                        _ctx.t0 = _ctx["catch"](5);
                        console.log(_ctx.t0);
                        dispatch((0,_features_main_store_dynamicSlice__WEBPACK_IMPORTED_MODULE_1__/* .setDynamicParams */ .B9)({
                            data: {
                                isError: true
                            }
                        }));
                    case 21:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    5,
                    17
                ]
            ]);
        }));
        return function(dispatch, getState) {
            return _ref.apply(this, arguments);
        };
    }();
};
var publishSite = function(handleShowResultPublish, handleHideLoadingBtn) {
    return function() {
        var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(dispatch, getState) {
            var siteSettings, dataResquest, responsePublishSite, payloadPosition, responsePublishSiteClone;
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        siteSettings = getState().siteSettings;
                        dataResquest = {
                            id: siteSettings.id,
                            user_id: siteSettings.user_id,
                            version: siteSettings.version
                        };
                        responsePublishSite = null;
                        _ctx.prev = 3;
                        _ctx.next = 6;
                        return (0,_share_api__WEBPACK_IMPORTED_MODULE_4__/* .publishSetting */ .aP)(dataResquest);
                    case 6:
                        responsePublishSite = _ctx.sent;
                        _ctx.next = 13;
                        break;
                    case 9:
                        _ctx.prev = 9;
                        _ctx.t0 = _ctx["catch"](3);
                        console.log(_ctx.t0);
                        (0,_features_main_store_dynamicSlice__WEBPACK_IMPORTED_MODULE_1__/* .setDynamicParams */ .B9)({
                            data: {
                                isError: true
                            }
                        });
                    case 13:
                        if (responsePublishSite) {
                            handleShowResultPublish(true);
                            handleHideLoadingBtn();
                            payloadPosition = responsePublishSite.positions;
                            responsePublishSiteClone = lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_5___default()(responsePublishSite);
                            if (responsePublishSiteClone) delete responsePublishSiteClone.positions;
                            dispatch((0,_features_main_store_positionsSlice__WEBPACK_IMPORTED_MODULE_2__/* .setPosition */ .wq)({
                                positions: payloadPosition
                            }));
                            dispatch((0,_features_main_store_siteSettingSlice__WEBPACK_IMPORTED_MODULE_3__/* .setSiteInfo */ .cP)({
                                sites: responsePublishSiteClone
                            }));
                            dispatch((0,_features_main_store_dynamicSlice__WEBPACK_IMPORTED_MODULE_1__/* .setDynamicParams */ .B9)({
                                data: {
                                    isError: false
                                }
                            }));
                        } else {
                            dispatch((0,_features_main_store_dynamicSlice__WEBPACK_IMPORTED_MODULE_1__/* .setDynamicParams */ .B9)({
                                data: {
                                    isError: true
                                }
                            }));
                        }
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    3,
                    9
                ]
            ]);
        // }
        }));
        return function(dispatch, getState) {
            return _ref.apply(this, arguments);
        };
    }();
};
var saveColor = function(primaryColor, secondColor) {
    var primaryColorGenerate = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, secondaryColorGenerate = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return function() {
        var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(dispatch, getState) {
            var currenState, siteSettings, displaySettings;
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        currenState = getState();
                        siteSettings = currenState.siteSettings;
                        displaySettings = _objectSpread({}, siteSettings.display_setting, {
                            primary_color: primaryColor,
                            second_color: secondColor,
                            primary_color_generate: primaryColorGenerate,
                            secondary_color_generate: secondaryColorGenerate
                        });
                        dispatch((0,_features_main_store_siteSettingSlice__WEBPACK_IMPORTED_MODULE_3__/* .setDisplaySetting */ .H9)({
                            data: displaySettings
                        }));
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        // dispatch(saveSite());
        }));
        return function(dispatch, getState) {
            return _ref.apply(this, arguments);
        };
    }();
};
var saveMainColor = function(primaryColor) {
    return function() {
        var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(dispatch, getState) {
            var currenState, siteSettings, displaySettings;
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        currenState = getState();
                        siteSettings = currenState.siteSettings;
                        displaySettings = _objectSpread({}, siteSettings.display_setting, {
                            primary_color: primaryColor
                        });
                        dispatch(setDisplaySetting({
                            data: displaySettings
                        }));
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        // dispatch(saveSite());
        }));
        return function(dispatch, getState) {
            return _ref.apply(this, arguments);
        };
    }();
};
var saveThemeBlockSetting = function(data) {
    return function(dispatch, getState) {
        var currentState = getState();
        var siteSettings = currentState.siteSettings;
        var displaySettings = _objectSpread({}, siteSettings.display_setting, {
            block_setting: data
        });
        dispatch((0,_features_main_store_siteSettingSlice__WEBPACK_IMPORTED_MODULE_3__/* .setDisplaySetting */ .H9)({
            data: displaySettings
        }));
    // dispatch(saveSite());
    };
};
var saveButtonThemeSetting = function(data) {
    return function(dispatch, getState) {
        var currentState = getState();
        var siteSettings = currentState.siteSettings;
        var displaySettings = _objectSpread({}, siteSettings.display_setting, {
            button_setting: data
        });
        dispatch(setDisplaySetting({
            data: displaySettings
        }));
    // dispatch(saveSite());
    };
};
var saveBackgroundSetting = function(data) {
    return function(dispatch, getState) {
        console.log(data);
    };
};
var saveThemeSetting = function(callbackFunctions, data) {
    return function() {
        var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(dispatch, getState) {
            var handleShowSuccessAlert, handleShowFailAlert, handleCancelThemeSetting, dataImageBase64, dataImageFileName, ref, siteSettings, _siteSettings, _display_setting, gradient, meta_data, _dynamicConfig, _themeSettings, primaryColor, fontFamily, gradientColor, solidColor, typeBackground, imageUrl, dataResquestUploadImage, response, responseImage, dataResquest, _$data, dataResquest1, _$data1;
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        handleShowSuccessAlert = callbackFunctions.handleShowSuccessAlert, handleShowFailAlert = callbackFunctions.handleShowFailAlert, handleCancelThemeSetting = callbackFunctions.handleCancelThemeSetting;
                        dataImageBase64 = data.dataImageBase64, dataImageFileName = data.dataImageFileName;
                        ref = getState(), siteSettings = ref.siteSettings, _siteSettings = ref.siteSettings, _display_setting = _siteSettings.display_setting, gradient = _display_setting.background.gradient, meta_data = _display_setting.meta_data, _dynamicConfig = ref.dynamicConfig, _themeSettings = _dynamicConfig.themeSettings, primaryColor = _themeSettings.primaryColor, fontFamily = _themeSettings.fontFamily, gradientColor = _themeSettings.gradientColor, solidColor = _themeSettings.solidColor, typeBackground = _themeSettings.typeBackground, imageUrl = _themeSettings.imageUrl;
                        dataResquestUploadImage = {
                            id: siteSettings.id,
                            user_id: siteSettings.user_id,
                            name: dataImageFileName,
                            content: dataImageBase64 || imageUrl
                        };
                        response = null;
                        responseImage = null;
                        if (!dataImageBase64) {
                            _ctx.next = 30;
                            break;
                        }
                        _ctx.prev = 7;
                        _ctx.next = 10;
                        return requestUploadImage(dataResquestUploadImage);
                    case 10:
                        responseImage = _ctx.sent;
                        _ctx.next = 16;
                        break;
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](7);
                        console.log(_ctx.t0);
                    case 16:
                        if (!responseImage) {
                            _ctx.next = 28;
                            break;
                        }
                        dataResquest = {
                            id: siteSettings.id,
                            user_id: siteSettings.user_id,
                            display_setting: {
                                primary_color: primaryColor,
                                font_family: fontFamily,
                                background: {
                                    type: typeBackground,
                                    color: solidColor,
                                    gradient: gradientColor || gradient,
                                    image: responseImage.url
                                },
                                meta_data: meta_data
                            }
                        };
                        _ctx.prev = 18;
                        _ctx.next = 21;
                        return requestSaveThemeSettings(dataResquest);
                    case 21:
                        response = _ctx.sent;
                        _ctx.next = 27;
                        break;
                    case 24:
                        _ctx.prev = 24;
                        _ctx.t1 = _ctx["catch"](18);
                        console.log(_ctx.t1);
                    case 27:
                        if (response && /^20[0-9]$/.test(response.status.toString())) {
                            _$data = response.data;
                            dispatch(setDisplaySetting({
                                data: _$data
                            }));
                            handleShowSuccessAlert();
                            handleCancelThemeSetting();
                        // dispatch(saveSite());
                        } else handleShowFailAlert();
                    case 28:
                        _ctx.next = 41;
                        break;
                    case 30:
                        dataResquest1 = {
                            id: siteSettings.id,
                            user_id: siteSettings.user_id,
                            display_setting: {
                                primary_color: primaryColor,
                                font_family: fontFamily,
                                background: {
                                    type: typeBackground,
                                    color: solidColor,
                                    gradient: gradientColor || gradient,
                                    image: imageUrl
                                },
                                meta_data: meta_data
                            }
                        };
                        _ctx.prev = 31;
                        _ctx.next = 34;
                        return requestSaveThemeSettings(dataResquest1);
                    case 34:
                        response = _ctx.sent;
                        _ctx.next = 40;
                        break;
                    case 37:
                        _ctx.prev = 37;
                        _ctx.t2 = _ctx["catch"](31);
                        console.log(_ctx.t2);
                    case 40:
                        if (response && /^20[0-9]$/.test(response.status.toString())) {
                            _$data1 = response.data;
                            dispatch(setDisplaySetting({
                                data: _$data1
                            }));
                            handleShowSuccessAlert();
                            handleCancelThemeSetting();
                        // dispatch(saveSite());
                        } else handleShowFailAlert();
                    case 41:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    7,
                    13
                ],
                [
                    18,
                    24
                ],
                [
                    31,
                    37
                ]
            ]);
        }));
        return function(dispatch, getState) {
            return _ref.apply(this, arguments);
        };
    }();
};
var restoreTheme = function(handleShowRestoreSuccessfully) {
    return function() {
        var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(dispatch, getState) {
            var siteSettings, dataResquest, response, payloadPosition, responseClone;
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        siteSettings = getState().siteSettings;
                        dataResquest = {
                            id: siteSettings.id,
                            user_id: siteSettings.user_id
                        };
                        response = null;
                        _ctx.prev = 3;
                        _ctx.next = 6;
                        return (0,_share_api__WEBPACK_IMPORTED_MODULE_4__/* .requestRestoreTheme */ .dA)(dataResquest);
                    case 6:
                        response = _ctx.sent;
                        _ctx.next = 12;
                        break;
                    case 9:
                        _ctx.prev = 9;
                        _ctx.t0 = _ctx["catch"](3);
                        console.log(_ctx.t0);
                    case 12:
                        if (response && /^20[0-9]$/.test(response.status.toString())) {
                            payloadPosition = response && response.data && response.data.positions;
                            responseClone = response && response.data && lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_5___default()(response.data);
                            if (responseClone) delete responseClone.positions;
                            dispatch((0,_features_main_store_positionsSlice__WEBPACK_IMPORTED_MODULE_2__/* .setPosition */ .wq)({
                                positions: payloadPosition
                            }));
                            dispatch((0,_features_main_store_siteSettingSlice__WEBPACK_IMPORTED_MODULE_3__/* .setSiteInfo */ .cP)({
                                sites: responseClone
                            }));
                            handleShowRestoreSuccessfully();
                        }
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    3,
                    9
                ]
            ]);
        }));
        return function(dispatch, getState) {
            return _ref.apply(this, arguments);
        };
    }();
};


/***/ }),

/***/ 7089:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ EffectPanorama; }
/* harmony export */ });
/**
 * UI Initiative Panorama Slider
 *
 * Infinite 3D panorama slider
 *
 * https://uiinitiative.com
 *
 * Copyright 2022 UI Initiative
 *
 * Released under the UI Initiative Regular License
 *
 */ function EffectPanorama(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on;
    extendParams({
        panoramaEffect: {
            depth: 200,
            rotate: 30
        }
    });
    on("beforeInit", function() {
        if (swiper.params.effect !== "panorama") return;
        swiper.classNames.push("".concat(swiper.params.containerModifierClass, "panorama"));
        swiper.classNames.push("".concat(swiper.params.containerModifierClass, "3d"));
        var overwriteParams = {
            watchSlidesProgress: true
        };
        Object.assign(swiper.params, overwriteParams);
        Object.assign(swiper.originalParams, overwriteParams);
    });
    on("progress", function() {
        if (swiper.params.effect !== "panorama") return;
        var sizesGrid = swiper.slidesSizesGrid;
        var _panoramaEffect = swiper.params.panoramaEffect, _depth = _panoramaEffect.depth, depth = _depth === void 0 ? 200 : _depth, _rotate = _panoramaEffect.rotate, rotate = _rotate === void 0 ? 30 : _rotate;
        var angleRad = rotate * Math.PI / 180;
        var halfAngleRad = angleRad / 2;
        var angleModifier = 1 / (180 / rotate);
        for(var i = 0; i < swiper.slides.length; i += 1){
            var slideEl = swiper.slides[i];
            var slideProgress = slideEl.progress;
            var slideSize = sizesGrid[i];
            var progressModifier = swiper.params.centeredSlides ? 0 : (swiper.params.slidesPerView - 1) * 0.5;
            var modifiedProgress = slideProgress + progressModifier;
            var angleCos = 1 - Math.cos(modifiedProgress * angleModifier * Math.PI);
            var translateX = "".concat(modifiedProgress * (slideSize / 3) * angleCos, "px");
            var rotateY = modifiedProgress * rotate;
            var radius = slideSize * 0.5 / Math.sin(halfAngleRad);
            var translateZ = "".concat(radius * angleCos - depth, "px");
            slideEl.style.transform = swiper.params.direction === "horizontal" ? "translateX(".concat(translateX, ") translateZ(").concat(translateZ, ") rotateY(").concat(rotateY, "deg)") : "translateY(".concat(translateX, ") translateZ(").concat(translateZ, ") rotateX(").concat(-rotateY, "deg)");
        }
    });
    on("setTransition", function(s, duration) {
        if (swiper.params.effect !== "panorama") return;
        swiper.slides.forEach(function(slideEl) {
            // eslint-disable-next-line
            slideEl.style.transition = "".concat(duration, "ms");
        });
    });
};


/***/ }),

/***/ 3304:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"area1":"style_area1__SyGkV","area2":"style_area2__OiYJm","activeButton":"style_activeButton__pgpKa","fontSize":"style_fontSize__KvdzC","rounded":"style_rounded__awmI_"};

/***/ }),

/***/ 20938:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"iframe":"style_iframe__Kufw8"};

/***/ }),

/***/ 99279:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"buttonStyle":"style_buttonStyle__ZaKzL","template1":"style_template1__Nc1I9","template2":"style_template2__6hGIM","template3":"style_template3__CGaJr"};

/***/ }),

/***/ 52889:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"borderTag":"style_borderTag__s2UJ6"};

/***/ })

}]);